var bodyScrollLockOptions = {
  reserveScrollBarGap: true,
};

// Define a global function to load a script
window.loadScript = function (url, callback, id) {
  // Check if the script already exists
  var existingScript = document.querySelector(`script[src="${url}"]`);

  if (existingScript) {
    return;
  }

  var head = document.getElementsByTagName('head')[0];
  var script = document.createElement('script');
  script.type = 'text/javascript';
  script.src = url;
  if (id) script.id = id;

  script.onreadystatechange = callback;
  script.onload = callback;

  head.appendChild(script);
};

// Global function for window inner width (mostly for mobile purposes)
if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
  const setVH = () => {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  };

  setVH();
  window.addEventListener('resize', setVH);
  window.addEventListener('orientationchange', setVH);
}



var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split("."),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      cents = parts[1] ? decimal + parts[1] : "";

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

/**
 * DOM event delegator
 *
 * The delegator will listen
 * for events that bubble up
 * to the root node.
 *
 * @constructor
 * @param {Node|string} [root] The root node or a selector string matching the root node
 */
function Delegate(root) {
  /**
   * Maintain a map of listener
   * lists, keyed by event name.
   *
   * @type Object
   */
  this.listenerMap = [{}, {}];
  if (root) {
    this.root(root);
  }

  /** @type function() */
  this.handle = Delegate.prototype.handle.bind(this);

  // Cache of event listeners removed during an event cycle
  this._removedListeners = [];
}

/**
 * Start listening for events
 * on the provided DOM element
 *
 * @param  {Node|string} [root] The root node or a selector string matching the root node
 * @returns {Delegate} This method is chainable
 */
Delegate.prototype.root = function (root) {
  const listenerMap = this.listenerMap;
  let eventType;

  // Remove master event listeners
  if (this.rootElement) {
    for (eventType in listenerMap[1]) {
      if (listenerMap[1].hasOwnProperty(eventType)) {
        this.rootElement.removeEventListener(eventType, this.handle, true);
      }
    }
    for (eventType in listenerMap[0]) {
      if (listenerMap[0].hasOwnProperty(eventType)) {
        this.rootElement.removeEventListener(eventType, this.handle, false);
      }
    }
  }

  // If no root or root is not
  // a dom node, then remove internal
  // root reference and exit here
  if (!root || !root.addEventListener) {
    if (this.rootElement) {
      delete this.rootElement;
    }
    return this;
  }

  /**
   * The root node at which
   * listeners are attached.
   *
   * @type Node
   */
  this.rootElement = root;

  // Set up master event listeners
  for (eventType in listenerMap[1]) {
    if (listenerMap[1].hasOwnProperty(eventType)) {
      // Add the 'passive' option for scroll events
      const isScrollEvent = ["wheel", "mousewheel"].indexOf(eventType) !== -1;
      this.rootElement.addEventListener(eventType, this.handle, { capture: true, passive: isScrollEvent });
    }
  }
  for (eventType in listenerMap[0]) {
    if (listenerMap[0].hasOwnProperty(eventType)) {
      // Add the 'passive' option for scroll events
      const isScrollEvent = ["wheel", "mousewheel"].indexOf(eventType) !== -1;
      this.rootElement.addEventListener(eventType, this.handle, { capture: false, passive: isScrollEvent });
    }
  }

  return this;
};

/**
 * @param {string} eventType
 * @returns boolean
 */
Delegate.prototype.captureForType = function (eventType) {
  return (
    ["blur", "error", "focus", "load", "resize", "scroll"].indexOf(
      eventType
    ) !== -1
  );
};

/**
 * Attach a handler to one
 * event for all elements
 * that match the selector,
 * now or in the future
 *
 * The handler function receives
 * three arguments: the DOM event
 * object, the node that matched
 * the selector while the event
 * was bubbling and a reference
 * to itself. Within the handler,
 * 'this' is equal to the second
 * argument.
 *
 * The node that actually received
 * the event can be accessed via
 * 'event.target'.
 *
 * @param {string} eventType Listen for these events
 * @param {string|undefined} selector Only handle events on elements matching this selector, if undefined match root element
 * @param {function()} handler Handler function - event data passed here will be in event.data
 * @param {boolean} [useCapture] see 'useCapture' in <https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener>
 * @returns {Delegate} This method is chainable
 */
Delegate.prototype.on = function (eventType, selector, handler, useCapture) {
  let root;
  let listenerMap;
  let matcher;
  let matcherParam;

  if (!eventType) {
    throw new TypeError("Invalid event type: " + eventType);
  }

  // handler can be passed as
  // the second or third argument
  if (typeof selector === "function") {
    useCapture = handler;
    handler = selector;
    selector = null;
  }

  // Fallback to sensible defaults
  // if useCapture not set
  if (useCapture === undefined) {
    useCapture = this.captureForType(eventType);
  }

  if (typeof handler !== "function") {
    throw new TypeError("Handler must be a type of Function");
  }

  root = this.rootElement;
  listenerMap = this.listenerMap[useCapture ? 1 : 0];
  const isScrollEvent = ["wheel", "mousewheel", "touchstart", "touchmove"].indexOf(eventType) !== -1;

  // Add master handler for type if not created yet
  if (!listenerMap[eventType]) {
    if (root) {
      root.addEventListener(eventType, this.handle, { capture: useCapture, passive: isScrollEvent });
    }
    listenerMap[eventType] = [];
  }

  if (!selector) {
    matcherParam = null;

    // COMPLEX - matchesRoot needs to have access to
    // this.rootElement, so bind the function to this.
    matcher = matchesRoot.bind(this);

    // Compile a matcher for the given selector
  } else if (/^[a-z]+$/i.test(selector)) {
    matcherParam = selector;
    matcher = matchesTag;
  } else if (/^#[a-z0-9\-_]+$/i.test(selector)) {
    matcherParam = selector.slice(1);
    matcher = matchesId;
  } else {
    matcherParam = selector;
    matcher = Element.prototype.matches;
  }

  // Add to the list of listeners
  listenerMap[eventType].push({
    selector: selector,
    handler: handler,
    matcher: matcher,
    matcherParam: matcherParam,
  });

  return this;
};

/**
 * Remove an event handler
 * for elements that match
 * the selector, forever
 *
 * @param {string} [eventType] Remove handlers for events matching this type, considering the other parameters
 * @param {string} [selector] If this parameter is omitted, only handlers which match the other two will be removed
 * @param {function()} [handler] If this parameter is omitted, only handlers which match the previous two will be removed
 * @returns {Delegate} This method is chainable
 */
Delegate.prototype.off = function (eventType, selector, handler, useCapture) {
  let i;
  let listener;
  let listenerMap;
  let listenerList;
  let singleEventType;

  // Handler can be passed as
  // the second or third argument
  if (typeof selector === "function") {
    useCapture = handler;
    handler = selector;
    selector = null;
  }

  // If useCapture not set, remove
  // all event listeners
  if (useCapture === undefined) {
    this.off(eventType, selector, handler, true);
    this.off(eventType, selector, handler, false);
    return this;
  }

  listenerMap = this.listenerMap[useCapture ? 1 : 0];
  if (!eventType) {
    for (singleEventType in listenerMap) {
      if (listenerMap.hasOwnProperty(singleEventType)) {
        this.off(singleEventType, selector, handler);
      }
    }

    return this;
  }

  listenerList = listenerMap[eventType];
  if (!listenerList || !listenerList.length) {
    return this;
  }

  // Remove only parameter matches
  // if specified
  for (i = listenerList.length - 1; i >= 0; i--) {
    listener = listenerList[i];

    if (
      (!selector || selector === listener.selector) &&
      (!handler || handler === listener.handler)
    ) {
      this._removedListeners.push(listener);
      listenerList.splice(i, 1);
    }
  }

  // All listeners removed
  if (!listenerList.length) {
    delete listenerMap[eventType];

    // Remove the main handler
    if (this.rootElement) {
      this.rootElement.removeEventListener(eventType, this.handle, useCapture);
    }
  }

  return this;
};

/**
 * Handle an arbitrary event.
 *
 * @param {Event} event
 */
Delegate.prototype.handle = function (event) {
  let i;
  let l;
  const type = event.type;
  let root;
  let phase;
  let listener;
  let returned;
  let listenerList = [];
  let target;
  const eventIgnore = "ftLabsDelegateIgnore";

  if (event[eventIgnore] === true) {
    return;
  }

  target = event.target;

  // Hardcode value of Node.TEXT_NODE
  // as not defined in IE8
  if (target.nodeType === 3) {
    target = target.parentNode;
  }

  // Handle SVG <use> elements in IE
  if (target.correspondingUseElement) {
    target = target.correspondingUseElement;
  }

  root = this.rootElement;

  phase = event.eventPhase || (event.target !== event.currentTarget ? 3 : 2);


  switch (phase) {
    case 1: //Event.CAPTURING_PHASE:
      listenerList = this.listenerMap[1][type];
      break;
    case 2: //Event.AT_TARGET:
      if (this.listenerMap[0] && this.listenerMap[0][type]) {
        listenerList = listenerList.concat(this.listenerMap[0][type]);
      }
      if (this.listenerMap[1] && this.listenerMap[1][type]) {
        listenerList = listenerList.concat(this.listenerMap[1][type]);
      }
      break;
    case 3: //Event.BUBBLING_PHASE:
      listenerList = this.listenerMap[0][type];
      break;
  }

  let toFire = [];

  // Need to continuously check
  // that the specific list is
  // still populated in case one
  // of the callbacks actually
  // causes the list to be destroyed.
  l = listenerList.length;
  while (target && l) {
    for (i = 0; i < l; i++) {
      listener = listenerList[i];

      // Bail from this loop if
      // the length changed and
      // no more listeners are
      // defined between i and l.
      if (!listener) {
        break;
      }

      if (
        target.tagName &&
        ["button", "input", "select", "textarea"].indexOf(
          target.tagName.toLowerCase()
        ) > -1 &&
        target.hasAttribute("disabled")
      ) {
        // Remove things that have previously fired
        toFire = [];
      }
      // Check for match and fire
      // the event if there's one
      //
      // TODO:MCG:20120117: Need a way
      // to check if event#stopImmediatePropagation
      // was called. If so, break both loops.
      else if (listener.matcher.call(target, listener.matcherParam, target)) {
        toFire.push([event, target, listener]);
      }
    }

    // TODO:MCG:20120117: Need a way to
    // check if event#stopPropagation
    // was called. If so, break looping
    // through the DOM. Stop if the
    // delegation root has been reached
    if (target === root) {
      break;
    }

    l = listenerList.length;

    // Fall back to parentNode since SVG children have no parentElement in IE
    target = target.parentElement || target.parentNode;

    // Do not traverse up to document root when using parentNode, though
    if (target instanceof HTMLDocument) {
      break;
    }
  }

  let ret;

  for (i = 0; i < toFire.length; i++) {
    // Has it been removed during while the event function was fired
    if (this._removedListeners.indexOf(toFire[i][2]) > -1) {
      continue;
    }
    returned = this.fire.apply(this, toFire[i]);

    // Stop propagation to subsequent
    // callbacks if the callback returned
    // false
    if (returned === false) {
      toFire[i][0][eventIgnore] = true;
      toFire[i][0].preventDefault();
      ret = false;
      break;
    }
  }

  return ret;
};

/**
 * Fire a listener on a target.
 *
 * @param {Event} event
 * @param {Node} target
 * @param {Object} listener
 * @returns {boolean}
 */
Delegate.prototype.fire = function (event, target, listener) {
  return listener.handler.call(target, event, target);
};

/**
 * Check whether an element
 * matches a tag selector.
 *
 * Tags are NOT case-sensitive,
 * except in XML (and XML-based
 * languages such as XHTML).
 *
 * @param {string} tagName The tag name to test against
 * @param {Element} element The element to test with
 * @returns boolean
 */
function matchesTag(tagName, element) {
  return tagName.toLowerCase() === element.tagName.toLowerCase();
}

/**
 * Check whether an element
 * matches the root.
 *
 * @param {?String} selector In this case this is always passed through as null and not used
 * @param {Element} element The element to test with
 * @returns boolean
 */
function matchesRoot(selector, element) {
  if (this.rootElement === window) {
    return (
      // Match the outer document (dispatched from document)
      element === document ||
      // The <html> element (dispatched from document.body or document.documentElement)
      element === document.documentElement ||
      // Or the window itself (dispatched from window)
      element === window
    );
  }
  return this.rootElement === element;
}

/**
 * Check whether the ID of
 * the element in 'this'
 * matches the given ID.
 *
 * IDs are case-sensitive.
 *
 * @param {string} id The ID to test against
 * @param {Element} element The element to test with
 * @returns boolean
 */
function matchesId(id, element) {
  return id === element.id;
}

/**
 * Short hand for off()
 * and root(), ie both
 * with no parameters
 *
 * @return void
 */
Delegate.prototype.destroy = function () {
  this.off();
  this.root();
};

// Global class to handle ios bodyScroll lock when using two fingers or other gestures
class IOSScrollLock {
  static _preventScroll = null;
  static _preventGesture = null;
  static _lockCount = 0;

  static lock() {
    if (this._lockCount === 0) {
      this._preventScroll = (e) => {
        if (e.target.closest('[data-scrollable]')) return;
        e.preventDefault();
      };
      document.addEventListener('touchmove', this._preventScroll, { passive: false, capture: true });

      this._preventGesture = (e) => e.preventDefault();
      document.addEventListener('gesturestart', this._preventGesture);
    }
    this._lockCount++;
  }

  static unlock() {
    if (this._lockCount < 0) return;
    this._lockCount--;

    if (this._lockCount === 0) {
      if (this._preventScroll) {
        document.removeEventListener('touchmove', this._preventScroll, { passive: false, capture: true });
        this._preventScroll = null;
      }

      if (this._preventGesture) {
        document.removeEventListener('gesturestart', this._preventGesture);
        this._preventGesture = null;
      }
    }
  }
}

class ToastNotifications {
  constructor() {
    this.container = null;
    this.toastCount = 0;
    this.init();
  }

  init() {
    // Create toast container if it doesn't exist
    if (!this.container) {
      this.container = document.createElement('div');
      this.container.id = 'toast-container';
      this.container.className = 'toast-container';
      document.body.appendChild(this.container);
    }
  }

  show(message, type = 'info', duration = 5000) {
    const toast = document.createElement('div');
    const toastId = `toast-${++this.toastCount}`;

    toast.id = toastId;
    toast.className = `toast toast--${type}`;
    toast.setAttribute('role', 'alert');
    toast.setAttribute('aria-live', 'polite');

    // Create toast content
    const content = document.createElement('div');
    content.className = 'toast__content';
    content.textContent = message;

    // Create close button
    const closeBtn = document.createElement('button');
    closeBtn.className = 'toast__close';
    closeBtn.innerHTML = '×';
    closeBtn.setAttribute('aria-label', 'Close notification');
    closeBtn.onclick = () => this.hide(toastId);

    toast.appendChild(content);
    toast.appendChild(closeBtn);

    // Add to container
    this.container.appendChild(toast);

    // Trigger animation
    requestAnimationFrame(() => {
      toast.classList.add('toast--show');
    });

    // Auto-hide after duration
    if (duration > 0) {
      setTimeout(() => {
        this.hide(toastId);
      }, duration);
    }

    return toastId;
  }

  hide(toastId) {
    const toast = document.getElementById(toastId);
    if (!toast) return;

    toast.classList.add('toast--hide');

    // Remove from DOM after animation
    setTimeout(() => {
      if (toast && toast.parentNode) {
        toast.parentNode.removeChild(toast);
      }
    }, 300);
  }

  // Convenience methods
  success(message, duration = 5000) {
    return this.show(message, 'success', duration);
  }

  error(message, duration = 7000) {
    return this.show(message, 'error', duration);
  }

  warning(message, duration = 6000) {
    return this.show(message, 'warning', duration);
  }

  info(message, duration = 5000) {
    return this.show(message, 'info', duration);
  }

  // Clear all toasts
  clearAll() {
    const toasts = this.container.querySelectorAll('.toast');
    toasts.forEach(toast => {
      this.hide(toastNotifications.id);
    });
  }
}

const toastNotifications = new ToastNotifications();

class TranslationUtils {
  static get(path, fallback = '') {
    const keys = path.split('.');
    let current = window.translations;

    for (const key of keys) {
      if (current && current[key]) {
        current = current[key];
      } else {
        return fallback;
      }
    }

    return current || fallback;
  }
}

class ErrorUtils {
  /**
   * Generic toast method with translation support
   * @param {string} namespace - Translation namespace (e.g., 'vendor.bookings', 'customer.account.redeem')
   * @param {string} translationKey - Translation key within namespace
   * @param {string} fallbackText - Fallback text if translation not found
   * @param {string} type - Toast type: 'success', 'error', 'warning', 'info'
   * @param {number} duration - Duration in ms (0 = no auto-hide)
   * @returns {string} Toast ID for programmatic control
   */
  static toast(namespace, translationKey, fallbackText, type = 'info', duration = null) {
    const fullPath = `${namespace}.${translationKey}`;
    const message = TranslationUtils.get(fullPath, fallbackText);

    // Use default durations based on type if not specified
    if (duration === null) {
      const defaultDurations = {
        success: 5000,
        error: 7000,
        warning: 6000,
        info: 5000
      };
      duration = defaultDurations[type] || 5000;
    }

    return toastNotifications.show(message, type, duration);
  }

  /**
   * Shorthand methods for common toast types with translation support
   */
  static success(namespace, translationKey, fallbackText, duration = 5000) {
    return this.toast(namespace, translationKey, fallbackText, 'success', duration);
  }

  static error(namespace, translationKey, fallbackText, duration = 7000) {
    return this.toast(namespace, translationKey, fallbackText, 'error', duration);
  }

  static warning(namespace, translationKey, fallbackText, duration = 6000) {
    return this.toast(namespace, translationKey, fallbackText, 'warning', duration);
  }

  static info(namespace, translationKey, fallbackText, duration = 5000) {
    return this.toast(namespace, translationKey, fallbackText, 'info', duration);
  }

  /**
   * Show inline error in form field, fallback to toast if no validation container
   */
  static showInlineError(element, translationKey, fallbackText, namespace = 'redeem', autoRemove = true) {
    const message = TranslationUtils.get(`customer.account.${namespace}.${translationKey}`, fallbackText);

    // Try to find input-validation container in the element
    const validationContainer = element ? element.querySelector('.input-validation') : null;
    const closestField = validationContainer ? validationContainer.closest('.field') : null;
    if (validationContainer) {
      validationContainer.innerHTML = message;
      validationContainer.style.display = 'block';
      if (closestField) {
        closestField.classList.add('field--error');
      }
      // Auto-remove after delay if specified
      if (autoRemove) {
        setTimeout(() => {
          validationContainer.style.display = 'none';
          validationContainer.innerHTML = '';
          if (closestField) {
            closestField.classList.remove('field--error');
          }
        }, 5000);
      }

      return;
    }

    // Fallback to toast notification if no input-validation container found
    toastNotifications.error(message);
  }
}



class GlobalScrollListener {
  constructor() {
    this.callbacks = new Map();
    this.listenerIdCounter = 0;
    this.isListening = false;
    this.boundRunCallbacks = this.runCallbacks.bind(this);
  }

  addScrollListener(classInstance, func) {
    const id = ++this.listenerIdCounter;
    const keyBase = `${classInstance.constructor.name}_${func.name}_${id}`;
    const key = keyBase.replace(/ /g, '_'); // Replace spaces with underscores
    const boundFunction = func.bind(classInstance);

    this.callbacks.set(key, boundFunction);

    if (!this.isListening) {
      window.addEventListener("scroll", this.boundRunCallbacks, { passive: true });
      this.isListening = true;
    }

    return {
      removeScrollListener: () => this.removeScrollListenerFunction(key)
    };
  }

  removeScrollListenerFunction(key) {
    if (this.callbacks.has(key)) {
      this.callbacks.delete(key);
    }

    if (this.callbacks.size === 0 && this.isListening) {
      window.removeEventListener("scroll", this.boundRunCallbacks);
      this.isListening = false;
    }
  }

  runCallbacks() {
    this.callbacks.forEach(callback => callback());
  }
}
const scrollListener = new GlobalScrollListener();

class Responsive {
  constructor(enableGeneralBreakpointChange, trackWindowHeight) {
    this.settings();

    this.trackWindowHeight = trackWindowHeight;
    this.generalBreakpointChange = enableGeneralBreakpointChange;
    this.currentBreakpoint = this.getCurrentBreakpoint();
    this.breakpointListeners = new Map(); // Stores listeners with their status
    this.resizeCallbacks = new Map();
    this.listenerIdCounter = 0;

    this.setWindowHeight();
    this.initResizeListener();
  }

  initResizeListener() {
    this.boundHandleResize = this.handleResize.bind(this);
    window.addEventListener("resize", this.boundHandleResize);
  }

  settings() {
    this.matchBreakpoints = {
      phone: "(max-width: 640px)",
      tablet: "(min-width: 641px) and (max-width: 1024px)",
      tablet_and_up: "(min-width: 768px)",
      pocket: "(max-width: 1024px)",
      lap_and_up: "(min-width: 1025px)",
      desktop: "(min-width: 1280px)",
      desktop_wide: "(min-width: 1440px)",
    };

    this.currentBreakpoints = {
      phone: "(max-width: 640px)",
      pocket: "(max-width: 1024px)",
      tablet: "(min-width: 641px) and (max-width: 1024px)",
      desktop: "(min-width: 1025px)",
    };
  }

  handleResize() {
    const newBreakpoint = this.getCurrentBreakpoint();

    if (this.generalBreakpointChange) {
      // Check for general breakpoint change
      if (this.currentBreakpoint !== newBreakpoint) {
        document.dispatchEvent(
          new CustomEvent("breakpoint:changed", {
            detail: {
              previousBreakpoint: this.currentBreakpoint,
              currentBreakpoint: newBreakpoint,
            },
          })
        );
      }
    }

    // Additional check for specific breakpoint
    this.breakpointListeners.forEach((value, key) => {
      const isCurrentlyInBreakpoint = this.matchesBreakpoint(key);
      if (value !== isCurrentlyInBreakpoint) {
        this.breakpointListeners.set(key, isCurrentlyInBreakpoint);
        document.body.dispatchEvent(
          new CustomEvent(`breakpoint:${key}`, {
            detail: {
              matches: isCurrentlyInBreakpoint,
            },
          })
        );
      }
    });

    this.currentBreakpoint = newBreakpoint;

    this.setWindowHeight();

    // Run additional registered resize callbacks
    this.runCallbacks();
  }

  setWindowHeight() {
    if (this.trackWindowHeight) {
      document.documentElement.style.setProperty(
        "--window-height",
        `${window.innerHeight}px`
      );
    }
  }

  matchesBreakpoint(breakpoint) {
    const query = this.matchBreakpoints[breakpoint];
    return window.matchMedia(`screen and ${query}`).matches;
  }

  getCurrentBreakpoint() {
    for (const [key, query] of Object.entries(this.currentBreakpoints)) {
      if (window.matchMedia(`screen and ${query}`).matches) {
        return key;
      }
    }
  }

  addBreakpointListener(breakpoint) {
    if (!this.matchBreakpoints[breakpoint]) {
      console.error("Breakpoint does not exist:", breakpoint);
      return;
    }

    if (this.breakpointListeners.has(breakpoint)) {
      console.warn("Listener already exists for breakpoint:", breakpoint);
      return;
    }

    const isInBreakpoint = this.matchesBreakpoint(breakpoint);
    this.breakpointListeners.set(breakpoint, isInBreakpoint);
  }

  addResizeListener(classInstance, func) {
    const id = ++this.listenerIdCounter;
    const keyBase = `${classInstance.constructor.name}_${func.name}_${id}`;
    const key = keyBase.replace(/ /g, "_"); // Replace spaces with underscores
    const boundFunction = func.bind(classInstance);

    this.resizeCallbacks.set(key, boundFunction);

    return {
      removeResizeListener: () => this.removeResizeListenerFunction(key),
    };
  }

  removeResizeListenerFunction(key) {
    if (this.resizeCallbacks.has(key)) {
      this.resizeCallbacks.delete(key);
    }
  }

  runCallbacks() {
    this.resizeCallbacks.forEach((callback) => callback());
  }
}

const responsive = new Responsive(false, true);

class dynamicVariables {
  constructor() {
    document.documentElement.style.setProperty(
      "--viewport_width",
      `${document.documentElement.clientWidth}px`
    );

    document.documentElement.style.setProperty(
      "--viewport-height",
      `${window.innerHeight}px`
    );

    responsive.addResizeListener(this, this.sync.bind(this));
  }

  sync() {
    this.syncWidth();
    this.syncHeight();
  }

  syncWidth() {
    document.documentElement.style.setProperty(
      "--viewport_width",
      `${document.documentElement.clientWidth}px`
    );

  }

  syncHeight() {
    document.documentElement.style.setProperty(
      "--viewport-height",
      `${window.innerHeight}px`
    );
  }
}

const dynamicVars = new dynamicVariables();
class Popup {
  constructor() {
    // Use a delegate for event handling on document.body.
    this.delegateBody = new Delegate(document.body);
    // Maintain a stack of active popups.
    this.activePopups = [];
    this.onPopupOpen = null;
    this.onPopupClose = null;
    this.bindEvents();

    // Initialize mobile drag handles and gesture listeners
    this.initMobileDragHandles();
  }

  bindEvents() {
    // Bind a listener for clicks on toggle buttons.
    this.delegateBody.on(
      'click',
      '[data-action="toggle-popup"]',
      this.handleOpenOptions.bind(this)
    );

    // Listen for the custom "drawer:close-other" event to close all open popups.
    this.delegateBody.on(
      'drawer:close-other',
      this.handleDrawerCloseOther.bind(this)
    );


    // Bind keydown directly on the delegate element so it fires only once.
    this.delegateBody.on('keydown', this.handleEscape.bind(this));
  }

  // Scan existing DOM for mobile drag handles, tag them with data-action,
  // and set up gesture listeners (pointer preferred, touch as fallback).
  initMobileDragHandles() {
    // Internal drag state
    this.dragging = false;
    this.dragStartY = 0;
    this.dragCurrentY = 0;
    this.dragThreshold = 120; // small downward drag to close
    this.maxTranslate = 120; // kept for potential future use (not used visually)
    this.dragPopupEl = null;

    // Pre-bind handlers for add/remove symmetry
    this.boundOnDragStart = this.onDragStart.bind(this);
    this.boundOnDragMove = this.onDragMove.bind(this);
    this.boundOnDragEnd = this.onDragEnd.bind(this);

    if (window.PointerEvent) {
      const sel = '[data-action="popup-drag-handle"]';
      this.delegateBody.on('pointerdown', sel, this.boundOnDragStart);
    } else {
      // Fallback for very old browsers
      const sel = '[data-action="popup-drag-handle"], .popup__mobile-drag-handle.not_desktop';
      this.delegateBody.on('touchstart', sel, this.boundOnDragStart);
    }
  }

  getPointY(e) {
    if (e && typeof e.clientY === 'number') return e.clientY;
    if (e?.touches && e.touches[0]) return e.touches[0].clientY;
    if (e?.changedTouches && e.changedTouches[0]) return e.changedTouches[0].clientY;
    return null;
  }

  onDragStart(event) {
    // Ignore non-primary mouse buttons
    if (event.pointerType === 'mouse' && event.button !== 0) return;

    const handle = event.target?.closest?.('[data-action="popup-drag-handle"], .popup__mobile-drag-handle.not_desktop');

    if (!handle) return;
    const popup = handle.closest('[aria-expanded]');
    if (!popup || popup.getAttribute('aria-expanded') !== 'true') return;

    const startY = this.getPointY(event);
    if (startY == null) return;

    this.dragging = true;
    this.dragStartY = startY;
    this.dragCurrentY = startY;
    this.dragPopupEl = popup;

    // Disable transition during drag
    popup.style.transition = 'none';

    // Attach global move/end listeners
    if (window.PointerEvent) {
      document.addEventListener('pointermove', this.boundOnDragMove);
      document.addEventListener('pointerup', this.boundOnDragEnd);
      document.addEventListener('pointercancel', this.boundOnDragEnd);
    } else {
      document.addEventListener('touchmove', this.boundOnDragMove, { passive: false });
      document.addEventListener('touchend', this.boundOnDragEnd);
      document.addEventListener('touchcancel', this.boundOnDragEnd);
    }

    // Capture pointer so we keep receiving move/up even when pointer leaves handle
    if (event.pointerId != null && handle.setPointerCapture) {
      try { handle.setPointerCapture(event.pointerId); } catch (e) { /* ignore */ }
    }

    event.preventDefault?.();
    event.stopPropagation?.();
  }

  onDragMove(event) {
    if (!this.dragging || !this.dragPopupEl) return;

    const y = this.getPointY(event);
    if (y == null) return;

    const delta = y - this.dragStartY;
    this.dragCurrentY = y;

    // Prevent scrolling during drag
    event.preventDefault?.();

    // Apply visual translation (only allow downward drag)
    if (delta > 0) {
      // Keep the -50% centering and add the drag offset
      this.dragPopupEl.style.transform = `translateY(calc(-50% + ${delta}px))`;

      // Optional: reduce opacity as you drag down
      const opacity = Math.max(0.3, 1 - (delta / this.dragThreshold));
      this.dragPopupEl.style.opacity = opacity;
    }

    // If dragged down beyond threshold, close
    if (delta > this.dragThreshold) {
      const popup = this.dragPopupEl;
      this.cleanupDragListeners();
      this.closePopup(popup);
    }
  }

  onDragEnd(event) {
    if (!this.dragging) return;

    // If drag ended without closing, snap back to original position
    if (this.dragPopupEl) {
      this.dragPopupEl.style.transition = 'transform 0.3s ease, opacity 0.3s ease';
      // Reset to centered position with -50%
      this.dragPopupEl.style.transform = 'translateY(-50%)';
      this.dragPopupEl.style.opacity = '';
    }

    this.cleanupDragListeners();
  }

  cleanupDragListeners() {
    // Clean up inline styles before clearing reference
    if (this.dragPopupEl) {
      this.dragPopupEl.style.transform = '';
      this.dragPopupEl.style.opacity = '';
      this.dragPopupEl.style.transition = '';
    }

    this.dragging = false;
    this.dragPopupEl = null;

    // Remove global listeners
    if (window.PointerEvent) {
      document.removeEventListener('pointermove', this.boundOnDragMove);
      document.removeEventListener('pointerup', this.boundOnDragEnd);
      document.removeEventListener('pointercancel', this.boundOnDragEnd);
    } else {
      document.removeEventListener('touchmove', this.boundOnDragMove);
      document.removeEventListener('touchend', this.boundOnDragEnd);
      document.removeEventListener('touchcancel', this.boundOnDragEnd);
    }
  }

  // This method is called when a toggle button is clicked.
  handleOpenOptions(event) {
    event.stopPropagation();
    event.preventDefault();

    const toggleButton = event.target.closest('[data-action="toggle-popup"]');
    if (toggleButton) {
      this.togglePopup(toggleButton);
      return;
    }

    // If a click occurs on the overlay of the top-most popup, close that popup.
    if (this.activePopups.length) {
      const topPopup = this.activePopups[this.activePopups.length - 1];
      const overlay = this.getOverlayElement(topPopup);
      if (overlay && overlay.contains(event.target)) {
        this.closePopup(topPopup);
      }
    }
  }

  destroy() {
    // The .off() method would need to be implemented in your Delegate class.
    // It should remove the listeners that .on() created.
    this.delegateBody.off('click', '[data-action="toggle-popup"]', this.handleOpenOptions);
    this.delegateBody.off('drawer:close-other', this.handleDrawerCloseOther);
    this.delegateBody.off('keydown', this.handleEscape);

    // Remove drag listeners
    if (window.PointerEvent) {
      this.delegateBody.off('pointerdown', '[data-action="popup-drag-handle"]', this.boundOnDragStart);
      this.delegateBody.off('pointermove', this.boundOnDragMove);
      this.delegateBody.off('pointerup', this.boundOnDragEnd);
      this.delegateBody.off('pointercancel', this.boundOnDragEnd);
    } else {
      this.delegateBody.off('touchstart', '[data-action="popup-drag-handle"], .popup__mobile-drag-handle.not_desktop', this.boundOnDragStart);
      this.delegateBody.off('touchmove', this.boundOnDragMove);
      this.delegateBody.off('touchend', this.boundOnDragEnd);
      this.delegateBody.off('touchcancel', this.boundOnDragEnd);
    }

    // Close any remaining popups.
    this.closeAllPopups();
  }

  // Handle keydown events.
  // Only close the top-most popup when Esc is pressed.
  handleEscape(event) {
    // If 'Escape' is pressed and there's an active popup, close the top one.
    if (event.key === 'Escape' && this.activePopups.length > 0) {
      event.preventDefault();
      event.stopPropagation();

      const topPopup = this.activePopups[this.activePopups.length - 1];
      this.closePopup(topPopup);
    }
  }

  // Toggle the popup associated with the given button.
  togglePopup(button) {

    const popupId = button.getAttribute('aria-controls');
    if (!popupId) return;

    const popupElement = document.getElementById(popupId);

    if (!popupElement) return;

    // Determine if this popup should be treated as a child popup.
    const isChild = button.getAttribute('data-child-popup') === 'true';
    // If the popup is already open, close it; otherwise, open it.
    if (popupElement.getAttribute('aria-expanded') == 'true') {
      this.closePopup(popupElement);
    } else {
      this.openPopup(popupElement, isChild, button);
    }
  }

  // Open the popup element.
  // If it's not a child popup, close all currently open popups.
  openPopup(popupElement, isChild = false, triggerButton = null) {
    // Mark the popup element as a child (or not) for later checks.
    popupElement._isChild = isChild;

    // Ensure the popup is visible before starting any animations.
    popupElement.style.display = '';

    // If this is a parent popup, close any other open popups.
    if (!isChild) {
      while (this.activePopups.length) {
        this._closePopup(this.activePopups.pop());
      }
    }

    const openEvent = new CustomEvent(`popup:open`, {
      detail: { triggerButton }
    });

    popupElement.dispatchEvent(openEvent);

    popupElement.setAttribute('aria-hidden', 'false');
    popupElement.removeAttribute('inert');
    requestAnimationFrame(() => {
      popupElement.setAttribute('aria-expanded', 'true');
      if (typeof this.onPopupOpen === 'function') {
        this.onPopupOpen(popupElement);
      }
    });

    if (popupElement.id === 'escalation-popup') {
      window.escalationOpen = true;
    }

    // Store the scrollable element reference on the popup for later use.
    const focus = popupElement.querySelector('[data-scrollable]');

    if (focus) {
      popupElement._scrollableElement = focus;
      bodyScrollLock.disableBodyScroll(focus, bodyScrollLockOptions);
      IOSScrollLock.lock();
    } else {
      popupElement._scrollableElement = document.body;
      bodyScrollLock.disableBodyScroll(document.body, bodyScrollLockOptions);
      IOSScrollLock.lock();
    }

    trapFocus(popupElement);
    // If the popup specifies an overlay, find it, display it, and attach a click listener.
    const overlay = this.getOverlayElement(popupElement);
    if (overlay) {
      overlay.classList.add('is-visible');
      const handleOverlayClick = (e) => {
        e.preventDefault();
        this.closePopup(popupElement);
      };
      // Store the handler so it can be removed later.
      popupElement._overlayClickHandler = handleOverlayClick;
      overlay.addEventListener('click', handleOverlayClick);
    }

    // Push this popup onto the active stack.
    this.activePopups.push(popupElement);
  }

  // Close the popup element.
  closePopup(popupElement) {
    const index = this.activePopups.indexOf(popupElement);
    if (index !== -1) {
      // Save the scrollable element from the popup being closed.
      const closedScrollEl = popupElement._scrollableElement;
      this._closePopup(popupElement);
      this.activePopups.splice(index, 1);

      // If there is a new top popup, check for its scrollable element.
      if (this.activePopups.length > 0) {
        const topPopup = this.activePopups[this.activePopups.length - 1];
        if (topPopup._scrollableElement) {
          // Reapply the scroll lock to the new top popup's scrollable element.
          bodyScrollLock.disableBodyScroll(topPopup._scrollableElement, bodyScrollLockOptions);
          IOSScrollLock.lock();
        }
      } else {
        // No active popups remain; remove the scroll lock from the closed element.
        if (closedScrollEl) {
          bodyScrollLock.enableBodyScroll(closedScrollEl);
          IOSScrollLock.unlock();
        }
      }

      // Close open selectboxes in market selector popup
      if (popupElement.id === "modal-country") {
        popupElement.dispatchEvent(new CustomEvent('drawer:close-selectboxes', { bubbles: true }));
      }

      if (popupElement.id.includes("mobile-menu-popup-special")) {
        popupElement.dispatchEvent(new CustomEvent('drawer:close-special-menu', { bubbles: true }));
      }


      const closeEvent = new CustomEvent("popup:closed", {
        detail: {
          popup: popupElement
        }
      });
      popupElement.dispatchEvent(closeEvent);
    }
  }



  // Internal method to remove open styles and attributes from the popup,
  // then wait for the transition to finish before setting display: none.
  _closePopup(popupElement) {
    popupElement.setAttribute('aria-expanded', 'false');

    const overlay = this.getOverlayElement(popupElement);
    if (overlay) {
      // Only remove overlay if no other popups are still open
      // Check if there are remaining popups that also use this overlay
      const remainingPopupsWithSameOverlay = this.activePopups.filter(popup =>
        popup !== popupElement && this.getOverlayElement(popup) === overlay
      );

      if (remainingPopupsWithSameOverlay.length === 0) {
        overlay.classList.remove('is-visible');
      }

      if (popupElement._overlayClickHandler) {
        overlay.removeEventListener('click', popupElement._overlayClickHandler);
        delete popupElement._overlayClickHandler;
      }
    }

    removeTrapFocus(popupElement);

    // This function will be called once the CSS transition is complete.
    const onTransitionEnd = () => {
      popupElement.setAttribute('aria-hidden', 'true');
      popupElement.setAttribute('inert', '');

      // Important: Remove the listener to prevent it from firing again.
      popupElement.removeEventListener('transitionend', onTransitionEnd);
      if (popupElement.id === 'escalation-popup') {
        window.escalationOpen = false;
      }
      if (typeof this.onPopupClose === 'function') {
        this.onPopupClose(popupElement);
      }
    };

    // Listen for the end of the transition.
    popupElement.addEventListener('transitionend', onTransitionEnd);
  }

  // Method to handle the custom event "drawer:close-other".
  // It closes all currently open popups.
  handleDrawerCloseOther(event) {
    event.preventDefault();
    this.closeAllPopups();
  }

  // Method to close all open popups.
  closeAllPopups() {
    while (this.activePopups.length) {
      const popup = this.activePopups.pop();
      this._closePopup(popup);
    }
  }

  // Retrieve the overlay element based on the popup's data-overlay attribute.
  getOverlayElement(popupElement) {
    const overlayClass = popupElement.getAttribute('data-overlay');
    if (overlayClass) {
      return document.querySelector(`.${overlayClass}`);
    }
    return null;
  }
}

window.globalPopup = new Popup();

class RevolutionSwiper {
  constructor(element, additionalSwiper) {
    var options =
      arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    this.element = element;
    this.thumb = additionalSwiper;
    this.initialConfig = JSON.parse(
      element.getAttribute("data-swiper-settings")
    );

    if (additionalSwiper) {
      this.initialConfigThumbs = JSON.parse(
        additionalSwiper.getAttribute("data-swiper-thumb-settings")
      );
    }
    this.options = options;
    this.build();
  }

  selectCell(index) {
    this.swiperElement.slideTo(index);
  }

  resize() {
    this.swiperElement.resize();
  }

  build() {
    var _this = this,
      configThumb = this.initialConfigThumbs;
    if (configThumb != null) {
      this.thumbSwiper = new Swiper(this.thumb, configThumb);
      this.initialConfig.thumbs["swiper"] = this.thumbSwiper;
    }

    this.swiperElement = new Swiper(this.element, this.initialConfig);
    this.selectedIndex = this.swiperElement.activeIndex;

    this.swiperElement.on("slideChange", function () {

      _this.element.dispatchEvent(
        new CustomEvent("swiper:slide-changed", {
          bubbles: true,
          detail: {
            currentIndex: _this.swiperElement.activeIndex,
            element: _this.swiperElement.el[0],
          },
        })
      );
    });


  }
}
class RevolutionImageZoom {
  constructor(element, slideshow) {
    this.element = element;
    this.slideshow = slideshow;
    this.delegateElement = new Delegate(this.element);
    this.delegateRoot = new Delegate(document.body);
    loadScript(window.theme.pswpScript);
    this.syncHeight();
    this.bindEvents();
  }

  syncHeight() {
    document.documentElement.style.setProperty(
      "--window-inner-height",
      `${window.innerHeight}px`
    );
  }

  bindEvents() {
    window.addEventListener("resize", this.syncHeight());
    this.delegateElement.on(
      "click",
      '[data-action="open-product-zoom"]',
      this.initPhotoSwipe.bind(this)
    );

    this.delegateRoot.on(
      "pswpTap",
      ".pswp__button--close",
      this.photoswiperClose.bind(this)
    );

    this.onPointerUpBinder = this.onPointerUp.bind(this);
    this.onPointerDownBinder = this.onPointerDown.bind(this);
    responsive.addBreakpointListener("lap_and_up");
    this.delegateRoot.on(
      "breakpoint:lap_and_up",
      this.toggleMoveZoom.bind(this)
    );
    this.toggleMoveZoom();
  }

  toggleMoveZoom(e) {
    if (responsive.matchesBreakpoint("lap_and_up")) {
      this.delegateRoot.on(
        "pointerdown",
        "[data-move]",
        this.onPointerDownBinder
      );
      this.delegateRoot.on("pointerup", "[data-move]", this.onPointerUpBinder);
    } else {
      this.delegateRoot.off(
        "pointerdown",
        "[data-move]",
        this.onPointerDownBinder
      );
      this.delegateRoot.off("pointerup", "[data-move]", this.onPointerUpBinder);
    }
  }

  onPointerDown(e) {
    this.timeout = setTimeout(() => {
      e.target.closest(".pswp__container")?.classList.add("move");
    }, 150);
  }

  onPointerUp(e) {
    if (this.timeout) {
      clearInterval(this.timeout);
    }
    e.target.closest(".pswp__container")?.classList.remove("move");
  }

  photoswiperClose() {
    this.photoSwipeInstance.close;
    if (/iPhone|iPad|iPod/i.test(window.navigator.userAgent)) {
      document.documentElement.classList.remove("pswp-open-in-ios");
    }
  }

  initPhotoSwipe() {
    const mobileContainer = document.querySelector(".pswp__mobile-container");

    // Clear mobile container if needed
    if (mobileContainer) mobileContainer.innerHTML = "";

    let images = [],
      index = 0;

    if (this.slideshow) {
      this.slideshow.swiperElement.slides.forEach(function (item) {
        if (item.classList.contains("ProductSliderCell--Zoom")) {
          const img = item.querySelector("img");
          if (img) {
            images.push(img);

            // Clone for mobile
            const imgClone = img.cloneNode(true);
            imgClone.style.width = "100%";
            imgClone.style.marginBottom = "1rem";
            if (mobileContainer) mobileContainer.appendChild(imgClone);
          }
        }
      });

      // Determine index
      index = this.slideshow.swiperElement.realIndex;
      const currentSlide = this.slideshow.swiperElement.slides[index];
      if (currentSlide) {
        const pos = currentSlide.querySelector(".ProductSlider--Element")?.getAttribute("data-image-position");
        if (pos !== null) index = pos;
      }
    } else {
      const img = document.querySelector(".ProductSlider--Image");
      if (img) {
        images.push(img);

        // Clone for mobile
        const imgClone = img.cloneNode(true);
        imgClone.style.width = "100%";
        if (mobileContainer) mobileContainer.appendChild(imgClone);
      }
    }

    // Always init PhotoSwipe (will just not be visible on mobile)
    this.createPhotoSwipeInstance(
      this.createPhotoSwipeItemsFromImages(images),
      parseInt(index)
    );
  }



  createPhotoSwipeItemsFromImages(images) {
    return images.map((image) => {
      const fullWidth = parseInt(image.getAttribute("data-max-width"));

      // Check if it's mobile or desktop
      const breakpoint = responsive.getCurrentBreakpoint();
      const isMobile = breakpoint === 'pocket' || breakpoint === 'phone';

      // Use different sizes but maintain 1:1 aspect ratio
      const targetDisplaySize = isMobile ? 328 : 541;
      const displaySize = isMobile ? 328 : 541;

      // Compute zoom level so the image displays at the target size initially
      const initialZoomLevel = targetDisplaySize / fullWidth;

      return {
        msrc: image.currentSrc || image.src,
        w: displaySize,
        h: displaySize,
        initialZoomLevel: initialZoomLevel,
        initZoomLevel: initialZoomLevel,
        src: image.dataset.originalSrc,
      };
    });
  }

  createPhotoSwipeInstance(items, selectedImageIndex) {
    var _this = this;
    var photoswipeContainer = document.querySelector(".pswp");
    this.photoSwipeInstance = new PhotoSwipe(
      photoswipeContainer,
      false,
      items,
      {
        index: selectedImageIndex,
        showHideOpacity: true,
        showAnimationDuration: 500,
        loop: false,
        history: false,
        closeOnVerticalDrag: true,
        allowPanToNext: false,
        pinchToClose: false,
        errorMsg: '<p class="pswp__error-msg"></p>',
        scaleMode: "orig",
        getDoubleTapZoom: function getDoubleTapZoom(isMouseClick, item) {
          if (isMouseClick) {
            return 1.35;
          } else {
            return item.initialZoomLevel < 0.7 ? 1 : 1.33;
          }
        },
        getThumbBoundsFn: function getThumbBoundsFn(index) {
          var allThumbnail = _this.element.querySelectorAll(
            ".mainSwiper .ProductSliderCell--Zoom img"
          ),
            thumbnail = allThumbnail[index],
            pageYScroll =
              window.pageYOffset || document.documentElement.scrollTop,
            rect = thumbnail.getBoundingClientRect();
          return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
        },
      }
    );

    this.delegateRoot.on("slide:change", (e) => {
      this.photoSwipeInstance.goTo(e.detail)
    });

    this.photoSwipeInstance.listen(
      "beforeChange",
      this.onslideChanged.bind(this)
    );

    this.photoSwipeInstance.listen(
      "destroy",
      this.destroyPhotoSwipe.bind(this)
    );
    this.photoSwipeInstance.listen("doubleTap", this.onDoubleTap.bind(this));
    this.photoSwipeInstance.listen(
      "initialZoomIn",
      this.onInitialZoomIn.bind(this)
    );
    this.photoSwipeInstance.listen(
      "initialZoomOut",
      this.onInitialZoomOut.bind(this)
    );

    this.delegateRoot.on(
      "pswpTap",
      ".pswp__scroll-wrap",
      this.onSingleTap.bind(this)
    );
    this.delegateRoot.on(
      "pswpTap",
      ".pswp__button--close",
      this.photoSwipeInstance.close
    );
    this.delegateRoot.on(
      "pswpTap",
      ".pswp__button--prev",
      this.photoSwipeInstance.prev
    );
    this.delegateRoot.on(
      "pswpTap",
      ".pswp__button--next",
      this.photoSwipeInstance.next
    );

    this.photoSwipeInstance.listen("close", this.photoswiperClose.bind(this));
    if (/iPhone|iPad|iPod/i.test(window.navigator.userAgent)) {
      document.documentElement.classList.add("pswp-open-in-ios");
    }
    this.photoSwipeInstance.init();
  }


  onslideChanged() {
    const currentIndex = this.photoSwipeInstance.getCurrentIndex() + 1;
    const totalSlides = this.photoSwipeInstance.options.getNumItemsFn();

    // Update our new element
    const counterEl = document.querySelector(".pswp__slide-info");
    if (counterEl) {
      counterEl.textContent = `${currentIndex} / ${totalSlides}`;
    }
  }

  onSingleTap(event) {
    if (!event.detail || event.detail.pointerType === "mouse") {
      if (event.target.classList.contains("pswp__img")) {
        this.photoSwipeInstance.toggleDesktopZoom(event.detail.releasePoint);
      }
    } else {
      if (event.target.classList.contains("pswp__button")) {
        return;
      }

      event.target
        .closest(".pswp")
        .querySelector(".pswp__ui")
        .classList.toggle("pswp__ui--hidden");
    }
  }

  onDoubleTap(point) {
    var initialZoomLevel = this.photoSwipeInstance.currItem.initialZoomLevel;

    if (this.photoSwipeInstance.getZoomLevel() !== initialZoomLevel) {
      this.photoSwipeInstance.zoomTo(initialZoomLevel, point, 333);
    } else {
      this.photoSwipeInstance.zoomTo(
        initialZoomLevel < 0.7 ? 1 : 1.33,
        point,
        333
      );
    }
  }

  onInitialZoomIn() {
    document.querySelector(".pswp__ui").classList.remove("pswp__ui--hidden");

    const currentIndex = this.photoSwipeInstance.getCurrentIndex() + 1;
    const totalSlides = this.photoSwipeInstance.options.getNumItemsFn();

    const counterEl = document.querySelector(".pswp__slide-info");
    if (counterEl) {
      counterEl.textContent = `${currentIndex} / ${totalSlides}`;
    }
  }

  onInitialZoomOut() {
    document.querySelector(".pswp__ui").classList.add("pswp__ui--hidden");
  }

  destroyPhotoSwipe() {
    this.delegateRoot.off("pswpTap");
    this.photoSwipeInstance = null;
  }
}

class RevolutionSelectbox {
  // -------------------------------------------------------------------
  // Static registry + helpers
  // -------------------------------------------------------------------
  static instances = new Set();

  /** Close every instance, regardless of open/closed state. */
  static closeAll() {
    for (let inst of RevolutionSelectbox.instances) {
      inst.closeDropdown(inst.mainButton);
    }
  }

  /**
   * Close all instances except the one passed in.
   * Useful before opening a specific instance.
   */
  static closeAllExcept(current) {
    for (let inst of RevolutionSelectbox.instances) {
      if (inst !== current) {
        inst.closeDropdown(inst.mainButton);
      }
    }
  }

  // -------------------------------------------------------------------
  // Constructor & lifecycle
  // -------------------------------------------------------------------
  constructor(element, popover = false, additionalOverlay = false) {
    this.wrapper = element;  // the root DOM node
    this.popover = popover;
    this.changeOverlay = additionalOverlay;
    this.domDelegate = new Delegate(this.wrapper);
    this.delegateBody = new Delegate(document.body);
    this.isAnimating = false;
    this.isOpen = false;

    // global close events
    this.delegateBody.on('drawer:close-other', this.closeDropdown.bind(this));
    this.delegateBody.on('drawer:close-selectboxes', () => RevolutionSelectbox.closeAll());
    this.delegateBody.on('menu:open', this.closeDropdown.bind(this));
    window.addEventListener('click', this.onClickOutside.bind(this));

    this.mainButton = this.wrapper.querySelector('.RevolutionSelectbox--Button');
    this.contentWrapper = this.wrapper.querySelector('.RevolutionSelectbox--Content');

    if (this.popover) {
      this.contentWrapper.classList.replace(
        'RevolutionSelectbox--animation',
        'PopoverContent'
      );
      this.pageOverlayElement = document.querySelector(
        this.changeOverlay ? '.localizationOverlay' : '.pageOverlay'
      );
    }

    this.bindEvents();

    if (!this.wrapper.classList.contains('dropdownSelector')) {
      this.initSelectbox();
    } else {
      this.wrapper.style.display = 'block';
    }

    // register instance
    RevolutionSelectbox.instances.add(this);
  }

  /** Call when removing the widget from DOM to avoid memory leaks */
  destroy() {
    RevolutionSelectbox.instances.delete(this);
    // unbind any other listeners here…
  }

  // -------------------------------------------------------------------
  // Event binding & init
  // -------------------------------------------------------------------
  bindEvents() {
    this.domDelegate.on(
      'click',
      '[data-action=toggle-selectbox]',
      this.toggleDropdown.bind(this)
    );
    this.domDelegate.on(
      'click',
      '[data-action=selectbox-change]',
      this.selectboxChange.bind(this)
    );
    this.domDelegate.on(
      'click',
      '[data-action=selectbox-submit]',
      this.selectboxSubmit.bind(this)
    );
    this.domDelegate.on(
      'keypress',
      '[data-action=selectbox-submit]',
      this.selectboxSubmit.bind(this)
    );
  }

  initSelectbox() {
    let selectedItem = this.wrapper.querySelector('.RevolutionSelectbox--Item[selected]');
    const hiddenSelect = this.wrapper.querySelector('select.selectboxInputs');
    const titleElem = this.wrapper.querySelector('.RevolutionSelectbox--Title');
    const titleCountryElem = titleElem?.querySelector('.RevolutionSelectbox--Title--country');
    const titleCurrencyElem = titleElem?.querySelector('.RevolutionSelectbox--Title--currency');

    // Fallback: if no button has [selected] but hidden select has a value, mark matching button.
    if (!selectedItem && hiddenSelect?.value) {
      selectedItem = this.wrapper.querySelector(
        `.RevolutionSelectbox--Item[data-value="${CSS.escape(hiddenSelect.value)}"]`
      );
      if (selectedItem && !selectedItem.hasAttribute('selected')) {
        selectedItem.setAttribute('selected', 'selected');
        selectedItem.setAttribute('disabled', 'true');
      }
    }

    // If still no selected item (edge case), choose first button.
    if (!selectedItem) {
      selectedItem = this.wrapper.querySelector('.RevolutionSelectbox--Item');
      if (selectedItem) {
        selectedItem.setAttribute('selected', 'selected');
        selectedItem.setAttribute('disabled', 'true');
      }
    }

    // Update composite title (used for country + currency variant only)
    if (selectedItem && titleCountryElem && titleCurrencyElem) {
      if (selectedItem.dataset.name) {
        titleCountryElem.textContent = selectedItem.getAttribute('data-name');
      }
      if (selectedItem.dataset.currency) {
        titleCurrencyElem.textContent = selectedItem.getAttribute('data-currency');
      }
    } else if (selectedItem && titleElem && !titleCountryElem) {
      // Generic title update for language or simple selectboxes
      titleElem.innerHTML = selectedItem.innerHTML;
    }

    this.wrapper.style.display = 'flex';
  }

  // -------------------------------------------------------------------
  // Dropdown open/close
  // -------------------------------------------------------------------
  toggleDropdown(event) {
    event.preventDefault();
    if (this.isAnimating) return;
    this.isOpen
      ? this.closeDropdown(event.currentTarget)
      : this.openDropdown(event.currentTarget);
  }

  openDropdown() {
    this.isAnimating = true;
    RevolutionSelectbox.closeAllExcept(this);

    const button = this.wrapper.querySelector('.RevolutionSelectbox--Button');
    const content = this.wrapper.querySelector('.RevolutionSelectbox--Content');
    if (!content) return;

    // ARIA
    button.setAttribute('aria-expanded', 'true');
    content.setAttribute('aria-hidden', 'false');

    // bubble up to close any other UI
    this.wrapper.dispatchEvent(new CustomEvent('close:search', { bubbles: true }));

    if (this.changeOverlay) {
      const scrollable = this.wrapper.querySelector('[data-scrollable]');
      bodyScrollLock.disableBodyScroll(scrollable, bodyScrollLockOptions);
    }

    if (this.popover) {
      this.pageOverlayElement.classList.add('is-visible');
      document.querySelector('.header-overlay')?.classList.add('is-visible');
      this.pageOverlayElement.addEventListener('click', this.onClickOutside.bind(this));
      trapFocus(button);
    }

    // Prepare height animation
    content.classList.add('rs-animating');
    content.style.display = 'block';
    content.style.height = '0px';
    // Force reflow before measuring full height
    void content.offsetHeight;
    const targetHeight = content.scrollHeight;
    content.style.height = targetHeight + 'px';
    content.classList.add('rs-open');

    trapFocus(this.wrapper);

    const cleanup = () => {
      content.style.height = '';
      content.classList.remove('rs-animating');
      content.removeEventListener('transitionend', onEnd);
      this.isAnimating = false;
    };

    const onEnd = (e) => {
      if (e.propertyName !== 'height') return; // wait for height transition
      cleanup();
    };
    content.addEventListener('transitionend', onEnd);

    setTimeout(cleanup, 600); // safety fallback

    this.isOpen = true;
  }

  closeDropdown() {
    if (!this.isOpen || this.isAnimating) return;
    this.isAnimating = true;

    const button = this.wrapper.querySelector('.RevolutionSelectbox--Button');
    const content = this.wrapper.querySelector('.RevolutionSelectbox--Content');
    if (!content) return;

    if (this.changeOverlay) {
      const scrollable = this.wrapper.querySelector('[data-scrollable]');
      bodyScrollLock.enableBodyScroll(scrollable, bodyScrollLockOptions);
    }

    // ARIA
    button.setAttribute('aria-expanded', 'false');
    content.setAttribute('aria-hidden', 'true');

    if (this.popover) {
      this.pageOverlayElement.classList.remove('is-visible');
      document.querySelector('.header-overlay')?.classList.remove('is-visible');
      this.pageOverlayElement.removeEventListener('click', this.onClickOutside.bind(this));
    }

    // Prepare current height then animate to 0
    content.classList.add('rs-animating');
    const startHeight = content.scrollHeight;
    content.style.height = startHeight + 'px';
    // Force reflow to ensure browser registers starting height
    void content.offsetHeight;
    // Start animation
    content.style.height = '0px';
    content.classList.remove('rs-open');

    const cleanup = () => {
      content.style.display = 'none';
      content.style.height = '';
      content.classList.remove('rs-animating');
      removeTrapFocus(this.wrapper);
      this.isAnimating = false;
      this.isOpen = false;
      content.removeEventListener('transitionend', onEnd);
    };

    const onEnd = (e) => {
      if (e.propertyName !== 'height') return;
      cleanup();
    };
    content.addEventListener('transitionend', onEnd);

    setTimeout(cleanup, 600); // safety fallback
  }

  // -------------------------------------------------------------------
  // Selection logic
  // -------------------------------------------------------------------
  selectboxChange(event) {
    const buttonEl = event.target.closest('.RevolutionSelectbox--Item');
    if (!buttonEl) return;
    const optionId = buttonEl.getAttribute('data-selectboxid');
    const optionEl = optionId ? this.wrapper.querySelector('#' + optionId) : null; // OPTION element if present
    const hiddenSelect = this.wrapper.querySelector('select.selectboxInputs');

    // Determine new value: if mapped to <option> use option.value else data-value
    let newValue = buttonEl.getAttribute('data-value');
    if (optionEl && optionEl.tagName === 'OPTION') {
      newValue = optionEl.value;
    }

    // Update buttons selection state
    const prevBtn = this.wrapper.querySelector('.RevolutionSelectbox--Item[selected]');
    prevBtn?.removeAttribute('selected');
    prevBtn?.removeAttribute('disabled');
    buttonEl.setAttribute('selected', 'selected');
    buttonEl.setAttribute('disabled', 'true');

    // Sync hidden select
    if (hiddenSelect) {
      if (optionEl) {
        // Clear previous selected in options
        [...hiddenSelect.options].forEach(o => o.selected = false);
        optionEl.selected = true;
      }
      hiddenSelect.value = newValue;
      hiddenSelect.dispatchEvent(new Event('change'));
    }

    // Update title
    const titleContainer = this.mainButton.querySelector('.RevolutionSelectbox--Title');
    if (titleContainer) titleContainer.innerHTML = buttonEl.innerHTML;

    // Generic change event for non-country selectboxes if needed
    this.wrapper.dispatchEvent(new CustomEvent('selectbox:change', { bubbles: true }));

    // Country specific event (wrapper marked with data-select="country_code")
    if (this.wrapper.dataset.select === 'country_code' && optionEl) {
      this.wrapper.dispatchEvent(new CustomEvent('change:countrySelector', {
        bubbles: true,
        detail: {
          country: optionEl.value,
          currency: optionEl.getAttribute('data-currency') || null,
          languages: optionEl.getAttribute('data-languages') || '[]'
        }
      }));
    }

    this.closeDropdown(this.mainButton);
  }

  selectboxSubmit(event) {
    if (event.key && event.key !== 'Enter') return;
    const item = event.target.closest('[data-value]');
    const value = item.getAttribute('data-value');
    const dataName = item.getAttribute('data-name');

    this.selectbox.value = value;
    this.closeDropdown(this.mainButton);
    this.mainButton.querySelector('.RevolutionSelectbox--Title').innerHTML = dataName;
    this.selectbox.parentElement.submit();
  }

  onClickOutside(event) {
    if (
      !this.wrapper.contains(event.target) ||
      event.target.classList.contains('FiltersDesktopWrapper')
    ) {
      this.closeDropdown(this.mainButton);
    }
  }
}

class Form {
  constructor() { }

  serialize(form) {
    function stringKey(key, value) {
      var beginBracket = key.lastIndexOf("[");

      if (beginBracket === -1) {
        var _hash = {};
        _hash[key] = value;
        return _hash;
      }

      var newKey = key.substr(0, beginBracket);
      var newValue = {};

      newValue[key.substring(beginBracket + 1, key.length - 1)] = value;

      return stringKey(newKey, newValue);
    }

    var hash = {};

    for (var i = 0, len = form.elements.length; i < len; i++) {
      var formElement = form.elements[i];

      if (formElement.name === "" || formElement.disabled) {
        continue;
      }

      if (
        formElement.name &&
        !formElement.disabled &&
        (formElement.checked ||
          /select|textarea/i.test(formElement.nodeName) ||
          /hidden|text|search|tel|url|email|password|datetime|date|month|week|time|datetime-local|number|range|color/i.test(
            formElement.type
          ))
      ) {
        var stringKeys = stringKey(formElement.name, formElement.value);
        hash = this.extend(hash, stringKeys);
      }
    }

    return hash;
  }
  extend() {
    var extended = {},
      i = 0,
      _this = this;

    // Merge the object into the extended object
    var merge = function merge(obj) {
      for (var prop in obj) {
        if (obj.hasOwnProperty(prop)) {
          // If property is an object, merge properties
          if (Object.prototype.toString.call(obj[prop]) === "[object Object]") {
            extended[prop] = _this.extend(extended[prop], obj[prop]);
          } else {
            extended[prop] = obj[prop];
          }
        }
      }
    };

    // Loop through each object and conduct a merge
    for (; i < arguments.length; i++) {
      merge(arguments[i]);
    }

    return extended;
  }
}

class AddToCart {
  constructor(element) {
    this.element = element;
    this.delegateElement = new Delegate(this.element);
    this.pageLoader = document.body.querySelector(".pageLoader");
    this.bindEvents();
  }


  bindEvents() {
    this.delegateElement.on(
      "click",
      "[data-action=add-to-cart]",
      this.addToCart.bind(this)
    );

    this.delegateElement.on(
      "click",
      "[data-action=delivery-add-to-cart]",
      this.addToCartDelivery.bind(this)
    );

    this.delegateElement.on(
      "click",
      "[data-action=delivery-change-cart]",
      this.updateCartDelivery.bind(this)
    );




  }


  async updateCartDelivery(event) {
    if (event) {
      event.preventDefault();
    }

    this.eventButton = event.target;
    this.popupEl = event.target.closest('delivery-popup');
    this.formEl = this.popupEl.querySelector('form');

    try {
      const popupData = this._extractPopupData();
      const shippingData = this._extractShippingFormData();

      if (!this._validateCartData(popupData, shippingData)) {
        return;
      }

      const groupId = this._getDeliveryGroupId();
      if (!groupId) {
        console.error('Cannot update cart: No delivery group ID found');
        return;
      }

      // Simple approach: Always remove old items and add new ones
      await this._replaceDeliveryGroup(groupId, popupData, shippingData);
      this._closePopupAndRefresh();

    } catch (error) {
      console.error('Error updating cart:', error);

      // Extract error message from API response or use fallback
      const errorMessage = this._extractErrorMessage(
        error,
        'sections.cart.cart_update_error',
        'Failed to update cart. Please try again.'
      );

      // Show toast notification for cart update errors
      if (typeof toastNotifications !== 'undefined' && toastNotifications) {
        toastNotifications.error(errorMessage);
      }

      // Re-enable the button that triggered the update
      if (this.eventButton) {
        this.eventButton.removeAttribute('disabled');
      }
    }
  }

  // SIMPLE: Always remove old, add new (most reliable)
  async _replaceDeliveryGroup(groupId, popupData, shippingData) {
    // Step 1: Get current cart
    const cart = await this._fetchCurrentCart();
    if (!cart) {
      throw new Error('Failed to fetch current cart');
    }

    if (!cart.items || !Array.isArray(cart.items)) {
      console.error('Cart structure invalid:', cart);
      throw new Error('Cart items not found or invalid');
    }

    // Step 2: Find items to remove
    const itemsToRemove = cart.items.filter(item =>
      item.properties && item.properties._delivery_group_id === groupId
    );

    // Step 3: Remove old items
    if (itemsToRemove.length > 0) {
      const removeUpdates = {};
      itemsToRemove.forEach(item => {
        removeUpdates[item.key] = 0; // Set quantity to 0 = remove
      });

      const removeResponse = await window.apiService.post('/cart/update.js', { updates: removeUpdates });
    }

    // Step 4: Add new items
    const newItems = this._prepareCartItems(popupData, shippingData, groupId);

    if (newItems.length > 0) {
      const addResponse = await window.apiService.post('/cart/add.js', { items: newItems }, {
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      }
      );
    }
  }


  async addToCartDelivery() {
    if (event) {
      event.preventDefault();
    }

    this.popupEl = event.target.closest('delivery-popup');
    this.formEl = this.popupEl.querySelector('form');

    try {
      const popupData = this._extractPopupData();
      const shippingData = this._extractShippingFormData();

      if (!this._validateCartData(popupData, shippingData)) {
        console.warn('[AddToCartDelivery] Validation failed:', { popupData, shippingData });
        return;
      }

      // SIMPLE: Save shipping data to localStorage before adding to cart
      try {
        localStorage.setItem('delivery_shipping_data', JSON.stringify(shippingData));
      } catch (error) {
        console.warn('[AddToCartDelivery] Failed to save to localStorage:', error);
      }

      const groupId = this._generateGroupId();
      const cartItems = this._prepareCartItems(popupData, shippingData, groupId);
      const result = await this._addItemsToShopifyCart(cartItems);

      // After successful add to cart, use smart navigation
      this._closePopupAndRefresh();
    } catch (error) {
      console.error('An unexpected error occurred in addToCartDelivery:', error);

      // Extract error message from API response or use fallback
      const errorMessage = this._extractErrorMessage(
        error,
        'sections.cart.add_to_cart_error',
        'Failed to add items to cart. Please try again.'
      );

      // Show toast notification for delivery add to cart errors
      if (typeof toastNotifications !== 'undefined' && toastNotifications) {
        toastNotifications.error(errorMessage);
      }

      // Re-enable any disabled buttons
      const buttons = this.popupEl.querySelectorAll('button[disabled]');
      buttons.forEach(button => button.removeAttribute('disabled'));
    }
  }

  _closePopupAndRefresh() {
    // Close the popup first
    if (this.popupEl && window.globalPopup && typeof window.globalPopup.closePopup === 'function') {
      window.globalPopup.closePopup(this.popupEl);
    } else if (window.globalPopup && typeof window.globalPopup.closeAllPopups === 'function') {
      window.globalPopup.closeAllPopups();
    } else {
      console.warn('No popup close method available');
    }

    // Wait for popup close animation (300ms) before refreshing
    setTimeout(() => {
      // Smart navigation based on current location
      const isOnCartPage = window.location.href.indexOf('cart') !== -1;

      if (isOnCartPage) {
        // Already on cart page - just refresh cart content
        const cartElement = document.querySelector('cart-items');
        if (cartElement && typeof cartElement.refreshAfterUpdate === 'function') {
          cartElement.refreshAfterUpdate(true);
        } else {
          location.reload();
        }
      } else {
        // Not on cart page - navigate to cart

        // Follow same pattern as regular addToCart - respect theme cart mode
        if (window.theme && window.theme.cartMode === 'page') {
          window.location.href = window.routes.cart_page_url || '/cart';
        } else {
          // If cart mode is drawer or other, still navigate to cart page for delivery items
          // since delivery groups need full cart page functionality
          window.location.href = window.routes.cart_page_url || '/cart';
        }
      }
    }, 400); // Wait for close animation to complete
  }

  // Keep the existing _fetchCurrentCart method
  async _fetchCurrentCart() {
    try {
      const response = await window.apiService.get('/cart.js');
      // Parse JSON if it's a string
      const cart = typeof response === 'string' ? JSON.parse(response) : response;
      return cart;
    } catch (error) {
      console.error('Error fetching cart:', error);
      return null;
    }
  }


  _getDeliveryGroupId() {
    // Get group ID from popup dataset (stored during edit restoration)
    if (this.popupEl.dataset.editGroup) {
      return this.popupEl.dataset.editGroup;
    }

    console.warn('No delivery group ID found in popup dataset');
    return null;
  }

  async addToCart() {
    var _this = this;
    event.preventDefault();
    var addToCartButton = event.target;
    this.pageLoader.style.width = 100 + "%";
    addToCartButton.setAttribute("disabled", "disabled");
    var formElement = event.target.closest("form");
    formElement.querySelector('[name="id"]').removeAttribute("disabled");
    var formHelper = new Form();
    const serialized = formHelper.serialize(formElement);

    // Check and remove any exchange products before adding new non-exchange items
    const variantId = serialized.id;
    if (variantId && !this._isExchangeProduct(variantId)) {
      await this._removeExchangeProducts();
    }

    try {
      const result = await window.apiService.post("/cart/add.js", serialized, {
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      });

      if (window.theme.cartMode === 'page') {
        location.href = window.routes.cart_page_url;
      }
      if (window.location.href.indexOf("cart") != -1) {
        const cartElement = document.querySelector('cart-items');
        if (cartElement && typeof cartElement.refreshAfterUpdate === 'function') {
          cartElement.refreshAfterUpdate(true);
        } else {
          location.reload();
        }
        return;
      }
      addToCartButton.removeAttribute("disabled");
      _this.element.dispatchEvent(
        new CustomEvent("product:added", {
          bubbles: true,
          detail: {
            variant: serialized.id,
            quantity: serialized.quantity,
          },
        })
      );
    } catch (error) {
      console.error('Add to cart error:', error);

      // Extract error message from API response or use fallback
      const errorMessage = this._extractErrorMessage(
        error,
        'sections.cart.add_to_cart_error',
        'Failed to add item to cart. Please try again.'
      );

      // Show toast notification for add to cart errors
      if (typeof toastNotifications !== 'undefined' && toastNotifications) {
        toastNotifications.error(errorMessage);
      }

      // Keep existing fallback error display for forms without toast support
      if (_this.element.querySelector(".ProductForm--Error")) {
        _this.element
          .querySelector(".ProductForm--Error")
          .classList.add("visible");
        setTimeout(function () {
          _this.element
            .querySelector(".ProductForm--Error")
            .classList.remove("visible");
        }, 2500);
      } else {
        // Also show inline error as backup
        var errorMessageElement = document.createElement("span");
        errorMessageElement.className = "u-p4 accent";
        errorMessageElement.innerHTML = errorMessage;
        addToCartButton.insertAdjacentElement(
          "afterend",
          errorMessageElement
        );
        setTimeout(function () {
          errorMessageElement.remove();
        }, 2500);
      }

      // Reset UI state
      addToCartButton.removeAttribute("disabled");
      _this.pageLoader.style.left = "unset";
      _this.pageLoader.style.right = 0 + "px";
      _this.pageLoader.style.width = 0 + "%";
      setTimeout(() => {
        _this.pageLoader.style.left = 0 + "px";
        _this.pageLoader.style.right = "unset";
      }, 550);
    }
  }

  _extractPopupData() {
    try {
      const dataset = this.popupEl.dataset;
      return {
        choices: JSON.parse(dataset.choices || '{}'),
        finalPrices: JSON.parse(dataset.finalPrices || '{}'),
        packAll: dataset.packAll === 'true',
        originalQuantity: parseInt(dataset.originalQuantity, 10) || 1,
        variantId: dataset.variantId,
        isGiftbox: dataset.isGiftbox === 'true',
        collectionHandle: dataset.collectionHandle || '',
        isMoviesOnly: dataset.isMoviesOnly === 'true',
        isMoviesWithSnacks: dataset.isMoviesWithSnacks === 'true'
        // The combined 'quantity' property is removed to make logic clearer.
      };
    } catch (error) {
      console.error('Error parsing data from popup attributes:', error);
      return {};
    }
  }

  _extractShippingFormData() {
    return {
      recipient_first_name: this.formEl.querySelector('#recipient_first_name')?.value?.trim() || '',
      recipient_last_name: this.formEl.querySelector('#recipient_last_name')?.value?.trim() || '',
      recipient_name: this.formEl.querySelector('#recipient_name')?.value?.trim() || '',
      recipient_email: this.formEl.querySelector('#recipient_email')?.value?.trim() || '',
      recipient_address: this.formEl.querySelector('#recipient_address')?.value?.trim() || '',
      recipient_city: this.formEl.querySelector('#recipient_city')?.value?.trim() || '',
      recipient_zip: this.formEl.querySelector('#recipient_zip')?.value?.trim() || '',
      greeting_message: this.formEl.querySelector('#greeting_message')?.value?.trim() || '',
      schedule_delivery: this.formEl.querySelector('#schedule_delivery')?.checked || false,
      delivery_datetime: this.formEl.querySelector('#delivery_datetime')?.value?.trim() || ''
    };
  }

  _validateCartData(popupData, shippingData) {
    const errors = [];
    const deliveryType = popupData.choices?.delivery_type;
    const deliveryPerson = popupData.choices?.delivery_person;

    // Dynamically set required fields based on delivery type
    let requiredFields = [];
    if (deliveryType === 'voucher') {
      // For voucher to gift_receiver, require first and last name
      if (deliveryPerson === 'gift_receiver') {
        requiredFields.push('recipient_first_name', 'recipient_last_name');
      }
      // Email is optional for voucher
    } else if (deliveryType === 'giftbox') {
      requiredFields = ['recipient_address', 'recipient_city', 'recipient_zip'];
      // For giftbox, check if we have either combined name or first+last name
      const hasRecipientName = shippingData.recipient_name?.trim();
      const hasFirstLastName = shippingData.recipient_first_name?.trim() && shippingData.recipient_last_name?.trim();
      if (!hasRecipientName && !hasFirstLastName) {
        errors.push('Recipient name is required (either full name or first and last name).');
      }
      // Email is optional for giftbox
    }
    // Email is always optional - no fallback requirement

    for (const field of requiredFields) {
      if (!shippingData[field]) {
        const friendlyName = field.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
        errors.push(`${friendlyName} is a required field.`);
      }
    }

    // Only validate email format if one is provided
    if (shippingData.recipient_email && shippingData.recipient_email.trim() && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(shippingData.recipient_email)) {
      errors.push('Please enter a valid email address.');
    }

    // Validate schedule delivery
    if (shippingData.schedule_delivery && !shippingData.delivery_datetime) {
      errors.push('Please select a delivery date and time.');
    }

    if (shippingData.schedule_delivery && shippingData.delivery_datetime) {
      const deliveryDate = new Date(shippingData.delivery_datetime);
      const now = new Date();
      if (deliveryDate <= now) {
        errors.push('Delivery date and time must be in the future.');
      }
    }

    if (errors.length > 0) {
      return false;
    }
    return true;
  }

  _prepareCartItems(popupData, shippingData, groupId) {
    const items = [];

    const mainProductQuantity = popupData.originalQuantity;
    const accessoryQuantity = popupData.packAll ? 1 : popupData.originalQuantity;

    // 1. Main Product Item
    // Prepare recipient data
    const recipientFirstName = shippingData.recipient_first_name?.trim();
    const recipientLastName = shippingData.recipient_last_name?.trim();
    const recipientName = shippingData.recipient_name?.trim();
    const recipientEmail = shippingData.recipient_email?.trim();
    const recipientAddress = shippingData.recipient_address?.trim();
    const recipientCity = shippingData.recipient_city?.trim();
    const recipientZip = shippingData.recipient_zip?.trim();
    const deliveryDatetime = shippingData.delivery_datetime?.trim();
    const deliveryPerson = popupData.choices.delivery_person;

    // Determine the full recipient name for display and storage
    let fullRecipientName = recipientName;
    if (!fullRecipientName && recipientFirstName && recipientLastName) {
      fullRecipientName = `${recipientFirstName} ${recipientLastName}`;
    } else if (!fullRecipientName && recipientFirstName) {
      fullRecipientName = recipientFirstName;
    }

    // Prepare properties object
    const properties = {
      '_delivery_group_id': groupId,
      '_delivery_type': popupData.choices.delivery_type || 'unknown',
      '_delivery_person': deliveryPerson || 'unknown',
      '_pack_all': popupData.packAll.toString(),
      'Delivery Type': this._getDeliveryTypeDisplay(popupData.choices.delivery_type)
    };

    // Add _giftbox property if this is a giftbox product
    if (popupData.isGiftbox) {
      properties['_giftbox'] = 'true';
    }

    // Add collection handle if present
    if (popupData.collectionHandle) {
      properties['_giftbox_collection'] = popupData.collectionHandle;
    }

    // Add cinema type properties if product has cinema tags
    if (popupData.isMoviesOnly) {
      properties['_movies_only'] = 'true';
    }
    if (popupData.isMoviesWithSnacks) {
      properties['_movies_with_snacks'] = 'true';
    }

    // Add _person_name when delivery is for another person (gift_receiver)
    if (deliveryPerson === 'gift_receiver' && fullRecipientName) {
      properties['_person_name'] = fullRecipientName;
    }

    // Add recipient info only if present
    if (fullRecipientName) properties['_recipient_name'] = fullRecipientName;
    if (recipientEmail) properties['_recipient_email'] = recipientEmail;
    if (recipientAddress) properties['_recipient_address'] = recipientAddress;
    if (recipientCity) properties['_recipient_city'] = recipientCity;
    if (recipientZip) properties['_recipient_zip'] = recipientZip;

    // Add full address only if we have all components
    if (recipientAddress && recipientCity && recipientZip) {
      properties['_recipient_full_address'] = `${recipientAddress}, ${recipientCity} ${recipientZip}`;
    }

    // Add schedule info only if scheduled
    if (shippingData.schedule_delivery) {
      properties['_scheduled_delivery'] = true;
      if (deliveryDatetime) {
        properties['_scheduled_date'] = deliveryDatetime;
      }
    }

    const mainItem = {
      id: popupData.variantId,
      quantity: mainProductQuantity,
      properties: properties
    };

    // Add greeting message to main item if present and no giftbox is selected
    const hasGiftbox = popupData.choices.giftbox_variant;
    if (shippingData.greeting_message && !hasGiftbox) {
      mainItem.properties['Greeting'] = shippingData.greeting_message.trim();
    }

    items.push(mainItem);

    // 2. Gift Box Item (if selected)
    if (hasGiftbox) {
      const greetingMessage = shippingData.greeting_message?.trim();

      const giftboxItem = {
        id: popupData.choices.giftbox_variant,
        quantity: accessoryQuantity,
        properties: {
          '_delivery_group_id': groupId,
          '_item_type': 'giftbox'
        }
      };

      // Add properties in desired order
      if (greetingMessage) {
        giftboxItem.properties['Greeting'] = greetingMessage;
      }

      items.push(giftboxItem);
    }

    // Note: Bows are now variants of giftboxes, not separate items
    // The bow selection is reflected in the giftbox_variant ID

    return items;
  }

  _generateGroupId() {
    return `delivery_${Date.now()}_${Math.random().toString(36).substring(2, 9)}`;
  }

  _getDeliveryTypeDisplay(deliveryType) {
    const displayNames = {
      'giftbox': 'Gift Box Delivery', 'voucher': 'Digital Voucher',
      'gift_receiver': 'Gift for Recipient', 'buyer': 'For Me'
    };
    return displayNames[deliveryType] || deliveryType;
  }

  async _addItemsToShopifyCart(items) {
    try {
      const result = await window.apiService.post('/cart/add.js', { items: items }, {
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      });
      return result;
    } catch (error) {
      console.error('Error adding items to cart:', error);
      throw error;
    }
  }

  // Helper function to check if a variant is an exchange product
  _isExchangeProduct(variantId) {
    // Exchange products have the "Exchange Product :" tag
    // We can check this by looking up the variant in the page data or make an API call
    // For now, we'll check if we have exchange data available in the window object
    if (window.voucherExchangeData && window.voucherExchangeData.exchangeProducts) {
      return window.voucherExchangeData.exchangeProducts.some(product =>
        product.variants && product.variants.some(variant => variant.id == variantId)
      );
    }
    return false;
  }

  // Helper function to extract error message from API response
  _extractErrorMessage(error, fallbackTranslationKey, fallbackText) {
    let rawMessage = '';

    if (error && typeof error === 'object') {
      // Check for structured API error response
      if (error.message) {
        rawMessage = error.message;
      } else if (error.description) {
        rawMessage = error.description;
      } else if (error.responseJSON && error.responseJSON.message) {
        rawMessage = error.responseJSON.message;
      } else if (error.responseJSON && error.responseJSON.description) {
        rawMessage = error.responseJSON.description;
      }
    }

    // If we have a raw message, try to make it more user-friendly
    if (rawMessage) {
      return this._getFriendlyErrorMessage(rawMessage, error);
    }

    // Use translation key as fallback
    return TranslationUtils.get(fallbackTranslationKey, fallbackText);
  }

  // Helper function to convert API error messages to user-friendly ones
  _getFriendlyErrorMessage(rawMessage, error) {
    const lowerMessage = rawMessage.toLowerCase();

    // Check for specific error patterns and return friendly messages
    if (lowerMessage.includes('maximum quantity') || lowerMessage.includes('max quantity')) {
      return TranslationUtils.get('sections.cart.max_quantity_error', 'The maximum quantity of this item is already in your cart.');
    }

    if (lowerMessage.includes('out of stock') || lowerMessage.includes('not available') || lowerMessage.includes('no inventory')) {
      return TranslationUtils.get('sections.cart.out_of_stock_error', 'Sorry, this item is currently out of stock.');
    }

    if (lowerMessage.includes('not enough inventory') || lowerMessage.includes('insufficient inventory')) {
      return TranslationUtils.get('sections.cart.inventory_error', 'Not enough inventory available for the requested quantity.');
    }

    if (lowerMessage.includes('variant') && (lowerMessage.includes('not found') || lowerMessage.includes('unavailable'))) {
      return TranslationUtils.get('sections.cart.variant_not_available', 'This product variant is no longer available.');
    }

    if (lowerMessage.includes('product') && (lowerMessage.includes('not found') || lowerMessage.includes('unavailable'))) {
      return TranslationUtils.get('sections.cart.product_unavailable', 'This product is currently unavailable.');
    }

    if (lowerMessage.includes('cart limit') || lowerMessage.includes('too many items')) {
      return TranslationUtils.get('sections.cart.cart_limit_exceeded', "You've reached the maximum number of items allowed in your cart.");
    }

    if (lowerMessage.includes('invalid quantity') || lowerMessage.includes('quantity must be')) {
      return TranslationUtils.get('sections.cart.invalid_quantity', 'Please enter a valid quantity.');
    }

    // Check for 422 status code and provide generic friendly message
    if (error && (error.status === 422 || (error.responseJSON && error.responseJSON.status === 422))) {
      return TranslationUtils.get('sections.cart.add_to_cart_error', 'Unable to add this item to your cart. Please check your selection and try again.');
    }

    // If no specific pattern matches, return the original message but cleaned up
    return this._cleanupErrorMessage(rawMessage);
  }

  // Helper function to clean up technical error messages
  _cleanupErrorMessage(message) {
    // Remove technical prefixes and make more user-friendly
    let cleaned = message
      .replace(/^Error:\s*/i, '')
      .replace(/^CartError:\s*/i, '')
      .replace(/^ValidationError:\s*/i, '')
      .replace(/^\[\w+\]\s*/i, '')  // Remove [ERROR] type prefixes
      .trim();

    // Capitalize first letter if not already
    if (cleaned.length > 0) {
      cleaned = cleaned.charAt(0).toUpperCase() + cleaned.slice(1);
    }

    // Ensure it ends with proper punctuation
    if (cleaned && !cleaned.match(/[.!?]$/)) {
      cleaned += '.';
    }

    return cleaned || TranslationUtils.get('sections.cart.add_to_cart_error', 'Failed to add item to cart. Please try again.');
  }

  // Helper function to remove exchange products from cart
  async _removeExchangeProducts() {
    try {
      // Get current cart
      const cart = await window.apiService.get('/cart.js');
      if (!cart || !cart.items) {
        return;
      }

      // Find exchange products in cart (those with "Exchange Product :" in title)
      const exchangeItems = cart.items.filter(item =>
        item.title && item.title.includes('Exchange Product :')
      );

      if (exchangeItems.length === 0) {
        return;
      }

      // Prepare updates to remove exchange products (set quantity to 0)
      const updates = {};
      exchangeItems.forEach(item => {
        updates[item.key] = 0;
      });

      // Remove exchange products
      const result = await window.apiService.post('/cart/update.js', { updates });

      return result;
    } catch (error) {
      console.error('Error removing exchange products:', error);
      // Don't throw - we don't want to block the main add to cart flow
    }
  }


}

/*GLOBAL FUNCTIONS */

function handleFirstTab(e) {
  if (e.keyCode === 9) {
    document.body.classList.add("user-is-tabbing");

    window.removeEventListener("keydown", handleFirstTab);
    window.addEventListener("mousedown", handleMouseDownOnce);
  }
}

function handleMouseDownOnce() {
  document.body.classList.remove("user-is-tabbing");

  window.removeEventListener("mousedown", handleMouseDownOnce);
  window.addEventListener("keydown", handleFirstTab);
}

window.addEventListener("keydown", handleFirstTab);

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe, .focusable"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);
  if (first) {
    first.focus();
  } else {
    elementToFocus.focus();
  }
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

class Dropdown {
  constructor() {
    this.domDelegate = new Delegate(document.body);
    this.breakpoint = responsive.getCurrentBreakpoint();
    this.allDropdowns = document.querySelectorAll(".Dropdown");
    this.pageOverlayElement = document.querySelector(".pageOverlay");
    this.lock = false;
    this.bindEvents();
  }

  bindEvents() {
    // Bind event for general dropdown toggle
    this.domDelegate.on(
      "click",
      "[data-action=toggle-dropdown]",
      this.toggleDropdown.bind(this)
    );

    let selector;
    switch (this.breakpoint) {
      case "desktop":
        // For lap-and-up breakpoint, bind event for desktop dropdown toggle
        selector = "[data-action=toggle-desktop-dropdown]";
        break;
      case "pocket":
        // For pocket breakpoint, bind event for mobile dropdown toggle
        selector = "[data-action=toggle-mobile-dropdown]";
        break;
      default:
        // If no specific breakpoint, set selector as false to skip binding
        selector = false;
        break;
    }

    if (selector) {
      // Bind event for specific breakpoint dropdown toggle
      this.domDelegate.on("click", selector, this.toggleDropdown.bind(this));
    }
  }

  updateAllDropdowns() {
    this.allDropdowns = document.querySelectorAll(".Dropdown");
  }

  openDropdown(elem, target) {
    if (this.lock) return;
    this.lock = true;
    // Open the dropdown by setting appropriate attributes and performing animation
    const DropdownButton = elem.querySelector(".Dropdown--Button");
    const DropdownContent = elem.querySelector(".Dropdown--Content");

    this.allDropdowns.forEach((dropdown) => {
      if (
        dropdown !== target.closest(".Dropdown") &&
        dropdown.querySelector("[aria-expanded='true']") &&
        !dropdown.classList.contains("do-not-close")
      ) {
        this.closeDropdown(dropdown, true);
      }
    });

    const transitionEndHandler = (event) => {
      if (event.propertyName === "height") {
        this.lock = false;

        DropdownContent.removeEventListener(
          "transitionend",
          transitionEndHandler
        );
      }
    };

    DropdownContent.addEventListener("transitionend", transitionEndHandler);

    DropdownButton.setAttribute("aria-expanded", "true");
    new RevolutionAnimation(DropdownContent, "true").slideDown();
  }

  closeAllDropdowns(namespace) {
    namespace.querySelectorAll(".Dropdown").forEach((dropdown) => {
      if (
        dropdown.querySelector("[aria-expanded='true']") &&
        !dropdown.classList.contains("do-not-close")
      ) {
        this.closeDropdown(dropdown);
      }
    });
  }

  closeDropdown(elem, ignore) {
    if (this.lock && !ignore) return;
    this.lock = true;
    // Close the dropdown by setting appropriate attributes and performing animation
    const DropdownButton = elem.querySelector(".Dropdown--Button");
    const DropdownContent = elem.querySelector(".Dropdown--Content");
    const transitionEndHandler = (event) => {
      if (event.propertyName === "height") {
        if (DropdownContent.getAttribute("aria-hidden") == "false") {
          DropdownContent.setAttribute("aria-hidden", "true");
        }

        this.lock = false;

        DropdownContent.removeEventListener(
          "transitionend",
          transitionEndHandler
        );
      }
    };

    DropdownContent.addEventListener("transitionend", transitionEndHandler);

    new RevolutionAnimation(DropdownContent, "true").slideUp();
    DropdownButton.setAttribute("aria-expanded", false);
  }

  toggleDropdown(event, target) {
    event.preventDefault();
    const mainDropdown = target.closest(".Dropdown");
    const isOpen = target.getAttribute("aria-expanded") === "true";

    if (!this.lock) {
      if (isOpen) {
        // If dropdown is open, close it
        this.closeDropdown(mainDropdown, target);

        if (mainDropdown.classList.contains('filter__dropdown')) {
          mainDropdown.dispatchEvent(
            new CustomEvent("close:filters", { bubbles: true })
          );
        }
      } else {
        // If dropdown is closed, open it
        this.openDropdown(mainDropdown, target);

        if (mainDropdown.classList.contains('filter__dropdown')) {
          mainDropdown.dispatchEvent(
            new CustomEvent("open:filters", { bubbles: true })
          );
        }
      }
    }
  }
}

const allDropdowns = new Dropdown();

class InfiniteScroll {

  constructor(container, paginationElement, restoreState) {
    if (
      !document.querySelector(container) ||
      !document.querySelector(paginationElement)
    )
      return;

    this.containerSelector = container;
    this.paginationElementSelector = paginationElement;
    this.restoreState = restoreState;
    this.treshold = 650;
    this.domDelegate = new Delegate(document.body);
    this.mainContainer = document.querySelector(this.containerSelector);
    this.loadType = this.mainContainer.dataset.load;
    this.running = false;
    this.bindEvents();

    const pageAccessedByReload = window.performance
      .getEntriesByType("navigation")
      .some((entry) => entry.type === "reload");

    if (
      this.restoreState &&
      sessionStorage.getItem("pageState") > 1 &&
      window.location.href === sessionStorage.getItem("pageStateURL") &&
      !pageAccessedByReload
    ) {
      const promises = this.generateFetchPromises(false);
      this.renderData(promises, true);
    } else {
      this.initObserver();
    }
  }

  initObserver() {
    const observerOptions = {
      root: null,
      rootMargin: "0px",
      threshold: 0,
    };

    this.observer = new IntersectionObserver(
      this.handleIntersect.bind(this),
      observerOptions
    );
    this.observer.observe(this.mainContainer);
  }

  bindEvents() {
    this.handleClickBinder = this.handleClick.bind(this);
    this.handleScrollBinder = this.handleScroll.bind(this);

    if (this.restoreState) {
      window.addEventListener(
        "beforeunload",
        this.rememberCurrentState.bind(this)
      );
    }
  }

  rememberCurrentState() {
    const scrollPositionY = window.scrollY;
    const currentUrl = window.location.href;
    const currentPage = document.querySelector(this.paginationElementSelector)
      .dataset.page;

    sessionStorage.setItem("pageState", currentPage);
    sessionStorage.setItem("pageStateURL", currentUrl);
    sessionStorage.setItem("pageStateScroll", scrollPositionY);
  }

  initialize() {
    if (this.loadType === "scroll") {
      this.scrollListener = scrollListener.addScrollListener(
        this,
        this.handleScrollBinder
      );
    } else {
      this.domDelegate.on(
        "click",
        `${this.paginationElementSelector} [data-action="load"]`,
        this.handleClickBinder
      );
    }
  }

  destroy() {
    if (this.loadType === "scroll") {
      this.scrollListener?.removeScrollListener();
    } else {
      this.domDelegate.off(
        "click",
        `${this.paginationElementSelector} [data-action="load"]`,
        this.handleClickBinder
      );
    }
  }

  handleIntersect(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        if (this.running === false) {
          this.initialize();
          this.running = true;
        }
      } else {
        this.running = false;
        this.destroy();
      }
    });
  }

  handleScroll() {
    this.paginationElement = document.querySelector(
      this.paginationElementSelector
    );
    if (!this.paginationElement) return;

    const top =
      this.paginationElement.getBoundingClientRect().top - this.treshold;
    const bottom =
      this.paginationElement.getBoundingClientRect().bottom + this.treshold;

    if (top <= window.innerHeight && bottom >= 0) {
      this.nextPageLinkElement = this.paginationElement.querySelector("a");

      if (this.nextPageLinkElement) {
        this.destroy();
        const nextPageUrl = this.nextPageLinkElement.href;
        const promises = this.generateFetchPromises(nextPageUrl);
        this.renderData(promises);
      }
    }
  }

  handleClick(e) {
    e.preventDefault();
    const loader = e.target.closest("a")?.querySelector(".itemLoader");
    if (loader) {
      loader.classList.add("is-visible");
    }


    this.paginationElement = document.querySelector(
      this.paginationElementSelector
    );
    if (!this.paginationElement) return;
    this.nextPageLinkElement = this.paginationElement.querySelector("a");

    if (this.nextPageLinkElement) {
      this.destroy();
      const nextPageUrl = this.nextPageLinkElement.href;
      const promises = this.generateFetchPromises(nextPageUrl);
      this.renderData(promises);
    }
  }

  generateFetchPromises(nextPageUrl) {
    const promises = [];

    if (nextPageUrl == false) {
      const hasSearchParameters = window.location.search.length > 0;
      const limit = parseInt(sessionStorage.getItem("pageState"));
      for (let i = 2; i <= limit; i++) {
        let url;

        // Build the URL based on the condition
        if (hasSearchParameters) {
          url = `${window.location.href}&page=${i}`;
        } else {
          url = `${window.location.href}?page=${i}`;
        }

        promises.push(
          fetch(url, {
            credentials: "same-origin",
            method: "GET",
          })
        );
      }
    } else {
      const url = `${nextPageUrl}`;

      promises.push(
        fetch(url, {
          credentials: "same-origin",
          method: "GET",
        })
      );
    }

    return promises;
  }

  async renderData(promises, restoreContent) {
    try {
      const responses = await Promise.all(promises);
      const contents = await Promise.all(
        responses.map((response) => response.text())
      );
      let isLastPromise = false;
      contents.forEach((content, index) => {
        isLastPromise = index === contents.length - 1;
        this.appendContent(content, isLastPromise, restoreContent);
      });
    } catch (error) {
      console.error("Error fetching or parsing data:", error);
    }
  }

  appendContent(content, lastPromise, restoreContent) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(content, "text/html");
    const contentToAdd = doc.querySelector(this.containerSelector);

    this.mainContainer = document.querySelector(this.containerSelector);
    this.paginationElement = document.querySelector(this.paginationElementSelector);

    if (this.paginationElement) {
      this.paginationElement.remove();
    }

    this.mainContainer.insertAdjacentHTML("beforeend", contentToAdd.innerHTML);

    if (lastPromise) {
      this.initialize();
      this.initObserver();
    }

    if (lastPromise && restoreContent) {
      this.restoreScroll();
    }

    document.dispatchEvent(
      new CustomEvent("pagination:finished", { bubbles: true })
    );

    document.dispatchEvent(new CustomEvent('update-favorites'));

    new RevolutionAnimation(this.mainContainer);
  }

  restoreScroll() {
    const scrollPosition = parseInt(sessionStorage.getItem("pageStateScroll"));

    if (scrollPosition) {
      window.scrollTo({
        top: scrollPosition,
        behavior: "smooth",
      });
    }
  }
}

class Drawer {
  constructor(element) {
    var options =
      arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    this.element = element;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.pageOverlayElement = document.querySelector(".pageOverlay");

    if (navigator.platform === "iPhone")
      document.documentElement.style.setProperty(
        "--viewport-height",
        `${window.innerHeight}px`
      );
    this.onOpen = options["onOpen"] || function () { };
    this.onClose = options["onClose"] || function () { };
    this.isOpen = false;

    this.SWIPE_THRESHOLD = 100;
    this.touchStartY = null;
    this.touchDiffY = 0;

    this.customDragTarget = this.element.querySelector('[data-action="close-on-swipe-down"]') || null;
    this.bindEvents();
  }

  bindEvents() {
    this.delegateBody.on(
      "click",
      '[data-action="open-drawer"][data-action-id="' + this.element.id + '"]',
      this.openDrawer.bind(this)
    );
    this.delegateBody.on(
      "click",
      '[data-action="close-drawer"][data-action-id="' + this.element.id + '"]',
      this.closeDrawer.bind(this)
    );
    this.delegateBody.on(
      "click",
      '[data-action="toggle-drawer"][data-action-id="' + this.element.id + '"]',
      this.toggleDrawer.bind(this)
    );
    this._openListener = this.openDrawer.bind(this);
    this._closeListener = this.closeDrawer.bind(this);


    this.delegateElement.on(
      "touchstart",
      '[data-action="close-on-swipe-down"] .dragHandle',
      this.handleTouchStart.bind(this)
    );

    this.delegateElement.on(
      "touchmove",
      '[data-action="close-on-swipe-down"] .dragHandle',
      this.handleTouchMove.bind(this)
    );

    this.delegateElement.on(
      "touchend",
      '[data-action="close-on-swipe-down"] .dragHandle',
      this.handleTouchEnd.bind(this)
    );
  }

  toggleDrawer() {
    event.preventDefault();
    this.isOpen ? this.closeDrawer() : this.openDrawer();
  }

  openDrawer() {
    this.element.dispatchEvent(
      new CustomEvent("close:search", { bubbles: true })
    );

    if (this.element.getAttribute("id") == "cart") {
      this.element.dispatchEvent(
        new CustomEvent("cart-drawer:open", { bubbles: true })
      );

    }
    if (this.isOpen) {
      return;
    }


    this.element.setAttribute("aria-expanded", "true");
    this.pageOverlayElement.classList.add("is-visible");
    this.pageOverlayElement.addEventListener("click", this._closeListener);
    var focus = this.element.querySelector("[data-scrollable]");
    bodyScrollLock.disableBodyScroll(focus, bodyScrollLockOptions);
    IOSScrollLock.lock();

    document.body.classList.add("scrollLock");
    this.isOpen = true;
    setTimeout(() => {
      trapFocus(this.element);
    }, 400);
    this.onOpen();
    return false;
  }

  closeDrawer(event) {
    if (!this.isOpen) {
      return;
    }
    if (event) {
      event.preventDefault();
    }

    if (this.element.getAttribute("id") == "Drawer") {
    }
    document.body.classList.remove("scrollLock");

    bodyScrollLock.clearAllBodyScrollLocks();
    IOSScrollLock.unlock();

    if (this.element.getAttribute("id") == "cart") {
      var options = JSON.parse(this.element.getAttribute("data-settings"));
      if (options["showRecommendations"]) {
        this.element
          .querySelector(".CartDrawer--Expendable")
          .setAttribute("aria-expanded", false);
        setTimeout(() => {
          this.element.querySelector(".CustomCart__Recommendations").innerHTML =
            "";
        }, 800);
      }
    }
    this.element.setAttribute("aria-expanded", "false");

    this.pageOverlayElement.classList.remove("is-visible");
    this.pageOverlayElement.removeEventListener("click", this._closeListener);
    removeTrapFocus(this.element);
    this.isOpen = false;
    this.onClose();
  }

  handleTouchStart(event) {
    if (responsive.matchesBreakpoint('lap_and_up')) return;

    this.currentSwipeTarget = event.currentTarget;

    const scrollableParent = this.currentSwipeTarget.closest('[data-scrollable]');
    if (scrollableParent && scrollableParent.scrollTop === 0) {
      this.touchStartY = event.touches[0].clientY;
      this.touchDiffY = 0;
    } else if (!scrollableParent) {
      this.touchStartY = event.touches[0].clientY;
      this.touchDiffY = 0;
    } else {
      this.touchStartY = null;
    }
  }

  handleTouchMove(event) {
    if (this.touchStartY === null) return;

    this.touchDiffY = event.touches[0].clientY - this.touchStartY;

    if (this.touchDiffY > 0) {
      const dragTarget = this.customDragTarget || this.currentSwipeTarget;
      if (dragTarget && dragTarget.classList) {
        dragTarget.classList.add('is-dragging');
        dragTarget.style.transform = `translateY(${this.touchDiffY}px)`;
      }
    }
  }

  handleTouchEnd() {
    if (this.touchStartY === null) return;

    const dragTarget = this.customDragTarget || this.currentSwipeTarget;
    if (dragTarget && dragTarget.classList) {
      dragTarget.classList.remove('is-dragging');
      if (this.touchDiffY > this.SWIPE_THRESHOLD) {
        dragTarget.classList.add('is-closing');
        dragTarget.style.transition = 'opacity 0.3s ease, transform 0.3s ease';
        dragTarget.style.opacity = '0';
        dragTarget.style.transform = `translateY(${this.touchDiffY + 100}px)`;
        const cleanup = () => {
          dragTarget.classList.remove('is-closing');
          dragTarget.style.transition = '';
          dragTarget.style.opacity = '';
          dragTarget.style.transform = '';
          dragTarget.removeEventListener('transitionend', cleanup);
          this.onClose();
        };
        dragTarget.addEventListener('transitionend', cleanup);
        setTimeout(cleanup, 350);
      } else {
        dragTarget.style.transform = '';
      }
    }

    this.touchStartY = null;
    this.currentSwipeTarget = null;
  }

}

class RevolutionAnimation {
  constructor(element, directAnimation) {
    this.element = element;
    this._cleanup = null; // holds the active transitionend handler

    if (!directAnimation) {
      this.intersectionObserver = [];
      this.integer = 0;

      // Find all elements with data-animation or animatedContent class
      const contentToAnimate = document.querySelectorAll("[data-animation], .animatedContent");
      contentToAnimate.forEach((item, i) => {
        this.animateElement(item, i);
        this.integer++;
      });

      const observer = new MutationObserver(mutations => {
        mutations.forEach(mutation => {
          // Handle added nodes
          mutation.addedNodes.forEach(node => {
            if (node.nodeType === Node.ELEMENT_NODE) {
              this.processNewElement(node);
            }
          });

          // Handle attribute changes (for class additions)
          if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
            const target = mutation.target;
            if (target.classList.contains('animatedContent') && !target.hasAttribute('data-loaded')) {
              this.processNewElement(target);
            }
          }
        });
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class']
      });
    }
  }

  _cancelCurrentTransition() {
    if (this._cleanup) {
      this.element.removeEventListener("transitionend", this._cleanup);
      this._cleanup = null;
    }
  }

  processNewElement(element) {
    const items = [];

    // Check if the element itself has data-animation or animatedContent class
    if (element.matches('[data-animation]') || element.classList.contains('animatedContent')) {
      items.push(element);
    }

    // Check child nodes for data-animation or animatedContent class
    element.querySelectorAll('[data-animation], .animatedContent').forEach(child => {
      if (!items.includes(child)) {
        items.push(child);
      }
    });

    items.forEach(item => {
      this.animateElement(item, this.integer++);
    });
  }

  // Generic method to find closest ancestor with a specific attribute
  _findClosestAttribute(element, attributeName) {
    if (element.hasAttribute(attributeName)) {
      return element.getAttribute(attributeName);
    }

    // Look for closest ancestor with the attribute
    const ancestor = element.closest(`[${attributeName}]`);
    if (ancestor) {
      return ancestor.getAttribute(attributeName);
    }

    return null;
  }

  // Find the closest ancestor with data-animation attribute
  findClosestAnimation(element) {
    return this._findClosestAttribute(element, 'data-animation');
  }

  // Find the closest ancestor with data-threshold attribute
  findClosestThreshold(element) {
    return this._findClosestAttribute(element, 'data-threshold');
  }

  // Public method to manually trigger animations for dynamically added content
  addElement(element) {
    this.processNewElement(element);
  }

  resetElement(el) {
    // 1) build a list: the element itself (if animated) + any descendants
    const toReset = [];
    if (el.classList.contains('animatedContent')) {
      toReset.push(el);
    }
    toReset.push(...el.querySelectorAll('.animatedContent'));

    toReset.forEach(target => {
      // 2) cancel any in-flight Web Animations
      if (target.getAnimations) {
        target.getAnimations().forEach(anim => anim.cancel());
      }

      // 3) cancel any pending transitionend listener (if slideUp/slideDown was targeting this.element)
      if (this.element === target) {
        this._cancelCurrentTransition();
      }

      // 4) remove the "loaded" flag so it can animate again on scroll
      target.removeAttribute('data-loaded');

      // 5) clear any inline styles your methods might have set
      ['transition', 'height', 'pointerEvents', 'transform', 'opacity'].forEach(prop => {
        target.style[prop] = '';
      });

      // 6) re-observe it so the IntersectionObserver will pick it up again
      this.intersectionObserver.forEach(obs => {
        try { obs.observe(target); }
        catch (_) { /* not originally observed by this one */ }
      });
    });
  }

  slideUp(onComplete) {
    this._cancelCurrentTransition();

    // freeze current height
    const currHeight = getComputedStyle(this.element).height;
    this.element.style.height = currHeight;
    this.element.offsetHeight; // force reflow

    // animate to zero
    this.element.style.pointerEvents = "none";
    this.element.style.transition = "height 0.3s ease";
    this.element.style.height = "0px";

    const finish = e => {
      if (e.propertyName === "height") {
        this.element.setAttribute("aria-hidden", "true");
        this.element.style.pointerEvents = "all";
        this.element.style.height = "";
        this.element.style.transition = "";
        this.element.removeEventListener("transitionend", finish);
        this._cleanup = null;
        onComplete && onComplete();
      }
    };
    this._cleanup = finish;
    this.element.addEventListener("transitionend", finish);
  }

  slideDown(onComplete) {
    this._cancelCurrentTransition();

    // freeze current height (could be 0 if closed or mid-way)
    const currHeight = getComputedStyle(this.element).height;
    this.element.style.height = currHeight;
    this.element.offsetHeight; // reflow

    // animate to full height
    this.element.setAttribute("aria-hidden", "false");
    this.element.style.pointerEvents = "none";
    this.element.style.transition = "height 0.3s ease";
    this.element.style.height = this.element.scrollHeight + "px";

    const finish = e => {
      if (e.propertyName === "height") {
        this.element.style.pointerEvents = "all";
        this.element.style.height = "auto";
        this.element.style.transition = "";
        this.element.removeEventListener("transitionend", finish);
        this._cleanup = null;
        onComplete && onComplete();
      }
    };
    this._cleanup = finish;
    this.element.addEventListener("transitionend", finish);
  }

  // Helper method to create and execute animations
  _createAnimation(elements, keyframes, options = {}) {
    const {
      duration = window.theme.animationDuration,
      delay = window.theme.animationBetweenElements,
      customDuration = null,
      customDelay = null
    } = options;

    elements.forEach((item, i) => {
      // Skip if already loaded (unless always-animate is set)
      if (item.getAttribute("data-loaded") && !item.hasAttribute("always-animate")) {
        return;
      }

      const finalDuration = customDuration || duration;
      const finalDelay = customDelay || delay;

      setTimeout(() => {
        item.animate(keyframes, {
          duration: finalDuration,
          fill: "forwards",
          ...options
        });
      }, finalDelay * i);

      // Mark as loaded (unless always-animate is set)
      if (!item.hasAttribute("always-animate")) {
        item.setAttribute("data-loaded", true);
      }
    });
  }

  // Helper method to get timing options from element
  _getTimingOptions(item) {
    return {
      duration: parseFloat(item.dataset.duration) || window.theme.animationDuration,
      delay: parseFloat(item.dataset.timeout) || window.theme.animationBetweenElements
    };
  }

  // A function to animate a list of elements by scaling them out
  elementScaleOut(elements) {
    const timing = this._getTimingOptions(elements[0]);
    const keyframes = [
      { transform: "scale(104%)", opacity: "0" },
      { transform: "scale(100%)", opacity: "1" },
    ];

    this._createAnimation(elements, keyframes, {
      duration: timing.duration * 2,
      delay: timing.delay
    });
  }

  elementScaleIn(elements) {
    const keyframes = [
      { transform: "scale(96%)", opacity: "0" },
      { transform: "scale(100%)", opacity: "1" },
    ];

    this._createAnimation(elements, keyframes, {
      duration: window.theme.animationDuration * 2,
      delay: window.theme.animationBetweenElements
    });
  }

  elementFadeIn(elements) {
    const keyframes = [
      { opacity: "0" },
      { opacity: "1" },
    ];

    this._createAnimation(elements, keyframes, {
      duration: 750,
      delay: window.theme.animationBetweenElements,
      easing: "ease"
    });
  }

  elementFromTop(elements) {
    const keyframes = [
      { transform: "translateY(-30px)", opacity: "0" },
      { transform: "translateY(0px)", opacity: "1" },
    ];

    this._createAnimation(elements, keyframes);
  }

  elementFromBottom(elements) {
    const timing = this._getTimingOptions(elements[0]);
    const keyframes = [
      { transform: "translateY(20px)", opacity: "0" },
      { transform: "translateY(0px)", opacity: "1" },
    ];

    this._createAnimation(elements, keyframes, {
      duration: timing.duration,
      delay: timing.delay
    });
  }

  elementFromRight(elements) {
    const keyframes = [
      { transform: "translateX(30px)", opacity: "0" },
      { transform: "translateX(0px)", opacity: "1" },
    ];

    this._createAnimation(elements, keyframes);
  }

  elementFromLeft(elements) {
    const keyframes = [
      { transform: "translateX(-30px)", opacity: "0" },
      { transform: "translateX(0px)", opacity: "1" },
    ];

    this._createAnimation(elements, keyframes);
  }

  elementFromRightBig(elements) {
    const keyframes = [
      { transform: "translateX(120px)", opacity: "0" },
      { transform: "translateX(0px)", opacity: "1" },
    ];

    this._createAnimation(elements, keyframes);
  }

  elementFromLeftBig(elements) {
    const keyframes = [
      { transform: "translateX(-120px)", opacity: "0" },
      { transform: "translateX(0px)", opacity: "1" },
    ];

    this._createAnimation(elements, keyframes);
  }



  animateElement(animatedItem, index) {
    // If element has animatedContent class but no data-animation, find closest ancestor
    let animationType = animatedItem.dataset.animation;

    if (!animationType && animatedItem.classList.contains('animatedContent')) {
      animationType = this.findClosestAnimation(animatedItem);
    }

    const options = {
      integer: index,
      type: animationType,
    };

    if (this.intersectionObserver[index]) {
      this.intersectionObserver[index].disconnect();
    }

    // Get custom threshold from element or use default
    let customThreshold = animatedItem.dataset.threshold;

    // If no threshold and element has animatedContent class, inherit from closest ancestor
    if (!customThreshold && animatedItem.classList.contains('animatedContent')) {
      customThreshold = this.findClosestThreshold(animatedItem);
    }

    const threshold = customThreshold ? parseFloat(customThreshold) : 0.1;

    this.intersectionObserver[index] = new IntersectionObserver(
      (results) => {
        const integer = options.integer;
        const elements = [];

        // Iterate over the IntersectionObserverEntry objects in the results array.
        results.forEach((result) => {
          // Check if the target element is intersecting the root element or if its intersection ratio is greater than 0.
          if (result.isIntersecting || result.intersectionRatio > 0) {
            // Add the target element to the elements array.
            const timeSinceScroll = performance.now() - this.lastScrollTime;

            // Check if animation should be prevented due to scroll lock
            const hasNoScrollLock = result.target.hasAttribute("animation-no-scroll");
            const hasAlwaysAnimate = result.target.hasAttribute("always-animate");

            if (hasNoScrollLock && document.body.classList.contains("scrollLock") ||
              hasNoScrollLock && timeSinceScroll < 100 ||
              result.target.getAnimations().length > 0) {
              return;
            }

            elements.push(result.target);

            // Unobserve the target element if it doesn't have always-animate
            if (!hasAlwaysAnimate) {
              this.intersectionObserver[integer].unobserve(result.target);
            }
          } else {
            // Cancel animations for elements with animation-no-scroll when they leave viewport
            if (result.target.hasAttribute("animation-no-scroll")) {
              result.target.getAnimations().forEach(animation => animation.cancel());
            }
          }
        });

        // If there are no elements to reveal, return.
        if (elements.length === 0) {
          return;
        }

        // An object that maps each animation type to the corresponding animation function.
        const animations = {
          elementFromTop: 'elementFromTop',
          elementFromBottom: 'elementFromBottom',
          elementFromRight: 'elementFromRight',
          elementFromLeft: 'elementFromLeft',
          elementFromLeftBig: 'elementFromLeftBig',
          elementFromRightBig: 'elementFromRightBig',
          elementScaleIn: 'elementScaleIn',
          elementScaleOut: 'elementScaleOut',
          elementFadeIn: "elementFadeIn",
        };

        // Get the animation function corresponding to the type from the animations object.
        const animation = animations[options.type];
        // If the animation function exists, call it with the elements array.
        if (animation) {
          this[animation](elements);
        }
      },
      { threshold: threshold }
    );

    if (animatedItem.classList.contains('animatedContent')) {
      this.intersectionObserver[index].observe(animatedItem);
    }

    animatedItem.querySelectorAll('.animatedContent').forEach((item) => {
      this.intersectionObserver[index].observe(item);
    });
  }
}

if (window.theme.enableAnimations) {
  document.addEventListener("DOMContentLoaded", function () {
    window.revolutionAnimation = new RevolutionAnimation();
  });
}

class LocationSelectboxPicker extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.isOpen = false;
    this.isAnimating = false;
  }

  connectedCallback() {
    this.selectboxWrapper = this.element.querySelector(".pm__connected-products-picker__wrapper");
    this.selectboxButton = this.element.querySelector(".pm__connected-products__selectbox-button");
    this.selectbox = this.element.querySelector(".pm__connected-product__selectbox");

    this.bindEvents();
  }

  bindEvents() {
    this.delegateElement.on(
      'click',
      '[data-action="toggle-selectbox"]',
      this.toggleSelectbox.bind(this)
    );

    this.delegateBody.on(
      'click',
      this.onClickOutside.bind(this)
    );
  }

  toggleSelectbox(event) {
    event.preventDefault();

    if (this.isAnimating) return;
    this.isOpen
      ? this.closeSelectbox(event.currentTarget)
      : this.openSelectbox(event.currentTarget);
  }

  openSelectbox() {
    this.isAnimating = true;

    // ARIA
    this.selectboxButton.setAttribute('aria-expanded', 'true');
    this.selectbox.setAttribute('aria-hidden', 'false');

    // animate
    this.selectbox.style.display = 'block';
    this.selectbox.style.overflow = 'hidden';
    const fullHeight = this.selectbox.scrollHeight + 'px';
    this.selectbox.style.height = '0';

    void this.selectbox.offsetHeight; // reflow

    this.selectbox.style.transition = 'height 300ms ease';
    this.selectbox.style.height = fullHeight;

    trapFocus(this.selectboxWrapper);

    const onTransitionEnd = (e) => {
      if (e.propertyName !== 'height') return;


      this.selectbox.style.height = '';
      this.selectbox.style.overflow = '';
      this.selectbox.style.transition = '';

      // cleanup
      this.selectbox.removeEventListener('transitionend', onTransitionEnd);
      this.isAnimating = false;
    };

    this.selectbox.addEventListener('transitionend', onTransitionEnd);

    // fallback in case transitionend never fires
    setTimeout(() => {
      this.selectbox.removeEventListener('transitionend', onTransitionEnd);
      // (optional) repeat cleanup just in case:
      this.selectbox.style.height = '';
      this.selectbox.style.overflow = '';
      this.selectbox.style.transition = '';
      this.isAnimating = false;
    }, 500);

    this.isOpen = true;
  }

  closeSelectbox() {
    if (!this.isOpen || this.isAnimating) return;
    this.isAnimating = true;

    this.selectbox.removeEventListener('transitionend', this._onOpenTransition);

    // ARIA
    this.selectboxButton.setAttribute('aria-expanded', 'false');
    this.selectbox.setAttribute('aria-hidden', 'true');

    const onCloseTransition = (e) => {
      if (e.propertyName !== 'height') return;

      this.selectbox.style.display = 'none';
      this.selectbox.style.height = '';
      this.selectbox.style.overflow = '';
      this.selectbox.style.transition = '';
      removeTrapFocus(this.selectboxWrapper);
      this.isAnimating = false;
      // remove *this* listener
      this.selectbox.removeEventListener('transitionend', onCloseTransition);
    };

    // 4) kick off the collapse animation
    this.selectbox.style.overflow = 'hidden';
    this.selectbox.style.height = this.selectbox.scrollHeight + 'px';
    // force reflow
    void this.selectbox.offsetHeight;

    this.selectbox.style.height = '0';

    // 5) fallback cleanup after 500 ms
    setTimeout(() => {
      this.selectbox.removeEventListener('transitionend', onCloseTransition);

      this.selectbox.style.display = 'none';
      this.selectbox.style.height = '';
      this.selectbox.style.overflow = '';
      this.selectbox.style.transition = '';
      removeTrapFocus(this.selectboxWrapper);
      this.isAnimating = false;
    }, 500);

    this.isOpen = false;
  }

  onClickOutside(event) {
    if (
      !this.selectboxWrapper.contains(event.target)
    ) {
      this.closeSelectbox();
    }
  }
}
customElements.define("connected-products-picker", LocationSelectboxPicker);

class ConnectedProducts extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
  }

  connectedCallback() {
    this.hiddenConnectedProducts = this.element.querySelectorAll('.pm__connected-product[aria-hidden="true"');
    this.loadButton = this.element.querySelector('.pm__connected-products__show-more-button');

    this.bindEvents();
  }

  bindEvents() {
    this.delegateElement.on(
      'click',
      '[data-action="show-connected-products"]',
      this.handleShowConnectedProducts.bind(this)
    );
  }

  handleShowConnectedProducts() {
    if (!this.hiddenConnectedProducts || this.hiddenConnectedProducts < 1) return;

    this.hiddenConnectedProducts.forEach((product) => {
      product.setAttribute("aria-expanded", true);
      requestAnimationFrame(() => {
        product.setAttribute("aria-hidden", false);
      });
    });

    this.loadButton.setAttribute("aria-expanded", false);
  }
}

customElements.define("connected-products", ConnectedProducts);

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.element = this;
  }

  connectedCallback() {
    this.input = this.querySelector("input");
    this.delegateElement = new Delegate(this.element);
    this.options = JSON.parse(this.element.getAttribute("data-settings"));

    this.delegateElement.on("click", "button", this.onButtonClick.bind(this));
    this.delegateElement.on("input", "input", this.onInput.bind(this));
  }

  onInput() {
    this.element.dispatchEvent(
      new CustomEvent("quantity:changed", { bubbles: true })
    );
    this.toggleAddButton();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();

    if (this.input.value > 1) {
      this.element.classList.add('active')
    } else {
      this.element.classList.remove('active')
    }

    if (previousValue !== this.input.value) {
      this.element.dispatchEvent(
        new CustomEvent("quantity:changed", { bubbles: true })
      );
    }

    this.toggleAddButton();
  }

  toggleAddButton() {
    let quantity = "";
    const addButton = document.querySelectorAll(".pm__atc-button--main"),
      addButtonInner = document.querySelectorAll(".pm__atc-button--main .ButtonText"),
      quantityEl = document.querySelector(".pm__quantity-input"),
      altButtons = document.querySelectorAll(".pm__alt-atc-button");

    if (quantityEl) {
      quantity = quantityEl.value;
    }

    if (!addButton) return;
    if (!quantity) {
      quantity = 1;
    }

    if (selectedVariant) {
      if (selectedVariant.available == false) {
        addButton.forEach(button => button.setAttribute("disabled", "disabled"));
        addButtonInner.forEach((btn) => {
          btn.innerHTML = window.variantStrings.soldOut;
        });
        altButtons.forEach(button => button.setAttribute("disabled", ""));
      } else {
        altButtons.forEach(button => button.removeAttribute("disabled"));
        addButton.forEach(button => button.removeAttribute("disabled"));
      }
    }
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const serializeForm = (form) => {
  const obj = {};
  const formData = new FormData(form);
  for (const key of formData.keys()) {
    obj[key] = formData.get(key);
  }
  return JSON.stringify(obj);
};

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class ProductForm extends HTMLElement {
  constructor() {
    super();
    new AddToCart(this);
  }
}

customElements.define("product-form", ProductForm);



class ProductCarousel extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    new AddToCart(this.element);
    this.observer = null;
  }

  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;
    this.initCarousels();
    this.bindEvents();
  }

  bindEvents() {
    this.delegateElement.on("click", "[data-action='toggle-tab']", this.toggleTab.bind(this));
    this.delegateElement.on("keydown", "[data-action='toggle-tab']", this.toggleTab.bind(this));
  }

  initCarousels() {
    this.carouselElement = this.element.querySelectorAll(".swiper.pc__carousel");
    this.carouselElementThumbs = this.element.querySelector(".pc__collections");

    const swiperSlides = [];

    if (this.carouselElement) {
      this.carouselElement.forEach((swiperElem, index) => {
        const title = swiperElem.getAttribute('data-title');
        const key = swiperElem.getAttribute('data-key');
        const collectionSlide = swiperElem.querySelector('.main-swiper-slide');

        if (title && key && collectionSlide) {
          // Create the outer slide element
          const slideEl = document.createElement('div');
          slideEl.classList.add('swiper-slide', 'pc__collection');
          slideEl.setAttribute('tabindex', '0');
          slideEl.setAttribute('aria-label', 'Open collection');
          slideEl.setAttribute('data-action', 'toggle-tab');
          slideEl.setAttribute('data-key', key);
          slideEl.setAttribute('data-swiper-slide-index', index);

          if (index === 0) {
            slideEl.classList.add('custom-active');
            slideEl.setAttribute('aria-expanded', 'true');
          }

          // Create a nested div for the title
          const titleDiv = document.createElement('div');
          if (this.element.hasAttribute('data-is-upsell')) {
            titleDiv.classList.add('pc__collection-title', 'u-s2');
          } else {
            titleDiv.classList.add('pc__collection-title', 'u-s2');

          }
          titleDiv.setAttribute('data-hover-text', title);
          titleDiv.textContent = title;
          // Append title inside the slide
          slideEl.appendChild(titleDiv);
          swiperSlides.push(slideEl);
        }

        //Set visibility for swiperElem
        if (index === 0) {
          swiperElem.setAttribute('aria-hidden', 'false');
          swiperElem.classList.remove('is-hidden');
        } else {
          swiperElem.setAttribute('aria-hidden', 'true');
          swiperElem.classList.add('is-hidden');
        }
      });
    }

    //Append slides to thumbs wrapper
    if (this.carouselElementThumbs) {
      const thumbsWrapper = this.carouselElementThumbs.querySelector('.swiper-wrapper');
      swiperSlides.forEach(slide => thumbsWrapper.appendChild(slide));
    }

    //Initialize swipers
    if (this.carouselElement) {
      this.carouselElement.forEach(swiperElem => {
        if (responsive.matchesBreakpoint("lap_and_up")) {
          new RevolutionSwiper(swiperElem, this.carouselElementThumbs);
        } else {
          this.initCarouselWithFade(swiperElem);
        }
      });
    }

    if (this.carouselElementThumbs) {
      this.initCarouselWithFade(this.carouselElementThumbs);
    }
  }

  initCarouselWithFade(swiperEl) {
    const rev = new RevolutionSwiper(swiperEl);
    const swiper = rev.swiperElement;

    const fadeContainer = swiperEl;

    const update = () => this.updateFadeClasses(swiper, fadeContainer);


    update();
    swiper.on('scrollbarDragMove', update);
    swiperEl.addEventListener('swiper:slide-changed', update);
    swiper.on('progress', update);
    swiper.on('touchMove', update);
    swiper.on('resize', update);
    window.addEventListener('resize', update);
  }

  updateFadeClasses(swiper, fadeContainer) {
    const c = fadeContainer.classList;
    c.remove('fade-left', 'fade-right', 'fade-both');

    const atStart = swiper.isBeginning;
    const atEnd = swiper.isEnd;

    if (!atStart && !atEnd) {
      c.add('fade-both');
    } else if (!atStart) {
      c.add('fade-left');
    } else if (!atEnd) {
      c.add('fade-right');
    }
  }

  openTab(target) {
    const currentlyOpen = this.element.querySelector("[aria-expanded='true']");
    if (currentlyOpen) this.closeTab(currentlyOpen.dataset.key);
    this.removeAllLinks();
    target.setAttribute("aria-expanded", "true");
    target.classList.add("custom-active");

    const key = target.dataset.key;
    const toggleElement = this.element.querySelector(`.swiper.pc__carousel[data-key="${key}"]`);

    if (toggleElement) {
      toggleElement.classList.remove("is-hidden");

      requestAnimationFrame(() => {
        setTimeout(() => {
          toggleElement.setAttribute("aria-hidden", "false");
        }, 200);
      });
    }
  }

  // Method to remove all link highlights
  removeAllLinks() {
    const linkedItems = this.element.querySelectorAll(".custom-active");
    linkedItems.forEach((item) => {
      item.classList.remove("custom-active");
    });
  }

  closeTab(key) {
    const toggleElement = this.element.querySelector(`.swiper.pc__carousel[data-key="${key}"]`);
    if (toggleElement) {
      toggleElement.classList.add("is-hidden");
      toggleElement.setAttribute("aria-hidden", "true");
    }
    if (window.revolutionAnimation) {
      window.revolutionAnimation.resetElement(toggleElement);
    }

    const button = this.element.querySelector(`[data-key="${key}"]`);
    if (button) {
      button.setAttribute("aria-expanded", "false");
    }
  }

  toggleTab(event) {
    const target = event.target;
    if (!target) return;

    const key = target.dataset.key;
    const toggleElement = this.element.querySelector(`.swiper.pc__carousel[data-key="${key}"]`);

    if (!toggleElement) return;
    if (target.getAttribute("aria-expanded") === "true") return;

    this.openTab(target);
  }
}

customElements.define("product-carousel", ProductCarousel);

class CollectionShowcase extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.observer = null;
  }

  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;
    this.initCarousels();
    this.bindEvents();
  }

  bindEvents() {
    this.delegateElement.on("click", "[data-action='toggle-tab']", this.toggleTab.bind(this));
    this.delegateElement.on("keydown", "[data-action='toggle-tab']", this.toggleTab.bind(this));
  }

  initCarousels() {
    this.carouselElement = this.element.querySelectorAll(".swiper.cs__carousel");
    this.carouselElementThumbs = this.element.querySelector(".cs__collections");

    const swiperSlides = [];

    if (this.carouselElement) {
      this.carouselElement.forEach((swiperElem, index) => {
        const title = swiperElem.getAttribute('data-title');
        const key = swiperElem.getAttribute('data-key');
        const collectionSlide = swiperElem.querySelector('.main-swiper-slide');

        if (title && key && collectionSlide) {
          // Create the outer slide element
          const slideEl = document.createElement('div');
          slideEl.classList.add('swiper-slide', 'cs__collection');
          slideEl.setAttribute('tabindex', '0');
          slideEl.setAttribute('aria-label', 'Open collection');
          slideEl.setAttribute('data-action', 'toggle-tab');
          slideEl.setAttribute('data-key', key);
          slideEl.setAttribute('data-swiper-slide-index', index);

          if (index === 0) {
            slideEl.classList.add('custom-active');
            slideEl.setAttribute('aria-expanded', 'true');
          }

          // Create a nested div for the title
          const titleDiv = document.createElement('div');
          if (this.element.hasAttribute('data-is-upsell')) {
            titleDiv.classList.add('cs__collection-title', 'u-s2');
          } else {
            titleDiv.classList.add('cs__collection-title', 'u-s2');

          }
          titleDiv.setAttribute('data-hover-text', title);
          titleDiv.textContent = title;
          // Append title inside the slide
          slideEl.appendChild(titleDiv);
          swiperSlides.push(slideEl);
        }

        //Set visibility for swiperElem
        if (index === 0) {
          swiperElem.setAttribute('aria-hidden', 'false');
          swiperElem.classList.remove('is-hidden');
        } else {
          swiperElem.setAttribute('aria-hidden', 'true');
          swiperElem.classList.add('is-hidden');
        }
      });
    }

    //Append slides to thumbs wrapper
    if (this.carouselElementThumbs) {
      const thumbsWrapper = this.carouselElementThumbs.querySelector('.swiper-wrapper');
      swiperSlides.forEach(slide => thumbsWrapper.appendChild(slide));
    }

    //Initialize swipers
    if (this.carouselElement) {
      this.carouselElement.forEach(swiperElem => {
        if (responsive.matchesBreakpoint("lap_and_up")) {
          new RevolutionSwiper(swiperElem, this.carouselElementThumbs);
        } else {
          this.initCarouselWithFade(swiperElem);
        }
      });
    }

    if (this.carouselElementThumbs) {
      this.initCarouselWithFade(this.carouselElementThumbs);
    }
  }

  initCarouselWithFade(swiperEl) {
    const rev = new RevolutionSwiper(swiperEl);
    const swiper = rev.swiperElement;

    const fadeContainer = swiperEl;

    const update = () => this.updateFadeClasses(swiper, fadeContainer);


    update();
    swiper.on('scrollbarDragMove', update);
    swiperEl.addEventListener('swiper:slide-changed', update);
    swiper.on('progress', update);
    swiper.on('touchMove', update);
    swiper.on('resize', update);
    window.addEventListener('resize', update);
  }

  updateFadeClasses(swiper, fadeContainer) {
    const c = fadeContainer.classList;
    c.remove('fade-left', 'fade-right', 'fade-both');

    const atStart = swiper.isBeginning;
    const atEnd = swiper.isEnd;

    if (!atStart && !atEnd) {
      c.add('fade-both');
    } else if (!atStart) {
      c.add('fade-left');
    } else if (!atEnd) {
      c.add('fade-right');
    }
  }

  openTab(target) {
    const currentlyOpen = this.element.querySelector("[aria-expanded='true']");
    if (currentlyOpen) this.closeTab(currentlyOpen.dataset.key);
    this.removeAllLinks();
    target.setAttribute("aria-expanded", "true");
    target.classList.add("custom-active");

    const key = target.dataset.key;
    const toggleElement = this.element.querySelector(`.swiper.cs__carousel[data-key="${key}"]`);

    if (toggleElement) {
      toggleElement.classList.remove("is-hidden");

      requestAnimationFrame(() => {
        setTimeout(() => {
          toggleElement.setAttribute("aria-hidden", "false");
        }, 200);
      });
    }
  }

  // Method to remove all link highlights
  removeAllLinks() {
    const linkedItems = this.element.querySelectorAll(".custom-active");
    linkedItems.forEach((item) => {
      item.classList.remove("custom-active");
    });
  }

  closeTab(key) {
    const toggleElement = this.element.querySelector(`.swiper.cs__carousel[data-key="${key}"]`);
    if (toggleElement) {
      toggleElement.classList.add("is-hidden");
      toggleElement.setAttribute("aria-hidden", "true");
    }
    if (window.revolutionAnimation) {
      window.revolutionAnimation.resetElement(toggleElement);
    }

    const button = this.element.querySelector(`[data-key="${key}"]`);
    if (button) {
      button.setAttribute("aria-expanded", "false");
    }
  }

  toggleTab(event) {
    const target = event.target;
    if (!target) return;

    const key = target.dataset.key;
    const toggleElement = this.element.querySelector(`.swiper.cs__carousel[data-key="${key}"]`);

    if (!toggleElement) return;
    if (target.getAttribute("aria-expanded") === "true") return;

    this.openTab(target);
  }

}

customElements.define("collection-showcase", CollectionShowcase);



class ArticleComments extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.articleWrapper = this.element.querySelector(".article-comments__main-container");
    this.showLessButton = this.element.querySelector(".article-comments__show-less-button");
    this.commentForm = this.element.querySelector("#comment_form");

    this.totalComments = parseInt(this.dataset.totalComments, 10) || 0;
    this.remainingCountSpan = this.querySelector('.article-comments__remaining-count');

    // If we just submitted a comment and the server-side count hasn't caught up yet,
    // bump the heading count once on the returned page load.
    const successAlert = this.querySelector('.article-comments__sucess-msg');
    const prevCountRaw = sessionStorage.getItem('prev-article-comments-count');
    if (successAlert && prevCountRaw) {
      const prevCount = parseInt(prevCountRaw, 10);
      if (!Number.isNaN(prevCount) && this.totalComments <= prevCount) {
        this.setHeadingCount(prevCount + 1);
        this.totalComments = prevCount + 1;
      }
      sessionStorage.removeItem('prev-article-comments-count');
    }


    this.bindEvents();
    this.toggleButton();
  }

  bindEvents() {
    this.delegateElement.on(
      "click",
      '[data-action="load-more"]',
      this.loadMore.bind(this)
    );

    this.delegateElement.on(
      "click",
      '[data-action="scroll-to-comment-form"]',
      this.scrollToCommentForm.bind(this)
    );

    this.delegateElement.on(
      "click",
      '[data-action="open-comment-form"]',
      this.openCommentForm.bind(this)
    );

    this.delegateElement.on(
      "click",
      '[data-action="show-less"]',
      this.showLess.bind(this)
    );

    this.delegateElement.on(
      "change",
      "[data-state='required']",
      this.toggleButton.bind(this)
    );

    this.delegateElement.on(
      "click",
      "[data-action='submit-comment']",
      this.customSubmit.bind(this)
    );

    this.delegateElement.on(
      "input",
      "[data-state='required']",
      this.toggleButton.bind(this)
    );
  }

  toggleButton() {
    this.buttonState = true;

    var allRequiredFields = this.element.querySelectorAll("[data-state='required']");

    allRequiredFields.forEach((item) => {
      if (item.type === "checkbox" && !item.checked) {
        this.buttonState = false;
      } else if (item.type !== "checkbox" && item.value.trim() === "") {
        this.buttonState = false;
      }
    });

    if (this.buttonState === true) {
      this.element.querySelector(".article-comments__submit-button")?.removeAttribute("disabled");
    } else {
      this.element.querySelector(".article-comments__submit-button")?.setAttribute("disabled", true);
    }
  }

  //Escaping first digit for valid querySelector
  escapeSelector(id) {
    // If id starts with a digit, escape it properly
    if (/^\d/.test(id)) {
      return `\\3${id[0]} ${id.slice(1)}`;
    }
    return id.replace(/([!"#$%&'()*+,.\/:;<=>?@[\\\]^`{|}~])/g, '\\$1');
  }


  async loadMore(event, target) {
    event.preventDefault();
    const dataHref = target.getAttribute("data-next-href");

    if (!dataHref) {
      console.error("Data next-href attribute is missing.");
      return;
    }

    const loader = this.element.querySelector(".article-comments__load-more-button .itemLoader");

    try {
      loader?.classList.add("is-visible");

      // Add small artificial delay because Shopify takes time 
      // validating and approving new comments
      await new Promise(resolve => setTimeout(resolve, 500));

      const response = await fetch(`${window.routes.localeRootUrl}${dataHref}`, {
        credentials: "same-origin",
        method: "GET",
      });

      if (!response.ok) {
        throw new Error(`Network response was not ok: ${response.statusText}`);
      }

      const htmlData = await response.text();
      const parser = new DOMParser();
      const htmlDocument = parser.parseFromString(htmlData, "text/html");

      const newComments = htmlDocument.querySelectorAll(".article-comments__comment");
      const commentsContainer = this.element.querySelector(".article-comments__main-container");

      newComments.forEach((comment) => {
        const commentId = comment.getAttribute('id');
        if (!commentId) return;

        const escapedId = this.escapeSelector(commentId);
        if (!commentsContainer.querySelector(`#${escapedId}`)) {
          commentsContainer.appendChild(comment);
        }
      });

      new RevolutionAnimation(this.element);

      const newLoadMoreElement = htmlDocument.querySelector("[data-next-href]");
      const currentLoadMoreElement = this.element.querySelector(".article-comments__load-more-button");

      if (newLoadMoreElement) {
        const newHref = newLoadMoreElement.dataset.nextHref;
        if (currentLoadMoreElement) {
          currentLoadMoreElement.dataset.nextHref = newHref;
          commentsContainer.appendChild(currentLoadMoreElement);
          commentsContainer.appendChild(this.showLessButton);
        }
      } else {
        currentLoadMoreElement?.remove();
        commentsContainer.appendChild(this.showLessButton);
        this.showLessButton.classList.remove('hidden');
      }

      this.updateRemaining();

    } catch (error) {
      console.error("Failed to load more comments:", error);
    } finally {
      loader?.classList.remove("is-visible");
    }
  }

  updateRemaining() {

    const shown = this.querySelectorAll('.article-comments__comment').length;
    const remaining = this.totalComments - shown;
    // update the number (in parentheses)
    if (this.remainingCountSpan) {
      this.remainingCountSpan.textContent = remaining > 0 ? `(${remaining})` : '';
    }

    // always ensure it's inside the ButtonText
    const btnText = this.querySelector('.article-comments__load-more-button .ButtonText');
    if (btnText && this.remainingCountSpan) {
      btnText.appendChild(this.remainingCountSpan);
    }
  }


  scrollToCommentForm(event) {
    event.preventDefault();
    const formRect = this.commentForm.getBoundingClientRect();
    const scrollOffset = 50;

    window.scrollTo({
      top: formRect.top + window.scrollY - scrollOffset,
      behavior: 'smooth'
    });
  }

  openCommentForm(event) {
    event.preventDefault();
    const target = event.target;
    target.classList.add('hidden');
    const commentForm = this.element.querySelector(".comment-form-wrapper");

    if (!commentForm) return;

    // Open form and scroll to it.
    target.setAttribute("data-action", "scroll-to-comment-form");
    setTimeout(() => {
      this.scrollToCommentForm(event);
    }, 300);

    commentForm.setAttribute("aria-expanded", true);
    requestAnimationFrame(() => {
      commentForm.setAttribute("aria-visible", true);
    });
  }

  customSubmit(event) {
    sessionStorage.setItem('comment-submitted', 'true');
    sessionStorage.setItem('prev-article-comments-count', String(this.totalComments));
    event.preventDefault();
    this.commentForm.submit();
  }

  async showLess(event, target) {
    event.preventDefault();
    const firstPageUrl = target.dataset.firstPageUrl;
    const loader = this.element.querySelector(".article-comments__show-less-button .itemLoader");

    try {
      loader?.classList.add("is-visible");

      const response = await fetch(`${window.routes.localeRootUrl}${firstPageUrl}`, {
        credentials: "same-origin",
        method: "GET",
      });

      if (!response.ok) {
        throw new Error(`Network response was not ok: ${response.statusText}`);
      }

      const htmlData = await response.text();
      const parser = new DOMParser();
      const htmlDocument = parser.parseFromString(htmlData, "text/html");

      const firstPageComments = htmlDocument.querySelectorAll(".article-comments__comment");
      const commentsContainer = this.element.querySelector(".article-comments__main-container");

      commentsContainer.querySelectorAll(".article-comments__comment").forEach(comment => comment.remove());
      commentsContainer.prepend(...firstPageComments);

      new RevolutionAnimation(this.element);

      this.showLessButton.classList.add('hidden');

      const loadMoreButton = htmlDocument.querySelector(".article-comments__load-more-button");
      if (loadMoreButton) {
        commentsContainer.appendChild(loadMoreButton);
      }

      const containerRect = this.element.getBoundingClientRect();
      const scrollOffset = 150;

      window.scrollTo({
        top: containerRect.top + window.scrollY - scrollOffset,
        behavior: 'smooth',
      });
    } catch (error) {
      console.error("Failed to load first page comments:", error);
    } finally {
      loader?.classList.remove("is-visible");
    }
  }
}

customElements.define("article-comments", ArticleComments);

class BlogSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
  }

  connectedCallback() {
    new InfiniteScroll('#blog-article--wrapper', '#infinite-scroll', true);
  }

}

customElements.define("blog-section", BlogSection);

class Banner extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.previousRealIndex = 0;
    this.options = JSON.parse(
      this.element.getAttribute("data-section-settings")
    );

    if (this.options.numberOfSlides > 1) {
      this.swiperElement = this.querySelector('swiper-init');

      this.swiperElement.addEventListener('swiper:initialized', () => {
        this.carousel = this.swiperElement.getSwiper();
        if (this.options.swipeAnimation === "wipe")
          this.onSwiperInitialized();
      });

      this.handleResize = debounce(this.onResize.bind(this), 250);
      window.addEventListener('resize', this.handleResize);

      this.onImagesReady = this.createObserver.bind(this);
      this.swiperElement.addEventListener("swiper:slide-changed", this.onImagesReady);

      this.createObserver();
    } else {
      this.createObserver();
    }
  }
  onSwiperInitialized() {
    if (this.carousel.swiperElement) {
      this.carousel.swiperElement.on('slideChangeTransitionStart', () => {
        this.prepareWipeTransition();
      });

      this.carousel.swiperElement.on('slideChangeTransitionEnd', () => {
        this.cleanupWipeTransition();
      });

      setTimeout(() => {
        this.initializeWipeEffect();
      }, 100);
    }
  }

  onResize() {
    const newBreakpoint = responsive.getCurrentBreakpoint();

    if (this.currentBreakpoint !== newBreakpoint) {
      this.currentBreakpoint = newBreakpoint;

      if (this.options.numberOfSlides > 1) {
        this.changeImageQuality();

        if (this.options.swipeAnimation === "wipe") {
          this.initializeWipeEffect();
        }
      } else {
        this.changeImageQuality(true);
      }
    }
  }


  initializeWipeEffect() {
    if (!this.carousel || !this.carousel.swiperElement) {
      return;
    }

    const swiperInstance = this.carousel.swiperElement;
    const slides = swiperInstance.slides;
    const activeRealIndex = swiperInstance.realIndex;

    slides.forEach((slide) => {
      const slideRealIndex = parseInt(slide.dataset.swiperSlideIndex);

      if (slideRealIndex === activeRealIndex) {
        slide.style.clipPath = 'inset(0 0 0 0)';
        slide.style.zIndex = '2';
        slide.style.opacity = '1';
      } else {
        slide.style.clipPath = 'inset(0 0 0 100%)';
        slide.style.zIndex = '1';
        slide.style.opacity = '1';
      }
    });

    this.previousRealIndex = activeRealIndex;
  }

  prepareWipeTransition() {
    if (!this.carousel || !this.carousel.swiperElement) {
      return;
    }

    const swiperInstance = this.carousel.swiperElement;
    const slides = swiperInstance.slides;
    const activeRealIndex = swiperInstance.realIndex;
    const totalSlides = this.options.numberOfSlides;

    let isGoingForward = true;

    if (this.previousRealIndex !== activeRealIndex) {
      if (this.previousRealIndex === totalSlides - 1 && activeRealIndex === 0) {
        isGoingForward = true;
      } else if (this.previousRealIndex === 0 && activeRealIndex === totalSlides - 1) {
        isGoingForward = false;
      } else {
        isGoingForward = activeRealIndex > this.previousRealIndex;
      }
    }

    const backgroundRealIndex = this.previousRealIndex;

    let activeSlide = null;
    let backgroundSlide = null;

    slides.forEach((slide) => {
      const slideRealIndex = parseInt(slide.dataset.swiperSlideIndex);

      if (slideRealIndex === activeRealIndex) {
        activeSlide = slide;
      } else if (slideRealIndex === backgroundRealIndex) {
        backgroundSlide = slide;
      } else {
        slide.style.clipPath = 'inset(0 0 0 100%)';
        slide.style.zIndex = '1';
        slide.style.opacity = '1';
      }
    });

    if (backgroundSlide) {
      backgroundSlide.style.clipPath = 'inset(0 0 0 0)';
      backgroundSlide.style.zIndex = '2';

      setTimeout(() => {
        if (backgroundSlide) {
          backgroundSlide.style.opacity = '1';
        }
      }, 10);
    }

    if (activeSlide) {
      activeSlide.style.zIndex = '3';

      if (isGoingForward) {
        activeSlide.style.clipPath = 'inset(0 0 0 100%)';
      } else {
        activeSlide.style.clipPath = 'inset(0 100% 0 0)';
      }

      requestAnimationFrame(() => {
        if (activeSlide) {
          activeSlide.style.opacity = '1';
          activeSlide.style.clipPath = 'inset(0 0 0 0)';
        }
      });

    }

    this.previousRealIndex = activeRealIndex;
  }

  cleanupWipeTransition() {
    if (!this.carousel || !this.carousel.swiperElement) {
      return;
    }

    const swiperInstance = this.carousel.swiperElement;
    const slides = swiperInstance.slides;
    const activeRealIndex = swiperInstance.realIndex;


    slides.forEach((slide) => {
      const slideRealIndex = parseInt(slide.dataset.swiperSlideIndex);


      if (slideRealIndex === activeRealIndex) {
        slide.style.clipPath = 'inset(0 0 0 0)';
        slide.style.zIndex = '2';
        slide.style.opacity = '1';
      } else {
        slide.style.clipPath = 'inset(0 0 0 100%)';
        slide.style.zIndex = '1';
        slide.style.opacity = '1';
      }
    });
  }

  createObserver() {
    this.observer = new IntersectionObserver(this.handleIntersect.bind(this), { threshold: 0.5 });
    this.observer.observe(this.element);
  }

  handleIntersect(entries) {
    var _this = this;
    entries.forEach((entry) => {
      if (entry.intersectionRatio === 1 || entry.isIntersecting == true) {
        if (_this.options["numberOfSlides"] > 1) {
          _this.changeImageQuality();
        } else {
          _this.changeImageQuality(true);
        }
        _this.observer.unobserve(_this);
      }
    });
  }
  changeImageQuality(singleItem) {
    const breakpoint = responsive.getCurrentBreakpoint();

    let imageContainers;
    if (singleItem) {
      imageContainers =
        Array.from(this.element.querySelectorAll(".image__element")).slice(0, 2);

    } else {
      const currentIndex = this.carousel.swiperElement.activeIndex;
      const cellElement = this.carousel.swiperElement.slides[currentIndex];

      imageContainers = Array.from(
        cellElement.querySelectorAll(".image__element")).slice(0, 2);
    }

    if (imageContainers.length === 0) {
      return;
    }

    let imageToReveal;
    if (
      breakpoint === "pocket" ||
      breakpoint === "phone" ||
      breakpoint === "tablet"
    ) {
      imageToReveal = imageContainers[0];
    } else {
      if (imageContainers.length == 2) {
        imageToReveal = imageContainers[1];
      } else {
        imageToReveal = imageContainers[0];
      }
    }


    if (!imageToReveal || imageToReveal.dataset.loadedImage === "true") {
      return;
    }

    if (imageToReveal.dataset.src) {
      const replaceUrl = imageToReveal.dataset.src.replace(
        "{width}x",
        "width=2600"
      );
      imageToReveal.src = replaceUrl;
      imageToReveal.dataset.loadedImage = "true";
    }
  }

}
customElements.define("banner-hero", Banner);

class Header extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.isSticky = JSON.parse(this.getAttribute('data-is-sticky'));
    this.scrollableElement = this.element.querySelector('[data-scrollable]');
    this.headerTransparent = false;
    this.topBar = this.element.querySelector(".header__top-bar");
    this.currentOpenMenu = null;
    this.announcementElement = document.querySelector(".announcement-bar--sticky");
    this.pageOverlay = document.querySelector('.pageOverlay');
    this.searchOverlay = document.querySelector('.searchOverlay');
    this.menuTimeout = null; // Single timeout for all menu operations
    this.bottomBar = this.element.querySelector(".header__bottom-bar");

    const selectBoxes = this.element.querySelectorAll(".RevolutionSelectbox");
    if (selectBoxes.length > 0) {
      selectBoxes.forEach((item, i) => {
        new RevolutionSelectbox(item);
      });
    }

    // Ensure accurate header height calculation after styles are loaded
    this.ensureAccurateHeaderHeight();

    this.updateVisibleHeight();
    this.bindEvents();

    this.swiperElement = this.element.querySelector('.swiper');


    if (this.isSticky) {
      this.toggleSticky();
    } else if (this.announcementElement) {
      this.adjustToStickyAnn();
    }

    if (this.isSticky) {
      this.headerTopBar = this.element.querySelector('.header__top-bar');
      this.lastScrollY = window.scrollY;
      this.isHeaderHidden = false;
      this.handleScrollDirection = this.handleScrollDirection.bind(this);
      window.addEventListener('scroll', this.handleScrollDirection, {
        passive: true,
      });
    }
  }

  toggleSticky() {
    if (this.announcementElement) {
      this.element.parentElement.classList.add("header--sticky-with-ann");
    } else {
      this.element.parentElement.classList.add("header--sticky");
    }

    this.element.parentElement.classList.remove("Header--Transparent");
  }

  adjustToStickyAnn() {
    this.element.classList.add("header--not-sticky");
  }

  ensureAccurateHeaderHeight() {
    const setHeaderHeight = () => {
      // Force a reflow to ensure styles are applied
      this.topBar.offsetHeight;

      const height = this.topBar.offsetHeight;
      document.documentElement.style.setProperty(
        "--header-height-fixed",
        height + "px"
      );
    };

    // Method 1: Check if stylesheets are loaded
    const checkStylesLoaded = () => {
      return Array.from(document.styleSheets).every(sheet => {
        try {
          // This will throw if stylesheet isn't loaded
          return sheet.cssRules.length > 0 || sheet.rules.length > 0;
        } catch (e) {
          return false;
        }
      });
    };

    // Method 2: Use multiple timing approaches to ensure accuracy
    const attemptSetHeight = () => {
      // Set height immediately
      setHeaderHeight();

      // Set again after a small delay to catch any late-loading styles
      setTimeout(() => {
        setHeaderHeight();
      }, 100);

      // Set again after DOM is fully ready
      if (document.readyState !== 'complete') {
        window.addEventListener('load', () => {
          setTimeout(setHeaderHeight, 50);
        });
      }
    };

    // Method 3: Use requestAnimationFrame for next paint cycle
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        setHeaderHeight();
      });
    });

    // Method 4: Check if styles are loaded, if not wait
    if (checkStylesLoaded()) {
      attemptSetHeight();
    } else {
      // Wait for stylesheets to load
      const checkInterval = setInterval(() => {
        if (checkStylesLoaded()) {
          clearInterval(checkInterval);
          attemptSetHeight();
        }
      }, 10);

      // Fallback timeout
      setTimeout(() => {
        clearInterval(checkInterval);
        attemptSetHeight();
      }, 1000);
    }

    // Method 5: Also recalculate on font load (which can affect height)
    if (document.fonts) {
      document.fonts.ready.then(() => {
        setTimeout(setHeaderHeight, 50);
      });
    }
  }

  handleScrollDirection() {
    const currentScroll = window.scrollY;
    if (currentScroll > this.lastScrollY && currentScroll > 50) {
      if (!this.isHeaderHidden) {
        this.headerTopBar.classList.add('header--hidden');
        this.isHeaderHidden = true;
      }
    } else {
      if (this.isHeaderHidden) {
        this.headerTopBar.classList.remove('header--hidden');
        this.isHeaderHidden = false;
      }
    }
    this.lastScrollY = currentScroll;
  }

  connectedCallback() {
    document.addEventListener(
      'search:opened',
      this.handleSearchOpened.bind(this)
    );
    document.addEventListener(
      'search:closed',
      this.handleSearchClosed.bind(this)
    );

    if (this.pageOverlay) {
      this._onOverlayClick = () => {
        this.element.dispatchEvent(
          new CustomEvent('close:search', { bubbles: true })
        );

        this.closeOverlay();
      };
      this.pageOverlay.addEventListener('click', this._onOverlayClick);
    }
    if (responsive.currentBreakpoint != 'desktop') {
      this.bottomBar = document.querySelector('.header__bottom-bar');
      this.setupBottomBarObserver();
    }
  }

  disconnectedCallback() {
    document.removeEventListener(
      'search:opened',
      this.handleSearchOpened.bind(this)
    );
    document.removeEventListener(
      'search:closed',
      this.handleSearchClosed.bind(this)
    );

    if (this.pageOverlay && this._onOverlayClick) {
      this.pageOverlay.removeEventListener('click', this._onOverlayClick);
    }

  }

  setupBottomBarObserver() {
    const footer = document.querySelector('footer.footer');
    if (!footer || !this.bottomBar) return;

    const observer = new IntersectionObserver(
      (entries) => {
        if (responsive.currentBreakpoint === 'desktop') return;
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.bottomBar.classList.add('is-hidden');
            this.bottomBar.setAttribute('aria-hidden', 'true');
          } else {
            this.bottomBar.classList.remove('is-hidden');
            this.bottomBar.setAttribute('aria-hidden', 'false');
          }
        });
      },
      {
        root: null,
        threshold: 0.5,
      }
    );

    observer.observe(footer);
  }

  bindEvents() {
    const _this = this;
    this.toggleColorListener = this.toggleColor.bind(this);
    this.delegateBody.on('drawer:close-special-menu', this.closeDropdown.bind(this));

    window.addEventListener('scroll', this.toggleColorListener);
    window.addEventListener('scroll', this.toggleTopBarListener);

    // Desktop menu logic: Open on hover, stay open while on top bar, close when hovering other elements

    // Open menu when hovering menu items with dropdown
    this.delegateElement.on(
      "mouseenter",
      '[data-action="desktop-menu-toggle"]',
      (event, target) => {
        this.keepMenuOpen(event, target);
        this.openMenu(event, target);
      },
      true
    );

    if (responsive.matchesBreakpoint("pocket")) {
      // Open special mobile menu when clicking menu items with dropdown
      this.delegateElement.on(
        "click",
        '[data-action="desktop-menu-toggle"]',
        this.openSpecialMenu.bind(this),
        true
      );
    }

    // Keep menu open when hovering dropdown content
    this.delegateElement.on(
      "mouseenter",
      ".desktop-menu__dropdown-wrapper",
      this.keepMenuOpen.bind(this),
      true
    );

    // Close menu when leaving dropdown
    this.delegateElement.on(
      "mouseleave",
      ".desktop-menu__dropdown-wrapper",
      this.closeMenu.bind(this),
      true
    );

    // Specifically target menu items without dropdown to close current menu
    this.delegateElement.on(
      "mouseenter",
      ".header__menu-item:not([data-action='desktop-menu-toggle'])",
      (event, target) => {
        if (this.currentOpenMenu) {
          this.closeMenu(event);
        }
      },
      true
    );

    // Also close menu when hovering main header elements (logo, account, etc.)
    this.delegateElement.on(
      "mouseenter",
      ".header__top-bar > .header--Wrapper > *:not(.header-link-list):not(.header-main-menu-items)",
      (event, target) => {
        if (this.currentOpenMenu) {
          this.closeMenu(event);
        }
      },
      true
    );


    // Keyboard support for desktop menu
    this.delegateElement.on(
      "keydown",
      '[data-action="desktop-menu-toggle"] a',
      this.handleKeyboardNavigation.bind(this),
      true
    );

    // Unified click: prevent navigation for top-level menu items with children
    this.delegateElement.on(
      'click',
      '[data-action="desktop-menu-toggle"], [data-action="desktop-menu-toggle"] a',
      (event, target) => {
        // Check if this menu item has a dropdown (children)
        const menuItem = event.target.closest('[data-action="desktop-menu-toggle"]');

        // If it has children (dropdown), prevent default navigation
        if (menuItem && menuItem.hasAttribute('data-action')) {
          event.preventDefault();
          event.stopPropagation();
          return false;
        }

        // For items without dropdown, allow normal navigation
        const anchor = (event.target?.closest && event.target.closest('[data-action="desktop-menu-toggle"] a[href]'))
          || (target.matches('a[href]') ? target : target.querySelector('a[href]'));
        if (!anchor || !anchor.href) return;

        // Respect new-tab behavior
        const openInNewTab = anchor.target === '_blank' || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey;
        event.preventDefault();

        // Close any open menus/overlays cleanly
        try { this.closeAllMenus?.(); } catch (_) { }

        if (openInNewTab) {
          window.open(anchor.href, anchor.target || '_blank');
        } else {
          window.location.href = anchor.href;
        }
      },
      true
    );

    window.addEventListener("scroll", this.updateVisibleHeight.bind(this));
    responsive.addResizeListener(this, this.updateVisibleHeight.bind(this));

    // Add specific listener for header height recalculation
    responsive.addResizeListener(this, this.recalculateHeaderHeight.bind(this));
  }

  recalculateHeaderHeight() {
    // Public method to recalculate header height when needed
    // Force reflow and ensure accurate height calculation
    this.topBar.offsetHeight;
    const accurateHeight = this.topBar.offsetHeight;
    document.documentElement.style.setProperty(
      "--header-height-fixed",
      accurateHeight + "px"
    );
  }

  openSpecialMenu(event, target) {
    event.preventDefault();
    event.stopPropagation();
    const handle = target.getAttribute("data-handle");
    if (!handle) return;
    const specialMenuContainer = this.element.querySelector(`#mobile-menu-popup-special--${handle}`);
    if (!specialMenuContainer) return;

    const isCurrentlyOpen = specialMenuContainer.getAttribute('aria-expanded') === 'true';

    if (isCurrentlyOpen) {
      if (window.globalPopup) {
        window.globalPopup.closePopup(specialMenuContainer);
      }
      target.setAttribute('aria-expanded', 'false');
      return;
    }

    const allTriggers = this.element.querySelectorAll('[data-handle][aria-expanded="true"]');
    allTriggers.forEach(trigger => {
      if (trigger !== target) {
        trigger.setAttribute('aria-expanded', 'false');
      }
    });

    // Open the popup (pass isChild=false so it closes other popups automatically)
    if (window.globalPopup) {
      window.globalPopup.openPopup(specialMenuContainer, false);
    }

    // Set trigger state in RAF to match popup timing
    requestAnimationFrame(() => {
      const searchBar = this.element.querySelector('.header__bottom-bar');
      target.setAttribute('aria-expanded', 'true');
      if (searchBar) searchBar.style.opacity = '0';
    });
  }

  closeDropdown(e) {
    const handle = e.target.getAttribute("data-handle-dropdown");
    const headerContainer = this.element.querySelector(`[data-handle="${handle}"]`);
    headerContainer.setAttribute('aria-expanded', 'false');
    const searchBar = this.element.querySelector('.header__bottom-bar');
    if (searchBar) searchBar.style.opacity = '1';
  }

  updateVisibleHeight() {
    setTimeout(() => {
      const rectTopBar = this.topBar.getBoundingClientRect();

      const windowHeight = window.innerHeight;

      let visibleHeightTopBar =
        Math.min(rectTopBar.bottom, windowHeight) - Math.max(rectTopBar.top, 0);

      visibleHeightTopBar = Math.max(visibleHeightTopBar, 0);
      document.documentElement.style.setProperty(
        '--header-dynamic-height',
        `${visibleHeightTopBar}px`
      );

      // Force reflow and ensure accurate height calculation
      this.topBar.offsetHeight;
      const accurateHeight = this.topBar.offsetHeight;
      document.documentElement.style.setProperty(
        "--header-height-fixed",
        accurateHeight + "px"
      );

      const bottomBar = this.element.querySelector(".header__bottom-bar");
      let rectBottomBar = null;
      if (bottomBar) rectBottomBar = bottomBar.getBoundingClientRect();

      // Calculate the visible height
      let visibleHeightBottomBar =
        Math.min(rectBottomBar.bottom, windowHeight) -
        Math.max(rectBottomBar.top, 0);

      visibleHeightBottomBar = Math.max(visibleHeightBottomBar, 0);

      document.documentElement.style.setProperty(
        '--bottom-bar-dynamic-height',
        `${visibleHeightBottomBar}px`
      );

      document.documentElement.style.setProperty(
        '--bottom-bar-height-fixed',
        document.querySelector('.header__bottom-bar').offsetHeight + 'px'
      );
    }, 300);
  }

  toggleTopBar() {
    let current = window.scrollY;
    let annBar = document.querySelector('.announcementBar');
    let element_height = this.element.offsetHeight;

    if ((element_height + annBar.offsetHeight) * 2 < current) {
      this.element.parentElement.classList.add('header--fixed-top-bar');
    }

    if (current <= annBar.offsetHeight) {
      this.element.parentElement.classList.remove('header--fixed-top-bar');
    }

    if (
      this.prevOffset < current &&
      current >= annBar.offsetHeight + this.element.offsetHeight
    ) {
      this.element.parentElement.classList.add('header--hide');
      document.documentElement.style.setProperty(
        '--header-dynamic-height',
        `0px`
      );
    } else {
      this.element.parentElement.classList.remove('header--hide');
      this.updateVisibleHeight();
    }

    this.prevOffset = current;
  }
  updateMenuPosition() {
    document.documentElement.style.setProperty(
      "--submenu-position",
      `${document.querySelector("#header").offsetHeight}px`
    );
  }

  openMenu(event, target) {
    // Only handle mouseenter events for desktop menu
    if (event.type !== "mouseenter") return;

    // Prevent menu opening if search bar is open
    if (this.classList.contains('header--search')) return;

    // Clear any existing timeout
    if (this.menuTimeout) {
      clearTimeout(this.menuTimeout);
      this.menuTimeout = null;
    }

    // Get the data-handle attribute
    const handle = target.getAttribute("data-handle");
    if (!handle) return;

    // Find the corresponding dropdown
    const dropdown = this.element.querySelector(`[data-dropdown="${handle}"]`);
    if (!dropdown) return;

    // If this menu is already open, don't do anything
    if (this.currentOpenMenu && this.currentOpenMenu.target === target) {
      return;
    }

    // Close any currently open menus first (but not this one)
    this.closeAllMenusExcept(handle);

    // Update menu position
    this.updateMenuPosition();

    // Show overlay and enable scroll lock
    this.showMenuOverlay();

    this.bottomBar.setAttribute('aria-hidden', 'true');
    target.setAttribute("aria-expanded", "true");
    target.setAttribute("data-action-state", "menu-open");
    dropdown.setAttribute("aria-hidden", "false");
    dropdown.setAttribute("data-state", "open");

    // Store reference to current open menu
    this.currentOpenMenu = { target, dropdown, handle };

  }

  closeMenu(event, target) {
    // Handle both mouseleave and mouseenter events
    const isMouseLeave = event.type === "mouseleave";
    const isMouseEnter = event.type === "mouseenter";

    if (!isMouseLeave && !isMouseEnter) return;

    // Don't close if no menu is open
    if (!this.currentOpenMenu) return;


    // Clear any existing timeout
    if (this.menuTimeout) {
      clearTimeout(this.menuTimeout);
    }

    if (isMouseEnter) {
      // For mouseenter events, close immediately
      this.closeAllMenus();
    } else {
      // For mouseleave events, use timeout logic
      this.menuTimeout = setTimeout(() => {
        // Check if mouse is over any menu-related element
        const isOverMenuItem = !!document.querySelector('[data-action="desktop-menu-toggle"]:hover');
        const isOverDropdown = !!document.querySelector('[data-dropdown]:hover');

        if (!isOverMenuItem && !isOverDropdown) {
          this.closeAllMenus();
          this.bottomBar.setAttribute('aria-hidden', 'false');
        }
      }, 150);
    }
  }

  keepMenuOpen(event, target) {
    // Clear any pending timeout when entering dropdown or menu
    if (this.menuTimeout) {
      clearTimeout(this.menuTimeout);
      this.menuTimeout = null;
    }
  }

  closeAllMenusExcept(exceptHandle) {
    // Close all open menu items except the specified one
    const allOpenMenuItems = this.element.querySelectorAll('[data-action="desktop-menu-toggle"][aria-expanded="true"]');
    allOpenMenuItems.forEach(item => {
      const handle = item.getAttribute("data-handle");
      if (handle !== exceptHandle) {
        item.setAttribute("aria-expanded", "false");
        item.removeAttribute("data-action-state");
      }
    });

    // Close all open dropdowns except the specified one
    const allOpenDropdowns = this.element.querySelectorAll('[data-dropdown][aria-hidden="false"]');
    allOpenDropdowns.forEach(dropdown => {
      const handle = dropdown.getAttribute("data-dropdown");
      if (handle !== exceptHandle) {
        dropdown.setAttribute("aria-hidden", "true");
      }
    });
  }

  closeAllMenus() {
    // Close all open menu items
    const allOpenMenuItems = this.element.querySelectorAll('[data-action="desktop-menu-toggle"][aria-expanded="true"]');
    allOpenMenuItems.forEach(item => {
      item.setAttribute("aria-expanded", "false");
      item.removeAttribute("data-action-state");
    });

    this.bottomBar.setAttribute('aria-hidden', 'false');

    // Close all open dropdowns
    const allOpenDropdowns = this.element.querySelectorAll('[data-dropdown][aria-hidden="false"]');
    allOpenDropdowns.forEach(dropdown => {
      dropdown.setAttribute("aria-hidden", "true");
    });

    // Reset all second-level menus to closed state (since main menu is closing)
    // Note: individual desktop-menu elements will handle their own second-level state

    // Hide overlay and remove scroll lock
    this.hideMenuOverlay();

    this.toggleColor();
    this.currentOpenMenu = null;

  }

  toggleColor() {
    if (window.pageYOffset > 25) {
      this.element.classList.add('Header--Scrolled');
    } else {
      this.element.classList.remove('Header--Scrolled');
    }
  }

  handleSearchOpened() {
    if (this.pageOverlay) {
      this.pageOverlay.classList.add('is-visible');
    }

    document.documentElement.style.setProperty(
      '--body-padding-right',

      `${document.body.style.paddingRight}`
    );

    this.classList.add('header--search');
    this.closeAllMenus();

    const bottomBarButtons = this.element.querySelector('.header__bottom-bar-buttons');
    if (bottomBarButtons) {
      bottomBarButtons.setAttribute('aria-hidden', 'true');
    }
  }

  handleSearchClosed() {
    this.closeOverlay();
    this.classList.remove('header--search');

    const bottomBarButtons = this.element.querySelector('.header__bottom-bar-buttons');
    if (bottomBarButtons) {
      bottomBarButtons.removeAttribute('aria-hidden');
    }
  }

  closeOverlay() {
    if (this.pageOverlay) {
      this.pageOverlay.classList.remove('is-visible');
    }
  }

  handleKeyboardNavigation(event, target) {
    const menuItem = target.closest('[data-action="desktop-menu-toggle"]');
    if (!menuItem) return;

    switch (event.key) {
      case 'ArrowDown':
      case 'Enter':
      case ' ': // Space key
        event.preventDefault();
        this.openMenu(event, menuItem);
        // Focus first item in dropdown
        const dropdown = this.element.querySelector(`[data-dropdown="${menuItem.getAttribute('data-handle')}"]`);
        if (dropdown) {
          const firstFocusable = dropdown.querySelector('a, button, [tabindex="0"]');
          if (firstFocusable) firstFocusable.focus();
        }
        break;
      case 'Escape':
        event.preventDefault();
        this.closeAllMenus();
        target.focus();
        break;
      case 'ArrowRight':
        event.preventDefault();
        this.focusNextMenuItem(menuItem);
        break;
      case 'ArrowLeft':
        event.preventDefault();
        this.focusPreviousMenuItem(menuItem);
        break;
    }
  }

  focusNextMenuItem(currentItem) {
    const menuItems = Array.from(this.element.querySelectorAll('[data-action="desktop-menu-toggle"] a'));
    const currentIndex = menuItems.findIndex(item => item.closest('[data-action="desktop-menu-toggle"]') === currentItem);
    const nextIndex = (currentIndex + 1) % menuItems.length;
    menuItems[nextIndex].focus();
  }

  focusPreviousMenuItem(currentItem) {
    const menuItems = Array.from(this.element.querySelectorAll('[data-action="desktop-menu-toggle"] a'));
    const currentIndex = menuItems.findIndex(item => item.closest('[data-action="desktop-menu-toggle"]') === currentItem);
    const prevIndex = currentIndex === 0 ? menuItems.length - 1 : currentIndex - 1;
    menuItems[prevIndex].focus();
  }

  showMenuOverlay() {
    if (!this.pageOverlay) return;

    this.pageOverlay.classList.add('is-visible');

    // Add scroll lock to body
    // document.body.classList.add('scrollLock');

    // Disable body scroll using bodyScrollLock if available
    if (typeof bodyScrollLock !== 'undefined') {
      // bodyScrollLock.disableBodyScroll(document.body, bodyScrollLockOptions);
    }

    // Add click listener to close menu when clicking overlay
    if (!this._onMenuOverlayClick) {
      this._onMenuOverlayClick = () => {
        this.closeAllMenus();
      };
    }
    this.pageOverlay.addEventListener('click', this._onMenuOverlayClick);
  }

  hideMenuOverlay() {
    if (!this.pageOverlay) return;

    if (!this.element.classList.contains('header--search')) {
      this.pageOverlay.classList.remove('is-visible');

      // Remove scroll lock from body
      // document.body.classList.remove('scrollLock');

      // Clear body scroll lock if available
      if (typeof bodyScrollLock !== 'undefined') {
        //  bodyScrollLock.clearAllBodyScrollLocks();
      }
    }

    // Remove click listener
    if (this._onMenuOverlayClick) {
      this.pageOverlay.removeEventListener('click', this._onMenuOverlayClick);
    }
  }
}
customElements.define('header-component', Header);

class DesktopMenu extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);

    this.bindEvents();
  }

  connectedCallback() {
    // Initialize any setup needed when element is added to DOM
  }

  bindEvents() {
    // Second-level menu hover events
    this.delegateElement.on(
      "mouseenter",
      '[data-action="open-second-lvl"]',
      this.openSecondLevel.bind(this),
      true
    );

    this.delegateElement.on(
      "mouseleave",
      '[data-action="open-second-lvl"]',
      this.closeSecondLevel.bind(this),
      true
    );

    // Handle hover over regular menu items (without second level)
    this.delegateElement.on(
      "mouseenter",
      '.desktop-menu__item:not([data-action="open-second-lvl"])',
      this.handleRegularItemHover.bind(this),
      true
    );

    // Handle hover over second-level columns
    this.delegateElement.on(
      "mouseenter",
      '.desktop-menu__column.second-column',
      this.keepSecondLevelOpen.bind(this),
      true
    );

    this.delegateElement.on(
      "mouseleave",
      '.desktop-menu__column.second-column',
      this.closeSecondLevel.bind(this),
      true
    );
  }

  openSecondLevel(event, target) {
    // Only handle mouseenter events
    if (event.type !== "mouseenter") return;

    const handle = target.getAttribute("data-handle");
    if (!handle) return;

    // Find the corresponding second column in this dropdown
    const targetColumn = this.element.querySelector(`[data-id="${handle}"]`);
    if (!targetColumn) return;

    // Hide all other second columns in this dropdown
    this.hideAllSecondColumns(handle);

    // Show the target column (CSS handles display via aria-expanded)
    targetColumn.setAttribute("aria-expanded", "true");

    // Add active state to the trigger
    target.setAttribute("data-second-level-active", "true");
  }

  closeSecondLevel(event, target) {
    // Only handle mouseleave events
    if (event.type !== "mouseleave") return;

    // Check if the target has sub-levels (data-action="open-second-lvl")
    const hasSecondLevel = target.hasAttribute('data-action') &&
      target.getAttribute('data-action') === 'open-second-lvl';

    // If hovering over item that doesn't have second level, don't close anything
    // The current second level should stay open
    if (!hasSecondLevel) {
      return;
    }

    // For items that do have second level, no auto-close behavior
    // The second level stays until another one is hovered
  }

  keepSecondLevelOpen(event, target) {
    // This method prevents closing when hovering over the second column
    // Maintains current state when moving between trigger and column
  }

  handleRegularItemHover(event, target) {
    // When hovering over items that don't have second level,
    // just ensure they don't interfere with current second-level state
    // The current second-level should stay open
  }

  hideAllSecondColumns(exceptHandle = null) {
    // Work only within this dropdown instance
    const secondColumns = this.element.querySelectorAll('.desktop-menu__column.second-column');

    secondColumns.forEach(column => {
      const columnId = column.getAttribute('data-id');

      if (exceptHandle && columnId === exceptHandle) {
        // This is the one we want to keep open
        return;
      }

      column.setAttribute("aria-expanded", "false");
      // CSS handles display via aria-expanded, no need for inline style
    });

    // Remove active state from all triggers except the specified one
    const triggers = this.element.querySelectorAll('[data-action="open-second-lvl"]');
    triggers.forEach(trigger => {
      if (exceptHandle && trigger.getAttribute('data-handle') === exceptHandle) {
        // This is the active one, keep its state
        return;
      }
      trigger.removeAttribute("data-second-level-active");
    });
  }
}

customElements.define("desktop-menu", DesktopMenu);


class MainMenuDropdown extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.viewStack = [];
    this.currentView = null;
    this.rootView = null;
    this.levelViews = [];
    this.cleanupObserver = null;
  }

  connectedCallback() {
    // Initialize when element is added to DOM
    this.cacheElements();
    this.setupAriaAndIds();
    this.bindEvents();
    this.observeVisibility();
  }

  bindEvents() {
    // Next level open (click)
    this.delegateElement.on('click', '[data-action="next-lvl"]', this.onNextLevel.bind(this));

    // Next level open (keyboard)
    this.delegateElement.on('keydown', '[data-action="next-lvl"]', (event, target) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        this.onNextLevel(event, target);
      }
    });

    // Back one level (click anywhere on header back container)
    // Allow links inside the header to work normally
    this.delegateElement.on('click', '[data-action="back-lvl"]', (event, target) => {
      // If the click originated from a link (or inside one), don't intercept
      if (event.target && event.target.closest('a')) {
        return; // let the browser follow the link
      }
      this.onBackLevel(event, target);
    });

    // Back one level (keyboard)
    this.delegateElement.on('keydown', '[data-action="back-lvl"]', (event, target) => {
      if (event.key === 'Enter' || event.key === ' ') {
        // If focus is on an interactive element (e.g., the link), let it handle Enter/Space
        if (event.target && event.target.closest('a, button, [role="button"], input, select, textarea')) {
          return;
        }
        event.preventDefault();
        this.onBackLevel(event, target);
      }
    });
  }

  cacheElements() {
    // First/root view is the first inner content that is not a next-level container
    this.rootView = this.element.querySelector(
      '.popup-content > .popup-content__inner.popup-gap:not(.mob-menu__next-lvl)'
    );
    this.levelViews = Array.from(
      this.element.querySelectorAll('.popup-content__inner.mob-menu__next-lvl')
    );

    // Fallback: if root not found, take the first .popup-content__inner
    if (!this.rootView) {
      this.rootView = this.element.querySelector('.popup-content__inner');
    }
  }

  setupAriaAndIds() {

    // Ensure IDs exist for aria-controls to point to real elements
    this.levelViews.forEach((view) => {
      const handle = view.getAttribute('data-id');
      if (handle && !view.id) view.id = handle;
      // Ensure focusable for programmatic focus
      if (!view.hasAttribute('tabindex')) view.setAttribute('tabindex', '-1');

      // Initialize hidden; CSS handles opacity/display via [aria-hidden]
      view.setAttribute('aria-hidden', 'true');
    });

    // Setup root view
    if (this.rootView) {
      if (!this.rootView.hasAttribute('tabindex')) this.rootView.setAttribute('tabindex', '-1');
      this.rootView.setAttribute('aria-hidden', 'false');
      this.currentView = this.rootView;
    }
  }

  observeVisibility() {
    // Reset to root when popup closes
    if (this.cleanupObserver) return;
    const observer = new MutationObserver((mutations) => {
      for (const m of mutations) {
        if (m.type === 'attributes' && m.attributeName === 'aria-hidden') {
          const hidden = this.getAttribute('aria-hidden') === 'true';
          if (hidden) {
            this.resetToRoot();
          } else {
            // focus root when opened
            this.currentView?.focus?.({ preventScroll: true });
          }
        }
      }
    });
    observer.observe(this, { attributes: true, attributeFilter: ['aria-hidden'] });
    this.cleanupObserver = () => observer.disconnect();
  }

  resetToRoot() {
    // Hide all next-level views, show root
    this.levelViews.forEach((v) => {
      v.setAttribute('aria-hidden', 'true');
    });
    // Reset triggers
    this.element.querySelectorAll('[data-action="next-lvl"]').forEach((t) => t.setAttribute('aria-expanded', 'false'));
    if (this.rootView) {
      this.rootView.setAttribute('aria-hidden', 'false');
      this.currentView = this.rootView;
      this.viewStack = [];
    }
  }

  onNextLevel(event, target) {
    event.preventDefault();

    const controls = target.getAttribute('aria-controls');
    if (!controls) return;

    const esc = window.CSS && CSS.escape ? CSS.escape : (s) => s.replace(/"/g, '\\"');
    // Find target by id or data-id
    let nextView = this.element.querySelector(`.mob-menu__next-lvl#${esc(controls)}`);
    if (!nextView) {
      nextView = this.element.querySelector(`.mob-menu__next-lvl[data-id="${esc(controls)}"]`);
    }
    if (!nextView) return;

    // Mark trigger expanded state
    target.setAttribute('aria-expanded', 'true');

    // Push current view to stack for back navigation
    if (this.currentView) {
      this.viewStack.push({ view: this.currentView, trigger: target });
    }

    this.switchView(nextView);
  }

  onBackLevel(event, target) {
    event.preventDefault();
    event.stopPropagation();
    const previous = this.viewStack.pop();
    if (!previous) return;

    // Collapse the trigger associated with the view we are leaving
    if (previous.trigger) previous.trigger.setAttribute('aria-expanded', 'false');

    this.switchView(previous.view);
  }

  switchView(nextView) {
    if (this.currentView === nextView) return;

    // Hide all sibling views to avoid overlap
    this.element.querySelectorAll('.popup-content__inner').forEach((view) => {
      if (view !== nextView) {
        this.hideView(view);
      }
    });

    // Show target view
    this.showView(nextView);

    // Re-apply body scroll lock to the newly active view (important for iOS)
    this._reassignBodyScrollLock(nextView);

    // Update pointer
    this.currentView = nextView;
  }

  hideView(view) {
    if (!view) return;
    // If already hidden, do nothing
    if (view.getAttribute('aria-hidden') === 'true') return;
    // Let CSS handle opacity/display via [aria-hidden]
    view.setAttribute('aria-hidden', 'true');
  }

  showView(view) {
    if (!view) return;
    // Prepare visibility; CSS handles transitions
    view.setAttribute('aria-hidden', 'false');

    // Focus the scrollable region for accessibility
    try {
      view.focus({ preventScroll: true });
      // Reset scroll position to top
      if (typeof view.scrollTo === 'function') {
        view.scrollTo({ top: 0, behavior: 'instant' });
      } else {
        view.scrollTop = 0;
      }
    } catch (_) {
      // fallback for older browsers
      view.scrollTop = 0;
      if (typeof view.focus === 'function') view.focus();
    }
  }

  /**
   * Ensure the body scroll lock is applied to the currently visible level view,
   * not a previously active one. This fixes iOS Safari where only the locked
   * element can scroll while the body is disabled.
   */
  _reassignBodyScrollLock(activeView) {
    try {
      if (!window.bodyScrollLock ||
        typeof bodyScrollLock.disableBodyScroll !== 'function' ||
        typeof bodyScrollLock.enableBodyScroll !== 'function') {
        return;
      }

      // The popup host element is this custom element; Popup.openPopup stores
      // the scrollable element reference on it as _scrollableElement.
      const popupHost = this; // <main-menu-dropdown>

      // Prefer an explicit [data-scrollable] inside the active view; otherwise use the view itself
      const newScrollable = activeView?.querySelector?.('[data-scrollable]') || activeView;

      // If it's unchanged, don't churn locks
      if (popupHost._scrollableElement === newScrollable) return;

      // Re-enable previous scroll target if any
      if (popupHost._scrollableElement) {
        bodyScrollLock.enableBodyScroll(popupHost._scrollableElement);
      }

      // Disable on the new scrollable target
      if (newScrollable) {
        bodyScrollLock.disableBodyScroll(newScrollable, bodyScrollLockOptions);
        popupHost._scrollableElement = newScrollable;
      }
    } catch (e) {
      // Fail-safe: never break navigation if bodyScrollLock errors
    }
  }
}
customElements.define("main-menu-dropdown", MainMenuDropdown);

class Transition {
  constructor() {
    this.pageOverlay = document.querySelector(".pageTransition");

    if (!this.isPageLoaded) {

      document.addEventListener(
        "DOMContentLoaded",
        this.onPageLoaded.bind(this)
      );
    } else {
      this.onPageLoaded();
    }
  }

  onPageLoaded() {
    this.isPageLoaded = true;
    if (this.pageOverlay && window.theme.showPageTransition) {
      this.pageOverlay.animate([{ opacity: 1 }, { opacity: 0 }], {
        duration: 100,
        fill: "forwards",
        easing: "ease-in-out",
        iterations: 1,
      });
    }
  }

  onPageUnload(event, target) {
    if (
      event.defaultPrevented ||
      event.ctrlKey ||
      event.metaKey ||
      !window.theme.showPageTransition ||
      !this.pageOverlay
    ) {
      return;
    }

    event.preventDefault(); // Prevent the click to happen

    if (this.pageOverlay) {
      var timeline = new TimelineLite({
        onComplete: function onComplete() {
          window.location.href = target.href;
        },
      });

      timeline.fromTo(
        this.pageOverlay,
        0.25,
        { autoAlpha: 0, ease: Linear.easeNone },
        { autoAlpha: 1, ease: Linear.easeNone }
      );
    }
  }
}
new Transition();

class VideoComponent extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.options = JSON.parse(this.element.getAttribute("data-section-settings"));
    this.trueObserver = false;
    this.userPaused = false;
    this.delegateElement = new Delegate(this.element);

    if (this.options["using_fade"] == "fade") {
      if (
        this.element.dataset.position == 0 ||
        this.element.closest(".swiper-slide")?.classList.contains("swiper-slide-active") ||
        this.element.closest(".swiper-slide")?.classList.contains("swiper-slide-duplicate-active")
      ) {
        this.checkLoaded();
        this.bindEvents();
      } else {
        this.bindEvents();
      }
    } else {
      this.checkLoaded();
    }
  }

  bindEvents() {
    window.removeEventListener("swiper:slide-changed", this.onSlideChangeListener);
    this.onSlideChangeListener = this.onSlideChange.bind(this);
    window.addEventListener("swiper:slide-changed", this.onSlideChangeListener);
  }

  checkLoaded() {
    var _this = this;
    if (typeof videojs !== "undefined") {
      this.videoPlayerInitialization();
    } else {
      loadScript(window.theme.videoScript);
      setTimeout(function () { _this.checkLoaded(); }, 100);
    }
  }

  onSlideChange(event) {
    this.elementPosition = parseInt(this.element.getAttribute("data-position"));
    if (event.detail.currentIndex == this.elementPosition) {
      if (!this.element.getAttribute("loaded")) {
        var node = document.createElement("div");
        node.appendChild(this.element.querySelector("template").content.firstElementChild.cloneNode(true));
        this.element.appendChild(node.firstElementChild).focus();
        this.element.setAttribute("loaded", true);
        if (!this.videoPlayer) {
          this.checkLoaded();
        } else if (this.options["viewport"]) {
          this.videoPlayer.play();
          this.createObserver();
        }
      } else {
        if (!this.videoPlayer) {
          this.checkLoaded();
        } else if (this.options["viewport"]) {
          this.videoPlayer.play();
          this.createObserver();
        }
      }
    } else if (this.videoPlayer && this.videoPlayer.el_.classList.contains("vjs-playing")) {
      this.videoPlayer.pause();
    }
  }

  videoPlayerInitialization() {
    if (!this.element.getAttribute("loaded")) {
      const node = document.createElement("div");
      node.appendChild(this.element.querySelector("template").content.firstElementChild.cloneNode(true));
      this.element.appendChild(node.firstElementChild).focus();
      this.element.setAttribute("loaded", true);
    }

    const isMobile = responsive.matchesBreakpoint("pocket");

    let aspect_ratio = "";
    let src = "";
    let host = "html5";

    if (isMobile) {
      aspect_ratio = this.options["aspect_mob"] || "9:16";

      if (this.options["videoType"] == "video_inside_media") {
        const sources = this.options["videod"]["sources"];
        let topQuality = null;
        sources.forEach((obj) => {
          if (obj.format === "mp4") {
            if (!topQuality) topQuality = obj;
            if (topQuality.height < obj.height) topQuality = obj;
          }
        });
        const aspectRatioHeight = Math.floor(100 / this.options["videod"]["aspect_ratio"]);
        if (!this.options["video_ratio"]) aspect_ratio = `100:${aspectRatioHeight}`;
        src = topQuality["url"] + "#t=0.001";
      } else if (this.options["videoType"] == "video_inside_media_external") {
        const aspectRatioHeight = Math.floor(100 / this.options["videom"]["aspect_ratio"]);
        if (!this.options["video_ratio"]) aspect_ratio = `100:${aspectRatioHeight}`;
        host = this.options["videom"]["host"];
        src = (host == "youtube")
          ? "https://www.youtube.com/watch?v=" + this.options["videom"]["external_id"]
          : this.options["videom"]["external_id"];
      } else {
        if (this.options["videom"].includes("youtube")) host = "youtube";
        else if (this.options["videom"].includes("vimeo")) host = "vimeo";
        src = this.options["videom"];
      }
    } else {
      aspect_ratio = this.options["aspect_desk"] || "16:9";

      if (this.options["videoType"] == "video_inside_media") {
        const sources = this.options["videod"]["sources"];
        let topQuality = null;
        sources.forEach((obj) => {
          if (obj.format === "mp4") {
            if (!topQuality) topQuality = obj;
            if (topQuality.height < obj.height) topQuality = obj;
          }
        });
        src = topQuality["url"] + "#t=0.001";
        const aspectRatioHeight = Math.floor(100 / this.options["videod"]["aspect_ratio"]);
        if (!this.options["video_ratio"]) aspect_ratio = `100:${aspectRatioHeight}`;
      } else if (this.options["videoType"] == "video_inside_media_external") {
        host = this.options["videod"]["host"];
        const aspectRatioHeight = Math.floor(100 / this.options["videod"]["aspect_ratio"]);
        if (!this.options["video_ratio"]) aspect_ratio = `100:${aspectRatioHeight}`;
        src = (host == "youtube")
          ? "https://www.youtube.com/watch?v=" + this.options["videod"]["external_id"]
          : this.options["videod"]["external_id"];
      } else {
        if (this.options["videod"].includes("youtube")) host = "youtube";
        else if (this.options["videod"].includes("vimeo")) host = "vimeo";
        src = this.options["videod"];
      }
    }

    if (!src) { src = "https://www.youtube.com/watch?v=_9VUPq3SxOc"; host = "youtube"; }

    const type =
      host === "youtube" ? "video/youtube" :
        host === "vimeo" ? "video/vimeo" :
          "video/mp4";

    aspect_ratio = aspect_ratio.replace("/", ":");
    const payload = {
      aspectRatio: aspect_ratio,
      autoplay: false,
      muted: this.options["muted"],
      loop: this.options["loop"],
      controls: false,
      poster: false,
      preload: "metadata",
      playsinline: true,
      responsive: true,
      techOrder: [host],
      disablePictureInPicture: true,
      sources: [{ type, src }]
    };

    const videoplayerID = this.element.querySelector("video");
    this.videoPlayer = videojs(videoplayerID, payload);

    this.videoPlayer.on("ready", () => {
      this.element.querySelector(".videoHolder").style.display = "block";
      if (this.trueObserver == false && this.options["viewport"]) {
        this.createObserver();
      }
      this.bindCustomControls();
      this.bindSurfaceToggle();
      this.syncButtonStates();
    });

    if (this.options["muted"] && host == "vimeo") {
      this.videoPlayer.on("play", () => { this.videoPlayer.muted(true); });
    }
  }

  // Click on the video surface toggles play/pause.
  bindSurfaceToggle() {
    const root = this.videoPlayer?.el();
    const holder = this.element.querySelector(".videoHolder");
    const tech = root?.querySelector(".vjs-tech");

    // guard to avoid double toggles when multiple listeners see the same click
    let toggling = false;
    const toggle = () => {
      if (toggling) return;
      toggling = true;
      if (this.videoPlayer.paused()) {
        this.userPaused = false;
        const p = this.videoPlayer.play();
        if (p && typeof p.then === "function") p.finally(() => { toggling = false; });
        else toggling = false;
      } else {
        this.userPaused = true;
        this.videoPlayer.pause();
        toggling = false;
      }
    };

    const onSurfaceClick = (event) => {
      if (event.target.closest(".section-video__controls")) return;
      if (event.target.closest("button[data-action]")) return;
      toggle();
    };

    if (root) root.addEventListener("click", onSurfaceClick, { capture: true });
    if (holder) holder.addEventListener("click", onSurfaceClick, { capture: true });
    if (tech && tech.tagName === "VIDEO") {
      tech.addEventListener("click", onSurfaceClick, { capture: true });
    }

    if (this.element.matches('[data-action="toggle-state"]')) {
      this.element.addEventListener("click", onSurfaceClick, { capture: true });
    }
  }

  bindCustomControls() {
    this.stateElements = this.element.querySelectorAll(
      "button.section-video__state[data-action='toggle-state']"
    );
    this.soundElements = this.element.querySelectorAll(
      "button.section-video__sound[data-action='toggle-sound']"
    );

    if (!this.stateElements.length && !this.soundElements.length) return;

    // Play/Pause button
    this.delegateElement.on(
      "click",
      "button.section-video__state[data-action='toggle-state']",
      (event) => {
        event.preventDefault();
        event.stopPropagation();

        if (this.videoPlayer.paused()) {
          this.userPaused = false;
          const p = this.videoPlayer.play();
          if (p && typeof p.then === "function") p.catch(() => { });
        } else {
          this.userPaused = true;
          this.videoPlayer.pause();
        }
      }
    );

    // Mute/Unmute button
    this.delegateElement.on(
      "click",
      "button.section-video__sound[data-action='toggle-sound']",
      (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.videoPlayer.muted(!this.videoPlayer.muted());
      }
    );

    // Keep aria-labels in sync
    this.videoPlayer.on("play", () => this.setPlayAria("playing"));
    this.videoPlayer.on("pause", () => this.setPlayAria("paused"));
    this.videoPlayer.on("volumechange", () => this.setSoundAria());

    // Initial sync
    this.syncButtonStates();
  }

  setPlayAria(label) {
    if (!this.stateElements) return;
    this.stateElements.forEach((btn) => btn.setAttribute("aria-label", label));
  }

  setSoundAria() {
    if (!this.soundElements) return;
    const label = this.videoPlayer.muted() ? "muted" : "unmuted";
    this.soundElements.forEach((btn) => btn.setAttribute("aria-label", label));
  }

  syncButtonStates() {
    this.setPlayAria(this.videoPlayer.paused() ? "paused" : "playing");
    this.setSoundAria();
  }

  createObserver() {
    const observer = new IntersectionObserver(this.handleIntersect.bind(this), {
      threshold: 0.2,
      rootMargin: "200px 0px 200px 0px",
    });

    observer.observe(this.element);
    this.trueObserver = true;
  }

  handleIntersect(entries) {
    entries.forEach((entry) => {
      if (entry.intersectionRatio === 1 || entry.isIntersecting == true) {
        if (!this.videoPlayer) {
          this.checkLoaded();
          return;
        }
        if (this.options["viewport"] && this.videoPlayer && !this.userPaused) {
          if (this.options["muted"]) this.videoPlayer.muted(true);
          const ensurePlaying = () => {
            if (!this.videoPlayer.el_.classList.contains("vjs-playing")) {
              const p = this.videoPlayer.play();
              if (p && typeof p.then === "function") p.catch(() => { });
              setTimeout(ensurePlaying, 100);
            }
          };
          ensurePlaying();
        }
      } else if (entry.intersectionRatio === 0 || entry.isIntersecting == false) {
        if (this.videoPlayer && this.videoPlayer.el_.classList.contains("vjs-playing")) {
          this.videoPlayer.pause();
        }
      }
    });
  }
}
customElements.define("video-component", VideoComponent);



var contentCache = {};
sessionStorage.setItem("elementaryLoad", "true");

class RatingElement extends HTMLElement {
  constructor() {
    super();
    this.element = this;
  }

  connectedCallback() {
    this.fetchRating();
  }

  async fetchRating() {
    const productId = this.element.getAttribute('data-product-id');
    // STORE ID
    const appKey = 'Wl13KztIB8th3vgdGC94Xdfy3I1ys2bJ8G3bw8Yv';

    if (!productId || !appKey) {
      console.error('Missing productId or appKey');
      return;
    }

    try {
      const res = await fetch(`https://api.yotpo.com/products/${appKey}/${productId}/bottomline`);

      // Check if the response is ok (status 200-299)
      if (!res.ok) {
        this.hideRating();
        return;
      }

      const data = await res.json();

      // Check if the response has the expected structure
      if (!data || !data.response || !data.response.bottomline) {
        this.hideRating();
        return;
      }

      const ratingData = data.response.bottomline;
      this.renderRating(ratingData);
    } catch (err) {
      this.hideRating();
    }
  }

  renderRating({ average_score, total_reviews }) {
    if (!total_reviews) return;

    const starsHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="14" height="13" viewBox="0 0 14 13" fill="none">
                        <path d="M7.00001 10.5142L11.12 13.0008L10.0267 8.31415L13.6667 5.16082L8.87334 4.75415L7.00001 0.334152L5.12668 4.75415L0.333344 5.16082L3.97334 8.31415L2.88001 13.0008L7.00001 10.5142Z" fill="#FFD814"/>
                      </svg>`;


    const element_location = this.element.getAttribute('data-location');

    const scoreText = element_location === 'product'
      ? `<span class="custom-rating__score u-s4">${average_score}/5 (${total_reviews} reviews)</span>`
      : `<span class="custom-rating__score u-s4">${average_score}/5</span>`;

    this.element.innerHTML = `
      <div class="custom-rating">
        ${starsHTML}
        ${scoreText}
      </div>
    `;
  }

  hideRating() {
    // Hide the rating element when no data is available
    this.element.style.display = 'none';
  }
}

customElements.define('rating-element', RatingElement);



let activeSlide = null;
class ProductElement extends HTMLElement {
  constructor() {
    super();
    this.element = this;
  }

  connectedCallback() {
    this.changeImageQuality();

    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.sectionId = this.element.getAttribute("data-section-id");
    this.carouselElement = this.element.querySelector(".pm__main-swiper");
    this.carouselElementThumbs = this.element.querySelector(".pm__thumb-swiper");

    this.swipers = this.element.querySelectorAll('.pm__information .swiper');

    this.productForm = this.element.querySelector('[data-product-form]');
    this.options = JSON.parse(this.carouselElement.getAttribute("data-section-settings"));
    this.stickyAtc = this.element.querySelector('.pm__atc-form--sticky');
    this.fixedAtc = this.element.querySelector('.pm__sticky-atc');
    this.annBar = document.querySelector('.announcement-bar--sticky');
    if (this.fixedAtc) {
      this.fixedInfo = this.fixedAtc.querySelector('.pm__sticy-product-info');
      this.fixedContainer = this.fixedAtc.querySelector('.pm__sticky-atc-container');
    }
    this.header = document.getElementById('header');
    this.footer = document.querySelector('footer');

    document.documentElement.style.setProperty(
      "--sticky-atc-height",
      `0px`
    );

    if (this.options.slides_number > 1) {
      if (this.carouselElementThumbs) {
        this.carousel = new RevolutionSwiper(
          this.carouselElement,
          this.carouselElementThumbs
        );

      } else {
        this.carousel = new RevolutionSwiper(
          this.carouselElement
        );
      }
    }

    this.swipers.forEach(carousel => {
      if (carousel.classList.contains("product-module__connected-items-inner-wrapper")) {
        if (responsive.currentBreakpoint == 'pocket' || responsive.currentBreakpoint == 'phone') {
          new RevolutionSwiper(carousel)
        }
      } else {
        new RevolutionSwiper(carousel)
      }
    });

    if (this.options.zoom) {
      new RevolutionImageZoom(this.carouselElement, this.carousel);
    }

    new AddToCart(this.element)

    if (
      this.options["variant_image_id"] &&
      this.options["show_variant_image_on_load"]
    ) {
      this.updateImage();
    }

    this.initSelectboxes();
    this.bindEvents();
    this.onScroll();
  }

  disconnectedCallback() {
    // Remove window event listeners using stored bound references
    if (this.boundOnScroll) {
      window.removeEventListener("scroll", this.boundOnScroll);
    }
    if (this.boundSetStickyContent && this.stickyAtc && this.fixedAtc) {
      window.removeEventListener("DOMContentLoaded", this.boundSetStickyContent);
    }
    if (this.boundReloadPage) {
      window.removeEventListener("popstate", this.boundReloadPage);
    }
    if (this.boundReloadWithoutRefresh) {
      window.removeEventListener("load", this.boundReloadWithoutRefresh);
    }

    // Clean up transition handler
    if (this.transitionHandler && this.fixedAtc) {
      this.fixedAtc.removeEventListener('transitionend', this.transitionHandler);
      this.transitionHandler = null;
    }

    // Destroy delegate instances
    if (this.delegateElement) {
      this.delegateElement.off();
    }
    if (this.delegateBody) {
      this.delegateBody.off();
    }

    // Clean up swiper instances if they have destroy methods
    if (this.carousel && typeof this.carousel.destroy === 'function') {
      this.carousel.destroy();
    }

    // Reset sticky ATC height
    document.documentElement.style.setProperty("--sticky-atc-height", "0px");
  }

  bindEvents() {
    // Store bound function references for proper cleanup
    this.boundOnScroll = this.onScroll.bind(this);
    this.boundReloadPage = this.reloadPage.bind(this);
    this.boundReloadWithoutRefresh = this.reloadWithoutRefresh.bind(this);

    window.addEventListener("scroll", this.boundOnScroll, { passive: true });

    if (this.stickyAtc && this.fixedAtc) {
      this.boundSetStickyContent = this.setStickyContent.bind(this);
      window.addEventListener("DOMContentLoaded", this.boundSetStickyContent);
    }

    if (this.productForm) {
      this.delegateElement.on('click', '[data-action="add-to-cart-og"]', () => {
        this.productForm.querySelector('.pm__atc-button--main')?.click();
      });
    }

    this.delegateElement.on('click', '[data-action="slide-to-thumb"]', this.selectSlideThumb.bind(this));
    this.delegateElement.on('click', '.pm__thumbs-swiper__btn-next', this.selectSlideThumb.bind(this));
    this.delegateElement.on('click', '.pm__thumbs-swiper__btn-prev', this.selectSlideThumb.bind(this));
    this.delegateBody.on("variant:changed", this.updateImage.bind(this));

    window.addEventListener("popstate", this.boundReloadPage);
    window.addEventListener("load", this.boundReloadWithoutRefresh);
    this.delegateElement.on("click", '[data-action="handle-reload"]', this.updateContentWithoutReload.bind(this));
  }

  initSelectboxes() {
    const selectBoxes = this.element.querySelectorAll(".RevolutionSelectbox");
    selectBoxes.forEach((item) => {
      new RevolutionSelectbox(item);
    });
  }

  reloadPage(e) {
    window.location.reload();
  }

  async reloadWithoutRefresh() {
    // Cache current section HTML immediately (using pathname only, no origin or params)

    let pdpUrls = this.element.querySelectorAll(
      ".product-module__selectbox-reload"
    );
    let urlsToFetch = Array.from(pdpUrls).map((link) => link.href);
    urlsToFetch.push(window.location.href);

    const fetchAndCacheContent = async (url) => {
      try {
        const htmlContent = await window.apiService.sectionRender(this.sectionId, url);

        contentCache[url] = new DOMParser()
          .parseFromString(htmlContent, "text/html")
          .querySelector(`.product-module--${this.sectionId}`);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    await Promise.all(urlsToFetch.map(fetchAndCacheContent));

    const preloadImages = (container) => {
      if (!container) return;
      const images = container.querySelectorAll(
        ".product-module__product-slider-image--load-first"
      );
      images.forEach((img) => {
        const preloadedImage = new Image();
        preloadedImage.src = img.getAttribute("src");
      });
    };

    Object.values(contentCache).forEach(preloadImages);
  }

  updateImage(event) {
    let imageID = this.options["variant_image_id"];
    if (event) {
      imageID = event.detail.new_image;
    }
    const selector = "#Image--" + imageID;
    const imageEl = this.element.querySelector(selector);

    const slideElement = imageEl.closest(".swiper-slide");
    const realIndex = Array.from(slideElement.parentNode.children).indexOf(
      slideElement
    );

    if (imageEl) {
      this.carousel.selectCell(realIndex);
    }
  }

  updateContentWithoutReload(e) {
    e.preventDefault();
    const url = e.target.href;

    // Check if the click is inside the detailed_view_popup
    const detailedViewPopup = e.target.closest('#detailed_view_popup');

    if (detailedViewPopup) {
      // Get the DetailedProductPopup instance
      // Try to get from global scope or create a new instance
      if (!window.globalDetailedProductPopup) {
        window.globalDetailedProductPopup = new DetailedProductPopup();
      }

      const popupInstance = window.globalDetailedProductPopup;

      // Show loading state
      const targetContainer = detailedViewPopup.querySelector('.popup-content__inner');
      if (targetContainer) {
        targetContainer.innerHTML = `
          <div class="itemLoader is-visible">
            <svg class="icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-dasharray="31.416" stroke-dashoffset="31.416">
                <animate attributeName="stroke-dasharray" dur="2s" values="0 31.416;15.708 15.708;0 31.416;0 31.416" repeatCount="indefinite"/>
                <animate attributeName="stroke-dashoffset" dur="2s" values="0;-15.708;-31.416;-31.416" repeatCount="indefinite"/>
              </circle>
            </svg>
          </div>
        `;
      }

      // Determine context and get appropriate exclude selectors
      let excludeSelectors = null;
      let isVoucherAboutExperience = false;

      // Get all context elements at once
      const exchangeGrid = document.querySelector('exchange-collection-grid');
      const giftboxHandler = document.querySelector('giftbox-choice-handler');
      const accountVouchers = document.querySelector('account-vouchers');
      const productGrid = document.querySelector('product-collection-grid');

      // Check for exchange collection context
      if (exchangeGrid && exchangeGrid.getExcludeSelectors) {
        excludeSelectors = exchangeGrid.getExcludeSelectors();
      }

      // Check for giftbox choice context
      if (!excludeSelectors && giftboxHandler && giftboxHandler.getExcludeSelectors) {
        excludeSelectors = giftboxHandler.getExcludeSelectors();
      }

      // Check for account vouchers context
      if (!excludeSelectors && accountVouchers && accountVouchers.getExcludeSelectors) {
        excludeSelectors = accountVouchers.getExcludeSelectors();
        isVoucherAboutExperience = true;
      }

      // Check for regular product collection grid context
      if (!excludeSelectors && productGrid && productGrid.getExcludeSelectors) {
        excludeSelectors = productGrid.getExcludeSelectors();
      }

      // Use DetailedProductPopup's renderProduct to fetch and display the new product
      popupInstance.renderProduct(detailedViewPopup, url, excludeSelectors, e.target, isVoucherAboutExperience)
        .then(() => {
          // After product is rendered, update popup dataset with new product info
          // Extract product data from the newly rendered content
          const productComponent = targetContainer.querySelector('product-component');
          if (productComponent) {
            const productId = productComponent.dataset.productId;
            const variantId = productComponent.dataset.variantId;

            // Try to get price from product form or data attributes
            const productForm = productComponent.querySelector('[data-product-form]');
            let productPrice = null;
            let productTitle = null;

            if (productForm) {
              productPrice = productForm.dataset.productPrice;
              productTitle = productForm.dataset.productTitle;
            }

            // Fallback: try to get from other elements
            if (!productPrice) {
              const priceElement = productComponent.querySelector('[data-product-price]');
              if (priceElement) {
                productPrice = priceElement.dataset.productPrice;
              }
            }

            // Update popup dataset with new product information
            if (productId) {
              detailedViewPopup.dataset.originalProductId = productId;
            }
            if (variantId) {
              detailedViewPopup.dataset.originalVariantId = variantId;
            }
            if (productPrice) {
              detailedViewPopup.dataset.originalProductPrice = productPrice;
            }
            if (productTitle) {
              detailedViewPopup.dataset.originalProductTitle = productTitle;
            }

            // Re-populate exchange pricing if in exchange context
            if (exchangeGrid && exchangeGrid.populateExchangePriceData) {
              requestAnimationFrame(() => {
                exchangeGrid.populateExchangePriceData(detailedViewPopup);
              });
            }

            // Re-populate giftbox choice data if in giftbox context
            if (giftboxHandler && giftboxHandler.populateChoiceData) {
              requestAnimationFrame(() => {
                giftboxHandler.populateChoiceData(detailedViewPopup);
              });
            }
          } else {
            console.warn('Could not find product-component in rendered content');
          }
        })
        .catch(error => {
          console.error('Error updating popup content:', error);
          console.error('Error details:', {
            message: error.message,
            stack: error.stack,
            url: url,
            excludeSelectors: excludeSelectors
          });
          // Show error message
          if (targetContainer) {
            const errorMessage = TranslationUtils.get('products.product.error_loading', 'Failed to load product. Please try again.');
            targetContainer.innerHTML = `
              <div class="error-message" style="padding: 2rem; text-align: center;">
                <p>${errorMessage}</p>
                <p style="font-size: 0.875rem; color: #666; margin-top: 0.5rem;">Error: ${error.message || 'Unknown error'}</p>
              </div>
            `;
          }
        });

      return;
    }

    // Original behavior for non-popup context (booking page quick load)
    const htmlContent = contentCache[url];
    this.element.parentElement.classList.add('disable-border', 'disable-transition');

    if (htmlContent) {
      // Before loading new product, save current variant options and connected products to sessionStorage
      if (window.selectedVariant) {
        try {
          // Get data-products from connected-products-picker
          const connectedProductsPicker = document.querySelector('connected-products-picker');
          const productsData = connectedProductsPicker?.getAttribute('data-products');
          const products = productsData ? JSON.parse(productsData) : [];

          sessionStorage.setItem('variant_preload', JSON.stringify({
            options: window.selectedVariant.options || [],
            products: products
          }));
        } catch (e) {
          console.error('Error saving variant to sessionStorage:', e);
        }
      }

      document.title = htmlContent.dataset.title;
      this.element.replaceWith(htmlContent);

      document.body.dispatchEvent(
        new CustomEvent("recommendations:reload", {
          bubbles: true,
          detail: htmlContent.dataset.productId
        })
      );

      history.pushState(null, null, url);
    } else {
      window.location.href = url;
    }
  }

  selectSlideThumb(e, target) {

    const currentlyActive = this.element.querySelector('.swiper-slide-thumb-active');
    if (currentlyActive) currentlyActive.classList.remove('swiper-slide-thumb-active');

    let goToIndex = null;

    if (target.classList.contains("pm__thumbs-swiper__btn-prev") || target.classList.contains("pm__thumbs-swiper__btn-next")) {
      const activeThumbSlide = this.element.querySelector(".ProductSlider--Thumb.swiper-slide-active");
      goToIndex = parseInt(activeThumbSlide.dataset.index);
      this.carousel.selectCell(goToIndex);
    } else {
      target.classList.add('swiper-slide-thumb-active')
      goToIndex = parseInt(target.dataset.index);
    }

    this.carousel.thumbSwiper.slideTo(goToIndex);
  }

  setStickyContent() {
    if (!this.stickyAtc) return;
    this.setStickyHeight();

    const selectorLabels = document.querySelectorAll('variant-selects .pm__selector-label');
    if (selectorLabels.length > 1) {
      const stickyDetails = this.fixedInfo.querySelector('.pm__sticky-details');
      stickyDetails.querySelectorAll('.pm__selector-label').forEach(label => label.remove());
      selectorLabels.forEach(label => {
        const clonedLabel = label.cloneNode(true);
        stickyDetails.appendChild(clonedLabel);
      });
    }
  }

  setStickyHeight() {
    if (!this.fixedAtc) return;

    this.fixedAtc.style.visibility = 'hidden';
    this.fixedAtc.style.pointerEvents = 'none';

    const show = this.fixedAtc.classList.contains('show');
    if (!show) this.fixedAtc.classList.add('show');
    const attrValue = this.fixedAtc.getAttribute('aria-expanded');
    this.fixedAtc.setAttribute('aria-expanded', 'true');

    document.documentElement.style.setProperty(
      "--sticky-atc-height",
      `${this.fixedAtc.offsetHeight}px`
    );

    if (!show) this.fixedAtc.classList.remove('show');
    this.fixedAtc.setAttribute('aria-expanded', attrValue);

    this.fixedAtc.style.visibility = '';
    this.fixedAtc.style.pointerEvents = '';
  }

  onScroll() {
    if (!this.stickyAtc) return;

    const annBarHeight = this.annBar ? this.annBar.offsetHeight : 0;
    const offsetTop = this.header.offsetHeight + annBarHeight;
    const showFixed = this.stickyAtc.getBoundingClientRect().top <= offsetTop;
    const productPageCollGrid = document.querySelector(".product-collection-grid");
    let productPageCollGridHeight = 0;
    if (productPageCollGrid) productPageCollGridHeight = productPageCollGrid.offsetHeight;
    const footerHeight = this.footer.offsetHeight || 0;
    const hideFixed = window.innerHeight + window.scrollY >= document.body.offsetHeight - footerHeight - productPageCollGridHeight;
    const shouldShow = showFixed && !hideFixed;

    if (this.fixedAtc && shouldShow && !this.fixedAtc.classList.contains('show')) {
      if (this.transitionHandler) {
        this.fixedAtc.removeEventListener('transitionend', this.transitionHandler);
        this.transitionHandler = null;
      }

      if (responsive.matchesBreakpoint('lap_and_up')) {
        this.fixedContainer.style.visibility = 'visible';
      }

      this.fixedAtc.classList.add('show');
      this.fixedAtc.setAttribute('aria-expanded', 'true');
      this.fixedInfo.setAttribute('aria-hidden', 'false');

    } else if (this.fixedAtc && !shouldShow && this.fixedAtc.classList.contains('show')) {
      this.fixedAtc.setAttribute('aria-expanded', 'false');
      this.fixedAtc.classList.remove('show');

      if (responsive.matchesBreakpoint('lap_and_up')) {
        if (this.transitionHandler) {
          this.fixedAtc.removeEventListener('transitionend', this.transitionHandler);
        }

        this.transitionHandler = () => {
          this.fixedContainer.style.visibility = 'hidden';
          this.fixedInfo.setAttribute('aria-hidden', 'true');
          this.transitionHandler = null;
        };

        this.fixedAtc.addEventListener('transitionend', this.transitionHandler, { once: true });

        setTimeout(() => {
          if (this.transitionHandler) {
            this.fixedAtc.removeEventListener('transitionend', this.transitionHandler);
            this.transitionHandler();
          }
        }, 500);
      } else {
        this.fixedInfo.setAttribute('aria-hidden', 'true');
      }
    }
  }

  changeImageQuality() {
    const imageToReveal = this.element.querySelector(".ProductSlider--ImageFirst");
    if (imageToReveal !== null) {
      const replaceUrl = imageToReveal
        .getAttribute("data-src")
        .replace("{width}x", "2600x");
      imageToReveal.src = replaceUrl;
    }
  }
}
customElements.define("product-component", ProductElement);
class ProductInsights extends HTMLElement {
  constructor() {
    super();
    this.sectionId = this.getAttribute("data-section-id");
    this.abortController = null;
    this.boundEventHandler = this.handleVariantChange.bind(this);
  }

  connectedCallback() {
    document.addEventListener("product-variant:changed", this.boundEventHandler);
  }

  disconnectedCallback() {
    document.removeEventListener("product-variant:changed", this.boundEventHandler);
    if (this.abortController) {
      this.abortController.abort();
    }
  }

  handleVariantChange(e) {
    this.updateVariantDropdowns(e.detail.url);
  }

  async updateVariantDropdowns(variantUrl) {
    try {
      if (this.abortController) {
        this.abortController.abort();
      }
      this.abortController = new AbortController();

      const url = new URL(variantUrl, window.location.origin);
      if (this.sectionId) {
        url.searchParams.set("section_id", this.sectionId);
      }

      const response = await fetch(url.toString(), {
        signal: this.abortController.signal,
        headers: {
          'Accept': 'text/html',
          'X-Requested-With': 'XMLHttpRequest'
        }
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const html = await response.text();

      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      const fetchedSection = doc.querySelector("product-insights");
      if (!fetchedSection) {
        console.warn("No product-insights section found in variant page");
        return;
      }

      const fetchedDropdowns = fetchedSection.querySelectorAll(".dropdown-usps-wrapper");
      if (fetchedDropdowns.length === 0) {
        console.warn("No dropdown-usps-wrapper elements found");
        return;
      }

      const currentDropdowns = this.querySelectorAll(".dropdown-usps-wrapper");
      const updates = [];

      currentDropdowns.forEach((current, i) => {
        const fetched = fetchedDropdowns[i];
        if (!fetched) return;

        const currentSource = current.getAttribute("data-source");
        const fetchedSource = fetched.getAttribute("data-source");

        // Skip if both are 'product'
        if (currentSource === "product" && fetchedSource === "product") {
          return;
        }

        updates.push({
          current,
          replacement: fetched.cloneNode(true)
        });
      });

      updates.forEach(({ current, replacement }) => {
        current.replaceWith(replacement);
      });

      // Re-initialize allDropdowns with the updated DOM
      if (typeof allDropdowns !== 'undefined' && allDropdowns.updateAllDropdowns) {
        allDropdowns.updateAllDropdowns();
      }

      this.abortController = null;

    } catch (err) {
      if (err.name === 'AbortError') {
        return;
      } else {
        console.error("Error updating variant dropdowns:", err);
      }
    }
  }
}

customElements.define("product-insights", ProductInsights);
class ExpandableText extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.isExpanded = false;
  }

  connectedCallback() {
    // We collapse the text content only (.pm__about-text) so that buttons remain visible.
    // Legacy implementation targeted the outer wrapper which included buttons, causing incorrect measurements.
    this.aboutTextWrapper = this.element.querySelector(".pm__about-text");
    this.aboutTextContainer = this.aboutTextWrapper; // alias for clarity / backwards references
    this.showMoreButton = this.element.querySelector(".pm__about__btn-more");
    this.showLessButton = this.element.querySelector(".pm__about__btn-less");

    // Height-based configuration
    this.mobileHeight = parseInt(this.element.dataset.mobileHeight, 10);
    this.desktopHeight = parseInt(this.element.dataset.desktopHeight, 10);
    // Backwards compatibility: if legacy data-max-height exists, treat it as mobile value when new attr absent
    if (!this.mobileHeight) {
      const legacy = parseInt(this.element.dataset.maxHeight, 10);
      if (legacy) this.mobileHeight = legacy;
    }
    // Sensible defaults if still unset
    if (!this.mobileHeight) this.mobileHeight = 180;
    if (!this.desktopHeight) this.desktopHeight = this.mobileHeight + 60; // mild offset default
    this.breakpointDesktopMin = 1025;
    this.fullHTML = this.aboutTextContainer?.innerHTML || '';
    this.fullHeight = null;
    this.currentCollapsedHeight = null;

    this.bindEvents();
    this.initializeHeights();
    this.applyCollapsedState();
    this.scheduleRecalculation();
    this.observeSizeChanges();
    // Mark element as enhanced for CSS adjustments (avoid clipping buttons in outer wrapper)
    this.setAttribute('enhanced', '');
    window.addEventListener('resize', this.handleResize.bind(this));
  }

  bindEvents() {
    this.delegateElement.on('click', '[data-action="show-more"]', this.handleShowMore.bind(this));
    this.delegateElement.on('click', '[data-action="show-less"]', this.handleShowLess.bind(this));
  }

  initializeHeights() {
    if (!this.aboutTextWrapper) return;
    // Remove any stylesheet-imposed max-height so we can measure true full height
    const prevTransition = this.aboutTextWrapper.style.transition;
    this.aboutTextWrapper.style.transition = 'none';
    this.aboutTextWrapper.style.maxHeight = 'none';
    this.aboutTextWrapper.style.overflow = 'hidden';
    this.fullHeight = this.aboutTextWrapper.scrollHeight;
    // Restore transition definition (animation will be applied later if needed)
    this.aboutTextWrapper.style.transition = prevTransition;
    this.currentCollapsedHeight = this.getCollapsedHeight();
    if (this.fullHeight <= this.currentCollapsedHeight + 4) {
      this.hideButtons();
    }
  }

  getCollapsedHeight() {
    return window.innerWidth >= this.breakpointDesktopMin ? this.desktopHeight : this.mobileHeight;
  }

  handleResize() {
    if (this.isExpanded) return;
    const newCollapsed = this.getCollapsedHeight();
    if (newCollapsed !== this.currentCollapsedHeight) {
      this.currentCollapsedHeight = newCollapsed;
      this.applyCollapsedState(false);
    }
  }

  applyCollapsedState(animate = true) {
    if (!this.aboutTextWrapper) return;
    if (this.fullHeight == null) this.fullHeight = this.aboutTextWrapper.scrollHeight;
    const collapsed = this.getCollapsedHeight();
    if (this.fullHeight <= collapsed + 4) {
      this.aboutTextWrapper.style.maxHeight = this.fullHeight + 'px';
      this.hideButtons();
      this.removeAttribute('data-collapsed');
      this.removeAttribute('data-expanded');
      return;
    }
    if (animate) this.aboutTextWrapper.classList.add('with-transition');
    this.aboutTextWrapper.style.maxHeight = collapsed + 'px';
    this.setAttribute('data-collapsed', '');
    this.removeAttribute('data-expanded');
    this.updateButtonVisibility();
  }

  handleShowMore(e) {
    e.preventDefault();
    this.isExpanded = true;
    const startHeight = this.aboutTextWrapper.offsetHeight;
    this.aboutTextWrapper.style.maxHeight = startHeight + 'px';
    this.aboutTextWrapper.offsetHeight; // force reflow
    this.aboutTextWrapper.style.maxHeight = this.fullHeight + 'px';
    this.setAttribute('data-expanded', '');
    this.removeAttribute('data-collapsed');

    this.updateButtonVisibility();
  }

  handleShowLess(e) {
    e.preventDefault();
    this.isExpanded = false;
    const startHeight = this.aboutTextWrapper.offsetHeight;
    const collapsed = this.getCollapsedHeight();
    this.aboutTextWrapper.style.maxHeight = startHeight + 'px';
    this.aboutTextWrapper.offsetHeight; // force reflow
    this.aboutTextWrapper.style.maxHeight = collapsed + 'px';
    this.setAttribute('data-collapsed', '');
    this.removeAttribute('data-expanded');

    this.updateButtonVisibility();
  }

  updateButtonVisibility() {
    if (this.isExpanded) {
      this.showButton(this.showLessButton);
      this.hideButton(this.showMoreButton);
    } else {
      this.showButton(this.showMoreButton);
      this.hideButton(this.showLessButton);
    }
  }

  showButton(button) {
    if (button) {
      button.style.display = "inline-block";
      button.setAttribute("aria-hidden", "false");
    }
  }

  hideButton(button) {
    if (button) {
      button.style.display = "none";
      button.setAttribute("aria-hidden", "true");
    }
  }

  hideButtons() {
    this.hideButton(this.showMoreButton);
    this.hideButton(this.showLessButton);
  }

  // Legacy truncation helpers removed; using height-based collapse.

  scheduleRecalculation() {
    // Recalculate after layout settles (fonts/images) – multiple passes for robustness
    if (!this.aboutTextWrapper) return;
    const recalc = () => {
      if (this.isExpanded) return; // don't override expanded state
      const oldFull = this.fullHeight;
      this.aboutTextWrapper.style.maxHeight = 'none';
      const measured = this.aboutTextWrapper.scrollHeight;
      this.fullHeight = measured;
      // Re-apply collapsed state only if we actually exceed collapsed height
      if (measured > this.getCollapsedHeight() + 4) {
        this.applyCollapsedState(false);
      } else {
        this.hideButtons();
        this.aboutTextWrapper.style.maxHeight = measured + 'px';
      }
    };
    // Microtask / next frame / delayed frame
    requestAnimationFrame(() => {
      recalc();
      setTimeout(() => recalc(), 100);
      setTimeout(() => recalc(), 350); // after potential image loads
    });
    window.addEventListener('load', recalc, { once: true });
  }

  observeSizeChanges() {
    if (!window.ResizeObserver || !this.aboutTextWrapper) return;
    this._resizeObserver = new ResizeObserver((entries) => {
      for (const entry of entries) {
        if (entry.target !== this.aboutTextWrapper) continue;
        if (this.isExpanded) return;
        // If content grew (e.g., image loaded) and we previously hid buttons incorrectly, re-evaluate
        const trueHeight = this.aboutTextWrapper.scrollHeight;
        if (trueHeight !== this.fullHeight) {
          this.fullHeight = trueHeight;
          if (trueHeight > this.getCollapsedHeight() + 4) {
            this.applyCollapsedState(false);
          }
        }
      }
    });
    this._resizeObserver.observe(this.aboutTextWrapper);
  }
}

customElements.define("expandable-text-element", ExpandableText);

window.selectedVariant = null;
class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.type = this.element.getAttribute("data-type");
    this.productID = this.element.getAttribute("data-product-id");
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.isBookingPage = this.element.getAttribute("data-booking-page");

    this.updateOptions();
    this.updateMasterId();
    this.bindEvents();
  }

  bindEvents() {
    this.delegateBody.on("quantity:changed", this.onQuantityChange.bind(this));

    var selectboxes = this.element.querySelectorAll("select:not(#vendor-selector), input");
    selectboxes.forEach((item) => {
      item.addEventListener("change", this.onVariantChange.bind(this));
    });
  }

  connectedCallback() {
    this.participantInput = this.element.querySelector('.pm__participants-input');
    this.productComponentParent = this.element.closest('.product__module-parent');

    // Check if there's a variant to restore from sessionStorage
    try {
      const variantPreload = sessionStorage.getItem('variant_preload');
      if (variantPreload) {
        const preloadData = JSON.parse(variantPreload);

        // Check if current product ID is in the saved products list
        if (preloadData.products && Array.isArray(preloadData.products)) {
          const currentProductId = this.productID ? String(this.productID) : null;
          // Convert all product IDs to strings for comparison
          const productsAsStrings = preloadData.products.map(id => String(id));
          const isInProductsList = currentProductId && productsAsStrings.includes(currentProductId);

          if (isInProductsList && preloadData.options?.length > 0) {
            // Select variant by options
            this.selectVariantByOptions(preloadData.options);

            // After variant is selected, restore participant values from localStorage
            setTimeout(() => {
              const bookingSteps = document.querySelector('booking-steps');
              if (bookingSteps && typeof bookingSteps.loadFormData === 'function') {
                bookingSteps.loadFormData();
              }
            }, 100);
          }
        }
      }
    } catch (e) {
      console.error('Error restoring variant from sessionStorage:', e);
    }
  }

  onQuantityChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton();
  }

  onVariantChange(e) {
    console.log('onVariantChange');
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton();
    this.emitVariantChanged();

    this.updateMedia();
    this.updateURL();
    this.updateVariantInput();
    this.renderProductInfo();
    if (e) this.handleBookingPageSteps(e);
    this.productComponentParent.classList.remove('disable-border');
    setTimeout(() => {
      this.productComponentParent.classList.remove('disable-transition');
    }, 50);

    this.element.dispatchEvent(
      new CustomEvent("product-variant:changed", {
        bubbles: true,
        detail: { productId: this.productID, url: window.location.href }
      })
    );
  }


  emitVariantChanged() {
    const detail = { variant: this.currentVariant };
    document.body.dispatchEvent(new CustomEvent('booking:variant-changed', { detail }));
  }

  handleBookingPageSteps(e) {

    const stepElement = e.target.closest(".pm__booking-step");
    if (!stepElement) return;
    const stepNumber = parseInt(stepElement.getAttribute("data-step"));

    this.element.dispatchEvent(
      new CustomEvent("update-step", {
        bubbles: true,
        detail: { stepNumber: stepNumber },
      })
    );
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll('select:not(#vendor-selector), input:checked, input[type="number"]'),
      (select) => select.value
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      // Check if both arrays have the same length
      if (variant.options.length !== this.options.length) {
        return false;
      }

      return this.options.every(option => variant.options.includes(option)) &&
        variant.options.every(option => this.options.includes(option));
    });

    // Expose globally for booking price calculator
    window.selectedVariant = this.currentVariant;
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const newMedia = this.currentVariant.featured_media.id;
    if (!newMedia) return;
    this.element.dispatchEvent(
      new CustomEvent("variant:changed", {
        bubbles: true,
        detail: { new_image: newMedia },
      })
    );
  }

  updateURL() {
    if (!this.currentVariant) return;

    const url = new URL(window.location);
    url.searchParams.set('variant', this.currentVariant.id);
    window.history.replaceState({}, "", url.toString());
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.productID}, #product-form-installment`
    );

    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  async renderProductInfo(...selectors) {
    // 1) default to the old two if none passed
    if (selectors.length === 0) {
      selectors = [
        '.pm__price-container',
        '.pm__price-container .price__compare',
        '.pm__sticky-info',
        '.pm__product-atc-wrapper',
        '.pm__sticky-atc-wrapper'
      ];
    }

    const url = new URL(this.dataset.url, window.location.origin);
    url.searchParams.set('variant', this.currentVariant.id);
    url.searchParams.set('section_id', this.dataset.section);

    try {
      const response = await fetch(url.href, {
        headers: {
          'Accept': 'text/html',
          'X-Requested-With': 'XMLHttpRequest'
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const text = await response.text();
      const html = new DOMParser().parseFromString(text, 'text/html');

      // 3) update each selector in turn
      selectors.forEach((sel) => {
        const src = html.querySelector(sel);
        const dests = document.querySelectorAll(sel);

        dests.forEach(dest => {
          if (src) {
            if (sel === '.pm__sticky-info') {    //copy el because wrapper element is needed
              const newEl = src.cloneNode(true);
              dest.replaceWith(newEl);
            } else {
              dest.innerHTML = src.innerHTML;  // reset any previous hiding
              dest.style.opacity = '';
            }
          } else {
            dest.style.opacity = '0';        // hide if missing in fetched HTML
          }
        });
      });

      // 4) finally trigger any follow-up logic
      this.toggleAddButton();
    }
    catch (err) {
      console.error('Error updating product info:', err);
    }
  }



  toggleAddButton() {
    if (!this.currentVariant) return;

    let quantity = "";
    const addButton = document.querySelector(".pm__atc-button--main"),
      quantityEl = document.querySelector('.pm__quantity-input');
    if (quantityEl) {
      quantity = quantityEl.value;
    }

    if (!addButton) return;
    if (!quantity) {
      quantity = 1;
    }



    if (this.currentVariant.available == false) {
      if (!document.querySelector('notify-me-popup')) {
        addButton.setAttribute("disabled", "disabled");
        addButton.classList.add("pc__sold-out");
      }
    } else {
      addButton.removeAttribute("disabled");
      addButton.classList.remove("pc__sold-out");
    }
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('#variants-json[type="application/json"]').textContent);
    return this.variantData;
  }

  selectVariantByOptions(options) {
    if (!options || options.length === 0) return false;

    // For each option value, find and click matching UI elements
    options.forEach((optionValue, optionIndex) => {
      // Check if this option is for participants by checking data-position
      const participantQuantity = this.element.querySelector(`quantity-input-participants[data-position]`);
      if (this.participantInput && optionIndex == (participantQuantity.dataset.position - 1)) {
        // This is a participant option - update the participant input
        this.participantInput.value = optionValue;
        this.participantInput.dispatchEvent(new Event('change', { bubbles: true }));
        return;
      }

      // Try to find input with matching value (radio, checkbox, etc.)
      const input = this.querySelector(`input[value="${optionValue}"]`);
      if (input) {
        if (input.type === 'radio' || input.type === 'checkbox') {
          input.click();
        }
        return;
      }

      // Try RevolutionSelectbox item with data-value
      const selectboxItem = this.querySelector(`.RevolutionSelectbox--Item[data-value="${optionValue}"]`);
      if (selectboxItem) {
        selectboxItem.click();
        return;
      }
    });

    return true;
  }

  captureParticipantFormValues() {
    const participantData = [];
    const participantForms = document.querySelectorAll('.pm__participant-info-form');

    participantForms.forEach((participantForm, formIndex) => {
      const participants = participantForm.querySelectorAll('.pm__participant-info');
      const formData = [];

      participants.forEach((participant, participantIndex) => {
        const inputs = participant.querySelectorAll('input, textarea, select');
        const participantData = {};

        inputs.forEach(input => {
          if (input.value && input.value.trim() !== '') {
            // Use multiple identifiers to reliably find this input later
            const key = input.id || input.name || input.type || `input-${Array.from(participant.querySelectorAll('input, textarea, select')).indexOf(input)}`;
            participantData[key] = input.value;
          }
        });

        formData[participantIndex] = participantData;
      });

      participantData[formIndex] = formData;
    });

    return participantData;
  }

  restoreParticipantFormValues(participantFormValues) {
    const participantForms = document.querySelectorAll('.pm__participant-info-form');

    participantForms.forEach((participantForm, formIndex) => {
      const savedFormData = participantFormValues[formIndex];
      if (!savedFormData) return;

      const currentParticipants = participantForm.querySelectorAll('.pm__participant-info');

      currentParticipants.forEach((participant, participantIndex) => {
        const savedParticipantData = savedFormData[participantIndex];
        if (!savedParticipantData) return; // No saved data for this participant (e.g., newly added)

        const inputs = participant.querySelectorAll('input, textarea, select');

        inputs.forEach(input => {
          const key = input.id || input.name || input.type || `input-${Array.from(participant.querySelectorAll('input, textarea, select')).indexOf(input)}`;

          if (savedParticipantData[key]) {
            input.value = savedParticipantData[key];
          }
        });
      });
    });
  }


}
customElements.define("variant-selects", VariantSelects);

class QuantityInputParticipants extends HTMLElement {
  constructor() {
    super();
    this.element = this;
  }

  connectedCallback() {
    this.input = this.querySelector("input");
    this.delegateElement = new Delegate(this.element);

    this.delegateElement.on("click", "button", this.onButtonClick.bind(this));
    this.delegateElement.on("input", "input", this.onInput.bind(this));
    this.delegateElement.on("change", "input", this.renderAllParticipantInputs.bind(this));

    // Only render on load for grouped vouchers (normal bookings already have inputs from Liquid)
    if (window.bookingData?.groupId) {
      this.renderGroupedParticipantInputs();
    }
  }

  onInput() {
    if (this._handlingInput) return;
    this._handlingInput = true;

    const max = parseInt(this.input.getAttribute('max'));
    const min = parseInt(this.input.getAttribute('min'));
    const previousValue = this.input.value;
    let value = parseInt(this.input.value);

    if (isNaN(value)) {
      value = min;
    } else if (value > max) {
      value = max;
    } else if (value < min) {
      value = min;
    }

    this.input.value = value;

    if (previousValue !== value.toString()) {
      this.input.dispatchEvent(new Event("change", { bubbles: true }));
    }

    this._handlingInput = false;
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    if (event.target.name === "plus-participants") {
      this.input.stepUp();
    } else {
      this.input.stepDown();
    }

    if (this.input.value > 1) {
      this.element.classList.add('active');
    } else {
      this.element.classList.remove('active');
    }

    if (previousValue !== this.input.value) {
      this.input.dispatchEvent(new Event("change", { bubbles: true }));
    }
  }

  renderAllParticipantInputs() {
    // Determine if this is a grouped booking or normal booking
    if (window.bookingData?.groupId) {
      this.renderGroupedParticipantInputs();
    } else {
      this.renderNormalParticipantInputs();
    }
  }

  renderNormalParticipantInputs() {
    // For normal (non-grouped) bookings - only called when user changes quantity
    const targetCount = parseInt(this.input.value) || 1;
    const participantWrapper = document.querySelector('[data-participant-wrapper]');
    if (!participantWrapper) return;

    // Get all existing participant containers (including the one with data-participant-template)
    const existingParticipants = Array.from(participantWrapper.querySelectorAll('.pm__participant-info'));
    const currentCount = existingParticipants.length;

    if (currentCount === targetCount) return;

    if (currentCount < targetCount) {
      // Need to add more participants - duplicate the last one
      const lastParticipant = existingParticipants[existingParticipants.length - 1];
      if (!lastParticipant) return;

      // Add new empty participants
      for (let i = currentCount; i < targetCount; i++) {
        const clone = lastParticipant.cloneNode(true);
        clone.removeAttribute('data-participant-template');

        // Clear input values for new participants
        clone.querySelectorAll('input, textarea, select').forEach(input => {
          input.value = '';
          if (input.type === 'checkbox' || input.type === 'radio') {
            input.checked = false;
          }
        });

        // Update label with correct order number
        const label = clone.querySelector('.pm__participant-info-label');
        if (label) {
          label.textContent = TranslationUtils.get('products.product.participant_form.participant', '{{ order_number }}. Participant').replace('{{ order_number }}', i + 1);
        }

        participantWrapper.appendChild(clone);
      }
    } else {
      // Need to remove extra participants (but keep at least one)
      for (let i = currentCount - 1; i >= targetCount; i--) {
        existingParticipants[i].remove();
      }
    }

    // Restore values from localStorage and save current state
    const bookingSteps = document.querySelector('booking-steps');
    if (bookingSteps) {
      if (typeof bookingSteps.loadFormData === 'function') {
        bookingSteps.loadFormData();
      }
      if (typeof bookingSteps.saveFormData === 'function') {
        bookingSteps.saveFormData();
      }
    }
  }

  renderGroupedParticipantInputs() {
    // For grouped bookings - renders voucher structure with participant inputs
    const participantsPerVoucher = parseInt(this.input.value) || 1;
    const participantWrapper = document.querySelector('[data-participant-wrapper]');
    if (!participantWrapper) return;

    // Get group vouchers info
    const orderIds = window.bookingData?.orderIds || [];
    const voucherCount = orderIds.length || 1;

    // Get all existing participants (including the one with data-participant-template) to clone from
    const existingParticipants = Array.from(participantWrapper.querySelectorAll('.pm__participant-info'));
    const lastParticipant = existingParticipants[existingParticipants.length - 1];
    if (!lastParticipant) return;

    // Clear all existing participants and headings
    participantWrapper.querySelectorAll('.pm__participant-info, .pm__voucher-group-heading').forEach(el => el.remove());

    // Render participants for each voucher
    for (let voucherIndex = 0; voucherIndex < voucherCount; voucherIndex++) {
      // Add voucher heading if multiple vouchers
      if (voucherCount > 1) {
        const heading = document.createElement('h4');
        heading.className = 'pm__voucher-group-heading u-s2';
        heading.textContent = `${TranslationUtils.get('products.product.participant_form.voucher_heading', 'Voucher')} ${orderIds[voucherIndex] || (voucherIndex + 1)}`;
        participantWrapper.appendChild(heading);
      }

      // Render participants for this voucher
      for (let participantIndex = 0; participantIndex < participantsPerVoucher; participantIndex++) {
        const clone = lastParticipant.cloneNode(true);

        // Remove data-participant-template from clones (first participant can keep it as reference)
        if (voucherIndex > 0 || participantIndex > 0) {
          clone.removeAttribute('data-participant-template');
        }

        // Clear all input values first
        clone.querySelectorAll('input, textarea, select').forEach(input => {
          input.value = '';
          if (input.type === 'checkbox' || input.type === 'radio') {
            input.checked = false;
          }
        });

        // Update label with correct order number
        const label = clone.querySelector('.pm__participant-info-label');
        if (label) {
          label.textContent = TranslationUtils.get('products.product.participant_form.participant', '{{ order_number }}. Participant').replace('{{ order_number }}', participantIndex + 1);
        }

        participantWrapper.appendChild(clone);
      }
    }

    // Restore values from localStorage and save current state
    const bookingSteps = document.querySelector('booking-steps');
    if (bookingSteps) {
      if (typeof bookingSteps.loadFormData === 'function') {
        bookingSteps.loadFormData();
      }
      if (typeof bookingSteps.saveFormData === 'function') {
        bookingSteps.saveFormData();
      }
    }
  }
}

customElements.define("quantity-input-participants", QuantityInputParticipants);

class NotifyMePopup extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);

    this.bindEvents();
  }

  connectedCallback() {
    if (document.querySelector(".notify-me__overlay")) {
      this.notifyMeOverlayElement = document.querySelector(".notify-me__overlay");
    }

    this.allMessages = this.element.querySelectorAll(".pm__notify-action");
    this.emailContainer = this.element.querySelector('.notify-me__popup-inputs-container .field');
    this.emailInput = this.element.querySelector('.notify-me__popup-inputs input');
    this.subscribeButton = this.element.querySelector(".notify-me__popup-submit");
    this.okButton = this.element.querySelector(".notify-me__popup-ok");
  }

  bindEvents() {
    //Notify me 
    this.delegateBody.on(
      "click",
      '[data-action="notify-me"]',
      this.openNotifyMe.bind(this)
    );
    this.delegateBody.on(
      "click",
      '[data-action="close-notify-me"]',
      this.closeNotifyMe.bind(this)
    );
    this.delegateBody.on(
      "click",
      '.notify-me__overlay.is-visible',
      this.closeNotifyMe.bind(this)
    );

    this.delegateElement.on(
      "click",
      '[data-action="subscribe-notify-me"]',
      this.handleSubscribe.bind(this)
    );
  }

  openNotifyMe(e) {
    e.preventDefault();
    const notifyMePopUp = this.element.querySelector('.notify-me__popup-wrapper[aria-hidden="true"]');
    if (notifyMePopUp) {
      //add choosen variants
      let form = document.querySelector('.pm__atc-form--notify-me');
      let inputID = form.querySelector('input[name="id"]');
      let variantINFO = inputID.getAttribute('value');
      notifyMePopUp.setAttribute('variant-value', `${variantINFO}`);

      notifyMePopUp.setAttribute('aria-hidden', 'false');
      requestAnimationFrame(() => {
        notifyMePopUp.setAttribute('aria-visible', 'true');
      });

      this.notifyMeOverlayElement.classList.add("is-visible");
      bodyScrollLock.disableBodyScroll(this.element, bodyScrollLockOptions);
    }
  }

  closeNotifyMe(e) {
    e.preventDefault();

    const notifyMePopUp = this.element.querySelector('.notify-me__popup-wrapper[aria-hidden="false"]');
    if (notifyMePopUp) {

      notifyMePopUp.setAttribute('aria-visible', 'false');

      const handleTransitionEnd = () => {
        notifyMePopUp.setAttribute('aria-hidden', 'true');
        notifyMePopUp.removeEventListener('transitionend', handleTransitionEnd);
      };

      notifyMePopUp.addEventListener('transitionend', handleTransitionEnd, { once: true });

      this.notifyMeOverlayElement.classList.remove("is-visible");
      bodyScrollLock.clearAllBodyScrollLocks();

      this.subscribeButton.style.display = "flex";
      this.okButton.setAttribute("aria-hidden", "true");
      this.emailInput.value = '';
      this.emailContainer.style.display = "flex";
    }
  }

  clearSuccessErrorMessages() {
    this.allMessages.forEach((el) =>
      el.setAttribute("aria-hidden", "true")
    );
  }

  handleSubscribe(e) {
    e.preventDefault();
    let elementWithId = this.element.querySelector('.notify-me__popup-wrapper');

    if (elementWithId) {
      const variantId = elementWithId.getAttribute("variant-value");
      const productId = elementWithId.getAttribute("notify-product-id");

      const email = this.emailInput.value;

      let promise = SI.create(email, variantId, productId);

      if (email !== "" && email.includes("@")) {
        promise.then((st, data) => {
          let resp = SI.parseJSON(data);
          if (resp.status == "OK") {
            this.showNotification("success");
          } else {
            this.showNotification("error");
          }
        });

      } else {
        this.showNotification("email-error");
      }
    }
  }

  showNotification(string) {
    this.clearSuccessErrorMessages();

    let activeNotification;
    switch (string) {
      case "success":
        activeNotification = this.element.querySelector(".notify-me__success-msg");

        this.subscribeButton.style.display = "none";
        this.okButton.setAttribute("aria-hidden", "false");
        activeNotification.setAttribute("aria-hidden", "false");
        this.emailInput.value = '';
        this.emailContainer.style.display = "none";
        break;

      case "email-error":
        activeNotification = this.element.querySelector(
          ".pm__notify-action-action--email-error"
        );
        break;

      default:
        activeNotification = this.element.querySelector(
          ".pm__notify-action-action--error"
        );
        break;
    }

    activeNotification.setAttribute("aria-hidden", "false");
  }

}
customElements.define("notify-me-popup", NotifyMePopup);

class SearchBar extends HTMLElement {
  static cachedResults = {};

  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.isOpen = false;

    this.searchInputElement =
      this.element.querySelector('.searchInput') ||
      this.element.querySelector('[name="q"]');
    this.searchForm = this.element.querySelector('.searchForm');

    this.searchResultsElement = this.element.querySelector('.searchWrapper');
    this.headerBottomBar = this.element.closest('.header__bottom-bar');
    this.predictiveSearchWrappper = this.element.querySelector(
      '.search-wrapper__predictive-search'
    );
    this.options = JSON.parse(this.element.getAttribute('data-settings'));
    this.initialSearchLayout = this.searchResultsElement.cloneNode(true);
    this.initialProductsWrapper = this.element.querySelector(
      '.search-wrapper__initial-products'
    );
    this.clearSearchButton = document.querySelectorAll('.searchInput--clear');

    this.bindEvents();
    this.setupDrawerIntegration();

    this.boundHandleInputFocus = this.handleInputFocus.bind(this);
    this.boundHandleInputBlur = this.handleInputBlur.bind(this);

    if (this.searchInputElement) {
      this.searchInputElement.addEventListener('focus', this.boundHandleInputFocus);
      this.searchInputElement.addEventListener('blur', this.boundHandleInputBlur);
    }

    this.responsive = new Responsive(true);
    responsive.addResizeListener(this, this.handleResize.bind(this));
    document.addEventListener(
      'breakpoint:changed',
      this.handleBreakpointChange.bind(this)
    );
    this.handleResize();

    this.selectedLocation =
      this.element.querySelector('.search-wrapper__location-card')?.dataset
        .location || null;

    if (this.searchInputElement === document.activeElement && this.responsive.matchesBreakpoint('pocket')) {
      this.searchInputElement.blur();
    }
  }

  setupDrawerIntegration() {
    this.searchDrawer = new Drawer(this.element, {
      onClose: this.closeSearch.bind(this),
    });
  }

  bindEvents() {
    this._onInputListener = debounce(this.onInput.bind(this), 450);

    this.delegateElement.on(
      'click',
      '[data-action="open-search"]',
      this.openSearch.bind(this)
    );
    this.delegateElement.on(
      'click',
      '[data-action="clear-input"]',
      this.resetSearch.bind(this)
    );
    this.delegateElement.on(
      'click',
      '[data-action="close-search"]',
      this.closeSearch.bind(this)
    );

    this.searchInputElement.addEventListener('input', this._onInputListener);

    this.delegateElement.on(
      'click',
      '[data-action="search-string"]',
      this.onInput.bind(this)
    );

    this.delegateElement.on(
      'keypress',
      '[data-action="search-string"]',
      this.onInput.bind(this)
    );

    this.delegateElement.on(
      'click',
      '.search-wrapper__location-card',
      this.onLocationSelect.bind(this)
    );

    this.delegateBody.on('menu:open', this.closeSearch.bind(this));
    this.delegateBody.on('close:search', this.closeSearch.bind(this));

    this.delegateBody.on(
      'click',
      '[data-action="close-quick-search"]',
      this.closeSearch.bind(this)
    );
  }

  handleInputFocus() {
    if (this.headerBottomBar) this.headerBottomBar.classList.add('search-focused')
  }

  handleInputBlur() {
    if (this.headerBottomBar) this.headerBottomBar.classList.remove('search-focused')
  }

  isMobileDevice() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  }

  onLocationSelect(event) {
    event.preventDefault();
    const card = event.target.closest('.search-wrapper__location-card');
    const location = card.dataset.location;

    this.element
      .querySelectorAll('.search-wrapper__location-card')
      .forEach((el) => el.classList.remove('is-selected'));

    this.element
      .querySelectorAll(`[data-location="${location}"]`)
      .forEach((item) => item.classList.add('is-selected'));
    this.selectedLocation = location;

    this.onInput({ target: this.searchInputElement });
  }

  resetLocations() {
    this.element
      .querySelectorAll('.search-wrapper__location-card')
      .forEach((el) => el.classList.remove('is-selected'));

    this.element
      .querySelectorAll(`[data-location="global"]`)
      .forEach((item) => item.classList.add('is-selected'));
    this.selectedLocation = 'global';
  }

  handleBreakpointChange() {
    if (this.isOpen) {
      this.closeSearch();
    }
  }

  handleResize() {
    if (!this.searchInputElement) return;
    const wrapper = this.element.querySelector('.searchInput--Wrapper');

    if (this.searchInputElement) {
      document.documentElement.style.setProperty(
        '--search-header-height',
        `${this.searchInputElement.offsetHeight + 48}px`
      );
    }

    if (
      this.responsive.matchesBreakpoint('phone') &&
      wrapper.offsetWidth < 200
    ) {
      this.searchInputElement.setAttribute(
        'placeholder',
        this.searchInputElement.getAttribute('data-placeholder-min')
      );
    } else if (this.responsive.matchesBreakpoint('lap_and_up')) {
      this.searchInputElement.setAttribute(
        'placeholder',
        this.searchInputElement.getAttribute('data-placeholder-desk')
      );
    } else {
      this.searchInputElement.setAttribute(
        'placeholder',
        this.searchInputElement.getAttribute('data-placeholder-mob')
      );
    }
  }

  openSearch(event) {
    const clickedInsideResults = event?.target?.closest('.searchWrapper');

    if (!clickedInsideResults) {
      this.searchInputElement.focus();
      if (this._searchCloseTimeout) {
        clearTimeout(this._searchCloseTimeout);
        this._searchCloseTimeout = null;
      }
      if (this._searchTransitionHandler) {
        this.searchResultsElement.removeEventListener(
          'transitionend',
          this._searchTransitionHandler
        );
        this._searchTransitionHandler = null;
      }
    }

    if (this.isOpen) return;

    if (responsive.matchesBreakpoint('pocket')) {
      document.body.classList.add('search-open');
      const announcementBar = document.querySelector('.shopify-section-section-announcement_bar');
      if (announcementBar && responsive.matchesBreakpoint('pocket')) {
        announcementBar.style.zIndex = 19;
      }
    }

    event.preventDefault();
    event.stopPropagation();

    this.element.dispatchEvent(
      new CustomEvent('menu:close', { bubbles: true })
    );

    if (!this.element || !this.searchResultsElement) {
      console.error('Search element not found');
      return;
    }

    if (this.searchInputElement) {
      document.documentElement.style.setProperty(
        '--search-header-height',
        `${this.searchInputElement.offsetHeight + 48}px`
      );
    }

    this.searchResultsElement.style.opacity = '';
    void this.searchResultsElement.offsetWidth;

    this.searchResultsElement.setAttribute('aria-hidden', 'false');
    this.searchResultsElement.style.visibility = 'visible';

    void this.searchResultsElement.offsetWidth;
    this.searchResultsElement.classList.add('is-visible');

    bodyScrollLock.disableBodyScroll(
      this.searchResultsElement,
      bodyScrollLockOptions
    );
    document.body.classList.add('scrollLock');

    this.isOpen = true;

    document.dispatchEvent(new CustomEvent('search:opened', { bubbles: true }));
  }

  closeSearch(event) {
    if (event) event.preventDefault();
    if (!this.isOpen) return;

    this.searchForm.reset();
    this.clearSearchButton.forEach((btn) =>
      btn.setAttribute('aria-hidden', 'true')
    );

    document.dispatchEvent(new CustomEvent('search:closed', { bubbles: true }));

    const announcementBar = document.querySelector('.shopify-section-section-announcement_bar');
    if (announcementBar && responsive.matchesBreakpoint('pocket')) {
      announcementBar.style.zIndex = '';
    }

    document.body.classList.remove('search-open');
    this.searchResultsElement.style.opacity = '';
    void this.searchResultsElement.offsetWidth;

    this.searchResultsElement.classList.remove('is-visible');
    this._searchTransitionHandler = () => {
      this.searchResultsElement.removeEventListener(
        'transitionend',
        this._searchTransitionHandler
      );
      this._searchTransitionHandler = null;
      this.searchResultsElement.style.visibility = 'hidden';
      this.searchResultsElement.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('scrollLock');
      bodyScrollLock.enableBodyScroll(
        this.searchResultsElement,
        bodyScrollLockOptions
      );
      this.isOpen = false;
      this.resetLocations();
      this.predictiveSearchWrappper.style.display = 'none';
      this.initialProductsWrapper.style.display = '';
    };
    this.searchResultsElement.addEventListener(
      'transitionend',
      this._searchTransitionHandler
    );

    this._searchCloseTimeout = setTimeout(this._searchTransitionHandler, 350);
  }

  async onInput(event) {
    this.lastInputValue = event.target.value;

    if (this.lastInputValue.trim().length === 0 && this.selectedLocation === 'global') {
      this.predictiveSearchWrappper.style.display = 'none';
      this.initialProductsWrapper.style.display = 'unset';
      return;
    }

    if (this.lastInputValue.length === 0) {
      this.clearSearchButton.forEach((btn) =>
        btn.setAttribute('aria-hidden', 'true')
      );
    } else {
      this.clearSearchButton.forEach((btn) =>
        btn.setAttribute('aria-hidden', 'false')
      );
    }
    if (event.target.getAttribute('data-value') && this.lastInputValue === 0) {
      this.lastInputValue = event.target.getAttribute('data-value');
      const el = this.element.querySelector('.searchInput');
      el.setAttribute('value', this.lastInputValue);
      el.value = this.lastInputValue;
    }

    let finalQuery = this.lastInputValue.trim();

    if (this.selectedLocation && this.selectedLocation !== 'global') {
      const t = this.selectedLocation.replace(/"/g, '\\"');
      finalQuery += ` tag:"${t}"`;
    }

    const cacheKey = `${this.lastInputValue.trim()}::${this.selectedLocation || 'global'}`;
    if (SearchBar.cachedResults[cacheKey]) {
      this.renderProductResults(SearchBar.cachedResults[cacheKey]);
      return;
    }

    const url =
      `${routes.predictive_search_url}?` +
      `q=${encodeURIComponent(finalQuery)}` +
      `&resources[limit_scope]=each&section_id=search-predictive` +
      `&view=html`;

    try {
      const response = await fetch(url, {
        view: 'suggest',
        type: 'product',
        headers: { Accept: 'text/html' },
      });

      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const resultsMarkup =
        doc.querySelector('.search-predictive')?.innerHTML || '';

      SearchBar.cachedResults[cacheKey] = resultsMarkup;
      this.renderProductResults(resultsMarkup);
    } catch (err) {
      if (err?.code === 20) return;
      console.error('Search error:', err);
      this.predictiveSearchWrappper.style.display = 'none';
      this.initialProductsWrapper.style.display = 'unset';
      throw err;
    }
  }

  ensureSearchIsOpen() {
    if (!this.isOpen && this.searchInputElement.value.trim().length > 0) {
      this.openSearch();
    }
  }

  renderProductResults(resultsMarkup) {
    this.ensureSearchIsOpen();

    try {
      const div = document.createElement('div');
      this.predictiveSearchWrappper.style.display = 'unset';
      this.initialProductsWrapper.style.display = 'none';
      div.innerHTML = resultsMarkup;

      this.predictiveSearchWrappper.innerHTML = div.innerHTML;

      const predictiveSearchSwiper = this.element.querySelector(
        '.search-wrapper__predictive-search swiper-init'
      );
      const seeAllBtn = this.element.querySelector(
        '.search-predictive__see-all-button'
      );
      if (predictiveSearchSwiper) predictiveSearchSwiper.initSwiper();
      if (seeAllBtn) {
        let finalQuery = this.lastInputValue.trim();

        if (this.selectedLocation && this.selectedLocation !== 'global') {
          const t = this.selectedLocation.replace(/"/g, '\\"');
          finalQuery += ` tag:"${t}"`;
        }
        const searchUrl = seeAllBtn.dataset.searchUrl;
        seeAllBtn.href = `${searchUrl}?q=${encodeURIComponent(finalQuery)}`;
      }
    } catch (error) {
      console.error('Error rendering product results:', error);
      this.predictiveSearchWrappper.style.display = 'none';
      this.initialProductsWrapper.style.display = 'unset';
    }
  }

  resetSearch() {
    this.searchInputElement.value = '';
    this.searchInputElement.removeAttribute('value');
    this.clearSearchButton.forEach((btn) =>
      btn.setAttribute('aria-hidden', 'true')
    );

    this.predictiveSearchWrappper.innerHTML = '';
    this.predictiveSearchWrappper.style.display = 'none';
    this.initialProductsWrapper.style.display = 'unset';
    this.resetLocations();

    const swiperInit = this.initialProductsWrapper.querySelector('swiper-init');
    if (swiperInit) {
      swiperInit.initSwiper();
    }
  }
}
customElements.define('search-bar', SearchBar);



class Search extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.filterSearchBars = this.element.querySelectorAll(
      ".collection-filters-template, #filter-section, .filter-bar__sort-filters-wrapper"
    );

    this.openProductBtn = this.element.querySelector("#productBtn");
    this.openArticleBtn = this.element.querySelector("#articleBtn");
    this.toggleButtons = this.element.querySelector('.main-search__buttons-wrapper');
    new AddToCart(this.element);

    this.bindEvents();
  }

  bindEvents() {
    window.addEventListener(
      "load",
      this.handleMainSearchWithPagination.bind(this)
    );

    // Delegate keydown only on toggle buttons
    this.delegateElement.on(
      'keydown',
      '.main-search__toggle-button[role="tab"]',
      (e) => {
        this.handleKeydown(e);
      }
    );
  }


  // Only fetch the active type (product or article) using async/await
  async handleMainSearchWithPagination() {
    const params = new URLSearchParams(window.location.search);
    const currentType = params.get('type');
    const page = parseInt(params.get('page')) || 1;

    this.articlePagination = this.element.querySelector('.pagination-container--article');
    this.productPagination = this.element.querySelector('.pagination-container--product');

    // Initialize page tracking
    if (currentType === 'article') {
      this.articlePage = page;
      this.productPage = 1;
      await this.fetchProductsOnly(false);
    } else if (currentType === 'product') {
      this.productPage = page;
      this.articlePage = 1;
      await this.fetchArticlesOnly(false);
    } else {
      this.productPage = page;
      this.articlePage = page;
      await Promise.all([
        this.fetchArticlesOnly(true),
        this.fetchProductsOnly(true)
      ]);
    }

    this.delegateElement.on(
      "click",
      '[data-action="toggle-products"]',
      this.showProducts.bind(this)
    );
    this.delegateElement.on(
      "click",
      '[data-action="toggle-articles"]',
      this.showArticles.bind(this)
    );

    this.element.style.opacity = '1';
  }

  // Generic fetch method that handles common logic
  async fetchContent(type, initial, config = {}) {
    const url = new URL(window.location.href);

    if (config.clearFilters) {
      [...url.searchParams.keys()].forEach(key => {
        if (key.startsWith('filter.')) {
          url.searchParams.delete(key);
        }
      });
    }

    url.searchParams.set('type', type);
    url.searchParams.set('page', '1');

    try {
      const response = await fetch(url.toString());
      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      // Execute type-specific updates (products/articles)
      if (config.updateContent) {
        config.updateContent(doc, initial);
      }

      this.updateResultNumber(doc, config.isArticle || false);
    } catch (error) {
      console.error(`Error fetching ${type}:`, error);
    }
  }

  async fetchArticlesOnly(initial) {
    await this.fetchContent('article', initial, {
      clearFilters: true,
      isArticle: true,
      updateContent: (doc, initial) => {
        const container = this.element.querySelector('#collection__main-grid-articles');
        const results = doc.querySelector('#collection__main-grid-articles');
        const oldPagination = document.querySelector('.true-pagination');
        this.articlePagination = doc.querySelector('.pagination-container--article');

        if (container && results) {
          if (!container.querySelector('.mainSearch--contentCard')) {
            container.innerHTML = results.innerHTML;
          } else if (oldPagination && this.articlePagination && initial) {
            oldPagination.innerHTML = this.articlePagination.outerHTML;
          }
        }
      }
    });
  }

  async fetchProductsOnly(initial) {
    await this.fetchContent('product', initial, {
      clearFilters: false,
      isArticle: false,
      updateContent: (doc, initial) => {
        const newFiltersWrapper = doc.querySelector(".collection__filters");
        const newResults = doc.querySelector('#main-collection-grid--holder');
        const oldPagination = document.querySelector('.true-pagination');
        const newProductPagination = doc.querySelector('.pagination-container--product');
        const container = this.element.querySelector('#main-collection-grid--holder');

        this.productPagination = newProductPagination;

        if (container && newResults) {
          if (!container.querySelector('.main-search__product')) {
            container.innerHTML = newResults.innerHTML;
          }
        }

        if (newFiltersWrapper) {
          const currentFiltersWrapper = this.element.querySelector(".collection__filters");
          if (currentFiltersWrapper) {
            currentFiltersWrapper.querySelector('.collection-filters-template').innerHTML =
              newFiltersWrapper.querySelector('.collection-filters-template').innerHTML;

            this.element.dispatchEvent(
              new CustomEvent('search-filters:rendered', { bubbles: true })
            );
          }
        }

        if (oldPagination && newProductPagination && initial) {
          oldPagination.innerHTML = newProductPagination.outerHTML;
        }
      }
    });
  }

  updateResultNumber(doc, article) {
    if (!article) {
      const productCount =
        doc.querySelector('.main-search__buttons-wrapper')?.dataset.count || 0;
      if (productCount === 0) {
        const productToggleButton = this.element.querySelector(".main-search__product-button");
        if (productToggleButton) productToggleButton.style.pointerEvents = "none";
      }

      this.element.querySelector('.itemNumber').innerHTML = `(${productCount})`;
    }

    if (article) {
      const articleCount =
        doc.querySelector('.main-search__buttons-wrapper')?.dataset.count || 0;
      if (articleCount === 0) {
        const articleToggleButton = this.element.querySelector(".main-search__article-button");
        if (articleToggleButton) articleToggleButton.style.pointerEvents = "none";
      }

      this.element.querySelector('.itemNumber_2').innerHTML = `(${articleCount})`;
    }

    this.toggleButtons.style.opacity = '1';
  }

  showProducts(e) {
    e.preventDefault();

    // Announce change to screen readers
    this.announceChange('Showing products');

    const url = new URL(window.location.href);
    url.searchParams.set('type', 'product');
    url.searchParams.set('page', this.productPage);
    window.history.replaceState({}, '', url);

    const oldPagination = document.querySelector('.true-pagination');
    oldPagination.setAttribute("aria-hidden", false);
    if (oldPagination) {
      oldPagination.innerHTML = this.productPagination.outerHTML;
      if (oldPagination.firstElementChild) {
        oldPagination.firstElementChild.setAttribute("aria-hidden", false);
      }
    }

    if (this.articlePagination) this.articlePagination.setAttribute("aria-hidden", true);
    window.addEventListener("filters:rerendered", () => {
      oldPagination.setAttribute("aria-hidden", true);
    })

    this.openProductBtn?.classList.add('active');
    this.openArticleBtn?.classList.remove('active');
    this.filterSearchBars.forEach(el => el.style.display = '');

    this.element.querySelector('#collection__main-grid-articles').style.display = "none";
    this.element.querySelector('#main-collection-grid--holder').style.display = "grid";

    // Focus the first card after content update
    requestAnimationFrame(() => {
      const firstCard = document.querySelector('.main-search__product');
      firstCard?.focus();
    });
  }

  showArticles(e) {
    e.preventDefault();

    // Announce change to screen readers
    this.announceChange('Showing articles');

    const url = new URL(window.location.href);

    // 1. Remove every query-param whose name starts with "filter."
    [...url.searchParams.keys()].forEach(key => {
      if (key.startsWith('filter.')) {
        url.searchParams.delete(key);
      }
    });

    // 2. Now set the parameters you actually want:
    url.searchParams.set('type', 'article');
    url.searchParams.set('page', this.articlePage);

    // 3. Push the new URL (without reload)
    window.history.replaceState({}, '', url);

    const oldPagination = document.querySelector('.true-pagination');
    oldPagination.setAttribute("aria-hidden", false);

    if (oldPagination && this.articlePagination) {
      oldPagination.innerHTML = this.articlePagination.outerHTML;
      if (oldPagination.firstElementChild) {
        oldPagination.firstElementChild.setAttribute("aria-hidden", false);
      }
    }

    this.productPagination = this.element.querySelector(".pagination-container--product");
    this.productPagination.setAttribute("aria-hidden", true);

    this.openArticleBtn?.classList.add('active');
    this.openProductBtn?.classList.remove('active');
    this.filterSearchBars.forEach((el) => {
      el.style.display = 'none';
    })

    this.element.querySelector("#collection-article").setAttribute("aria-hidden", false);

    this.element.querySelector('#collection__main-grid-articles').style.display = "grid";
    this.element.querySelector('#main-collection-grid--holder').style.display = "none";

    // Focus the first card after content update
    requestAnimationFrame(() => {
      const firstCard = document.querySelector('.main-search__article');
      firstCard?.focus();
    });
  }

  announceChange(message) {
    const announcer = this.element.querySelector('.sr-only-announcer');
    if (announcer) {
      announcer.textContent = message;
    }
  }

  scrollToTop(gridToScrollTo) {
    const header = document.querySelector("#header");

    if (gridToScrollTo) {
      let position = gridToScrollTo.getBoundingClientRect().top + window.scrollY;

      if (header && document.querySelector(".header--sticky")) {
        position -= header.offsetHeight;
      }

      window.scrollTo({
        top: position,
        behavior: "smooth",
      });
    }
  }

  handleKeydown(event) {
    const { key, target } = event;

    if (key === 'ArrowLeft' || key === 'ArrowRight') {
      event.preventDefault();
      this.navigateTabs(key === 'ArrowRight' ? 1 : -1);
    } else if (key === 'Enter' || key === ' ') {
      event.preventDefault();
      this.activateTab(target, event);
    }
  }


  navigateTabs(direction) {
    const tabs = Array.from(document.querySelectorAll('[role="tab"]'));
    const currentIndex = tabs.findIndex(tab => tab === document.activeElement);

    let nextIndex = currentIndex + direction;

    // wrap around
    if (nextIndex < 0) nextIndex = tabs.length - 1;
    if (nextIndex >= tabs.length) nextIndex = 0;

    tabs[nextIndex].focus();
  }

  activateTab(tab, event) {
    const tabs = document.querySelectorAll('[role="tab"]');
    tabs.forEach(t => t.setAttribute('aria-selected', 'false'));

    tab.setAttribute('aria-selected', 'true');
    tab.focus();

    const type = tab.dataset.type;
    if (type === "product") {
      this.showProducts(event);
    } else if (type === "article") {
      this.showArticles(event);
    }
  }
}

customElements.define("search-component", Search);
class ContactSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.bindEvents();
    this.toggleButton();
  }

  bindEvents() {
    this.delegateElement.on(
      "change",
      "[data-state='required']",
      this.toggleButton.bind(this)
    );

  }

  toggleButton() {
    this.buttonState = true;

    var allBoxes = this.element.querySelectorAll("[data-state='required']");
    allBoxes.forEach((item, i) => {
      if (item.checked == false) {
        this.buttonState = false;
      }
    });
    if (this.buttonState == true) {
      this.element.querySelector(".Contact-Btn").removeAttribute("disabled");
    } else {
      this.element.querySelector(".Contact-Btn").setAttribute("disabled", true);
    }
  }
}

customElements.define("contact-section", ContactSection);





class AccountHandler extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);

    this.drawer = new Drawer(this.element.querySelector('#accountDrawer'));
    this.bindEvents();

  }
  bindEvents() {

    this.delegateElement.on('click', '[data-action="toggle-tab"]', this.toggleTab.bind(this));
    this.delegateElement.on('click', '[data-action="submit-login"]', this.submitLogin.bind(this));
    this.delegateElement.on('click', '[data-action="submit-register"]', this.submitRegistration.bind(this));
    this.delegateElement.on('click', '[data-action="toggle-recovery"]', this.toggleRecovery.bind(this));
    this.delegateElement.on('click', '[data-action="submit-recovery"]', this.accountRecover.bind(this));
  }

  toggleRecovery() {
    event.preventDefault();
    const id = event.target.dataset.id;

    if (id == 'recoverFlex') {
      this.element.querySelector('#recoverFlex').setAttribute('aria-visible', 'true');
      this.element.querySelector('#loginFlex').setAttribute('aria-visible', 'false');
    }
    else {
      this.element.querySelector('#recoverFlex').setAttribute('aria-visible', 'false');
      this.element.querySelector('#loginFlex').setAttribute('aria-visible', 'true');
    }
  }

  accountRecover(event) {
    event.preventDefault();
    const _this = this;
    const registrationEndpoint = '/account/recover';

    // Create the request body with the registration data
    const requestBody = {
      'email': this.element.querySelector('#RecoverEmail').value
    };

    event.target.querySelector('.ButtonText').style.visibility = "hidden";
    event.target.querySelector('.itemLoader').classList.add('is-visible');

    // Send the AJAX request
    (async function () {
      try {
        const response = await fetch(registrationEndpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(requestBody)
        });

        const responseText = await response.text();
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = responseText;

        if (responseText.indexOf('RecoverEmail-email-error') !== -1) {

          _this.element.querySelector('#recoverFlex .accountDrawer--ErrorSpace').innerHTML = tempDiv.querySelector('#RecoverEmail-email-error').innerHTML;
        } else if (responseText.indexOf('recoverSuccess') !== -1) {


          _this.element.querySelector('#recoverFlex .accountDrawer--SuccessSpace').innerHTML = tempDiv.querySelector('#recoverSuccess').innerHTML;
        }

        event.target.querySelector('.button--text').style.visibility = "visible";
        event.target.querySelector('.itemLoader').classList.remove('is-visible');


      } catch (error) {
        console.error('An error occurred during the registration request:', error);
      }
    })();
  }


  submitRegistration(event) {
    event.preventDefault();
    const _this = this;
    const registrationEndpoint = '/account';

    // Create the request body with the registration data
    const requestBody = {
      'customer': {
        'first_name': this.element.querySelector('#register #RegisterForm-FirstName').value,
        'last_name': this.element.querySelector('#register #RegisterForm-LastName').value,
        'email': this.element.querySelector('#register #RegisterForm-email').value,
        'password': this.element.querySelector('#register #RegisterForm-password').value
      }
    };

    event.target.querySelector('.ButtonText').style.visibility = "hidden";
    event.target.querySelector('.itemLoader').classList.add('is-visible');

    // Send the AJAX request
    (async function () {
      try {
        const response = await fetch(registrationEndpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(requestBody)
        });

        const responseText = await response.text();

        if (responseText.indexOf('registerErrors') !== -1) {
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = responseText;

          _this.element.querySelector('#register .accountDrawer--ErrorSpace').innerHTML = tempDiv.querySelector('.registerErrors').innerHTML;
        } else {
          location.href = window.routes.account_url;
        }

        event.target.querySelector('.ButtonText').style.visibility = "visible";
        event.target.querySelector('.itemLoader').classList.remove('is-visible');


      } catch (error) {
        console.error('An error occurred during the registration request:', error);
      }
    })();
  }


  submitLogin(event) {
    event.preventDefault();
    const _this = this;
    const loginEndpoint = '/account/login';

    // Create the request body with the login credentials
    const requestBody = {
      'customer': {
        'email': this.element.querySelector('#customer_login #CustomerEmail').value,
        'password': this.element.querySelector('#customer_login #CustomerPassword').value
      }
    };

    event.target.querySelector('.ButtonText').style.visibility = "hidden";
    event.target.querySelector('.itemLoader').classList.add('is-visible');

    // Send the AJAX request
    (async function () {
      try {
        const response = await fetch(loginEndpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(requestBody)
        });


        const responseText = await response.text();

        if (responseText.indexOf('loginError') !== -1) {
          const tempDiv = document.createElement('div');

          tempDiv.innerHTML = responseText;

          _this.element.querySelector('#login .accountDrawer--ErrorSpace').innerHTML = tempDiv.querySelector('.AlertError').innerHTML;
          event.target.querySelector('.ButtonText').style.visibility = "visible";
          event.target.querySelector('.itemLoader').classList.remove('is-visible');
        } else {
          location.href = window.routes.account_url;

        }



      } catch (error) {
        console.error('An error occurred during the login request:', error);
      }
    })();

  }

  toggleTab(event) {
    const id = event.target.dataset.id;
    const allTabs = this.element.querySelectorAll('.accountDrawer--Tab[aria-expanded="true"]');
    const allContent = this.element.querySelectorAll('.accountContent');

    allTabs.forEach((tab) => {
      tab.setAttribute('aria-expanded', 'false');
    });

    event.target.setAttribute('aria-expanded', 'true');

    allContent.forEach((content) => {
      content.setAttribute('aria-visible', 'false');
    });

    const content = this.element.querySelector(`#${id}`);
    if (content) {
      content.setAttribute('aria-visible', 'true');
    }
  }

}

customElements.define("account-handler", AccountHandler);


class LocalizationSelectors extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    const selectBoxes = this.element.querySelectorAll(".RevolutionSelectbox");
    // Internal state for dynamic language regeneration
    this.countryLanguages = {}; // { COUNTRY_CODE: [ { name, iso }, ... ] }
    this.currentCountry = this.element.getAttribute('data-default-market') || null;
    this.currentLanguage = this.element.getAttribute('data-default-language') || null;
    this.languageSelectboxInstance = null; // RevolutionSelectbox instance for language

    if (selectBoxes.length > 0) {
      selectBoxes.forEach((item) => {
        const inst = new RevolutionSelectbox(item);
        if (item.classList.contains('rs-language__selectbox')) {
          this.languageSelectboxInstance = inst;
        }
      });
    }

    // Ensure hidden selects have correct initial values
    this.ensureHiddenSelectValues();

    this.buildCountryLanguageMap();
    // Listen to custom event dispatched from RevolutionSelectbox (country wrapper)
    this.element.addEventListener('change:countrySelector', (e) => this.onCountryChange(e));

    // Initial edge-case handling: if current country has no languages hide language select
    if (this.currentCountry && (!this.countryLanguages[this.currentCountry] || !this.countryLanguages[this.currentCountry].length)) {
      const langWrapper = this.element.querySelector('.rs-language__selectbox');
      if (langWrapper) langWrapper.style.display = 'none';
    }

    // Ensure UI matches hidden select initial values (after server render)
    this.syncInitialSelectionState();
  }

  /**
   * Parse all <option> entries inside #selector__country and build a mapping
   * Each option has: value (country_code), data-languages='[ {"name":"English","iso":"en"}, ... ]'
   */
  buildCountryLanguageMap() {
    const countrySelect = this.element.querySelector('#selector__country');
    if (!countrySelect) return;
    [...countrySelect.options].forEach((opt) => {
      const code = opt.value;
      const raw = opt.getAttribute('data-languages');
      if (!code || !raw) return;
      try {
        const parsed = JSON.parse(raw);
        if (Array.isArray(parsed)) {
          this.countryLanguages[code] = parsed.map(l => ({ name: l.name, iso: l.iso }));
        }
      } catch (e) {
        console.warn('LocalizationSelectors: invalid data-languages JSON for', code, e);
      }
    });
  }

  // Correct data-default-market values on initial load
  ensureHiddenSelectValues() {
    const countrySelect = this.element.querySelector('#selector__country');
    const languageSelect = this.element.querySelector('#selector__language');

    // Force country select to match data-default-market
    if (countrySelect && this.currentCountry) {
      const matchingOption = [...countrySelect.options].find(opt => opt.value === this.currentCountry);
      if (matchingOption) {
        countrySelect.value = this.currentCountry;
        matchingOption.selected = true;
      }
    }

    // Force language select to match data-default-language
    if (languageSelect && this.currentLanguage) {
      const matchingOption = [...languageSelect.options].find(opt => opt.value === this.currentLanguage);
      if (matchingOption) {
        languageSelect.value = this.currentLanguage;
        matchingOption.selected = true;
      }
    }
  }

  /** Handle custom change:countrySelector event */
  onCountryChange(event) {
    const detail = event.detail || {};
    const countryCode = detail.country;
    if (!countryCode) return;
    this.currentCountry = countryCode;
    let languages = [];
    try {
      if (typeof detail.languages === 'string') {
        languages = JSON.parse(detail.languages);
      } else if (Array.isArray(detail.languages)) {
        languages = detail.languages;
      }
    } catch (e) {
      console.warn('LocalizationSelectors: invalid languages in event detail', e);
    }
    if ((!languages || !languages.length) && this.countryLanguages[countryCode]) {
      languages = this.countryLanguages[countryCode];
    }
    this.updateLanguageSelect(countryCode, languages);
  }

  /**
   * Regenerate language select based on chosen country.
   * @param {string} countryCode
   * @param {Array<{name:string, iso:string}>} languages
   */
  updateLanguageSelect(countryCode, languages) {
    const wrapper = this.element.querySelector('.rs-language__selectbox');
    if (!wrapper) return;
    const hiddenSelect = wrapper.querySelector('#selector__language');
    const content = wrapper.querySelector('.RevolutionSelectbox--Content');
    const titleEl = wrapper.querySelector('.RevolutionSelectbox--Title');
    if (!hiddenSelect || !content || !titleEl) return;
    if (!languages || !languages.length) {
      wrapper.style.display = 'none';
      return;
    }
    wrapper.style.display = 'flex';
    let preserved = this.currentLanguage && languages.some(l => l.iso === this.currentLanguage) ? this.currentLanguage : null;
    hiddenSelect.innerHTML = '';
    content.innerHTML = '';
    let firstLanguageISO = null;
    languages.forEach((lang, index) => {
      if (!firstLanguageISO) firstLanguageISO = lang.iso;
      const opt = document.createElement('option');
      opt.value = lang.iso;
      opt.id = `${lang.iso}-lang-${index}`;
      opt.textContent = lang.name;
      hiddenSelect.appendChild(opt);
      const btn = document.createElement('button');
      btn.className = 'RevolutionSelectbox--Item u-p3';
      btn.type = 'button';
      btn.setAttribute('aria-label', 'select');
      btn.setAttribute('tabindex', '0');
      btn.setAttribute('data-value', lang.iso);
      btn.setAttribute('data-action', 'selectbox-change');
      btn.setAttribute('data-selectboxid', `${lang.iso}-lang-${index}`);
      btn.textContent = lang.name;
      content.appendChild(btn);
    });
    const newSelection = preserved || firstLanguageISO;
    this.currentLanguage = newSelection;
    hiddenSelect.value = newSelection;
    hiddenSelect.dispatchEvent(new Event('change'));
    const selectedBtn = content.querySelector(`.RevolutionSelectbox--Item[data-value="${CSS.escape(newSelection)}"]`);
    if (selectedBtn) {
      selectedBtn.setAttribute('selected', 'selected');
      selectedBtn.setAttribute('disabled', 'true');
    }
    titleEl.textContent = languages.find(l => l.iso === newSelection)?.name || newSelection;
    if (this.languageSelectboxInstance?.isOpen) {
      this.languageSelectboxInstance.closeDropdown();
    }
  }

  /**
   * Ensure that for both country and language selectboxes the button marked selected
   * matches the hidden <select> current value. If mismatch -> fix it without changing true value.
   */
  syncInitialSelectionState() {
    this.syncOneBox('.rs-country__selectbox');
    this.syncOneBox('.rs-language__selectbox');
  }

  /**
   * @param {string} selector selectbox wrapper selector
   */
  syncOneBox(selector) {
    const box = this.element.querySelector(selector);
    if (!box) return;
    const hiddenSelect = box.querySelector('select.selectboxInputs');
    if (!hiddenSelect) return;
    const currentValue = hiddenSelect.value;

    // If server already marked a button selected, trust it and just ensure hidden select matches.
    const alreadySelected = box.querySelector('.RevolutionSelectbox--Item[selected]');
    if (alreadySelected) {
      const titleEl = box.querySelector('.RevolutionSelectbox--Title');
      if (titleEl) titleEl.innerHTML = alreadySelected.innerHTML;
      // If hidden select differs try to map via data-selectboxid -> option id
      if (hiddenSelect.value !== currentValue) {
        // no-op; hiddenSelect normally already correct from server.
      }
      return;
    }

    // No pre-selected button -> derive from hidden select value
    let matchOption = [...hiddenSelect.options].find(o => o.value === currentValue);
    // Ako nema matchOption NE radimo fallback – ostavljamo stanje kako jeste.
    if (!matchOption) return;
    const optionId = matchOption?.id;
    let matchButton = optionId ? box.querySelector(`.RevolutionSelectbox--Item[data-selectboxid="${CSS.escape(optionId)}"]`) : null;
    if (!matchButton) return; // Bez dodatnog fallback-a na prvo dugme
    matchButton.setAttribute('selected', 'selected');
    matchButton.setAttribute('disabled', 'true');
    const titleEl = box.querySelector('.RevolutionSelectbox--Title');
    if (titleEl) titleEl.innerHTML = matchButton.innerHTML;
  }
}
customElements.define("localization-modal", LocalizationSelectors);




// SwiperInit class that uses existing Responsive system
class SwiperInit extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.swiper = null;
    this.initializationMode = this.getInitializationMode();
    this.intersectionObserver = null;
    this.isDynamic = this.element.hasAttribute('data-swiper-dynamic');
    this.isDynamicOnce = this.element.hasAttribute('data-swiper-dynamic-once');
    this.isHorizontalFadeDesktop = this.element.hasAttribute("data-swiper-fade-horizontal-desktop");
    this.isHorizontalFadeMobile = this.element.hasAttribute("data-swiper-fade-horizontal-mobile");
    this.isHorizontalFade = this.element.hasAttribute("data-swiper-fade-horizontal");
    this.hasBeenInitialized = false; // Track if dynamic-once has been initialized

    // Bind methods
    this.handleBreakpointChange = this.handleBreakpointChange.bind(this);
    this.handleIntersection = this.handleIntersection.bind(this);
  }

  getInitializationMode() {
    // Check data attributes to determine mode
    if (this.element.hasAttribute('data-swiper-mobile')) {
      return 'mobile';
    } else if (this.element.hasAttribute('data-swiper-desktop')) {
      return 'desktop';
    } else if (this.element.hasAttribute('data-swiper-tablet')) {
      return 'tablet';
    } else {
      return 'universal';
    }
  }

  connectedCallback() {
    // Listen to responsive system breakpoint changes
    document.addEventListener('breakpoint:changed', this.handleBreakpointChange);

    // Set up intersection observer for dynamic swipers
    if (this.isDynamic || this.isDynamicOnce) {
      this.setupIntersectionObserver();
    } else {
      // Auto-initialize if not dynamic and not disabled
      if (!this.element.hasAttribute('data-swiper-manual')) {
        this.initSwiper();
      }
    }
  }

  disconnectedCallback() {
    document.removeEventListener('breakpoint:changed', this.handleBreakpointChange);
    this.cleanupIntersectionObserver();
    this.destroy();
  }

  setupIntersectionObserver() {
    // Get threshold from attribute or use default
    const threshold = parseFloat(this.element.getAttribute('data-swiper-dynamic-threshold')) || 0.1;

    // Get root margin from attribute or use default
    const rootMargin = this.element.getAttribute('data-swiper-dynamic-margin') || '50px';

    this.intersectionObserver = new IntersectionObserver(this.handleIntersection, {
      threshold: threshold,
      rootMargin: rootMargin
    });

    this.intersectionObserver.observe(this.element);
  }

  cleanupIntersectionObserver() {
    if (this.intersectionObserver) {
      this.intersectionObserver.disconnect();
      this.intersectionObserver = null;
    }
  }

  handleIntersection(entries) {
    entries.forEach(entry => {
      if (entry.target === this.element) {
        if (entry.isIntersecting) {
          // Element is in view - initialize if should be active
          if (this.shouldInitialize() && !this.swiper) {
            this.initSwiper();
          }
        } else {
          // Element is out of view
          if (this.isDynamic && this.swiper) {
            // Dynamic mode: destroy when out of view
            this.destroy();
          }
          // Dynamic-once mode: keep swiper active once initialized
        }
      }
    });
  }

  handleBreakpointChange(event) {
    const { currentBreakpoint } = event.detail;

    // Check if we should be active on this breakpoint
    const shouldBeActive = this.shouldInitialize(currentBreakpoint);
    const currentlyActive = !!this.swiper;

    // For dynamic swipers, only initialize if also in view
    if (this.isDynamic || this.isDynamicOnce) {
      // Let the intersection observer handle initialization
      // Just destroy if shouldn't be active
      if (!shouldBeActive && currentlyActive) {
        this.destroy();
      }
    } else {
      // Normal behavior for non-dynamic swipers
      if (shouldBeActive && !currentlyActive) {
        this.initSwiper();
      } else if (!shouldBeActive && currentlyActive) {
        this.destroy();
      } else if (shouldBeActive && currentlyActive) {
        this.initSwiper();
      }
    }
  }

  initHorizontalFadeOnSwiper() {
    const swiper = this.element.getSwiper();
    const swiperInstance = swiper.swiperElement;
    if (!swiper) return;

    // Add "content-fade" class here
    this.element.classList.add('content-fade');
    const fadeContainer = this.element;

    const update = () => this.updateHorizontalFadeClasses(swiperInstance, fadeContainer);

    // Initial update
    update();

    // Listen to swiper events
    swiperInstance.on('slideChange', update);
    swiperInstance.on('resize', update);
    swiperInstance.on('progress', update);
    swiperInstance.on('touchMove', update);

    window.addEventListener('resize', update);
  }

  updateHorizontalFadeClasses(swiperInstance, fadeContainer) {
    const c = fadeContainer.classList;
    c.remove('fade-left', 'fade-right', 'fade-both-horizontal');

    const atStart = swiperInstance.isBeginning;
    const atEnd = swiperInstance.isEnd;

    if (!atStart && !atEnd) {
      c.add('fade-both-horizontal');
    } else if (!atStart) {
      c.add('fade-left');
    } else if (!atEnd) {
      c.add('fade-right');
    }
  }

  shouldInitialize(breakpoint = null) {
    const currentBreakpoint = breakpoint || responsive.getCurrentBreakpoint();

    switch (this.initializationMode) {
      case 'mobile':
        return ['phone', 'pocket'].includes(currentBreakpoint);
      case 'desktop':
        return ['desktop', 'lap_and_up', 'desktop_wide'].includes(currentBreakpoint);
      case 'tablet':
        return ['tablet', 'tablet_and_up'].includes(currentBreakpoint);
      case 'universal':
        return true;
      default:
        return true;
    }
  }

  initSwiper() {
    // Don't initialize if we shouldn't be active
    if (!this.shouldInitialize()) {
      return;
    }

    // Destroy existing swiper
    this.destroy();

    try {
      // Get thumb element if specified
      const thumbSelector = this.element.getAttribute('data-swiper-thumb');
      const thumbElement = thumbSelector ? document.querySelector(thumbSelector) : null;

      // Use existing RevolutionSwiper class as-is
      this.swiper = new RevolutionSwiper(this.element, thumbElement);

      // Mark as initialized for dynamic-once mode
      if (this.isDynamicOnce) {
        this.hasBeenInitialized = true;
      }

      if (this.isHorizontalFadeDesktop && responsive.matchesBreakpoint('lap_and_up')) {
        this.initHorizontalFadeOnSwiper(this.element);
      }

      const currentBreakpoint = responsive.getCurrentBreakpoint();
      if (this.isHorizontalFadeMobile && (currentBreakpoint === 'phone' || currentBreakpoint === 'pocket')) {
        this.initHorizontalFadeOnSwiper(this.element);
      }

      if (this.isHorizontalFade) {
        this.initHorizontalFadeOnSwiper(this.element);
      }

      // Dispatch initialization event
      this.element.dispatchEvent(new CustomEvent('swiper:initialized', {
        bubbles: true,
        detail: {
          breakpoint: responsive.getCurrentBreakpoint(),
          mode: this.initializationMode,
          isDynamic: this.isDynamic,
          isDynamicOnce: this.isDynamicOnce,
          swiper: this.swiper
        }
      }));

    } catch (error) {
      console.error('SwiperInit: Failed to initialize swiper', error);
    }
  }

  destroy() {
    if (this.swiper && this.swiper.swiperElement) {
      this.swiper.swiperElement.destroy(true, true);
      this.swiper = null;

      this.element.dispatchEvent(new CustomEvent('swiper:destroyed', {
        bubbles: true,
        detail: {
          breakpoint: responsive.getCurrentBreakpoint(),
          mode: this.initializationMode,
          isDynamic: this.isDynamic,
          isDynamicOnce: this.isDynamicOnce
        }
      }));
    }
  }

  // Public API methods
  selectSlide(index) {
    if (this.swiper && this.swiper.selectCell) {
      this.swiper.selectCell(index);
    } else {
      // Wait for swiper to initialize, then select
      this.element.addEventListener('swiper:initialized', () => {
        if (this.swiper && this.swiper.selectCell) {
          this.swiper.selectCell(index);
        }
      }, { once: true });
    }
  }

  resize() {
    if (this.swiper) {
      this.swiper.resize();
    }
  }

  getSwiper() {
    return this.swiper;
  }

  getCurrentBreakpoint() {
    return responsive.getCurrentBreakpoint();
  }

  reinitialize() {
    this.initSwiper();
  }

  isDynamicSwiper() {
    return this.isDynamic || this.isDynamicOnce;
  }

  getDynamicMode() {
    if (this.isDynamic) return 'dynamic';
    if (this.isDynamicOnce) return 'dynamic-once';
    return 'static';
  }

  // Static method to initialize all swipers
  static initializeAll() {
    document.querySelectorAll('swiper-init').forEach(element => {
      element.initSwiper();
    });
  }
}
customElements.define("swiper-init", SwiperInit);

class FormValidator {
  constructor(formElement, options = {}) {
    this.form = formElement;
    this.delegate = new Delegate(this.form);
    this.options = {
      errorClass: 'field--error',
      fieldSelector: '.field',
      buttonSelector: null,
      validateOnBlur: true,
      validateOnInput: false,
      errorOutputSelector: null,
      fieldErrorSelector: null, // New option for field-specific error containers
      showErrorsOnSubmitOnly: false,
      disableButton: true, // Option to disable button when form is invalid
      activelyValidateAfterSubmit: false, // New flag: no validation before submit, then active validation on blur AND input after submit
      wrapFieldForErrors: false, // New flag: wrap field element and append error inside wrapper
      ...options
    };

    this.customValidators = new Map();
    this.hasSubmittedOnce = false;
    this.init();
  }

  init() {
    this.setupEventListeners();
    this.setupButtonListener();

    if (this.options.buttonSelector) {
      // NEW FLAG: activelyValidateAfterSubmit - keep buttons enabled before submit
      if (this.options.activelyValidateAfterSubmit) {
        this.enableButton();
      } else if (this.options.showErrorsOnSubmitOnly) {
        this.enableButton();
      } else {
        this.updateButtonState();
      }
    }
  }

  enableButton() {
    if (!this.options.buttonSelector) return;

    const buttons = document.querySelectorAll(this.options.buttonSelector);
    buttons.forEach(button => {
      button.removeAttribute('disabled');
      button.classList.remove('disabled');
      button.setAttribute('aria-disabled', 'false');
    });

    console.log('Button enabled:', buttons);
  }

  setupButtonListener() {
    if (!this.options.buttonSelector) return;

    const buttons = document.querySelectorAll(this.options.buttonSelector);
    buttons.forEach(button => {
      button.addEventListener('click', (e) => {
        this.markSubmitted();
        const isValid = this.showAllErrors();
        if (!isValid) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
        }
      }, true); // Use capture phase to run before other listeners
    });
  }

  outputErrors(errors) {
    if (!this.options.errorOutputSelector) {
      // Fallback to inline error display when no errorOutputSelector is provided
      if (errors.length > 0 && ErrorUtils) {
        const firstError = errors[0];
        ErrorUtils.showInlineError(this.form, 'validation_error', firstError, 'redeem');
      }
      return;
    }

    // NEW FLAG: activelyValidateAfterSubmit - no errors before submit
    if (this.options.activelyValidateAfterSubmit && !this.hasSubmittedOnce) {
      return;
    }

    // ORIGINAL BEHAVIOR
    if (this.options.showErrorsOnSubmitOnly && !this.hasSubmittedOnce) {
      return;
    }

    // Special handling for dynamic button wrapping (errorOutputSelector = true)
    if (this.options.errorOutputSelector === true) {
      // Check if any field errors are visible
      const visibleFieldErrors = this.form.querySelectorAll('.field__error:not([aria-hidden="true"])');
      const hasVisibleErrors = visibleFieldErrors.length > 0;

      // Find the visible booking button
      const visibleButton = document.querySelector('.booking__action-button[aria-hidden="false"]');

      if (visibleButton) {
        // Check if button is already wrapped
        let wrapper = visibleButton.parentElement;
        if (!wrapper.classList.contains('booking__button-wrapper')) {
          // Create wrapper
          wrapper = document.createElement('div');
          wrapper.className = 'booking__button-wrapper';
          wrapper.style.width = '100%';
          visibleButton.parentNode.insertBefore(wrapper, visibleButton);
          wrapper.appendChild(visibleButton);
        }

        // Find or create button error message inside wrapper
        let buttonError = wrapper.querySelector('.booking__validation-error');

        if (!buttonError) {
          // Create button error element (hidden by default)
          const errorMessage = TranslationUtils.get('form_validation.alert_error', 'Please correct the errors above before continuing.');
          buttonError = document.createElement('p');
          buttonError.className = 'booking__validation-error u-p4';
          buttonError.style.color = 'var(--error_color, #d32f2f)';
          buttonError.style.marginTop = '0.5rem';
          buttonError.textContent = errorMessage;
          buttonError.setAttribute('aria-hidden', 'true');
          wrapper.appendChild(buttonError);
        }

        // Show or hide button error based on field errors
        buttonError.setAttribute('aria-hidden', hasVisibleErrors ? 'false' : 'true');
      }

      return;
    }

    // Regular container-based error output
    const container = typeof this.options.errorOutputSelector === 'string'
      ? document.querySelector(this.options.errorOutputSelector)
      : this.options.errorOutputSelector;

    if (!container) {
      // Fallback to inline error display when container is not found
      if (errors.length > 0 && ErrorUtils) {
        const firstError = errors[0];
        ErrorUtils.showInlineError(this.form, 'validation_error', firstError, 'redeem');
      }
      return;
    }

    container.innerHTML = '';
    if (errors.length > 0) {
      container.innerHTML = errors.join('<br>');
    }
  }

  // New method for field-specific error output
  outputFieldError(field, errorMessage) {
    if (!this.options.fieldErrorSelector) return;

    const fieldContainer = field.closest(this.options.fieldSelector);
    if (!fieldContainer) return;

    // Find error container - check both fieldContainer and its parent wrapper
    let errorContainer = fieldContainer.querySelector(this.options.fieldErrorSelector);

    // If not found and wrapFieldForErrors is enabled, check parent wrapper
    if (!errorContainer && this.options.wrapFieldForErrors) {
      const wrapper = fieldContainer.parentElement;
      if (wrapper && wrapper.classList.contains('field-wrapper')) {
        errorContainer = wrapper.querySelector(this.options.fieldErrorSelector);
      }
    }

    // Create error container if it doesn't exist
    if (!errorContainer) {
      errorContainer = document.createElement('div');
      errorContainer.className = this.options.fieldErrorSelector.replace('.', '');

      if (this.options.wrapFieldForErrors) {
        // Create wrapper and move field into it
        this.wrapFieldWithErrorContainer(fieldContainer, errorContainer);
      } else {
        // Append error container to field container
        fieldContainer.appendChild(errorContainer);
      }
    }

    if (errorMessage) {
      errorContainer.textContent = errorMessage;
      errorContainer.style.display = 'block';
    } else {
      errorContainer.style.display = 'none';
    }
  }

  // Helper method to wrap field with error container
  wrapFieldWithErrorContainer(fieldContainer, errorContainer) {
    // Create wrapper div
    const wrapper = document.createElement('div');
    wrapper.className = 'field-wrapper';

    // Preserve layout classes: copy to wrapper and remove from field
    const classesToPreserve = ['contactWidth50', 'contact-layout50'];
    classesToPreserve.forEach(className => {
      if (fieldContainer.classList.contains(className)) {
        wrapper.classList.add(className);
        fieldContainer.classList.remove(className);  // Remove from original element
      }
    });

    // Insert wrapper before fieldContainer
    fieldContainer.parentNode.insertBefore(wrapper, fieldContainer);

    // Move fieldContainer into wrapper
    wrapper.appendChild(fieldContainer);

    // Append error container to wrapper
    wrapper.appendChild(errorContainer);
  }

  // Clear field-specific error
  clearFieldErrorOutput(field) {
    if (!this.options.fieldErrorSelector) return;

    const fieldContainer = field.closest(this.options.fieldSelector);
    if (!fieldContainer) return;

    // Look for error container in fieldContainer or its parent wrapper
    let errorContainer = fieldContainer.querySelector(this.options.fieldErrorSelector);
    if (!errorContainer && this.options.wrapFieldForErrors) {
      // Check if fieldContainer is inside a wrapper
      const wrapper = fieldContainer.parentElement;
      if (wrapper && wrapper.classList.contains('field-wrapper')) {
        errorContainer = wrapper.querySelector(this.options.fieldErrorSelector);
      }
    }

    if (errorContainer) {
      errorContainer.style.display = 'none';
      errorContainer.textContent = '';
    }
  }

  setupEventListeners() {
    // Use event delegation for input, blur, and change events
    // This automatically handles dynamically added inputs

    if (this.options.validateOnInput) {
      this.delegate.on('input', 'input, textarea, select', (e) => this.handleInputChange(e.target));
    } else {
      this.delegate.on('input', 'input, textarea, select', (e) => this.handleInputForErrorClearing(e.target));
    }

    if (this.options.validateOnBlur) {
      this.delegate.on('blur', 'input, textarea, select', (e) => this.handleFieldBlur(e.target));
    }

    this.delegate.on('change', 'input, textarea, select', (e) => this.handleInputChange(e.target));
    this.delegate.on('selectbox:change', (e) => this.handleInputChange(e.target));

  }

  handleInputChange(input) {
    // NEW FLAG: activelyValidateAfterSubmit - no validation before submit, then active on input after
    if (this.options.activelyValidateAfterSubmit) {
      if (!this.hasSubmittedOnce) {
        return; // No validation before submit
      }
      // After submit, always validate on input
      this.validateField(input, false);
      this.updateErrorOutput();
      if (this.options.buttonSelector) {
        this.updateButtonState();
      }
      return;
    }

    // ORIGINAL BEHAVIOR: respect showErrorsOnSubmitOnly and validateOnInput flags
    if (this.options.showErrorsOnSubmitOnly && !this.hasSubmittedOnce) {
      return;
    }

    // For SELECT elements, treat 'change' event as equivalent to 'input'
    const isSelectChange = input.tagName === 'SELECT';
    if (this.options.validateOnInput || isSelectChange) {
      this.validateField(input, false);
    } else {
      // Even if validateOnInput is false, clear errors if field becomes valid
      if (this.isFieldValid(input)) {
        this.clearFieldError(input);
        this.clearFieldErrorOutput(input);
      }
    }

    this.updateErrorOutput();

    if (this.options.buttonSelector) {
      this.updateButtonState();
    }
  }

  updateErrorOutput() {
    if (!this.options.errorOutputSelector) return;

    // NEW FLAG: activelyValidateAfterSubmit - no errors before submit
    if (this.options.activelyValidateAfterSubmit && !this.hasSubmittedOnce) {
      return;
    }

    // ORIGINAL BEHAVIOR
    if (this.options.showErrorsOnSubmitOnly && !this.hasSubmittedOnce) {
      return;
    }

    const errors = this.getAllErrors();
    this.outputErrors(errors);
  }

  // Updated to include errors for empty required fields when form is submitted
  getAllErrors() {
    const errors = [];
    this.form.querySelectorAll('input, textarea, select').forEach(field => {
      if (!this.isFieldValid(field)) {
        const errorMessage = this.getFieldErrorMessage(field);
        if (errorMessage) {
          errors.push(errorMessage);
        }
      }
    });
    return errors;
  }

  handleInputForErrorClearing(input) {
    // NEW FLAG: activelyValidateAfterSubmit - no validation before submit
    if (this.options.activelyValidateAfterSubmit) {
      if (!this.hasSubmittedOnce) {
        return; // No validation before submit
      }
      // After submit, validate to clear/show errors
      this.validateField(input, false);
      this.updateErrorOutput();
      if (this.options.buttonSelector) {
        this.updateButtonState();
      }
      return;
    }

    // ORIGINAL BEHAVIOR
    if (this.options.showErrorsOnSubmitOnly && !this.hasSubmittedOnce) {
      return;
    }

    // Clear errors if field becomes valid
    if (this.isFieldValid(input)) {
      this.clearFieldError(input);
      this.clearFieldErrorOutput(input);
    }

    this.updateErrorOutput();

    if (this.options.buttonSelector) {
      this.updateButtonState();
    }
  }

  handleFieldBlur(input) {
    // NEW FLAG: activelyValidateAfterSubmit - no validation before submit, then active on blur after
    if (this.options.activelyValidateAfterSubmit) {
      if (!this.hasSubmittedOnce) {
        return; // No validation before submit
      }
      // After submit, always validate on blur
      this.validateField(input, false);
      this.updateErrorOutput();
      if (this.options.buttonSelector) {
        this.updateButtonState();
      }
      return;
    }

    // ORIGINAL BEHAVIOR
    if (this.options.showErrorsOnSubmitOnly && !this.hasSubmittedOnce) {
      return;
    }

    if (this.options.validateOnBlur) {
      this.validateField(input, false);
    }

    this.updateErrorOutput();

    if (this.options.buttonSelector) {
      this.updateButtonState();
    }
  }

  // New helper method to clear field errors
  clearFieldError(field) {
    const fieldContainer = field.closest(this.options.fieldSelector);
    if (fieldContainer && fieldContainer.classList.contains(this.options.errorClass)) {
      fieldContainer.classList.remove(this.options.errorClass);
    }

    // Also clear error class from wrapper if wrapFieldForErrors is enabled
    if (this.options.wrapFieldForErrors && fieldContainer) {
      const wrapper = fieldContainer.parentElement;
      if (wrapper && wrapper.classList.contains('field-wrapper') && wrapper.classList.contains(this.options.errorClass)) {
        wrapper.classList.remove(this.options.errorClass);
      }
    }

    // Clear field-specific error output
    this.clearFieldErrorOutput(field);
  }

  addValidator(fieldId, validatorFn, errorMessage) {
    this.customValidators.set(fieldId, { validatorFn, errorMessage });
  }

  validateField(field, silent = true) {
    const fieldContainer = field.closest(this.options.fieldSelector);
    if (!fieldContainer) return true;

    // Skip validation for fields inside hidden booking steps
    const bookingStep = field.closest('.pm__booking-step');
    if (bookingStep && bookingStep.getAttribute('aria-hidden') === 'true') {
      return true;
    }

    const isValid = this.isFieldValid(field);
    const shouldShowErrors = !silent && (!this.options.showErrorsOnSubmitOnly || this.hasSubmittedOnce);

    // During silent validation (e.g., for button state), don't manipulate the UI
    if (silent) {
      return isValid;
    }

    // After this point, we're not silent - we should update the UI
    if (shouldShowErrors) {
      // Get wrapper if wrapFieldForErrors is enabled
      const wrapper = this.options.wrapFieldForErrors && fieldContainer.parentElement?.classList.contains('field-wrapper')
        ? fieldContainer.parentElement
        : null;

      if (isValid) {
        // Field is valid - clear errors
        fieldContainer.classList.remove(this.options.errorClass);
        if (wrapper) wrapper.classList.remove(this.options.errorClass);
        this.clearFieldErrorOutput(field);
      } else {
        // Field is invalid - show error
        fieldContainer.classList.add(this.options.errorClass);
        if (wrapper) wrapper.classList.add(this.options.errorClass);
        const errorMessage = this.getFieldErrorMessage(field);
        this.outputFieldError(field, errorMessage);
      }
    }

    return isValid;
  }

  // New method to get field-specific error message
  getFieldErrorMessage(field) {
    // Check custom validators first
    if (this.customValidators.has(field.id)) {
      const { errorMessage } = this.customValidators.get(field.id);
      return errorMessage;
    }

    // Check for data-invalid attribute (for custom elements)
    if (field.hasAttribute('data-invalid') && field.getAttribute('data-invalid') === 'true') {
      return TranslationUtils.get('products.booking_validation.select_required', 'Please make a selection');
    }

    // Checkbox validation
    if (field.type === 'checkbox' && field.hasAttribute('required') && !field.checked) {
      return TranslationUtils.get('form_validation.checkbox_required', 'You must check this box to continue');
    }

    // Select validation
    if (field.tagName === 'SELECT') {
      const selectedOption = field.options[field.selectedIndex];
      if (!selectedOption || selectedOption.disabled) {
        return TranslationUtils.get('products.booking_validation.select_required', 'Please make a selection');
      }
    }

    // Required field validation
    if (field.hasAttribute('required') && !field.value.trim()) {
      return TranslationUtils.get('form_validation.field_required', 'This field is required');
    }

    // Email validation
    if (field.type === 'email' && field.value && !this.isValidEmail(field.value)) {
      return TranslationUtils.get('form_validation.email_invalid', 'Please enter a valid email address');
    }

    // Phone validation
    if (field.type === 'tel' && field.value && !this.isValidPhone(field.value)) {
      return TranslationUtils.get('form_validation.phone_invalid', 'Please enter a valid phone number');
    }

    return TranslationUtils.get('form_validation.field_required', 'This field is required');
  }

  markSubmitted() {
    this.hasSubmittedOnce = true;
    if (this.options.buttonSelector) {
      this.updateButtonState();
    }
  }

  isFieldValid(field) {
    // Check for explicit data-invalid attribute (for custom elements like connected products selectbox)
    if (field.hasAttribute('data-invalid') && field.getAttribute('data-invalid') === 'true') {
      return false;
    }

    // Check if field has required attribute or is in a checkbox that needs to be checked
    if (field.type === 'checkbox' && field.hasAttribute('required')) {
      return field.checked;
    }

    // Check required fields (for inputs, textareas)
    if (field.hasAttribute('required') && field.tagName !== 'SELECT' && !field.value.trim()) {
      return false;
    }

    // Check select elements
    if (field.tagName === 'SELECT') {
      const selectedOption = field.options[field.selectedIndex];
      // Invalid if no option selected OR selected option is disabled
      if (!selectedOption || selectedOption.disabled) {
        return false;
      }
    }

    // Check email format (only if field has value)
    if (field.type === 'email' && field.value && !this.isValidEmail(field.value)) {
      return false;
    }

    // Check phone format (only if field has value)
    if (field.type === 'tel' && field.value && !this.isValidPhone(field.value)) {
      return false;
    }

    // Check custom validators
    if (this.customValidators.has(field.id)) {
      const { validatorFn } = this.customValidators.get(field.id);
      const result = validatorFn(field.value, field);
      if (typeof result === 'string') {
        return false;
      }
      return !!result;
    }

    return true;
  }

  validateForm(silent = true) {
    const allFields = this.form.querySelectorAll('input, textarea, select, [data-invalid]');
    let isFormValid = true;

    allFields.forEach(field => {
      const isFieldValid = this.validateField(field, silent);
      if (!isFieldValid) {
        isFormValid = false;
      }
    });

    if (!silent) {
      this.updateErrorOutput();
    }

    return isFormValid;
  }

  updateButtonState() {
    if (!this.options.buttonSelector || !this.options.disableButton) return;

    const buttons = document.querySelectorAll(this.options.buttonSelector);

    // NEW FLAG: activelyValidateAfterSubmit - keep buttons enabled before submit
    if (this.options.activelyValidateAfterSubmit && !this.hasSubmittedOnce) {
      buttons.forEach(button => {
        button.removeAttribute('disabled');
        button.classList.remove('disabled');
        button.setAttribute('aria-disabled', 'false');
      });
      return;
    }

    // ORIGINAL BEHAVIOR
    if (this.options.showErrorsOnSubmitOnly && !this.hasSubmittedOnce) {
      buttons.forEach(button => {
        button.removeAttribute('disabled');
        button.classList.remove('disabled');
        button.setAttribute('aria-disabled', 'false');
      });
      return;
    }

    const isValid = this.validateForm(true);
    buttons.forEach(button => {
      if (isValid) {
        button.removeAttribute('disabled');
        button.classList.remove('disabled');
        button.setAttribute('aria-disabled', 'false');
      } else {
        button.setAttribute('disabled', 'true');
        button.classList.add('disabled');
        button.setAttribute('aria-disabled', 'true');
      }
    });
  }

  clearErrors() {
    const errorFields = this.form.querySelectorAll(`.${this.options.errorClass}`);
    errorFields.forEach(field => {
      field.classList.remove(this.options.errorClass);
    });

    if (this.options.errorOutputSelector) {
      this.outputErrors([]);
    }
  }

  showAllErrors() {
    return this.validateForm(false);
  }

  getFormData() {
    const formData = new FormData(this.form);
    return Object.fromEntries(formData.entries());
  }

  isValidEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  isValidPhone(phone) {
    // Basic phone validation - allows various formats
    const phoneRegex = /^[\+]?[\d\s]{1,16}$/;
    return phoneRegex.test(phone.replace(/[\s\-\(\)]/g, ''));
  }

  isValidFutureDate(dateString) {
    if (!dateString) return false;
    const selectedDate = new Date(dateString);
    const now = new Date();
    return selectedDate > now;
  }
}
class DetailedProductPopup {
  constructor() {
    // Use Map for better performance with many entries
    this.productCache = new Map();
    this.hoverTimeouts = new Map();
    this.maxCacheSize = 25; // Prevent unlimited memory growth

    // Prevent multiple simultaneous popup operations
    this.isProcessing = false;

    this.pendingElements = [];
  }

  // Attach event delegation to a specific element
  attachToElement(element, excludeSelectors = null) {
    // Create delegate instance for this element
    const delegate = new Delegate(element);

    // Click handler for popup triggers within this element
    delegate.on('click', '[data-action="open-detailed"]', (event, target) => {
      this.openProductPagePopup(event, excludeSelectors);
    });

    // Mouseover handler for prefetching within this element
    delegate.on('mouseover', '[data-action="open-detailed"]', (event, target) => {
      this.debouncedPrefetch(target);
    });
  }

  // Use existing debounce function from global.js
  debouncedPrefetch = debounce((target) => {
    this.prefetchProduct(target);
  }, 200);

  // Cache management methods
  addToCache(url, content) {
    // Implement FIFO cache eviction when max size reached
    if (this.productCache.size >= this.maxCacheSize) {
      const firstKey = this.productCache.keys().next().value;
      this.productCache.delete(firstKey);
    }
    this.productCache.set(url, content);
  }

  clearTimeout(url) {
    if (this.hoverTimeouts.has(url)) {
      clearTimeout(this.hoverTimeouts.get(url));
      this.hoverTimeouts.delete(url);
    }
  }

  // Shared method to fetch and parse product content
  async fetchProductContent(url) {
    try {
      const html = await apiService.get(url, null, {
        headers: {
          'Accept': 'text/html',
          'X-Requested-With': 'XMLHttpRequest'
        }
      });

      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newContent = doc.querySelector('.product__module');

      if (newContent) {
        const contentHTML = newContent.innerHTML;
        this.addToCache(url, contentHTML);
        return contentHTML;
      } else {
        console.warn('Product module not found in fetched HTML.');
        return null;
      }
    } catch (error) {
      console.error('Failed to fetch product content:', error);
      return null;
    }
  }

  async prefetchProduct(target) {
    const url = target.getAttribute("data-url");
    if (!url || this.productCache.has(url)) return;

    // Clear any existing timeout for this URL
    this.clearTimeout(url);

    await this.fetchProductContent(url);
  }

  async renderProduct(modalElement, url, excludeSelectors = null, originalElement = null, isVoucherAboutExperience = false) {
    const targetContainer = modalElement?.querySelector('.popup-content__inner');
    const titleElement = modalElement?.querySelector('.detailed_view-title');

    if (!modalElement || !targetContainer) {
      console.warn('Modal element or target container not found.');
      return Promise.resolve();
    }

    // Use cache if available
    if (this.productCache.has(url)) {
      let contentHTML = this.productCache.get(url);

      // Process content (extract title and filter if needed)
      const processedContent = this.filterCachedContent(contentHTML, excludeSelectors, titleElement, isVoucherAboutExperience);

      // **Clear the existing content including the loader**
      targetContainer.innerHTML = '';

      // Create a temporary container to parse the processed content
      const tempContainer = document.createElement('div');
      tempContainer.innerHTML = processedContent.content;
      const productComponent = tempContainer.querySelector('product-component');

      if (productComponent) {
        targetContainer.appendChild(productComponent);
      } else {
        targetContainer.innerHTML = processedContent.content;
      }

      // Wait for DOM to be updated
      await new Promise(resolve => requestAnimationFrame(resolve));

      // Dispatch event after product is rendered
      modalElement.dispatchEvent(
        new CustomEvent('detailed-product-popup:product-rendered', {
          detail: {
            popup: modalElement,
            originalElement: originalElement,
            popupInstance: this,
            targetContainer: targetContainer
          },
          bubbles: true
        })
      );

      // Dispatch event after content is loaded
      this.dispatchContentLoadedEvent(modalElement, originalElement);

      return Promise.resolve();
    }

    // Fetch content using shared method (loader is already shown)
    let contentHTML = await this.fetchProductContent(url);

    if (contentHTML) {
      // Process content (extract title and filter if needed)
      const processedContent = this.filterCachedContent(contentHTML, excludeSelectors, titleElement, isVoucherAboutExperience);

      targetContainer.innerHTML = processedContent.content;

      // Wait for DOM to be updated after setting innerHTML
      await new Promise(resolve => requestAnimationFrame(resolve));

      modalElement.dispatchEvent(
        new CustomEvent('detailed-product-popup:product-rendered', {
          detail: {
            popup: modalElement,
            originalElement: originalElement,
            popupInstance: this,
            targetContainer: targetContainer
          },
          bubbles: true
        })
      );

      // Dispatch event after content is loaded
      this.dispatchContentLoadedEvent(modalElement, originalElement);
    } else {
      // Show error message if fetch failed - use appropriate translation based on context
      const errorMessage = isVoucherAboutExperience
        ? TranslationUtils.get('customer.account.vouchers.about_experience.popup_error', 'Failed to load experience details. Please try again.')
        : 'Sorry, we couldn\'t load the product details. Please try again.';

      targetContainer.innerHTML = `
        <div class="error-message" style="padding: 2rem; text-align: center;">
          <p>${errorMessage}</p>
        </div>
      `;
    }

    return Promise.resolve();
  }

  openProductPagePopup(event, excludeSelectors = null) {
    event.preventDefault();
    event.stopPropagation(); // Prevent event bubbling that might trigger other handlers

    // Prevent multiple simultaneous clicks
    if (this.isProcessing) {
      return;
    }

    const target = event.target.closest('[data-action="open-detailed"]') || event.target;
    const url = target.getAttribute("data-url");

    // Always use the detailed_view_popup
    const modalElement = document.getElementById('detailed_view_popup');

    if (!modalElement) {
      console.warn("Modal not found for ID: detailed_view_popup");
      return;
    }

    if (!url) {
      console.warn("No data-url found on element:", target);
      return;
    }

    // Check if this is an "About This Experience" button from vouchers
    const isVoucherAboutExperience = target.closest('voucher-action-handler') || target.dataset.voucherId;

    // Mark as processing to prevent multiple clicks
    this.isProcessing = true;

    // 1. Open empty popup immediately for instant feedback
    this.openEmptyPopup(modalElement, isVoucherAboutExperience);

    // 2. Render product content in the background
    this.renderProduct(modalElement, url, excludeSelectors, target, isVoucherAboutExperience).finally(() => {
      // Reset processing flag when done
      this.isProcessing = false;
    });
  }

  // Method to transfer price and how to modals from detailed popup outside of it
  handleTransferInformationPopups(popup) {
    const targetContainer = document.querySelector(".product-collection-grid");
    if (!targetContainer) return;

    // helper function to handle a single modal type
    const transferModal = (selector) => {
      const modal = popup.querySelector(selector);
      if (!modal) return;

      const popupId = modal.getAttribute("id");
      if (!popupId) {
        console.warn(`⚠️ ${selector} has no identifiable ID`);
        return;
      }

      // find existing modal of the same type, but not inside detailed view popup
      const existingModal = Array.from(
        document.querySelectorAll(`.product-collection-grid ${selector}`)
      ).find(m => !m.closest("#detailed_view_popup"));

      const existingModalId = existingModal ? existingModal.getAttribute("id") : null;

      // same modal already exists in grid → skip
      if (existingModal && existingModalId === popupId) {
        return;
      }

      // different modal already there → remove it
      if (existingModal && existingModalId !== popupId) {
        existingModal.remove();
      }

      // move new modal into the grid
      targetContainer.appendChild(modal);
    };

    // apply the same logic for both modals
    transferModal(".how-it-works-modal");
    transferModal(".price-info-modal");

    // If neither modal exists, warn once
    if (
      !popup.querySelector(".how-it-works-modal") &&
      !popup.querySelector(".price-info-modal")
    ) {
      console.warn("⚠️ No .how-it-works-modal or .price-info-modal found in popup instance");
    }
  }

  openEmptyPopup(modalElement, isVoucherAboutExperience = false) {
    // Clear any existing content and show loader
    const targetContainer = modalElement.querySelector('.popup-content__inner');
    if (targetContainer) {
      targetContainer.innerHTML = `
        <div class="itemLoader is-visible">
          <svg class="icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-dasharray="31.416" stroke-dashoffset="31.416">
              <animate attributeName="stroke-dasharray" dur="2s" values="0 31.416;15.708 15.708;0 31.416;0 31.416" repeatCount="indefinite"/>
              <animate attributeName="stroke-dashoffset" dur="2s" values="0;-15.708;-31.416;-31.416" repeatCount="indefinite"/>
            </circle>
          </svg>
        </div>
      `;
    }

    // Set the appropriate title based on context
    const titleElement = modalElement.querySelector('.detailed_view-title');
    if (titleElement && isVoucherAboutExperience) {
      titleElement.textContent = TranslationUtils.get('customer.account.vouchers.about_experience.popup_title', 'About This Experience');
    }

    // Calculate and update header height
    this.updatePopupHeaderHeight(modalElement);

    // Open popup immediately using the global popup system
    if (window.globalPopup && typeof window.globalPopup.openPopup === 'function') {
      window.globalPopup.openPopup(modalElement);
    } else {
      console.warn('Global popup system not available');
    }
  }

  // Calculate and set the popup header height dynamically
  updatePopupHeaderHeight(modalElement) {
    // Wait for title to be loaded before measuring header height
    const titleElement = modalElement.querySelector('.detailed_view-title');

    if (!titleElement) {
      console.warn('DetailedProductPopup: Title element not found');
      return;
    }

    // Function to measure and update header height
    const measureAndUpdate = () => {
      requestAnimationFrame(() => {
        const header = modalElement.querySelector('.popup-header');
        if (header) {
          // Get the actual computed height of the header
          const headerHeight = header.getBoundingClientRect().height + 40;

          // Update the CSS custom property
          modalElement.style.setProperty('--popup-header', `${headerHeight}px`);
        } else {
          console.warn('DetailedProductPopup: Popup header not found');
        }
      });
    };

    // Check if title is already loaded
    if (titleElement.textContent.trim()) {
      measureAndUpdate();
    } else {
      // Wait for title to be set using MutationObserver
      const observer = new MutationObserver((mutations) => {
        for (const mutation of mutations) {
          if (mutation.type === 'childList' || mutation.type === 'characterData') {
            if (titleElement.textContent.trim()) {
              observer.disconnect();
              measureAndUpdate();
              break;
            }
          }
        }
      });

      // Observe changes to the title element
      observer.observe(titleElement, {
        childList: true,
        characterData: true,
        subtree: true
      });

      // Fallback timeout in case title never loads
      setTimeout(() => {
        observer.disconnect();
        measureAndUpdate(); // Measure anyway after timeout
      }, 2000);
    }
  }

  // Dispatch event when content is loaded for other components to listen
  dispatchContentLoadedEvent(popup, originalElement = null) {
    const event = new CustomEvent('detailed-view-content-loaded', {
      detail: {
        popup: popup,
        originalElement: originalElement
      },
      bubbles: true
    });

    document.dispatchEvent(event);
  }

  // Process cached HTML content: extract title and filter content before appending to modal
  filterCachedContent(contentHTML, excludeSelectors = [], titleElement = null, isVoucherAboutExperience = false) {
    if (!contentHTML) {
      return { content: contentHTML, title: null };
    }

    // Create a temporary DOM to work with the cached content
    const tempContainer = document.createElement('div');
    tempContainer.innerHTML = contentHTML;

    // Find and extract only the product-component
    const productComponent = tempContainer.querySelector('product-component');
    if (!productComponent) {
      console.warn('DetailedProductPopup: product-component not found in cached content');
      return { content: contentHTML, title: null };
    }

    // Extract and set title if titleElement is provided
    let extractedTitle = null;
    if (isVoucherAboutExperience) {
      // For voucher about experience, use the translation key instead of product title
      extractedTitle = TranslationUtils.get('customer.account.vouchers.about_experience.popup_title', 'About This Experience');
      if (titleElement) {
        titleElement.textContent = extractedTitle;
      }
    } else if (productComponent.dataset.title) {
      // For regular product popups, use the product title
      extractedTitle = productComponent.dataset.title;
      if (titleElement) {
        titleElement.textContent = extractedTitle;
      }
    }

    // Apply excludeSelectors to the product component only
    if (excludeSelectors && excludeSelectors.length > 0) {
      let removedCount = 0;
      excludeSelectors.forEach(selector => {
        const elementsToRemove = productComponent.querySelectorAll(selector);
        elementsToRemove.forEach(element => {
          if (element.parentNode) {
            element.remove();
            removedCount++;
          }
        });
      });
    }

    // Return clean product component content
    return {
      content: productComponent.outerHTML,
      title: extractedTitle
    };
  }

  /**
   * Simple method to append an existing element to a target container in the popup
   * @param {string} elementSelector - CSS selector for the element to move
   * @param {string} targetSelector - CSS selector for the target container within popup
   * @param {boolean} clone - Whether to clone the element (default: true)
  **/
  appendElement(elementSelector, targetSelector, clone = true) {
    const sourceElement = document.querySelector(elementSelector);

    if (!sourceElement) {
      console.warn('❌ Source element not found:', elementSelector);
      return;
    }

    if (!this.pendingElements) {
      this.pendingElements = [];
    }

    this.pendingElements.push({
      sourceElement,
      targetSelector,
      clone,
      queuedAt: Date.now(),
      instanceId: this.instanceId
    });
  }

  /**
   * Inject queued elements into the popup container
   * @param {HTMLElement} popupContainer - The popup container (.popup-content__inner)
  **/
  injectQueuedElements(popupContainer) {
    if (!this.pendingElements || this.pendingElements.length === 0) return;

    this.pendingElements.forEach(({ sourceElement, targetSelector, clone }) => {
      const targetContainer = targetSelector ?
        popupContainer.querySelector(targetSelector) :
        popupContainer;

      if (!targetContainer) {
        console.warn('DetailedProductPopup: Target container not found:', targetSelector);
        return;
      }

      // Clone or move the element
      let elementToInject;

      if (sourceElement.tagName === 'TEMPLATE') {
        elementToInject = clone
          ? sourceElement.content.cloneNode(true)
          : sourceElement.content;
      } else {
        elementToInject = clone
          ? sourceElement.cloneNode(true)
          : sourceElement;
      }

      targetContainer.appendChild(elementToInject);
    });

    // Clear the queue after injection
    this.pendingElements = [];
  }
}

class ProductCollectionGrid extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);

    // Create our own DetailedProductPopup instance
    this.detailedPopup = new DetailedProductPopup();
  }

  // Define which elements to exclude when filtering popup content
  getExcludeSelectors() {
    const excludeSelectors = [
      '.pm__info-note-wrapper',
      '.pdp__variants--grid',
      '.pc__labels-holder',
      'notify-me-popup',
      '.pm__connected-products-picker',
      '.pm__payment-options__payment',
      '.pm__buttons-pay-quantity form',
      '.pm__buttons-pay-quantity .pm__quantity',
      '.pm__price'
    ];
    return excludeSelectors;
  }

  connectedCallback() {
    this.productUrl = this.element.dataset.productUrl;
    this.collectionHandle = this.element.dataset.collectionHandle;
    this.baseUrl = this.element.dataset.paginationBaseUrl;
    this.currentPage = Number(this.element.dataset.currentPage) || 1;

    this.renderGrid();
    this.bindEvents();

    // Attach detailed product popup functionality to this grid with excludeSelectors
    this.detailedPopup.attachToElement(this.element, this.getExcludeSelectors());
  }

  bindEvents() {
    // Only pagination handler - popup functionality is now handled globally
    this.delegateElement.on(
      'click',
      '[data-action="pagination"]',
      this.onPaginationClick.bind(this)
    );

    this.delegateBody.on(
      'product-collection-grid:rendered', () => {
        if (typeof allDropdowns !== 'undefined' && allDropdowns.updateAllDropdowns) {
          allDropdowns.updateAllDropdowns();
        }
      }
    );

    this.delegateBody.on('detailed-product-popup:product-rendered', (event) => {
      const { popupInstance, targetContainer, popup } = event.detail;
      // Queue elements on the correct instance
      popupInstance.appendElement('#popup-small-experience-preview', '.pm__media-information-wrapper');
      popupInstance.appendElement('.pm__price', '.pm__price-container');
      popupInstance.appendElement('.pm__buttons-pay-quantity form', '.pm__buttons-pay-quantity');
      popupInstance.appendElement('.pm__buttons-pay-quantity .pm__quantity', '.pm__buttons-pay-quantity');

      requestAnimationFrame(() => {
        popupInstance.injectQueuedElements(targetContainer);
      });

      popupInstance.handleTransferInformationPopups(popup);
    });
  }

  async renderGrid() {
    const page = 1;
    const url = `${this.baseUrl}?page=${page}&view=giftbox-collection`;
    if (!url) return;

    try {
      // Fetch next page's HTML content from the collection page
      const response = await fetch(url, {
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      });

      if (!response.ok) throw new Error('Network response was not ok');

      const html = await response.text();

      // Parse the returned HTML and extract the product grid and pagination
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      // Update product grid content
      const newGrid = doc.querySelector('.pm__collection-grid-with-filters');
      const oldGrid = this.element.querySelector(".pdp__collection-grid-template");

      if (newGrid) {
        oldGrid.innerHTML = newGrid.innerHTML;
        this.element.dispatchEvent(
          new CustomEvent('product-collection-grid:rendered', {
            detail: { page: page },
            bubbles: true
          })
        );
      }

    } catch (error) {
      console.error('Failed to load collection page:', error);
    }
  }


  async onPaginationClick(event) {
    event.preventDefault();
    const page = event.target.closest('[data-action="pagination"]').getAttribute('data-page');
    const url = `${this.baseUrl}?page=${page}&view=giftbox-collection`;
    if (!url) return;


    try {
      // Fetch next page's HTML content from the collection page
      const response = await fetch(url, {
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      });

      if (!response.ok) throw new Error('Network response was not ok');

      const html = await response.text();

      // Parse the returned HTML and extract the product grid and pagination
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      // Update product grid content
      const newGrid = doc.querySelector('.pm__collection-grid-with-filters');
      const oldGrid = this.element.querySelector(".pdp__collection-grid-template");

      if (newGrid) {
        oldGrid.innerHTML = newGrid.innerHTML;

        // Also update data attributes with new current page
        this.currentPage = Number(newGrid.dataset.currentPage) || this.currentPage;
        this.element.dataset.currentPage = this.currentPage;
      }

      // Update pagination controls
      const newPagination = doc.querySelector('#product-grid-pagination');
      const paginationContainer = document.querySelector('#product-grid-pagination');
      if (paginationContainer && newPagination) {
        paginationContainer.innerHTML = newPagination.innerHTML;
      }

      this._updateUrl(page);

    } catch (error) {
      console.error('Failed to load collection page:', error);
    }
  }

  _updateUrl(currentPage) {
    let productPageUrl = this.productUrl;
    const newUrl = `${productPageUrl}?page=${currentPage}`;
    window.history.replaceState({}, "", newUrl);
  }
}

customElements.define("product-collection-grid", ProductCollectionGrid);

class ProductCard extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
  }

}
customElements.define("product-card", ProductCard);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);

    this.intersectionObserver = new IntersectionObserver(
      this.handleIntersection.bind(this),
      { rootMargin: '-250px 0px 200px 0px' }
    );
  }

  connectedCallback() {
    this.intersectionObserver.observe(this);
    new AddToCart(this.element);
  }

  async handleIntersection(entries, observer) {
    const entry = entries?.[0];
    if (!entry?.isIntersecting) return;

    observer.unobserve(this);

    const url = this.dataset?.url;
    if (!url) {
      console.warn("ProductCarousel: Missing data-url attribute.");
      return;
    }

    try {
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error(`Failed to fetch content: ${response.status} ${response.statusText}`);
      }

      const text = await response.text();
      const html = document.createElement('div');
      html.innerHTML = text;

      const recommendations = html.querySelector('.product-recommendation');
      if (!recommendations || !recommendations.innerHTML.trim()) {
        console.warn("ProductCarousel: No valid .product-recommendation content.");
        return;
      }

      this.innerHTML = recommendations.innerHTML;

    } catch (error) {
      console.error("ProductCarousel: Error loading carousel content.", error);
    }
  }
}

customElements.define("product-recommendations", ProductRecommendations);

class ApiError extends Error {
  constructor(message, status, response, responseCode = null, code = null) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    this.response = response;
    this.responseCode = responseCode;
    this.code = code;
  }
}

class ApiService {
  constructor() {
    this.timeout = 10000;
    this.defaultHeaders = {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    };
  }

  get baseURL() {
    // Dynamically get baseURL to ensure it's always current
    return window.routes?.localeRootUrl || '';
  }

  async request(endpoint, options = {}) {
    const {
      method = 'GET',
      body = null,
      headers = {},
      timeout = this.timeout
    } = options;

    const config = {
      method,
      // Merge user headers with default headers (user headers take precedence)
      headers: { ...this.defaultHeaders, ...headers }
    };

    // Add timeout with fallback for older browsers
    if (typeof AbortSignal.timeout === 'function') {
      config.signal = AbortSignal.timeout(timeout);
    } else {
      const controller = new AbortController();
      config.signal = controller.signal;
      setTimeout(() => controller.abort(), timeout);
    }

    if (body && method !== 'GET') {
      config.body = typeof body === 'string' ? body : JSON.stringify(body);
    }

    try {
      const response = await fetch(`${this.baseURL}${endpoint}`, config);

      if (!response.ok) {
        // Try to parse error response as JSON first
        let errorData = null;
        let errorMessage = `HTTP ${response.status}: ${response.statusText}`;
        let responseCode = null;
        let code = null;

        try {
          const errorText = await response.text();
          errorData = JSON.parse(errorText);

          // Extract message, responseCode, and code from JSON error response
          if (errorData.message) {
            errorMessage = errorData.message;
          }
          if (errorData.responseCode) {
            responseCode = errorData.responseCode;
          }
          if (errorData.code) {
            code = errorData.code;
          }
        } catch (parseError) {
          // If JSON parsing fails, keep the default error message
          errorData = await response.text().catch(() => 'Unknown error');
        }

        throw new ApiError(
          errorMessage,
          response.status,
          errorData,
          responseCode,
          code
        );
      }

      return this._parseResponse(response);
    } catch (error) {
      // Re-throw ApiError as-is, wrap other errors
      if (error instanceof ApiError) {
        throw error;
      }

      // Network errors or timeouts
      throw new ApiError(
        error.message || 'Network error',
        0,
        null
      );
    }
  }

  async _parseResponse(response) {
    const contentType = response.headers.get('content-type') || '';

    if (contentType.includes('application/json')) {
      return await response.json();
    } else if (contentType.includes('text/')) {
      return await response.text();
    } else if (contentType.includes('application/octet-stream')) {
      return await response.blob();
    }

    return await response.text();
  }

  // Convenience methods
  async get(endpoint, body = null, options = {}) {
    return this.request(endpoint, { ...options, method: 'GET', body });
  }

  async post(endpoint, body, options = {}) {
    return this.request(endpoint, { ...options, method: 'POST', body });
  }

  async put(endpoint, body, options = {}) {
    return this.request(endpoint, { ...options, method: 'PUT', body });
  }

  async delete(endpoint, options = {}) {
    return this.request(endpoint, { ...options, method: 'DELETE' });
  }

  // General purpose methods for specific use cases
  async sectionRender(sectionId = null, url, options = {}) {
    // For Shopify section rendering - url is required
    const urlObj = new URL(url, window.location.origin);

    // Add section_id parameter if provided
    if (sectionId) {
      urlObj.searchParams.set('section_id', sectionId);
    }

    const endpoint = urlObj.pathname + urlObj.search;

    return this.request(endpoint, {
      ...options,
      method: 'GET',
      headers: {
        'Accept': 'text/html',
        ...options.headers
      }
    });
  }

  async searchApi(query, options = {}) {
    // For search operations
    const {
      type = 'product',
      view = 'ajax',
      limit = null,
      ...restOptions
    } = options;

    let endpoint;
    if (view === 'suggest') {
      // Predictive search
      endpoint = `/search/suggest.json?q=${encodeURIComponent(query)}`;
      if (type) endpoint += `&resources[type]=${type}`;
      if (limit) endpoint += `&resources[limit]=${limit}`;
    } else {
      // Regular search
      endpoint = `/search?view=${view}&q=${encodeURIComponent(query)}`;
      if (type) endpoint += `&type=${type}`;
    }

    return this.get(endpoint, restOptions);
  }
}

// Global API service instance
const apiService = new ApiService();
window.apiService = apiService;

// Global function to clean up exchange products on page load
async function cleanupExchangeProductsOnPageLoad() {
  try {
    // Only run if not on exchange pages (where exchange products should remain)
    const isExchangePage = window.location.href.includes('exchange') ||
      window.location.href.includes('customer-exchange');

    if (isExchangePage) {
      return;
    }

    // Get current cart
    const cart = await window.apiService.get('/cart.js');
    if (!cart || !cart.items) {
      return;
    }

    // Find exchange products in cart (those with "Exchange Product :" in title)
    const exchangeItems = cart.items.filter(item =>
      item.title && item.title.includes('Exchange Product :')
    );

    if (exchangeItems.length === 0) {
      return;
    }

    // Prepare updates to remove exchange products (set quantity to 0)
    const updates = {};
    exchangeItems.forEach(item => {
      updates[item.key] = 0;
    });

    // Remove exchange products
    await window.apiService.post('/cart/update.js', { updates });

  } catch (error) {
    console.error('Error cleaning up exchange products on page load:', error);
  }
}

// Run cleanup on page load
document.addEventListener('DOMContentLoaded', cleanupExchangeProductsOnPageLoad);

class FavoritesStorage {
  static STORAGE_KEY = 'productFavorites';
  static MAX_FAVORITES = 50;

  static getFavorites() {
    try {
      return JSON.parse(localStorage.getItem(this.STORAGE_KEY) || '[]')
        .filter(item => item.id !== null);
    } catch (error) {
      console.error('Error parsing favorites from storage:', error);
      return [];
    }
  }

  static saveFavorites(items) {
    try {
      const limitedItems = items.slice(0, this.MAX_FAVORITES);
      localStorage.setItem(this.STORAGE_KEY, JSON.stringify(limitedItems));
      return true;
    } catch (error) {
      console.error('Error saving favorites to storage:', error);
      return false;
    }
  }

  static addFavorite(productId, size = null) {
    const items = this.getFavorites();
    const existingIndex = items.findIndex(item => item.id === productId);

    if (existingIndex === -1) {
      items.unshift({ id: productId, size });
      return this.saveFavorites(items);
    }
    return false;
  }

  static removeFavorite(productId) {
    const items = this.getFavorites();
    const filteredItems = items.filter(item => item.id !== productId);
    return this.saveFavorites(filteredItems);
  }

  static hasFavorite(productId) {
    return this.getFavorites().some(item => item.id === productId);
  }
}

class FavoritesDOM {
  static updateHeartIcon(container, isActive) {
    const solidHeart = container.querySelector('.solid-favorite');
    const emptyHeart = container.querySelector('.empty-favorite');

    if (!solidHeart || !emptyHeart) return;

    if (isActive) {
      solidHeart.style.display = 'flex';
      emptyHeart.style.display = 'none';
      solidHeart.ariaHidden = 'false';
      emptyHeart.ariaHidden = 'true';
    } else {
      solidHeart.style.display = 'none';
      emptyHeart.style.display = 'flex';
      solidHeart.ariaHidden = 'true';
      emptyHeart.ariaHidden = 'false';
    }
  }

  static updateHeaderHeartIcon(container, hasFavorites) {
    const emptyHeart = container.querySelector('.header__favorites--empty');
    const filledHeart = container.querySelector('.header__favorites--filled');

    if (!emptyHeart || !filledHeart) return;

    if (hasFavorites) {
      emptyHeart.style.display = 'none';
      emptyHeart.ariaHidden = 'true';
      filledHeart.style.display = 'flex';
      filledHeart.ariaHidden = 'false';
    } else {
      emptyHeart.style.display = 'flex';
      emptyHeart.ariaHidden = 'false';
      filledHeart.style.display = 'none';
      filledHeart.ariaHidden = 'true';
    }
  }
}

class FavoritesHeader extends HTMLElement {
  static hasBound = false;

  constructor() {
    super();
    this.element = this;
    this.delegateBody = new Delegate(document.body);

    this.toggleFavorites();
    this.bindEvents();
    this.updateHeaderIcons();
  }

  bindEvents() {
    // Only bind events once globally
    if (FavoritesHeader.hasBound) return;
    FavoritesHeader.hasBound = true;

    this.delegateBody.on(
      "click",
      '[data-action="toggle-favorites"]',
      this.addToFavorites.bind(this)
    );

    this.delegateBody.on(
      "keydown",
      '[data-action="toggle-favorites"]',
      this.addToFavorites.bind(this)
    );

    // Listen for custom events
    document.body.addEventListener('favorites:retoggle', () => {
      this.toggleFavorites();
    });

    document.body.addEventListener('favorites:reinitialize', () => {
      this.reinitializeFavorites();
    });
  }

  toggleFavorites() {
    const items = this.getFavorites();
    const favorites = document.querySelectorAll(
      ".product-card_favorites-container, .pm__review-favorites-icon-wrapper"
    );

    favorites.forEach(item => {
      const state = item.getAttribute("state");
      const myID = item.getAttribute("data-id");
      const exists = items.some(fav => fav.id === myID);

      if (state == "not-active" && exists) {
        FavoritesDOM.updateHeartIcon(item, true);
        item.setAttribute("state", "active");
      } else if (!exists) {
        FavoritesDOM.updateHeartIcon(item, false);
        item.setAttribute("state", "not-active");
      }
    });
  }

  updateHeaderIcons() {
    const favorites = this.getFavorites();
    const hasFavorites = favorites.length > 0;

    document.querySelectorAll('.fav-icon__wrapper').forEach(container => {
      FavoritesDOM.updateHeaderHeartIcon(container, hasFavorites);
    });
  }

  getFavorites() {
    return FavoritesStorage.getFavorites();
  }

  saveFavorites(items) {
    FavoritesStorage.saveFavorites(items);
    this.toggleFavorites();
    this.updateHeaderIcons();
  }

  removeFromFavorites(productId, size) {
    FavoritesStorage.removeFavorite(productId);
    this.updateHeaderIcons();
    this.toggleFavorites();

    document.body.dispatchEvent(new CustomEvent("favorite:remove", {
      detail: { id: productId, size: size }
    }));
  }

  reinitializeFavorites() {
    this.toggleFavorites();
    this.bindNewFavoriteButtons();
  }

  bindNewFavoriteButtons() {
    const newFavoriteButtons = document.querySelectorAll('[data-action="toggle-favorites"]:not([data-favorites-bound])');

    newFavoriteButtons.forEach(button => {
      button.setAttribute('data-favorites-bound', 'true');
    });
  }

  addToFavorites(e) {
    e.preventDefault();
    e.stopPropagation();

    if (e.key && e.key != "Enter") {
      return;
    }

    const closestLink = e.target.closest('a');
    if (closestLink) {
      closestLink.onclick = function (event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        return false;
      };

      setTimeout(() => {
        if (closestLink) closestLink.onclick = null;
      }, 100);
    }

    let items = this.getFavorites();
    const productId = e.target.parentElement.getAttribute("data-id") || e.target.getAttribute("data-id");
    const size = e.target.parentElement.getAttribute("data-size") || e.target.getAttribute("data-size") || null;

    if (!productId) {
      return;
    }

    const existingItemIndex = items.findIndex(item => item.id === productId);

    if (existingItemIndex === -1) {
      items.unshift({ id: productId, size: size });
    } else {
      this.removeFromFavorites(productId, size);
      return;
    }

    this.saveFavorites(items);
  }
}

customElements.define("favorites-header", FavoritesHeader);

class AnimatedAnnouncementBar extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    const self = this;
    this.delegateElement = new Delegate(this.element);

    this.announcementBar = document.querySelector(".announcementBar");




    this.updateVisibleHeight();

    this.transitionSpeed = this.element.getAttribute('data-settings');
    this.animWrapper = this.element.querySelector('.announcementBar--AnimWrapper');
    this.original = this.element.querySelector('.announcementBar--DuplicateWrapper');
    this.firstLoad = true;

    this.bindEvents();
  }


  connectedCallback() {
    requestAnimationFrame(() => {
      const height = this.element.offsetHeight;
      document.documentElement.style.setProperty(
        "--announcement-height-fixed",
        height + "px"
      );
    });
  }


  bindEvents() {
    window.addEventListener("scroll", this.updateVisibleHeight.bind(this));
    window.addEventListener("resize", this.updateVisibleHeight.bind(this));

    const debouncedFunc = debounce(this.handleBreakpointChange.bind(this), 100);
    responsive.addResizeListener(this, debouncedFunc);
    this.handleBreakpointChange();

    if (this.element.dataset.main == 'true') {
      scrollListener.addScrollListener(this, this.updateVisibleHeight.bind(this));
      responsive.addResizeListener(this, this.updateVisibleHeight.bind(this));
    }
  }

  updateVisibleHeight() {
    const rect = this.element.getBoundingClientRect();
    const windowHeight = window.innerHeight;


    let visibleHeight = Math.min(rect.bottom, windowHeight) - Math.max(rect.top, 0);

    // Ensure the visibleHeight is never negative
    visibleHeight = Math.max(visibleHeight, 0);

    // Update the height of .announcementBar with the visible height
    document.documentElement.style.setProperty(
      "--announcement-dynamic-height",
      `${visibleHeight}px`
    );
  }


  handleBreakpointChange() {
    if (!this.original) return; // Prevent error if original is null

    if (responsive.matchesBreakpoint("lap_and_up")) {
      this.mobile = false;
      if (this.transitionSpeed) {
        this.duplicateBlockWrappers();
      } else {
        Array.from(this.original.children).forEach((block, i) => block.style.display = 'block');
        this.original.style.justifyContent = 'space-between';
      }
    } else {
      this.mobile = true;
      if (this.transitionSpeed) {
        this.duplicateBlockWrappers();
      } else {
        Array.from(this.original.children).forEach((block, i) => {
          if (i != 0) block.style.display = 'none';
        });
        this.original.style.justifyContent = 'center';
      }
    }
  }


  resetWrapper() {
    Array.from(this.animWrapper.children).forEach((child, i) => { if (i != 0) this.animWrapper.removeChild(this.animWrapper.lastChild) });
    this.originalNew = this.element.offsetWidth - (parseInt(getComputedStyle(this.element).paddingLeft) * 2);
  }

  duplicateBlockWrappers() {
    this.resetWrapper();
    const duplicate = this.original.cloneNode(true),
      spaceDiv = document.createElement('div');

    var originalWidth = originalWidth = this.original.offsetWidth;
    if (this.originalNew) originalWidth = this.originalNew;

    if (this.mobile) {
      duplicate.style.width = (originalWidth * this.original.children.length - window.innerWidth) + 'px';
      this.original.style.width = (originalWidth * this.original.children.length - window.innerWidth) + 'px';
      this.animWrapper.style.width = (2 * (originalWidth * this.original.children.length - window.innerWidth)) + "px";

      if (this.original.children.length >= 2) this.spaceDivWidth = this.getDistanceBetweenBlocks(this.original.children[0], this.original.children[1])
      else this.spaceDivWidth = 0;
    }
    else {
      if (this.original.children.length >= 2) this.spaceDivWidth = this.getDistanceBetweenBlocks(this.original.children[0], this.original.children[1])
      else this.spaceDivWidth = 0;

      duplicate.style.width = originalWidth + 'px';
      this.original.style.width = originalWidth + 'px';
      this.animWrapper.style.width = (2 * originalWidth + this.spaceDivWidth) + "px";
    }

    spaceDiv.style.width = this.spaceDivWidth + 'px';
    this.animWrapper.style.position = "absolute";
    if (this.mobile && this.firstLoad) this.animWrapper.style.transform = `translateX(${this.spaceDivWidth / 2}px)`;

    this.element.style.height = this.animWrapper.offsetHeight + 'px';

    this.animWrapper.appendChild(spaceDiv);
    this.animWrapper.appendChild(duplicate);

    setTimeout(() => {
      this.startAnimating();
    }, 100);
  }

  startAnimating() {
    var translate;
    this.mobile && this.firstLoad ? translate = this.spaceDivWidth / 2 : translate = 0;
    this.firstLoad = false;

    this.animWrapper.animate(
      [
        { transform: `translateX(${translate}px)` },
        { transform: `translateX(calc(-50% - ${this.spaceDivWidth / 2}px))` }
      ],
      {
        duration: parseInt(this.transitionSpeed) * 1000,
        iterations: Infinity,
        fill: 'forwards',
        easing: 'linear'
      }
    );
  }

  getDistanceBetweenBlocks(blockOne, blockTwo) {
    return blockTwo.getBoundingClientRect().left - blockOne.getBoundingClientRect().right;
  }
}
customElements.define("announcement-bar", AnimatedAnnouncementBar);


class LookbookSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.settings = JSON.parse(this.element.getAttribute("data-section-settings"));
    this.activeFloatCards = [];
    this.onFloatCardOpen = null;
    this.onFloatCardClose = null;
  }

  connectedCallback() {
    this.updateVisibleItems();
    this.bindEvents();
  }

  bindEvents() {
    this.delegateBody.on(
      'click',
      '[data-action="toggle-float-card"]',
      this.handleOpenOptions.bind(this)
    );

    this.delegateBody.on(
      'keydown',
      this.handleEscClick.bind(this)
    );

    this.boundHandleResize = this.updateVisibleItems.bind(this);
    window.addEventListener("resize", this.boundHandleResize);
  }

  updateVisibleItems() {
    const wrapper = this.element.querySelector('.lookbook-grid ');
    if (!wrapper) return;

    const mobileLimit = this.settings.mobile_items_count || 50;
    const desktopLimit = this.settings.desktop_items_count || 50;

    const breakpoint = responsive.getCurrentBreakpoint();
    const isMobile = breakpoint === 'phone' || breakpoint === 'pocket';
    const limit = isMobile ? mobileLimit : desktopLimit;

    const items = wrapper.querySelectorAll('.lookbook-item');

    items.forEach((item, index) => {
      if (index < limit) {
        item.style.display = '';
      } else {
        item.style.display = 'none';
      }
    });
  }

  handleEscClick(event) {
    if (event.key === 'Escape' || event.key === 'Esc') {
      this.closeAllFloatCards();
    }
  }

  handleOpenOptions(event) {
    event.stopPropagation();
    event.preventDefault();

    const toggleButton = event.target.closest('[data-action="toggle-float-card"]');
    if (toggleButton) {
      this.toggleFloatCard(toggleButton);
      return;
    }
  }

  toggleFloatCard(button) {
    const floatElementId = button.getAttribute('aria-controls');
    if (!floatElementId) return;

    const floatElement = document.getElementById(floatElementId);
    if (!floatElement) return;

    const isExpanded = button.getAttribute('aria-expanded') === 'true';

    if (isExpanded) {
      this.closeFloatCard(floatElement, button);
    } else {
      this.closeAllFloatCards();
      this.openFloatCard(floatElement, button);
    }
  }

  openFloatCard(floatElement, button) {
    floatElement.style.display = '';
    floatElement.setAttribute('aria-hidden', 'false');
    floatElement.removeAttribute('inert');

    if (button) {
      button.setAttribute('aria-expanded', 'true');
    }

    // Store reference to button on the float element
    floatElement._triggerButton = button;

    requestAnimationFrame(() => {
      floatElement.setAttribute('aria-expanded', 'true');
      if (typeof this.onFloatCardOpen === 'function') {
        this.onFloatCardOpen(floatElement);
      }
    });

    const handleOutsideClick = (e) => {
      if (!floatElement.contains(e.target) && !button.contains(e.target)) {
        this.closeFloatCard(floatElement, button);
        document.removeEventListener('click', handleOutsideClick);
      }
    };

    floatElement._outsideClickHandler = handleOutsideClick;
    document.addEventListener('click', handleOutsideClick);

    this.activeFloatCards.push(floatElement);
  }

  closeFloatCard(floatCardElement, button) {
    if (button) {
      button.setAttribute('aria-expanded', 'false');
    }

    const index = this.activeFloatCards.indexOf(floatCardElement);
    if (index !== -1) {
      this._closeFloatCard(floatCardElement);
      this.activeFloatCards.splice(index, 1);
    }

    // Remove outside click listener
    if (floatCardElement._outsideClickHandler) {
      document.removeEventListener('click', floatCardElement._outsideClickHandler);
      delete floatCardElement._outsideClickHandler;
    }

    // Remove reference to button
    delete floatCardElement._triggerButton;
  }

  _closeFloatCard(floatCardElement) {
    floatCardElement.setAttribute('aria-expanded', 'false');


    // This function will be called once the CSS transition is complete.
    const onTransitionEnd = () => {
      floatCardElement.setAttribute('aria-hidden', 'true');
      floatCardElement.setAttribute('inert', '');

      floatCardElement.removeEventListener('transitionend', onTransitionEnd);

      if (typeof this.onFloatCardClose === 'function') {
        this.onFloatCardClose(floatCardElement);
      }
    };

    floatCardElement.addEventListener('transitionend', onTransitionEnd);
  }

  closeAllFloatCards() {
    const openCards = [...this.activeFloatCards];

    for (const floatCardElement of openCards) {
      const triggerButton = floatCardElement._triggerButton;
      this.closeFloatCard(floatCardElement, triggerButton);
    }

    this.activeFloatCards = [];
  }
}

customElements.define("lookbook-section", LookbookSection)

class QuoteContainer extends HTMLElement {
  constructor() {
    super();
    this.element = this;
  }

  connectedCallback() {
    this.delegateElement = new Delegate(this.element);
    this.swiperElement = this.querySelector('swiper-init');
    this.swiperInstance = this.swiperElement?.getSwiper();
    this.totalSlides = parseInt(this.swiperElement?.dataset.totalSlides || '1');
    this.statusElement = this.querySelector('[id^="slider-status-"]');

    this.swiperElement.addEventListener('swiper:initialized', (e) => {
      this.swiperInstance = e.detail;
      this.updateNavigationState();
    });

    this.swiperElement.addEventListener('swiper:slide-changed', (e) => {
      if (this.swiperInstance) {
        const currentSlide = this.swiperInstance.realIndex + 1;
        this.updateScreenReaderStatus(currentSlide);
        this.updateNavigationState();
      }
    });
  }

  updateNavigationState() {
    const prevButton = this.querySelector('[data-swiper-button="prev"]');
    const nextButton = this.querySelector('[data-swiper-button="next"]');

    if (!prevButton || !nextButton || !this.swiperInstance) return;

    if (this.totalSlides <= 1) {
      prevButton.setAttribute('aria-disabled', 'true');
      nextButton.setAttribute('aria-disabled', 'true');
    } else if (this.swiperInstance.params?.loop) {
      prevButton.setAttribute('aria-disabled', 'false');
      nextButton.setAttribute('aria-disabled', 'false');
    } else {
      prevButton.setAttribute('aria-disabled', this.swiperInstance.isBeginning ? 'true' : 'false');
      nextButton.setAttribute('aria-disabled', this.swiperInstance.isEnd ? 'true' : 'false');
    }
  }

  updateScreenReaderStatus(currentSlide) {
    if (!this.statusElement) return;

    this.statusElement.textContent = '';

    setTimeout(() => {
      this.statusElement.textContent = `Quote ${currentSlide} of ${this.totalSlides}`;
    }, 100);
  }
}

customElements.define('quote-container', QuoteContainer);

class Socialproof extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);

    if (this.element.dataset.stretchLastRow) {
      this.addEnlargeClassesToLastChildren();

      responsive.addResizeListener(
        this,
        this.addEnlargeClassesToLastChildren.bind(this)
      );
    }
  }

  connectedCallback() {
    const videoLinks = this.element.querySelectorAll('a.linked-element');

    videoLinks.forEach((link) => {
      let buttonClickInProgress = false;

      link.addEventListener(
        'click',
        (event) => {
          if (event.target.closest('.section-video__controls button')) {
            buttonClickInProgress = true;
            setTimeout(() => {
              buttonClickInProgress = false;
            }, 50);
          }
        },
        true
      );

      link.addEventListener(
        'click',
        (event) => {
          if (
            buttonClickInProgress ||
            event.target.closest('.section-video__controls button')
          ) {
            event.preventDefault();
            event.stopPropagation();
          }
        },
        false
      );
    });

    const videoComponents = this.element.querySelectorAll('video-component');

    videoComponents.forEach((videoComp) => {
      videoComp.addEventListener('touchstart', (event) => {
        if (event.target.closest('.section-video__controls button')) return;
        const parentLink = videoComp.closest('a.linked-element');
        if (parentLink && parentLink.href) {
          window.location.href = parentLink.href;
        }
      });
    });
  }

  addEnlargeClassesToLastChildren() {
    if (responsive.currentBreakpoint != 'desktop') return;

    const masonryWrappers = this.querySelectorAll('.masonry-grid__wrapper');

    masonryWrappers.forEach((wrapper) => {
      wrapper.classList.add('masonry-grid__wrapper--min-height');
      const lastChild = wrapper.lastElementChild;
      if (lastChild) {
        lastChild.classList.remove('masonry-image--enlarge');
      }
    });

    let tallestHeight = 0;
    let tallestWrapper = null;

    masonryWrappers.forEach((wrapper) => {
      const height = wrapper.offsetHeight;
      if (height > tallestHeight) {
        tallestHeight = height;
        tallestWrapper = wrapper;
      }
    });

    masonryWrappers.forEach((wrapper) => {
      if (wrapper !== tallestWrapper) {
        wrapper.classList.remove('masonry-grid__wrapper--min-height');

        const lastChild = wrapper.lastElementChild;
        if (lastChild) {
          lastChild.classList.add('masonry-image--enlarge');
        }
      }
    });
  }
}
customElements.define('socialproof-section', Socialproof);

class DropdownUsps extends HTMLElement {

  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
  }

  connectedCallback() {
    this.responsive = new Responsive();
    this.breakpoint = this.responsive.getCurrentBreakpoint();

    if (this.breakpoint == 'pocket' || this.breakpoint == 'phone') {
      this.dropdownContent = this.element.querySelector(".custom__dropdown-inner-content .metafield-rich_text_field");
      this.showMoreBtn = this.element.querySelector(".dropdown-usps__show-more-btn");
      this.showLessBtn = this.element.querySelector(".dropdown-usps__show-less-btn");
      this.maxDropdownHeight = 80;
      this.originalHeight = null;

      this.bindEvents();
      this.InitializeDropdown();
    }
  }

  bindEvents() {
    // Show More button
    this.delegateElement.on('click', '[data-action="show-more"]', (e) => {
      e.preventDefault();
      this.showMore();
    });

    // Show Less button
    this.delegateElement.on('click', '[data-action="show-less"]', (e) => {
      e.preventDefault();
      this.showLess();
    });
  }

  InitializeDropdown() {
    if (!this.dropdownContent) return;

    // Get the natural height of the content
    this.dropdownContent.style.height = 'auto';
    this.originalHeight = this.dropdownContent.scrollHeight;

    // Check if content exceeds max height
    if (this.originalHeight > this.maxDropdownHeight) {
      // Content is too tall - show collapsed state with Show More button
      this.dropdownContent.style.height = `${this.maxDropdownHeight}px`;
      this.dropdownContent.style.overflow = 'hidden';

      if (this.showMoreBtn) {
        this.showMoreBtn.style.display = 'block';
      }
      if (this.showLessBtn) {
        this.showLessBtn.style.display = 'none';
      }
    } else {
      // Content fits within max height - no buttons needed
      this.dropdownContent.style.height = 'auto';
      this.dropdownContent.style.overflow = 'visible';

      if (this.showMoreBtn) {
        this.showMoreBtn.style.display = 'none';
      }
      if (this.showLessBtn) {
        this.showLessBtn.style.display = 'none';
      }
    }
  }

  showMore() {
    if (!this.dropdownContent) return;

    // Expand to full height
    this.dropdownContent.style.height = `${this.originalHeight}px`;
    this.dropdownContent.style.transition = 'height 0.3s ease';

    // Toggle button visibility
    if (this.showMoreBtn) {
      this.showMoreBtn.style.display = 'none';
    }
    if (this.showLessBtn) {
      this.showLessBtn.style.display = 'block';
    }
  }

  showLess() {
    if (!this.dropdownContent) return;

    // Collapse to max height
    this.dropdownContent.style.height = `${this.maxDropdownHeight}px`;
    this.dropdownContent.style.transition = 'height 0.3s ease';

    // Toggle button visibility
    if (this.showMoreBtn) {
      this.showMoreBtn.style.display = 'block';
    }
    if (this.showLessBtn) {
      this.showLessBtn.style.display = 'none';
    }
  }
}

customElements.define('dropdown-usps', DropdownUsps);

class BigTextSlider extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.announcementBar = document.querySelector(".text-slider");


    this.transitionSpeed = parseInt(this.getAttribute('data-settings'), 10) || 15;

    this.firstLoad = true;

  }

  connectedCallback() {
    this.animWrapper = this.querySelector('.text-slider__anim-wrapper');
    this.original = this.querySelector('.text-slider__duplicate-wrapper');

    if (!this.animWrapper || !this.original) {
      requestAnimationFrame(() => this.connectedCallback());
      return;
    }


    let children = Array.from(this.original.children);
    let index = 0;
    while (children.length < 4 && children.length > 0) {
      this.original.appendChild(children[index].cloneNode(true));
      children = Array.from(this.original.children);
      index++;
    }


    const start = () => this.bindEvents();
    if (document.readyState === 'complete') {
      const imgs = Array.from(this.querySelectorAll('img')).filter(img => !img.complete);
      if (imgs.length) {
        let remaining = imgs.length;
        imgs.forEach(img => img.addEventListener('load', () => {
          if (--remaining === 0) start();
        }, { once: true }));
        setTimeout(start, 200);
      } else {
        start();
      }
    } else {
      window.addEventListener('load', start, { once: true });
    }
  }

  bindEvents() {
    this.handleBreakpointChange();

    this.element.addEventListener("mouseenter", this.pauseAnimation.bind(this));
    this.element.addEventListener("mouseleave", this.resumeAnimation.bind(this));

    // re-evaluate on resize (layout can change widths)
    this._onResize = () => this.handleBreakpointChange();
    window.addEventListener('resize', this._onResize, { passive: true });
  }

  disconnectedCallback() {
    this.animation?.cancel?.();
    if (this._onResize) window.removeEventListener('resize', this._onResize);
    try { this.intersectionObserver?.disconnect?.(); } catch { /* noop */ }
  }

  pauseAnimation() { if (this.animation) this.animation.pause(); }
  resumeAnimation() { if (this.animation) this.animation.play(); }

  handleBreakpointChange() {
    // Keep your breakpoint behavior; we just always rebuild the track
    if (responsive?.matchesBreakpoint?.("lap_and_up")) {
      this.mobile = false;
    } else {
      this.mobile = true;
    }
    this.duplicateBlockWrappers();
  }

  resetWrapper() {
    // remove everything AFTER the first child (which is the original row)
    for (let i = this.animWrapper.children.length - 1; i >= 1; i--) {
      this.animWrapper.removeChild(this.animWrapper.children[i]);
    }
  }

  duplicateBlockWrappers() {
    // 1) Clean up whatever we appended last time
    for (let i = this.animWrapper.children.length - 1; i >= 1; i--) {
      this.animWrapper.removeChild(this.animWrapper.children[i]);
    }
    if (!this.original) return;

    // 2) Fixed gap: 2rem everywhere (between slides & at the seam)
    // Try to read from CSS variable --slider-gap, fallback to 32px if missing
    let GAP_PX = parseFloat(
      getComputedStyle(this.element).getPropertyValue('--slider-gap')
    ) || 32;


    // Normalize the original row to pure content width
    const row = this.original;
    row.style.justifyContent = 'flex-start';
    row.style.flexWrap = 'nowrap';
    row.style.gap = `${GAP_PX}px`;
    row.style.width = 'auto';

    // 3) Ensure the row is at least as wide as the viewport to avoid blank space
    //    If not, keep duplicating its children inside itself until it is.
    const viewportW = this.element.clientWidth || window.innerWidth;
    // Cache one copy of current children so we can append them as a chunk
    const baseChildren = Array.from(row.children).map(n => n.cloneNode(true));

    // Force a measurement, then expand if needed
    let contentW = row.scrollWidth;
    // Give ourselves headroom so the seam never shows as blank
    const targetW = viewportW + GAP_PX;

    while (contentW < targetW && baseChildren.length) {
      const frag = document.createDocumentFragment();
      baseChildren.forEach(n => frag.appendChild(n.cloneNode(true)));
      row.appendChild(frag);
      // re-measure after appending
      contentW = row.scrollWidth;
    }

    // 4) Measure final content width and build the second copy + seam spacer
    void row.offsetWidth;
    const originalWidth = row.scrollWidth;

    const duplicate = row.cloneNode(true);
    duplicate.style.justifyContent = 'flex-start';
    duplicate.style.flexWrap = 'nowrap';
    duplicate.style.gap = `${GAP_PX}px`;
    duplicate.style.width = `${originalWidth}px`;

    const seamSpacer = document.createElement('div');
    seamSpacer.style.flexShrink = '0';
    seamSpacer.style.width = `${GAP_PX}px`;

    // Lock original width so it won't stretch
    row.style.width = `${originalWidth}px`;

    // 5) Assemble track: [original][seam][duplicate]
    this.animWrapper.style.position = 'absolute';
    this.animWrapper.appendChild(seamSpacer);
    this.animWrapper.appendChild(duplicate);

    // Total scrolling width
    const trackWidth = originalWidth * 2 + GAP_PX;
    this.animWrapper.style.width = `${trackWidth}px`;

    // Keep container height tight
    this.element.style.height = this.animWrapper.offsetHeight + 'px';

    // Distances for animation
    this.spaceDivWidth = GAP_PX;                // seam size
    this.slideDistance = originalWidth + GAP_PX; // distance for one seamless loop

    // 6) Animate
    this.startAnimating();
  }


  startAnimating() {
    // cancel old animation to avoid stacking
    this.animation?.cancel?.();

    // ensure clean starting transform
    this.animWrapper.style.transform = 'translateX(0px)';

    const distance = this.slideDistance || 0;
    if (!distance) return;

    this.animation = this.animWrapper.animate(
      [
        { transform: 'translateX(0px)' },
        { transform: `translateX(${-distance}px)` }
      ],
      {
        duration: (parseInt(this.transitionSpeed, 10) || 15) * 1000,
        iterations: Infinity,
        easing: 'linear',
        fill: 'forwards'
      }
    );
  }
}
customElements.define("text-slider", BigTextSlider);

class USPSectionDefault extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.bindEvents();
  }

  connectedCallback() {
    this.markEmptyDropdowns(); // NEW: disable empty dropdowns on mount
  }


  bindEvents() {
    this.delegateElement.on(
      "click",
      "[data-action='toggle-usp-dropdown']",
      this.handleDropdownToggle.bind(this)
    );

    this.delegateElement.on(
      "click",
      ".usp-dropdown",
      this.handleSlideSync.bind(this)
    );
    this.delegateElement.on(
      "click",
      "[data-action='toggle-state']",
      (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.handleToggleState(event);
      }
    );

    this.delegateElement.on(
      "click",
      "[data-action='toggle-sound']",
      (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.handleToggleSound(event);
      }
    );

  }

  handleDropdownToggle(event) {
    const button = event.target.closest("[data-action='toggle-usp-dropdown']");
    if (!button) return;

    const clickedDropdown = button.closest(".usp-dropdown");
    if (!this.hasRenderableContent(clickedDropdown)) return;
    const clickedWrapper = clickedDropdown.querySelector(".usp-dropdown-wrapper");
    const clickedContent = clickedDropdown.querySelector(".usp-dropdown-content");
    if (!clickedContent || !clickedWrapper) return;

    const isOpen = clickedContent.getAttribute("aria-hidden") === "false";

    // Close all dropdowns
    this.element.querySelectorAll(".usp-dropdown").forEach((dropdown) => {
      const wrapper = dropdown.querySelector(".usp-dropdown-wrapper");
      const content = dropdown.querySelector(".usp-dropdown-content");
      const toggleBtn = dropdown.querySelector("[data-action='toggle-usp-dropdown']");

      if (content && wrapper && toggleBtn) {
        content.setAttribute("aria-hidden", "true");
        toggleBtn.setAttribute("aria-expanded", "false");
        content.classList.remove("open");
        wrapper.classList.remove("open");
      }
    });

    // Open clicked dropdown if it was closed
    if (!isOpen) {
      clickedContent.setAttribute("aria-hidden", "false");
      button.setAttribute("aria-expanded", "true");

      requestAnimationFrame(() => {
        clickedContent.classList.add("open");
        clickedWrapper.classList.add("open");
      });
    }
  }

  handleSlideSync(event) {
    const dropdown = event.target.closest(".usp-dropdown");
    if (!dropdown) return;

    // Find ID from wrapper or <summary>
    let targetId = dropdown.id?.trim();
    if (!targetId) {
      const summary = dropdown.querySelector("summary");
      if (summary?.id) targetId = summary.id.trim();
    }
    if (!targetId) return;

    const swiperInitEl = this.element.querySelector("swiper-init");
    if (!swiperInitEl) {
      console.warn("No <swiper-init> element found.");
      return;
    }

    const slides = Array.from(swiperInitEl.querySelectorAll(".swiper-slide"));
    const targetIndex = slides.findIndex((slide) => slide.id?.trim() === targetId);
    if (targetIndex === -1) {
      console.warn(`No slide found for ID "${targetId}"`);
      return;
    }

    // Handle slide change based on swiper implementation
    if (typeof swiperInitEl.selectSlide === "function") {
      swiperInitEl.selectSlide(targetIndex);
    } else if (swiperInitEl.swiper && typeof swiperInitEl.swiper.selectCell === "function") {
      swiperInitEl.swiper.selectCell(targetIndex);
    } else {
      console.warn("No valid method found to change slides.");
    }
  }

  // NEW
  hasRenderableContent(dropdown) {
    const inner = dropdown.querySelector(".usp-dropdown-inner");
    if (!inner) return false;
    const hasElements = inner.children && inner.children.length > 0;
    const hasText = (inner.textContent || "").replace(/\s+/g, "").length > 0;
    return hasElements || hasText;
  }

  // NEW
  markEmptyDropdowns() {
    this.element.querySelectorAll(".usp-dropdown").forEach((dropdown) => {
      const button = dropdown.querySelector("[data-action='toggle-usp-dropdown']");
      if (!button) return;

      const isEmpty = !this.hasRenderableContent(dropdown);

      if (isEmpty) {
        dropdown.classList.add("is-empty");
        button.setAttribute("aria-disabled", "true");
        button.setAttribute("tabindex", "-1");
        button.disabled = true;
      } else {
        dropdown.classList.remove("is-empty");
        button.removeAttribute("aria-disabled");
        button.removeAttribute("tabindex");
        button.disabled = false;
      }
    });
  }

}

customElements.define("usp-section-default", USPSectionDefault);

class JwtTokenCache {
  static setCookie(cookieName, token, expiresInSeconds = 3600, customerId = null) {
    const date = new Date();
    date.setTime(date.getTime() + (expiresInSeconds * 1000));
    const expires = `expires=${date.toUTCString()}`;
    const tokenData = customerId ? JSON.stringify({ token, customerId }) : token;
    document.cookie = `${cookieName}=${encodeURIComponent(tokenData)};${expires};path=/;SameSite=Strict`;
  }

  static getCookie(cookieName) {
    const name = cookieName + "=";
    const decodedCookie = decodeURIComponent(document.cookie);
    const cookieArray = decodedCookie.split(';');

    for (let i = 0; i < cookieArray.length; i++) {
      let cookie = cookieArray[i].trim();
      if (cookie.indexOf(name) === 0) {
        return cookie.substring(name.length, cookie.length);
      }
    }
    return null;
  }

  static removeCookie(cookieName) {
    document.cookie = `${cookieName}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;`;
  }

  static isTokenExpired(token, bufferSeconds = 60) {
    if (!token) return true;

    try {
      const parts = token.split('.');
      if (parts.length !== 3) return true;

      const payload = JSON.parse(atob(parts[1]));

      if (!payload.exp) return true;

      const now = Math.floor(Date.now() / 1000);

      return (payload.exp - now) < bufferSeconds;
    } catch (error) {
      console.error('Error checking token expiration:', error);
      return true;
    }
  }

  static getValidToken(cookieName, bufferSeconds = 60, currentCustomerId = null) {
    const cookieValue = this.getCookie(cookieName);
    if (!cookieValue) return null;

    try {
      let token;
      let storedCustomerId = null;

      try {
        const tokenData = JSON.parse(cookieValue);
        if (tokenData.token && tokenData.customerId) {
          token = tokenData.token;
          storedCustomerId = tokenData.customerId;
        } else {
          token = cookieValue;
        }
      } catch {
        token = cookieValue;
      }

      if (currentCustomerId && storedCustomerId) {
        if (currentCustomerId.toString() !== storedCustomerId.toString()) {
          console.warn('[JwtTokenCache] Customer ID mismatch - clearing stale token', {
            cookieName,
            currentCustomerId,
            storedCustomerId
          });
          this.removeCookie(cookieName);
          return null;
        }
      }

      if (token && !this.isTokenExpired(token, bufferSeconds)) {
        return token;
      }

      if (token) {
        this.removeCookie(cookieName);
      }

      return null;
    } catch (error) {
      console.error('[JwtTokenCache] Error validating token:', error);
      this.removeCookie(cookieName);
      return null;
    }
  }
}

window.JwtTokenCache = JwtTokenCache;

class ChatWidget extends HTMLElement {
  static CHAT_TOKEN_COOKIE = 'zendesk_jwt_token';
  static MAX_AUTH_RETRIES = 3;
  static AUTH_RETRY_DELAY = 1000;
  static IFRAME_POLL_INTERVAL = 100;
  static IFRAME_POLL_TIMEOUT = 10000;

  constructor() {
    super();
    this.zendeskScriptUrl = "https://static.zdassets.com/ekr/snippet.js?key=536879b9-ffa2-47d2-bcb1-004b960c2d1a";
    this.open = false;
    this.isIframeHovered = false;
    this.stylesAdded = false;

    this.chatIframe = null;
    this.outerObserver = null;
    this.innerObserver = null;
    this.vendorConversations = new Map();
    this.vendorTags = new Map();

    this.forceIframeFailure = false;

    window.escalationOpen = false;
    window.escalationMatches = [];
  }

  connectedCallback() {
    this.delegateElement = new Delegate(this);
    this.delegateBody = new Delegate(document.body);
    this.escalationTriggers = document.querySelectorAll('.escalation-support');
    this.button = this.querySelector('[data-action="toggle-customer-support"]');
    this.mobileButton = document.getElementById('chat-close-btn');
    this.userLoggedIn = this.getAttribute('user-authenticated') === 'true';
    this.escalateSupport = this.getAttribute('escalate-support') === 'true';
    this.bottomBar = this.closest('.header__bottom-bar');
    this.unreadBadge = this.querySelector('.chat__unseen-badge');
    this.unreadCountEl = this.querySelector('.chat__unseen-count');

    this.processVendorConversations();

    window.addEventListener('load', () =>
      window.loadScript(this.zendeskScriptUrl, this.init.bind(this), "ze-snippet")
    );
  }

  async init() {
    if (!window.zE || typeof window.zE !== 'function') return;
    window.zE('messenger', 'close');

    this.bindEvents();
    window.zE("messenger:set", "locale", window.Shopify.locale);
    window.zE("messenger:set", "zIndex", 10);
    await this.syncZendeskAuth();

    this.setAttribute('aria-hidden', false);
    this.bottomBar.setAttribute('aria-hidden', false);
  }

  bindEvents() {
    this.onToggleClick = () => this.toggleTo(!this.open);
    this.delegateBody.on('click', '[data-action="toggle-customer-support"]', this.onToggleClick);

    window.zE("messenger:on", "open", () => this.syncToggleState(true));
    window.zE("messenger:on", "close", () => this.syncToggleState(false));
    window.zE("messenger:on", "unreadMessages", (count) => this.updateUnread(count));

    this.onOutsideClick = (evt) => { if (!this.contains(evt.target)) this.toggleTo(false); };

    this.onScrollMaybeClose = () => { if (this.open && !this.isIframeHovered) this.toggleTo(false); };

    this.onHoverIn = () => { this.isIframeHovered = true; };
    this.onHoverOut = () => { this.isIframeHovered = false; };
  }

  toggleTo(shouldOpen) {
    if (shouldOpen === this.open || window.escalationOpen) return;

    if (shouldOpen) {
      if (!this.chatIframe) this.detectIframeInsertion();
      window.zE('messenger', 'open');
    } else {
      window.zE('messenger', 'close');
    }
  }

  updateUnread(count) {
    const capped = count > 99 ? '99+' : String(count);
    this.unreadCountEl.textContent = capped;
    this.unreadBadge.setAttribute('aria-hidden', count > 0 ? 'false' : 'true');
  };

  syncToggleState(isOpen) {
    this.open = isOpen;
    this.button?.setAttribute('aria-expanded', String(isOpen));

    if (isOpen) {
      if (this.chatIframe) this.mobileButton.setAttribute('aria-hidden', 'false');
      if (this.escalateSupport) {
        this.attachInnerObserver();
        this.checkEscalationMatches();
      }
    } else {
      this.escalationTriggers.forEach(trigger => trigger.setAttribute('aria-expanded', 'false'));
      this.mobileButton.setAttribute('aria-hidden', 'true');
      if (this.escalateSupport) {
        this.innerObserver?.disconnect();
        this.innerObserver = null;
        this.isIframeHovered = false;
      }
    }

    document.body.classList.remove('scrollLock');
    if (responsive.matchesBreakpoint('lap_and_up')) {
      if (isOpen) {
        this.delegateBody.on('click', this.onOutsideClick);
        window.addEventListener('scroll', this.onScrollMaybeClose, { passive: true });
        this.delegateBody.on('mouseover', 'iframe[data-chat-frame]', this.onHoverIn);
        this.delegateBody.on('mouseout', 'iframe[data-chat-frame]', this.onHoverOut);
      } else {
        this.delegateBody.off('click', this.onOutsideClick);
        window.removeEventListener('scroll', this.onScrollMaybeClose);
        this.delegateBody.off('mouseover', 'iframe[data-chat-frame]', this.onHoverIn);
        this.delegateBody.off('mouseout', 'iframe[data-chat-frame]', this.onHoverOut);
      }
    } else if (window.innerWidth <= 576) {
      if (isOpen) {
        document.body.classList.add('scrollLock');
      } else {
        document.body.classList.remove('scrollLock');
      }
    }
  }

  async syncZendeskAuth() {
    if (!this.userLoggedIn) return;
    const payload = JSON.parse(this.getAttribute('data-customer') || '{}');
    if (!Object.keys(payload).length) return;

    const currentCustomerId = payload.id || payload.customerId;

    window.zE('messenger', 'loginUser', async (callback) => {
      let retryCount = 0;

      const fetchTokenWithRetry = async () => {
        try {
          const cachedToken = JwtTokenCache.getValidToken(ChatWidget.CHAT_TOKEN_COOKIE, 60, currentCustomerId);

          if (cachedToken) {
            callback(cachedToken);
            return;
          }

          const res = await window.apiService.post(`${window.proxyPath}/conversation/jwt`, payload);
          const data = res?.data || res;
          if (!data?.token) throw new Error('No token in response');

          JwtTokenCache.setCookie(ChatWidget.CHAT_TOKEN_COOKIE, data.token, 3600, currentCustomerId);
          callback(data.token);
        } catch (e) {
          retryCount++;
          console.error(`Zendesk JWT request failed (attempt ${retryCount}/${ChatWidget.MAX_AUTH_RETRIES})`, e);

          if (retryCount < ChatWidget.MAX_AUTH_RETRIES) {
            await new Promise(resolve => setTimeout(resolve, ChatWidget.AUTH_RETRY_DELAY));
            await fetchTokenWithRetry();
          } else {
            console.error('Max retries reached. Logging out user.');
            JwtTokenCache.removeCookie(ChatWidget.CHAT_TOKEN_COOKIE);
            window.zE('messenger', 'logoutUser');
          }
        }
      };

      await fetchTokenWithRetry();
    }, (error) => {
      if (error) console.error('Zendesk login failed', error);
    });
  }

  detectIframeInsertion() {
    this.outerObserver = new MutationObserver((mutations) => {
      for (const m of mutations) {
        if (m.type !== 'childList') continue;

        let iframe = Array.from(m.addedNodes).find(n => n.tagName === 'IFRAME');

        if (!iframe) {
          for (const node of m.addedNodes) {
            if (node.nodeType === Node.ELEMENT_NODE) {
              iframe = node.querySelector('iframe');
              if (iframe) break;

              if (!iframe) {
                iframe = node.closest('iframe');
              }
            }
          }
        }

        if (!iframe) continue;
        this.mobileButton.setAttribute('aria-hidden', 'false');

        this.chatIframe = iframe;
        this.chatIframe.setAttribute('data-chat-frame', '');
        this.chatIframe.classList.add('chat-iframe');
        this.attachInnerObserver();

        this.outerObserver?.disconnect();
        this.outerObserver = null;
        return;
      }
    });

    this.outerObserver.observe(document.body, { childList: true, subtree: true });
  }

  attachInnerObserver() {
    if (!this.chatIframe) return;

    const doc = this.chatIframe.contentDocument || this.chatIframe.contentWindow?.document;
    if (!doc || !doc.body) return;

    const pollInterval = setInterval(() => {
      const doc = this.chatIframe.contentDocument || this.chatIframe.contentWindow?.document;
      if (!doc || !doc.body) return;
      const presentationElement = doc.body.querySelector('[role="presentation"]');
      if (presentationElement) {
        clearInterval(pollInterval);

        this.innerObserver?.disconnect();
        this.innerObserver = null;

        this.loaded = false;

        const addStylesOnce = () => {
          if (!this.loaded) {
            this.addStyleToIframe();
            this.loaded = true;
          }
        };

        this.innerObserver = new MutationObserver((mutations) => {
          const lastMutation = mutations[mutations.length - 1];
          if (lastMutation.type === 'childList' && lastMutation.addedNodes.length > 0) {
            addStylesOnce();
            this.checkEscalationMatches(doc);
          }
        });

        this.innerObserver.observe(doc.body, {
          childList: true,
          subtree: true
        });

        addStylesOnce();
      }
    }, ChatWidget.IFRAME_POLL_INTERVAL);

    setTimeout(() => {
      clearInterval(pollInterval);
    }, ChatWidget.IFRAME_POLL_TIMEOUT);
  }

  checkEscalationMatches(doc = null) {
    if (this.forceIframeFailure) {
      console.warn('[Escalation] 🧪 TESTING MODE: Simulating iframe detection failure (forceIframeFailure = true)');
      const shouldShowButton = this.vendorConversations.size > 0;
      this.escalationTriggers.forEach(trigger => trigger.setAttribute('aria-expanded', shouldShowButton ? 'true' : 'false'));
      if (shouldShowButton) {
        window.escalationMatches = [];
      }
      return;
    }

    const chatDoc = doc || (this.chatIframe && this.chatIframe.contentDocument);
    if (!chatDoc) return;

    const h2Element = chatDoc.body.querySelector('h2');

    if (h2Element && this.vendorConversations.size > 0) {
      const h2Text = h2Element.textContent.trim();
      let purchaseNumber = null;

      const withHashMatch = h2Text.match(/#(\d+)/);
      if (withHashMatch) {
        purchaseNumber = withHashMatch[1];
      } else {
        const digitsMatch = h2Text.match(/[^\d]*(\d+)\s*$/);
        if (digitsMatch) {
          purchaseNumber = digitsMatch[1];
        }
      }

      const matches = [];

      if (purchaseNumber) {
        for (const [conversationId, tagPurchaseNumber] of this.vendorConversations) {
          if (tagPurchaseNumber === purchaseNumber) {
            const fullTag = this.vendorTags.get(conversationId);
            const [, , productHandle] = fullTag ? fullTag.split('|') : [null, null, null];
            matches.push({ conversationId, purchaseNumber, productHandle });
          }
        }
      }

      window.escalationMatches = matches.length > 0 ? matches : [];
      const shouldShowButton = matches.length > 0;
      this.escalationTriggers.forEach(trigger => trigger.setAttribute('aria-expanded', shouldShowButton ? 'true' : 'false'));
    } else {
      const shouldShowButton = this.vendorConversations.size > 0;
      this.escalationTriggers.forEach(trigger => trigger.setAttribute('aria-expanded', shouldShowButton ? 'true' : 'false'));
      if (this.vendorConversations.size > 0) {
        window.escalationMatches = [];
      }
    }
  }

  processVendorConversations() {
    const vendorData = this.getAttribute('data-vendor-conversations');
    if (!vendorData) return;

    try {
      const conversations = JSON.parse(vendorData);

      conversations.forEach(convStr => {
        const [conversationId, purchaseNumberWithHash, productHandle] = convStr.split('|');
        let purchaseNumber = null;

        if (purchaseNumberWithHash) {
          const withHashMatch = purchaseNumberWithHash.match(/#(\d+)/);
          if (withHashMatch) {
            purchaseNumber = withHashMatch[1];
          } else if (/^\d+$/.test(purchaseNumberWithHash)) {
            purchaseNumber = purchaseNumberWithHash;
          }
        }

        if (conversationId && purchaseNumber) {
          this.vendorConversations.set(conversationId, purchaseNumber);
          this.vendorTags.set(conversationId, convStr);
        } else {
          console.warn('[ChatWidget] ❌ Invalid conversation tag format:', {
            convStr,
            conversationId,
            purchaseNumber,
            reason: !conversationId ? 'missing conversationId' : 'missing purchaseNumber'
          });
        }
      });
    } catch (e) {
      console.error('[ChatWidget] Error processing vendor conversations:', e);
    }
  }

  addStyleToIframe() {
    if (!this.chatIframe) return;

    const doc = this.chatIframe.contentDocument || this.chatIframe.contentWindow?.document;
    const style = document.createElement('style');
    style.textContent = `
      ul li button p:not([role="timer"]) {
        color: black !important;
      }
    `;

    doc.head.appendChild(style);
  }

  disconnectedCallback() {
    this.delegateElement?.destroy();
    this.delegateBody?.destroy();
    this.outerObserver?.disconnect();
    this.innerObserver?.disconnect();
  }
}
customElements.define('chat-widget', ChatWidget);

class EscalationPopup extends HTMLElement {
  static productDataCache = null;
  static productDataCacheTimestamp = null;
  static CACHE_DURATION = 5 * 60 * 1000;
  static LIQUID_HANDLE_LIMIT = 20;

  constructor() {
    super();
    this.cachedConversations = null;
    this.conversations = [];
    this.conversationMapping = {};
    this.forceBackendFetch = false;
  }

  connectedCallback() {
    this.delegateElement = new Delegate(this);
    this.cacheElements();
    this.initializeFormValidation();
    this.bindEvents();
  }

  cacheElements() {
    this.cancelButton = this.querySelector('.popup-footer [data-action="toggle-popup"]');
    this.backButton = this.querySelector('.popup-footer [data-action="back-escalation"]');
    this.nextButton = this.querySelector('.popup-footer [data-action="next-escalation"]');
    this.submitButton = this.querySelector('.popup-footer [data-action="submit-escalation"]');
    this.okButton = this.querySelector('.popup-footer [data-action="escalation-ok"]');
    this.closeButton = this.querySelector('.popup-footer [data-action="escalation-close"]');

    this.vendorSelection = this.querySelector('.escalation-popup__vendor-selection');
    this.reasonStep = this.querySelector('.escalation-popup__reason-step');
    this.successView = this.querySelector('.escalation-popup__success-view');
    this.errorView = this.querySelector('.escalation-popup__error-view');
    this.selectedConversationContainer = this.querySelector('.escalation-popup__selected-conversation');
    this.loadingSpinner = this.querySelector('.escalation-popup__loading');

    this.titleElement = this.querySelector('#escalation-popup-title');
    this.reasonTextarea = this.querySelector('#escalation-reason');
    this.submitLoader = this.submitButton.querySelector('.itemLoader');
  }

  bindEvents() {
    this.delegateElement.on('popup:open', async () => {
      this.resetPopupState();

      const escalationButtons = document.querySelectorAll('.escalation-support');
      escalationButtons.forEach(btn => btn.setAttribute('aria-expanded', 'true'));

      if (!window.escalationMatches || window.escalationMatches.length === 0) {
        const chatWidget = document.querySelector('chat-widget');
        if (chatWidget && chatWidget.vendorConversations && chatWidget.vendorConversations.size > 0) {
          const allMatches = Array.from(chatWidget.vendorConversations.entries()).map(([conversationId, purchaseNumber]) => {
            const fullTag = chatWidget.vendorTags.get(conversationId);
            const [, , productHandle] = fullTag ? fullTag.split('|') : [null, null, null];
            return { conversationId, purchaseNumber, productHandle };
          });

          await this.fetchConversationsForEscalation(allMatches);
        } else {
          console.warn('[Escalation] No vendor conversations available - showing empty selection');
          this.conversations = [];
          this.showVendorSelection();
        }
        return;
      }

      await this.fetchConversationsForEscalation(window.escalationMatches || []);
    });

    this.delegateElement.on('popup:closed', () => {
      const escalationButtons = document.querySelectorAll('.escalation-support');
      const hasMatches = window.escalationMatches && window.escalationMatches.length > 0;
      escalationButtons.forEach(btn => btn.setAttribute('aria-expanded', hasMatches ? 'true' : 'false'));
    });

    this.delegateElement.on('click', '[data-action="next-escalation"]', async () => {
      if (this.validateConversationSelection()) {
        this.showReasonForm();
        await this.populateSelectedConversationDisplay();
      }
    });

    this.delegateElement.on('click', '[data-action="back-escalation"]', () => {
      this.showVendorSelection();
    });

    this.delegateElement.on('click', '[data-action="select-conversation"]', (event) => {
      this.querySelectorAll('[data-action="select-conversation"]').forEach(opt => opt.setAttribute('aria-selected', 'false'));
      event.target.setAttribute('aria-selected', 'true');
      this.updateNextButtonState();
    });

    this.delegateElement.on('click', '[data-action="submit-escalation"]', async () => {
      await this.submitEscalation();
    });

    this.delegateElement.on('click', '[data-action="escalation-ok"]', () => {
      this.querySelector('[data-action="toggle-popup"]').click();
    });

    this.delegateElement.on('click', '[data-action="escalation-close"]', () => {
      this.querySelector('[data-action="toggle-popup"]').click();
    });
  }

  async fetchConversationsForEscalation(matches) {
    if (!matches || matches.length === 0) {
      this.conversations = [];
      this.showVendorSelection();
      return;
    }

    this.conversations = matches.map(match => ({
      id: match.conversationId,
      purchase_number: match.purchaseNumber,
      metadata: {
        purchaseNumber: match.purchaseNumber,
        productHandle: match.productHandle
      }
    }));

    this.conversations.length === 1 ? this.showReasonForm() : this.showVendorSelection();

    await this.loadProductInfo();

    if (this.conversations.length > 1) {
      await this.populateConversationContainers();
    } else if (this.conversations.length === 1) {
      await this.populateSelectedConversationDisplay();
    }
  }

  showView(viewType, options = {}) {
    this.hideAllViews();

    const configs = {
      vendor: {
        view: this.vendorSelection,
        buttons: [this.cancelButton, this.nextButton],
        callback: () => this.updateNextButtonState()
      },
      reason: {
        view: this.reasonStep,
        buttons: this.conversations.length <= 1
          ? [this.cancelButton, this.submitButton]
          : [this.backButton, this.submitButton]
      },
      success: {
        view: this.successView,
        buttons: [this.okButton],
        title: TranslationUtils.get('escalation.success_title', 'Escalation Successful')
      },
      error: {
        view: this.errorView,
        buttons: [this.closeButton],
        title: TranslationUtils.get('escalation.error_title', 'Escalation Failed')
      }
    };

    const config = configs[viewType];
    if (!config) return;

    config.view.setAttribute('aria-hidden', 'false');
    config.buttons.forEach(btn => btn.setAttribute('aria-hidden', 'false'));

    if (config.title) {
      this.titleElement.textContent = config.title;
    }

    if (config.callback) {
      config.callback();
    }
  }

  showVendorSelection() {
    this.showView('vendor');
  }

  showReasonForm() {
    this.showView('reason');
  }

  showSuccessView() {
    this.showView('success');
  }

  showErrorView() {
    this.showView('error');
  }

  hideAllViews() {
    this.vendorSelection.setAttribute('aria-hidden', 'true');
    this.reasonStep.setAttribute('aria-hidden', 'true');
    this.successView.setAttribute('aria-hidden', 'true');
    this.errorView.setAttribute('aria-hidden', 'true');
    this.hideLoadingSpinner();

    this.cancelButton.setAttribute('aria-hidden', 'true');
    this.backButton.setAttribute('aria-hidden', 'true');
    this.nextButton.setAttribute('aria-hidden', 'true');
    this.submitButton.setAttribute('aria-hidden', 'true');
    this.okButton.setAttribute('aria-hidden', 'true');
    this.closeButton.setAttribute('aria-hidden', 'true');
  }

  resetPopupState() {
    this.titleElement.textContent = TranslationUtils.get('escalation.title', 'Escalate Conversation');
    this.reasonTextarea.value = '';
    this.querySelectorAll('[data-action="select-conversation"]').forEach(opt => opt.setAttribute('aria-selected', 'false'));

    [this.nextButton, this.submitButton].forEach(btn => {
      btn.setAttribute('disabled', 'true');
      btn.classList.add('disabled');
      btn.setAttribute('aria-disabled', 'true');
    });

    this.querySelectorAll('.input-validation').forEach(c => {
      c.style.display = 'none';
      c.innerHTML = '';
    });
    this.querySelectorAll('.field--error').forEach(f => f.classList.remove('field--error'));

    this.hideAllViews();
  }

  initializeFormValidation() {
    const reasonForm = this.querySelector('.escalation-popup__reason-form');
    this.formValidator = new FormValidator(reasonForm, {
      fieldSelector: '.field',
      buttonSelector: '[data-action="submit-escalation"]',
      validateOnInput: true,
      validateOnBlur: false,
      showErrorsOnSubmitOnly: false,
      fieldErrorSelector: '.input-validation'
    });
  }

  validateConversationSelection() {
    const selectedOption = this.querySelector('[data-action="select-conversation"][aria-selected="true"]');
    if (!selectedOption) {
      ErrorUtils.error('conversation_required', 'Please select a conversation to escalate.', 'escalation');
      return false;
    }
    return true;
  }

  updateNextButtonState() {
    const hasSelection = !!this.querySelector('[data-action="select-conversation"][aria-selected="true"]');
    this.nextButton.toggleAttribute('disabled', !hasSelection);
    this.nextButton.classList.toggle('disabled', !hasSelection);
    this.nextButton.setAttribute('aria-disabled', String(!hasSelection));
  }

  formatConversationTime(dateString) {
    if (!dateString) return '';

    const now = new Date();
    const date = new Date(dateString);
    const diffMs = now - date;
    const diffHours = diffMs / (1000 * 60 * 60);
    const diffMinutes = diffMs / (1000 * 60);
    const diffYears = diffMs / (1000 * 60 * 60 * 24 * 365);

    const locale = window.Shopify?.locale || '';

    if (diffYears >= 1) return date.toLocaleDateString(locale, { month: 'short', day: 'numeric', year: 'numeric' });
    if (diffHours >= 16) return date.toLocaleDateString(locale, { month: 'short', day: 'numeric' });
    if (diffHours >= 1) {
      const hours = Math.floor(diffHours);
      return hours === 1 ? (window.timeStrings?.hour_ago || '1 hour ago') : `${hours} ${window.timeStrings?.hours_ago || 'hours ago'}`;
    }
    const minutes = Math.floor(diffMinutes);
    return minutes === 1 ? (window.timeStrings?.minute_ago || '1 minute ago') : `${minutes} ${window.timeStrings?.minutes_ago || 'minutes ago'}`;
  }

  async populateSelectedConversationDisplay() {
    const conversation = this.conversations.length === 1 ? this.conversations[0] : this.selectedConversation;

    if (!conversation) {
      this.selectedConversationContainer.style.display = 'none';
      return;
    }

    this.loadConversationMapping();

    const productData = this.getProductDataByConversationId(conversation.id);
    const purchaseNumber = conversation.purchase_number || conversation.metadata?.purchaseNumber || 'N/A';

    const titleElement = this.selectedConversationContainer.querySelector('.escalation-popup__product-title');
    titleElement.textContent = productData?.title || conversation.metadata?.productTitle || 'Unknown Product';

    const bookingNumberElement = this.selectedConversationContainer.querySelector('.escalation-popup__booking-number');
    bookingNumberElement.textContent = `#${purchaseNumber}`;

    const imageElement = this.selectedConversationContainer.querySelector('.escalation-popup__product-image');
    if (productData?.image) {
      imageElement.innerHTML = `<img src="${productData.image}" alt="${productData.title || 'Product'}" />`;
    } else {
      imageElement.innerHTML = '';
    }

    this.selectedConversationContainer.style.display = 'block';
  }

  async populateConversationContainers() {
    const vendorList = this.querySelector('.escalation-popup__vendor-list');
    const template = this.querySelector('.escalation-popup__vendor-option');

    vendorList.querySelectorAll('.escalation-popup__vendor-option:not(:first-child)').forEach(opt => opt.remove());

    this.loadConversationMapping();

    this.conversations.forEach((conversation, index) => {
      const productData = this.getProductDataByConversationId(conversation.id);
      const purchaseNumber = conversation.purchase_number || conversation.metadata?.purchaseNumber || 'N/A';
      const clone = template.cloneNode(true);

      const titleElement = clone.querySelector('.escalation-popup__product-title');
      titleElement.textContent = productData?.title || conversation.metadata?.productTitle || 'Unknown Product';

      const bookingNumberElement = clone.querySelector('.escalation-popup__booking-number');
      bookingNumberElement.textContent = `#${purchaseNumber}`;

      const imageElement = clone.querySelector('.escalation-popup__product-image');
      if (productData?.image) {
        imageElement.innerHTML = `<img src="${productData.image}" alt="${productData.title || 'Product'}" />`;
      } else {
        imageElement.innerHTML = '<div class="default-product-icon">📦</div>';
      }

      clone.addEventListener('click', () => this.selectConversation(conversation, index));
      clone.dataset.conversationId = conversation.id;
      clone.dataset.purchaseNumber = purchaseNumber;
      clone.style.display = 'flex';

      if (index === 0) template.style.display = 'none';
      vendorList.appendChild(clone);
    });
  }

  selectConversation(conversation, index) {
    this.querySelectorAll('.escalation-popup__vendor-option').forEach(opt => opt.classList.remove('selected'));
    const selectedOption = this.querySelectorAll('.escalation-popup__vendor-option')[index + 1];
    selectedOption.classList.add('selected');
    this.selectedConversation = conversation;
  }

  showLoadingSpinner() {
    this.loadingSpinner?.classList.add('is-visible');
  }

  hideLoadingSpinner() {
    this.loadingSpinner?.classList.remove('is-visible');
  }

  async loadProductInfo() {
    const uniqueHandles = [...new Set(
      this.conversations
        .map(conv => conv.metadata?.productHandle)
        .filter(Boolean)
    )];

    const handleCount = uniqueHandles.length;
    const shouldUseLiquid = handleCount <= EscalationPopup.LIQUID_HANDLE_LIMIT;

    const willFetchFromBackend = this.forceBackendFetch || !shouldUseLiquid || !this.querySelector('#escalation-product-data')?.textContent;
    if (willFetchFromBackend) {
      this.showLoadingSpinner();
    }

    try {
      if (!this.forceBackendFetch) {
        const cacheAge = EscalationPopup.productDataCacheTimestamp
          ? Date.now() - EscalationPopup.productDataCacheTimestamp
          : Infinity;

        if (EscalationPopup.productDataCache && cacheAge < EscalationPopup.CACHE_DURATION) {
          this.hideLoadingSpinner();
          return true;
        }
      }

      if (this.forceBackendFetch) {
        const result = await this.fetchProductInfoFromBackend();
        this.hideLoadingSpinner();
        return result;
      }

      if (!shouldUseLiquid) {
        const result = await this.fetchProductInfoFromBackend();
        this.hideLoadingSpinner();
        return result;
      }

      const scriptTag = this.querySelector('#escalation-product-data');

      if (scriptTag?.textContent) {
        const scriptContent = scriptTag.textContent.trim();
        EscalationPopup.productDataCache = JSON.parse(scriptContent);
        EscalationPopup.productDataCacheTimestamp = Date.now();
        this.hideLoadingSpinner();
        return true;
      }

      const result = await this.fetchProductInfoFromBackend();
      this.hideLoadingSpinner();
      return result;

    } catch (error) {
      console.error('[Escalation] ❌ Failed to load product data:', error);
      this.hideLoadingSpinner();
    }

    EscalationPopup.productDataCache = {};
    this.hideLoadingSpinner();
    return false;
  }

  async fetchProductInfoFromBackend() {
    try {
      const productHandles = [...new Set(
        this.conversations
          .map(conv => conv.metadata?.productHandle)
          .filter(Boolean)
      )];

      if (productHandles.length === 0) {
        return false;
      }

      const response = await window.apiService.post(`${window.proxyPath}/product/info`, {
        handles: productHandles
      });

      if (response.success && response.data) {
        EscalationPopup.productDataCache = response.data;
        EscalationPopup.productDataCacheTimestamp = Date.now();
        return true;
      }

      console.warn('[Escalation] Failed to fetch product data from backend');
      return false;

    } catch (error) {
      console.error('[Escalation] Error fetching product data from backend:', error);
      return false;
    }
  }

  loadConversationMapping() {
    try {
      const scriptTag = this.querySelector('#escalation-convo-mapping');
      if (scriptTag?.textContent) {
        this.conversationMapping = JSON.parse(scriptTag.textContent.trim());
        return true;
      }
    } catch (error) {
      console.error('[escalation] Failed to load conversation mapping:', error);
    }
    this.conversationMapping = {};
    return false;
  }

  getProductDataByConversationId(conversationId) {
    const productHandle = this.conversationMapping[conversationId];
    return productHandle && EscalationPopup.productDataCache?.[productHandle]
      ? EscalationPopup.productDataCache[productHandle]
      : null;
  }

  async submitEscalation() {
    try {
      this.submitLoader.classList.add('is-visible');

      let conversationId;
      const selectedOption = this.querySelector('[data-action="select-conversation"][aria-selected="true"]');

      if (selectedOption) {
        conversationId = selectedOption.dataset.conversationId;
      } else if (this.conversations.length === 1) {
        conversationId = this.conversations[0].id;
      } else {
        console.error('[escalation] No conversation selected');
        this.submitLoader.classList.remove('is-visible');
        return;
      }

      const message = this.reasonTextarea.value.trim();
      const subjectInput = this.querySelector('input[name="escalation-subject"]');
      const subject = subjectInput?.value.trim() || 'Escalation Request';

      const chatWidget = document.querySelector('chat-widget');
      const customerTag = chatWidget?.vendorTags?.get(conversationId);

      await window.apiService.post(`${window.proxyPath}/ticket/escalate/${conversationId}`, {
        subject,
        message,
        escalationMessage: TranslationUtils.get('escalation.notification_message', 'This conversation has been escalated to our customer support team. A dedicated support agent will reach out to you shortly to assist with your inquiry.'),
        escalationLabel: TranslationUtils.get('escalation.escalation_label', 'Escalation'),
        customerTag
      });

      this.conversations = this.conversations.filter(conv => conv.id !== conversationId);

      if (this.cachedConversations?.data) {
        this.cachedConversations.data = this.cachedConversations.data.filter(conv => conv.id !== conversationId);
      }

      chatWidget?.vendorConversations.delete(conversationId);
      chatWidget?.vendorTags.delete(conversationId);

      if (chatWidget?.vendorConversations.size === 0) {
        chatWidget.escalationTriggers.forEach(trigger => trigger.setAttribute('aria-hidden', 'true'));
      }

      this.submitLoader.classList.remove('is-visible');
      this.showSuccessView();
    } catch (error) {
      console.error('[escalation] Failed to submit escalation:', error);
      this.submitLoader.classList.remove('is-visible');
      this.showErrorView();
    }
  }

  disconnectedCallback() {
    this.delegateElement?.destroy();
  }
}

customElements.define('escalation-popup', EscalationPopup);
class NewsletterPopup extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.pageOverlayElement = document.querySelector(".pageOverlay");
    this.options = JSON.parse(this.element.getAttribute("data-section-settings"));
    this.validator = null;
    this.klaviyoSent = false;
    this.onSubmit = this.onSubmit.bind(this);
  }

  connectedCallback() {
    if (this.options.edit_mode) {
      this.options.delay = 0;
      this.openNewsletter();
    } else {
      this.handleOpenOptions();
    }

    if (window.location.href.indexOf("customer_posted=true#popupForm") > -1) {
      this.options.delay = 0;
      this.openNewsletter();
      sessionStorage.setItem("newsletter-success", "true");
    }

    this.initFormValidation();
    this.bindEvents();
  }

  initFormValidation() {
    const form = this.element.querySelector("#popupForm");
    if (!form) return;

    this.validator = new FormValidator(form, {
      errorClass: "field--error",
      fieldSelector: ".field",
      buttonSelector: "[data-role='newsletter-submit']",
      validateOnBlur: true,
      validateOnInput: true,
      fieldErrorSelector: ".input-validation",
      showErrorsOnSubmitOnly: false
    });


    this.setupCustomValidators();
  }

  setupCustomValidators() {

    this.validator.addValidator(
      "klaviyoEmail",
      (value) => /\S+@\S+\.\S+/.test(value),
      "Please enter a valid email address"
    );
  }

  bindEvents() {
    this.delegateElement.on("click", "[data-action='close-modal']", this.closeNewsletter);

    const form = this.element.querySelector("#popupForm");
    if (!form) return;
    this.delegateElement.on("click", "[data-role='newsletter-submit']", this.onSubmit);
    this.delegateElement.on("submit", "#popupForm", this.onSubmit);

  }

  async onSubmit(e) {
    e.preventDefault();
    e.stopPropagation();

    if (this.validator && !this.validator.validateForm(false)) return;
    if (this.klaviyoSent) return;

    this.klaviyoSent = true;
    const btn = this.element.querySelector('[data-role="newsletter-submit"]');
    if (btn) btn.setAttribute("disabled", "disabled");

    const email = (this.element.querySelector("#klaviyoEmail")?.value || "").trim();
    const listId = window.klaviyoListId;
    const publicKey = window.klaviyoPublicKey;

    if (email && listId && publicKey) {
      const payload = {
        data: {
          type: "subscription",
          attributes: {
            profile: {
              data: {
                type: "profile",
                attributes: {
                  email: email
                }
              }
            }
          },
          relationships: {
            list: {
              data: {
                type: "list",
                id: listId
              }
            }
          }
        }
      };

      try {
        await fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${encodeURIComponent(publicKey)}`, {
          method: "POST",
          headers: {
            "Content-Type": "application/vnd.api+json",
            revision: "2024-06-15" // Use a valid revision date from Klaviyo docs
          },
          body: JSON.stringify(payload),
          keepalive: true
        });
      } catch (error) {
        console.error("Klaviyo subscription error:", error);
      }
    }

    sessionStorage.setItem("newsletter-success", "true");
    this.showSuccessState();
    this.klaviyoSent = false;
  }


  clickOpen() {
    this.options.delay = 0;
    this.openNewsletter();
  }

  handleOpenOptions() {
    const localKey = localStorage.getItem("popup-seen");
    if (this.options.show_only_once && localKey === "true") return;
    if (this.options.not_show_subscribed && this.options.is_subscribed) return;
    if (this.options.scroll_amount > 0) {
      this.myScrollListener = scrollListener.addScrollListener(this, this.scrollListener);
    } else {
      this.openNewsletter();
    }
  }

  scrollListener = () => {
    const body = document.body;
    const html = document.documentElement;

    const docHeight = Math.max(
      body.scrollHeight,
      body.offsetHeight,
      html.clientHeight,
      html.scrollHeight,
      html.offsetHeight
    );

    const percScrolled = (window.scrollY / docHeight) * 100;

    if (percScrolled >= this.options.scroll_amount) {
      this.openNewsletter();
    }
  };

  openNewsletter() {
    if (sessionStorage.getItem('newsletter-success') === 'true' && !this.options.edit_mode) return;
    if (this.myScrollListener) {
      this.myScrollListener.removeScrollListener();
    }

    setTimeout(() => {
      this.element.style.display = "flex";

      requestAnimationFrame(() => {
        this.element.setAttribute("aria-hidden", "false");
      });

      this.pageOverlayElement.classList.add("is-visible");
      bodyScrollLock.disableBodyScroll(this.element, bodyScrollLockOptions);
      document.body.classList.add("scrollLock");
      this.pageOverlayElement.addEventListener("click", this.closeNewsletter);

      localStorage.setItem("popup-seen", true);

      this.delegateBody.on("keydown", this.onEsc.bind(this));
      this.delegateElement.on("click", '[data-action="close-modal"]', this.closeNewsletter);
    }, 1000 * this.options.delay);
  }

  onEsc(e) {
    if (e.key === 'Escape') {
      this.closeNewsletter(e);
    }
  }

  onTransitionEnd = (event) => {
    if (event.propertyName === "opacity") {
      if (this.element.getAttribute("aria-hidden") === "true") {
        requestAnimationFrame(() => {
          this.element.style.display = "none";
          document.body.classList.remove("scrollLock");
          bodyScrollLock.enableBodyScroll(this.element);
          this.element.removeEventListener("transitionend", this.onTransitionEnd);
        });
      }
    }
  };

  closeNewsletter = () => {
    this.element.addEventListener("transitionend", this.onTransitionEnd);
    this.element.setAttribute("aria-hidden", "true");
    bodyScrollLock.clearAllBodyScrollLocks();
    document.body.classList.remove('scrollLock');
    this.pageOverlayElement.classList.remove("is-visible");
    this.pageOverlayElement.removeEventListener("click", this.closeNewsletter);
    this.element.offsetHeight;

    if (this.myScrollListener) {
      this.myScrollListener.removeScrollListener();
    }
  };

  showSuccessState() {
    const popup = this.element;
    const formBox = popup.querySelector('#popupForm');
    const success = popup.querySelector('.newsletter-success-text_wrapper');


    if (formBox) formBox.style.display = 'none';
    if (success) success.style.display = '';
  }
}

customElements.define("newsletter-popup", NewsletterPopup);

class NewsletterFooter extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.footer = document.querySelector(".main-footer");
    this.domDelegate = new Delegate(this.element);
  }

  connectedCallback() {
    this.initFormValidation();
    this.checkShopifySuccessMessage();

    if (window.klaviyoListId && window.klaviyoPublicKey) {
      requestAnimationFrame(() => this.bindEvents());
    }
  }

  bindEvents() {
    const btn = this.element.querySelector("[data-role='footer-newsletter-submit']");
    if (!btn) return;

    this.domDelegate.on(
      "click",
      "[data-role='footer-newsletter-submit']",
      this.handleNewsletterSubmit.bind(this)
    );
  }

  async handleNewsletterSubmit(e) {
    if (!e) return;
    e.preventDefault();
    e.stopPropagation();

    const emailInput = this.element.querySelector("#klaviyoEmailFooter");
    const email = emailInput?.value.trim();
    const listId = window.klaviyoListId;
    const publicKey = window.klaviyoPublicKey;

    if (!email || !listId || !publicKey) return;

    const payload = {
      data: {
        type: "subscription",
        attributes: {
          profile: {
            data: { type: "profile", attributes: { email: email } }
          }
        },
        relationships: { list: { data: { type: "list", id: listId } } }
      }
    };

    try {
      await fetch(
        `https://a.klaviyo.com/client/subscriptions/?company_id=${encodeURIComponent(publicKey)}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/vnd.api+json",
            revision: "2024-06-15"
          },
          body: JSON.stringify(payload),
          keepalive: true
        }
      );

      const successMessage = this.element.querySelector(".footer__newsletter-form--success");
      const formWrapper = this.element.querySelector(".footer__newsletter-form-inputs");
      const submitButton = this.element.querySelector("[data-role='footer-newsletter-submit']");

      if (formWrapper) formWrapper.style.display = "none";
      if (submitButton) submitButton.style.display = "none";
      if (successMessage) successMessage.style.display = "";
    } catch (error) {
      console.error("Klaviyo subscription error:", error);
    }
  }

  initFormValidation() {
    const form = this.element.querySelector("#footerForm");
    if (!form) return;

    this.validator = new FormValidator(form, {
      errorClass: "field--error",
      fieldSelector: ".field",
      buttonSelector: ".validate-button",
      validateOnBlur: true,
      validateOnInput: false,
      fieldErrorSelector: ".input-validation",
      showErrorsOnSubmitOnly: false
    });
  }

  checkShopifySuccessMessage() {
    const url = new URL(window.location.href);

    if (url.searchParams.get("customer_posted") === "true") {
      const form = this.element.querySelector("#footerForm");
      if (!form) return;

      const successMessage = form.querySelector(".footer__newsletter-form--success");
      const formWrapper = form.querySelector(".footer__newsletter-form-inputs");
      const submitButton = form.querySelector(".validate-button");

      if (successMessage) successMessage.style.display = "";
      if (formWrapper) formWrapper.style.display = "none";
      if (submitButton) submitButton.style.display = "none";
    }
  }
}

customElements.define("newsletter-footer", NewsletterFooter);

class ImageTextGrid extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);

    // options via data-attrs (defaults shown)
    this.initialVisible = parseInt(this.getAttribute('data-initial-visible') || '2', 10);
    this.textMore = this.getAttribute('data-text-more') || 'Show more';
    this.textLess = this.getAttribute('data-text-less') || 'Show less';

    this.onToggle = this.onToggle.bind(this);
  }

  connectedCallback() {
    this.setup();
    this.bindEvents();
  }

  setup() {
    const slides = this.element.querySelectorAll('.grid-items .image-text-slide');
    if (!slides.length) return;

    // mark and collapse if needed
    if (slides.length > this.initialVisible) {
      this.classList.add('has-more');
      this.classList.remove('is-expanded');

      // add toggle button once
      if (!this.element.querySelector('.show-more-btn')) {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'show-more-btn';
        btn.setAttribute('data-action', 'toggle-show-more');
        btn.setAttribute('aria-expanded', 'false');
        btn.textContent = this.textMore;
        this.element.appendChild(btn);
      }
    }
  }

  bindEvents() {
    this.delegateElement.on('click', "[data-action='toggle-show-more']", this.onToggle);
  }

  onToggle(e) {
    const expanded = this.classList.toggle('is-expanded');
    const btn = e.target.closest("[data-action='toggle-show-more']");
    if (!btn) return;

    btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');

    // only update the label text, keep icons intact
    const labelEl = btn.querySelector('.show-more-btn__label');
    if (labelEl) {
      labelEl.textContent = expanded ? this.textLess : this.textMore;
    } else {
      // fallback if label span is missing (will replace icons)
      btn.textContent = expanded ? this.textLess : this.textMore;
    }
  }
}

customElements.define('image-text-grid', ImageTextGrid);



class FAQSearch extends HTMLElement {
  constructor() {
    super();
    this.element = this;

    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);

    this.rootEl = null;
    this.input = null;
    this.clearBtn = null;
    this.noResultsEl = null;
    this.items = [];
    this.groups = [];

    this.onInput = this.onInput.bind(this);
    this.onClear = this.onClear.bind(this);
  }

  connectedCallback() {
    this.rootEl = this.resolveRoot();
    this.input = this.querySelector('input[type="search"]');
    this.clearBtn = this.querySelector('[data-action="clear"]');
    this.noResultsEl = document.getElementById('faq__results--none');

    this.collectTargets();
    this.bindEvents();

    if (this.input) this.filter(this.input.value);
  }

  bindEvents() {
    this.delegateElement.on('input', 'input[type="search"]', this.onInput);
    this.delegateElement.on('keyup', 'input[type="search"]', this.onInput);
    this.delegateElement.on('click', '[data-action="clear"]', this.onClear);
  }

  onInput(event) {
    const el = event.target.closest('input[type="search"]');
    if (!el) return;
    this.filter(el.value);
  }

  onClear(event) {
    event.preventDefault();
    if (!this.input) this.input = this.querySelector('input[type="search"]');
    if (!this.input) return;
    this.input.value = '';
    this.filter('');
    this.input.focus();
  }

  resolveRoot() {
    const sel = this.getAttribute('root') || '';
    if (sel) {
      const el = document.querySelector(sel);
      if (el) return el;
    }
    const nearest = this.closest('.Faq-Section');
    return nearest ? nearest : document.body;
  }

  collectTargets() {
    this.items = Array.prototype.slice.call(this.rootEl.querySelectorAll('.FAQ--Terms'));
    this.groups = Array.prototype.slice.call(this.rootEl.querySelectorAll('.faq__content-block'));
  }

  filter(q) {
    const query = (q || '').toLowerCase().trim();
    const hasQ = query.length > 0;

    if (this.clearBtn) this.clearBtn.style.display = hasQ ? '' : 'none';

    // Track if any results are visible
    let hasVisibleResults = false;

    // Group visibility
    for (let g = 0; g < this.groups.length; g++) {
      const group = this.groups[g];

      // Does the group's heading match?
      let headingMatches = false;
      const headings = group.querySelectorAll('.heading-block');
      for (let h = 0; h < headings.length; h++) {
        const ht = (headings[h].textContent || '').toLowerCase();
        if (ht.indexOf(query) !== -1) {
          headingMatches = true;
          break;
        }
      }

      // Get all items in this group
      const groupItems = group.querySelectorAll('.FAQ--Terms');

      if (headingMatches) {
        // If heading matches, show the entire group and all its items
        group.style.display = '';
        for (let k = 0; k < groupItems.length; k++) {
          groupItems[k].style.display = '';
        }
        if (hasQ) hasVisibleResults = true;
      } else {
        // Otherwise, filter items individually
        let anyItemVisible = false;
        for (let k = 0; k < groupItems.length; k++) {
          const text = (groupItems[k].textContent || '').toLowerCase();
          const match = !hasQ || text.indexOf(query) !== -1;
          groupItems[k].style.display = match ? '' : 'none';
          if (match) anyItemVisible = true;
        }

        const groupVisible = !hasQ || anyItemVisible;
        group.style.display = groupVisible ? '' : 'none';

        if (groupVisible && hasQ) {
          hasVisibleResults = true;
        }
      }
    }

    // Show/hide no results message and handle content visibility
    if (this.noResultsEl) {
      if (hasQ && !hasVisibleResults) {
        // No results found - show the message AND all content
        this.noResultsEl.classList.remove('is-hidden');
        this.noResultsEl.setAttribute('aria-hidden', 'false');

        // Show all items and groups
        for (let i = 0; i < this.items.length; i++) {
          this.items[i].style.display = '';
        }
        for (let g = 0; g < this.groups.length; g++) {
          this.groups[g].style.display = '';
        }
      } else {
        // Either no query or has results - hide the no results message
        this.noResultsEl.classList.add('is-hidden');
        this.noResultsEl.setAttribute('aria-hidden', 'true');
      }
    }
  }
}

customElements.define('faq-search', FAQSearch);

class FAQTabs extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);

    this.root = null;
    this.nav = null;
    this.links = [];
    this.sections = [];
    this.sectionTops = [];
    this.active = '';
    this.bar = null;

    this.lead = parseInt(this.getAttribute('data-activation-lead') || '100', 10);

    this.suppressUntil = 0;

    this.onClick = this.onClick.bind(this);
    this.onScroll = this.onScroll.bind(this);
    this.onResize = this.onResize.bind(this);
  }

  connectedCallback() {
    this.root = this._root();
    this.nav = this.querySelector('.tc-tabs__nav-wrapper') || this;
    this.bar = this.closest('.tc-tabs__bar') || null;

    this._collect();
    this._computeSectionTops();

    this.bindEvents();
    this.onScroll();

    this._setInitialActive();


    requestAnimationFrame(() => this._computeSectionTops());
    setTimeout(() => this._computeSectionTops(), 300);
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScroll, { passive: true });
    window.removeEventListener('resize', this.onResize);
  }

  bindEvents() {
    this.delegateElement.on('click', "[data-action='faq-tab']", this.onClick);
    this.delegateElement.on('click', ".tc-tabs__button", this.onClick);

    window.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.onResize);
  }

  onClick(e) {
    const link = e.target.closest("[data-action='faq-tab'], .tc-tabs__button");
    if (!link) return;

    const id = this._idFrom(link);
    if (!id) return;

    e.preventDefault();

    this.setActive(id, true);
    this.suppressUntil = performance.now() + 1200;

    const firstId = this.sections[0] ? this.sections[0].id : null;
    const isFirst = id === firstId;

    const sec = this._sectionById(id);
    const targetEl = isFirst ? this.root : sec;

    const stickyTop = this.bar
      ? (parseFloat(getComputedStyle(this.bar).top) || 0) + (this.bar.offsetHeight || 0)
      : 0;

    const effectiveOffset = isFirst ? stickyTop : this.lead;

    if (targetEl) {
      const rect = targetEl.getBoundingClientRect();
      const absoluteTop = (window.pageYOffset || document.documentElement.scrollTop || 0) + rect.top;
      const targetTop = Math.max(0, absoluteTop - effectiveOffset);
      window.scrollTo({ top: targetTop, behavior: 'smooth' });
    }

    if (history && history.replaceState) {
      history.replaceState(null, '', '#' + id);
    }
  }

  onResize() {
    this._computeSectionTops();
    this.onScroll();
  }

  onScroll() {
    if (!this.sections.length) return;

    if (this.bar) this.bar.classList.toggle('is-stuck', this._isStuck());

    if (performance.now() < this.suppressUntil) return;

    const scrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
    const activationLine = scrollY + this.lead;

    let idx = 0;
    for (let i = 0; i < this.sectionTops.length; i++) {
      if (this.sectionTops[i] <= activationLine) idx = i; else break;
    }

    const activeId = this.sections[idx] ? this.sections[idx].id : '';
    if (activeId) this.setActive(activeId, false);
  }

  setActive(id, scrollNav) {
    if (this.active === id) return;
    this.active = id;

    for (let i = 0; i < this.links.length; i++) {
      const a = this.links[i];
      const targetId = (a.getAttribute('data-target') || a.getAttribute('href') || '')
        .replace(/^.*#/, '')
        .trim();
      const match = targetId === id;
      a.classList.toggle('is-active', match);
      if (match && scrollNav) this._ensureVisible(a);
    }
  }

  _ensureVisible(a) {
    if (!this.nav || !a) return;
    const n = this.nav.getBoundingClientRect();
    const b = a.getBoundingClientRect();
    if (b.left < n.left) {
      this.nav.scrollBy({ left: b.left - n.left - 16, behavior: 'smooth' });
    } else if (b.right > n.right) {
      this.nav.scrollBy({ left: b.right - n.right + 16, behavior: 'smooth' });
    }
  }

  _setInitialActive() {
    const hash = (window.location.hash || '').replace(/^#/, '').trim();
    let id = '';

    if (hash && this._sectionById(hash)) {
      id = hash;
    } else if (this.sections[0]) {
      id = this.sections[0].id;
    }

    if (id) this.setActive(id, true);
  }


  _computeSectionTops() {
    const scrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
    this.sectionTops = this.sections.map(sec => {
      const r = sec.getBoundingClientRect();
      return scrollY + r.top;
    });
  }

  _isStuck() {
    if (!this.bar) return false;
    const topCSS = getComputedStyle(this.bar).top;
    const stickyTop = parseFloat(topCSS) || 0;
    const currentTop = this.bar.getBoundingClientRect().top;
    return currentTop <= stickyTop + 0.5;
  }

  _collect() {
    const nodeList = this.querySelectorAll("[data-action='faq-tab'], .tc-tabs__button");
    this.links = Array.prototype.slice.call(nodeList);

    this.sections = [];
    for (let i = 0; i < this.links.length; i++) {
      const id = this._idFrom(this.links[i]);
      if (!id) continue;
      const sec = this._sectionById(id);
      if (sec) this.sections.push(sec);
    }
  }

  _sectionById(id) {
    const safe = (window.CSS && CSS.escape) ? CSS.escape(id) : id;
    return this.root.querySelector('#' + safe);
  }

  _root() {
    const sel = this.getAttribute('root');
    const el = sel ? document.querySelector(sel) : null;
    return el || this.closest('.Faq-Section') || document.body;
  }

  _idFrom(a) {
    let t = a && a.getAttribute ? (a.getAttribute('data-target') || '') : '';
    if (t) return t.replace(/^#/, '').trim();
    const h = a && a.getAttribute ? (a.getAttribute('href') || '') : '';
    const i = h ? h.indexOf('#') : -1;
    return i >= 0 ? h.slice(i + 1).trim() : '';
  }
}

customElements.define('faq-tabs', FAQTabs);

class ContactFormTicket extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.form = this.querySelector('#contact_form');
    this.submitButton = this.querySelector('#contact-form-submit-btn');
    this.successMsg = this.querySelector('.contact-form__message--sent-custom');
    this.errorMsg = this.querySelector('.contact-form__message--error-custom');

    if (this.submitButton) {
      this.submitButton.addEventListener('click', this.handleSubmit.bind(this));
    }

    const selectBoxes = this.element.querySelectorAll(".RevolutionSelectbox");
    if (selectBoxes.length > 0) {
      selectBoxes.forEach((item, i) => {
        new RevolutionSelectbox(item);
      });
    }
  }

  async handleSubmit(event) {
    event.preventDefault();

    this.hideMessages();

    if (!this.form.checkValidity()) {
      this.form.reportValidity();
      return;
    }

    if (this.dataset.ticket === 'true') {
      await this.submitToTicketingSystem();
    } else {
      this.form.submit();
    }
  }

  async submitToTicketingSystem() {
    try {
      const formData = new FormData(this.form);
      const formObject = this.formDataToObject(formData);

      // Get the dropdown container (has field_id) and selected item (has item_value)
      const dropdownContainer = this.querySelector('.contact-form__selectbox');
      const selectedOption = dropdownContainer?.querySelector('.RevolutionSelectbox--Item[selected="selected"]');

      // Get field_id from the dropdown container
      const fieldId = dropdownContainer?.dataset?.fieldId || null;

      // Get item_value from the selected dropdown item
      const itemValue = selectedOption?.dataset?.value || null;

      let subject = this.dataset.formPurpose;
      if (subject) {
        if (itemValue) {
          const formattedValue = itemValue.replace(/[-_]/g, ' ').trim();
          const capitalizedItemValue = formattedValue.charAt(0).toUpperCase() + formattedValue.slice(1);
          subject = subject + ' - ' + capitalizedItemValue;
        }
      } else {
        subject = this.querySelector('.contact__form-header h2')?.textContent.trim() || 'Contact Form';
      }
      const ticketPayload = {
        email: formObject.email || '',
        name: formObject.Name || formObject.name || '',
        subject: subject,
        text: formObject.Message || formObject.message || formObject.body || '',
        type: "question",
        tags: [itemValue, 'contact-form'],
        custom_fields: []
      };

      // Add dropdown selection to custom_fields
      if (fieldId && itemValue) {
        ticketPayload.custom_fields.push({
          id: parseInt(fieldId),
          value: itemValue
        });
      }

      // Add other custom fields
      const customFields = this.collectCustomFields();
      ticketPayload.custom_fields.push(...customFields);

      const result = await window.apiService.post(
        `${window.proxyPath}/ticket/request`,
        ticketPayload
      );

      this.showSuccessMessage();
      this.form.reset();
    } catch (error) {
      console.error('Error submitting ticket:', error);
      this.showErrorMessage();
    }
  }

  formDataToObject(formData) {
    const obj = {};

    for (let [key, value] of formData.entries()) {
      const cleanKey = key.replace('contact[', '').replace(']', '');

      if (cleanKey === 'form_type' || cleanKey === 'utf8' || key.startsWith('terms_checkbox_')) {
        continue;
      }

      obj[cleanKey] = value;
    }

    return obj;
  }

  collectCustomFields() {
    const customFields = [];
    const customInputs = this.form.querySelectorAll('[data-field-id]:not(.contact-form__selectbox)');

    customInputs.forEach(input => {
      const fieldId = input.dataset.fieldId;
      const value = input.value.trim();

      if (fieldId && fieldId !== 'blank' && fieldId !== '' && value) {
        customFields.push({
          id: parseInt(fieldId),
          value: value
        });
      }
    });

    return customFields;
  }

  handleize(str) {
    if (!str) return '';

    return str
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '_')
      .replace(/^_+|_+$/g, '');
  }

  showSuccessMessage() {
    if (this.successMsg) {
      this.successMsg.classList.remove('hidden');
    }
  }

  showErrorMessage() {
    if (this.errorMsg) {
      this.errorMsg.classList.remove('hidden');
    }
  }

  hideMessages() {
    if (this.successMsg) {
      this.successMsg.classList.add('hidden');
    }
    if (this.errorMsg) {
      this.errorMsg.classList.add('hidden');
    }
  }
}

customElements.define('contact-form-ticket', ContactFormTicket);


class Sitemap extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);

    const tabs = this.element.querySelectorAll('.tc-tabs__button');
    const hash = window.location.hash;

    if (hash) {
      tabs.forEach(btn => {
        if (btn.getAttribute('href') === hash) {
          btn.classList.add('is-active');
        }
      });
    } else if (tabs.length > 0) {
      tabs[0].classList.add('is-active');
    }
  }

  connectedCallback() {
    this.bindEvents();
  }

  bindEvents() {
    this.delegateElement.on('click', '.tc-tabs__button', (e) => {
      e.preventDefault();

      this.element.querySelectorAll('.tc-tabs__button').forEach(btn => {
        btn.classList.remove('is-active');
      });
      e.target.classList.add('is-active');

      const href = e.target.getAttribute('href');
      if (href && href.startsWith('#')) {
        const targetId = href.substring(1);
        const targetElement = document.getElementById(targetId);
        if (targetElement) {
          const header = document.querySelector('.header__top-bar');
          const headerOffset = header ? header.offsetHeight + 70 : 70;
          const elementPosition = targetElement.getBoundingClientRect().top + window.pageYOffset;
          const offsetPosition = elementPosition - headerOffset;
          window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
        }
      }
    });
  }
}
customElements.define('sitemap-element', Sitemap);

class CollectionsList extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
  }

  connectedCallback() {
    this.collectionGrid = this.querySelector('#main-collection-grid--holder');
    this.tabs = this.querySelectorAll('.collection-list__tab');

    if (this.tabs.length > 0) {
      this.tabs[0].classList.add('active');
    }

    this.delegateElement.on('click', '.collection-list__tab', this.handleTabClick.bind(this));
  }

  handleTabClick(event) {
    const tab = event.target.closest('.collection-list__tab');
    if (!tab) return;

    event.preventDefault();

    this.tabs.forEach(t => t.classList.remove('active'));
    tab.classList.add('active');

    const filterHref = tab.dataset.href;

    setTimeout(() => {
      window.location.href = filterHref;
    }, 300);
  }
}
customElements.define('collections-list', CollectionsList);